const Issuers = {
  ['121 FINANCIAL C.U.']: '121 FINANCIAL C.U.',
  ['1880 BANK']: '1880 BANK',
  ['1ST ADVANTAGE F.C.U.']: '1ST ADVANTAGE F.C.U.',
  ['1ST COMMUNITY FEDERAL CREDIT UNION']: '1ST COMMUNITY FEDERAL CREDIT UNION',
  ['1ST CONSTITUTION BANK']: '1ST CONSTITUTION BANK',
  ['1ST FINANCIAL BANK USA']: '1ST FINANCIAL BANK USA',
  ['1ST FINANCIAL F.C.U.']: '1ST FINANCIAL F.C.U.',
  ['1ST GENERAL C.U.']: '1ST GENERAL C.U.',
  ['1ST MIDAMERICA C.U.']: '1ST MIDAMERICA C.U.',
  ['1ST NATIONAL COMMUNITY BANK']: '1ST NATIONAL COMMUNITY BANK',
  ['1ST NOR CAL C.U.']: '1ST NOR CAL C.U.',
  ['1ST SOURCE BANK']: '1ST SOURCE BANK',
  ['1ST SUMMIT BANK']: '1ST SUMMIT BANK',
  ['1ST UNITED SERVICES C.U.']: '1ST UNITED SERVICES C.U.',
  ['1ST UNIVERSAL FEDERAL CREDIT UNION']: '1ST UNIVERSAL FEDERAL CREDIT UNION',
  ['2C2P (THAILAND) COMPANY LIMITED']: '2C2P (THAILAND) COMPANY LIMITED',
  ['2C2P PLUS THAILAND CO LTD']: '2C2P PLUS THAILAND CO LTD',
  ['33 FINANCIAL SERVICES LIMITED']: '33 FINANCIAL SERVICES LIMITED',
  ['3VPREPAID ISSUED BY R RAPHAEL & SONS PLC']: '3VPREPAID ISSUED BY R RAPHAEL & SONS PLC',
  ['4FRONT C.U.']: '4FRONT C.U.',
  ['4U C.U.']: '4U C.U.',
  ['5STAR BANK']: '5STAR BANK',
  ['77 CARD CO., LTD.']: '77 CARD CO., LTD.',
  ['A.O.D. F.C.U.']: 'A.O.D. F.C.U.',
  ['AAA F.C.U.']: 'AAA F.C.U.',
  ['AAC C.U.']: 'AAC C.U.',
  ['AB AND T NATIONAL BANK']: 'AB AND T NATIONAL BANK',
  ['AB CITADELE BANKAS']: 'AB CITADELE BANKAS',
  ['ABA CARD SOLUTIONS, INC.']: 'ABA CARD SOLUTIONS, INC.',
  ['ABACUS FEDERAL SAVINGS BANK']: 'ABACUS FEDERAL SAVINGS BANK',
  ['ABANKA D.D.']: 'ABANKA D.D.',
  ['ABBYBANK']: 'ABBYBANK',
  ['ABERDEEN PROVING GROUND F.C.U.']: 'ABERDEEN PROVING GROUND F.C.U.',
  ['ABLV BANK, A.S.']: 'ABLV BANK, A.S.',
  ['ABN AMRO BANK N.V']: 'ABN AMRO BANK N.V',
  ['ABNB FEDERAL CREDIT UNION']: 'ABNB FEDERAL CREDIT UNION',
  ['ABOUND C.U.']: 'ABOUND C.U.',
  ['ABRI C.U.']: 'ABRI C.U.',
  ['ABSA BANK, LTD.']: 'ABSA BANK, LTD.',
  ['ABSOLUT BANK']: 'ABSOLUT BANK',
  ['ABU DHABI COMMERCIAL BANK']: 'ABU DHABI COMMERCIAL BANK',
  ['ABU DHABI ISLAMIC BANK']: 'ABU DHABI ISLAMIC BANK',
  ['ACADEMIC F.C.U.']: 'ACADEMIC F.C.U.',
  ['ACADEMY BANK, N.A.']: 'ACADEMY BANK, N.A.',
  ['ACADIA F.C.U.']: 'ACADIA F.C.U.',
  ['ACCESO']: 'ACCESO',
  ['ACCESS BANK PLC']: 'ACCESS BANK PLC',
  ['ACCESS C.U.']: 'ACCESS C.U.',
  ['ACCESS F.C.U.']: 'ACCESS F.C.U.',
  ['ACCESSBANK TEXAS']: 'ACCESSBANK TEXAS',
  ['ACCORDFIN ESPANA, ESTABLECIMIENTO FINANCIERO DE']: 'ACCORDFIN ESPANA, ESTABLECIMIENTO FINANCIERO DE',
  ['ACESSO SOLUCOES DE PAGAMENTO S.A.']: 'ACESSO SOLUCOES DE PAGAMENTO S.A.',
  ['ACHIEVA CREDIT UNION']: 'ACHIEVA CREDIT UNION',
  ['ACHIEVE FINANCIAL C.U.']: 'ACHIEVE FINANCIAL C.U.',
  ['ACIPCO F.C.U.']: 'ACIPCO F.C.U.',
  ['ACLEDA BANK PLC.']: 'ACLEDA BANK PLC.',
  ['ACME CONTINENTAL C.U.']: 'ACME CONTINENTAL C.U.',
  ['ACMG F.C.U.']: 'ACMG F.C.U.',
  ['ACOM CO., LTD.']: 'ACOM CO., LTD.',
  ['ADAMS BANK AND TRUST']: 'ADAMS BANK AND TRUST',
  ['ADCB']: 'ADCB',
  ['ADDIKO BANK A.D. BEOGRAD']: 'ADDIKO BANK A.D. BEOGRAD',
  ['ADDIKO BANK AD PODGORICA']: 'ADDIKO BANK AD PODGORICA',
  ['ADDIKO BANK D.D.']: 'ADDIKO BANK D.D.',
  ['ADDIKO BANK D.D. SARAJEVO']: 'ADDIKO BANK D.D. SARAJEVO',
  ['ADDITION FINANCIAL C.U.']: 'ADDITION FINANCIAL C.U.',
  ['ADDITION FINANCIAL CREDIT UNION']: 'ADDITION FINANCIAL CREDIT UNION',
  ['ADIRONDACK REGIONAL F.C.U.']: 'ADIRONDACK REGIONAL F.C.U.',
  ['ADIRONDACK TRUST COMPANY']: 'ADIRONDACK TRUST COMPANY',
  ['ADMINISTRADORA DE CARTAO DE CREDITO BANKOF BOSTON S.C., LTD.']:
    'ADMINISTRADORA DE CARTAO DE CREDITO BANKOF BOSTON S.C., LTD.',
  ['ADVANCE BANK AG']: 'ADVANCE BANK AG',
  ['ADVANCED BANK OF ASIA LIMITED']: 'ADVANCED BANK OF ASIA LIMITED',
  ['ADVANCED PAYMENT SOLUTIONS LIMITED']: 'ADVANCED PAYMENT SOLUTIONS LIMITED',
  ['ADVANCIAL F.C.U.']: 'ADVANCIAL F.C.U.',
  ['ADVANTAGE F.C.U.']: 'ADVANTAGE F.C.U.',
  ['ADVANTAGE FINANCIAL F.C.U.']: 'ADVANTAGE FINANCIAL F.C.U.',
  ['ADVANTAGE ONE C.U.']: 'ADVANTAGE ONE C.U.',
  ['ADVANTAGE ONE F.C.U.']: 'ADVANTAGE ONE F.C.U.',
  ['ADVANTAGE PLUS F.C.U.']: 'ADVANTAGE PLUS F.C.U.',
  ['ADVANTIS C.U.']: 'ADVANTIS C.U.',
  ['ADVANZIA BANK S.A.']: 'ADVANZIA BANK S.A.',
  ['ADVENTURE C.U.']: 'ADVENTURE C.U.',
  ['ADVIA C.U.']: 'ADVIA C.U.',
  ['ADYEN N.V.']: 'ADYEN N.V.',
  ['AEGON BANK N.V.']: 'AEGON BANK N.V.',
  ['AEON CREDIT CARD (TAIWAN) CO., LTD.']: 'AEON CREDIT CARD (TAIWAN) CO., LTD.',
  ['AEON CREDIT SERVICE (ASIA) CO., LTD.']: 'AEON CREDIT SERVICE (ASIA) CO., LTD.',
  ['AEON CREDIT SERVICE (M) BERHAD']: 'AEON CREDIT SERVICE (M) BERHAD',
  ['AEON CREDIT SERVICE CO., LTD.']: 'AEON CREDIT SERVICE CO., LTD.',
  ['AEON FINANCIAL SERVICE CO., LTD.']: 'AEON FINANCIAL SERVICE CO., LTD.',
  ['AEON THANA SINSAP (THAILAND) PUBLIC COMPANY LIMITED']: 'AEON THANA SINSAP (THAILAND) PUBLIC COMPANY LIMITED',
  ['AERO F.C.U.']: 'AERO F.C.U.',
  ['AF PAYMENTS LTD']: 'AF PAYMENTS LTD',
  ['AFB BANK OPEN JOINT-STOCK COMPANY']: 'AFB BANK OPEN JOINT-STOCK COMPANY',
  ['AFFIN BANK BERHAD']: 'AFFIN BANK BERHAD',
  ['AFFINITY F.C.U.']: 'AFFINITY F.C.U.',
  ['AFFINITY PLUS F.C.U.']: 'AFFINITY PLUS F.C.U.',
  ['AFL CIO EMPLOYEES F.C.U.']: 'AFL CIO EMPLOYEES F.C.U.',
  ['AFONE PAIEMENT']: 'AFONE PAIEMENT',
  ['AFRASIA BANK LIMITED']: 'AFRASIA BANK LIMITED',
  ['AFRICAN BANKING CORPORATION OF ZIMBABWE LIMITED']: 'AFRICAN BANKING CORPORATION OF ZIMBABWE LIMITED',
  ['AFRILAND FIRST BANK']: 'AFRILAND FIRST BANK',
  ['AFTRA-SAG F.C.U.']: 'AFTRA-SAG F.C.U.',
  ['AFTRA-SAG FEDERAL CREDIT UNION']: 'AFTRA-SAG FEDERAL CREDIT UNION',
  ['AGILLITAS SOLUCOES DE PAGAMENTOS LTDA.']: 'AGILLITAS SOLUCOES DE PAGAMENTOS LTDA.',
  ['AGODA COMPANY PTE. LTD.']: 'AGODA COMPANY PTE. LTD.',
  ['AGOS DUCATO SPA']: 'AGOS DUCATO SPA',
  ['AGRICULTURAL BANK OF CHINA']: 'AGRICULTURAL BANK OF CHINA',
  ['AGRICULTURE F.C.U.']: 'AGRICULTURE F.C.U.',
  ['AGROINDUSTRIJSKO KOMERCIJALNA BANKA AIK BANKA AKCIONARSKO DRUSTVO BEOG']:
    'AGROINDUSTRIJSKO KOMERCIJALNA BANKA AIK BANKA AKCIONARSKO DRUSTVO BEOG',
  ['AHLI BANK Q.S.C.']: 'AHLI BANK Q.S.C.',
  ['AHLI UNITED BANK']: 'AHLI UNITED BANK',
  ['AIB GROUP (UK) PLC']: 'AIB GROUP (UK) PLC',
  ['AION S.A.']: 'AION S.A.',
  ['AIR BANK A.S.']: 'AIR BANK A.S.',
  ['AIRPLUS INTERNATIONAL SA']: 'AIRPLUS INTERNATIONAL SA',
  ['AIRTEL PAYMENTS BANK LIMITED']: 'AIRTEL PAYMENTS BANK LIMITED',
  ['AKTIA BANK PLC']: 'AKTIA BANK PLC',
  ['AKTIA FINANS AB']: 'AKTIA FINANS AB',
  ['AL AHLI BANK OF KUWAIT (KSC)']: 'AL AHLI BANK OF KUWAIT (KSC)',
  ['AL BARAKA ISLAMIC BANK B.S.C. (CLOSED)']: 'AL BARAKA ISLAMIC BANK B.S.C. (CLOSED)',
  ['AL HILAL BANK P.J.S.C.']: 'AL HILAL BANK P.J.S.C.',
  ['AL HILAL BANK PJSC']: 'AL HILAL BANK PJSC',
  ['AL JANOOB ISLAMIC BANK FOR INVESTMENT AND FINANCE']: 'AL JANOOB ISLAMIC BANK FOR INVESTMENT AND FINANCE',
  ['AL RAJHI BANKING AND INVESTMENT CORP.']: 'AL RAJHI BANKING AND INVESTMENT CORP.',
  ['AL-MAWARID BANK S.A.L.']: 'AL-MAWARID BANK S.A.L.',
  ['ALABAMA CREDIT UNION']: 'ALABAMA CREDIT UNION',
  ['ALABAMA ONE C.U.']: 'ALABAMA ONE C.U.',
  ['ALABAMA RURAL ELECTRIC F.C.U.']: 'ALABAMA RURAL ELECTRIC F.C.U.',
  ['ALABAMA STATE EMPLOYEES C.U.']: 'ALABAMA STATE EMPLOYEES C.U.',
  ['ALABAMA TEACHERS C.U.']: 'ALABAMA TEACHERS C.U.',
  ['ALANDSBANKEN ABP']: 'ALANDSBANKEN ABP',
  ['ALASKA USA F.C.U.']: 'ALASKA USA F.C.U.',
  ['ALATRUST C.U.']: 'ALATRUST C.U.',
  ['ALAWWAL BANK']: 'ALAWWAL BANK',
  ['ALBARAKA TURK KATILIM BANKASI, A.S.']: 'ALBARAKA TURK KATILIM BANKASI, A.S.',
  ['ALBERTA TREASURY BRANCHES']: 'ALBERTA TREASURY BRANCHES',
  ['ALCOA COMMUNITY F.C.U.']: 'ALCOA COMMUNITY F.C.U.',
  ['ALCOA FEDERAL CREDIT UNION']: 'ALCOA FEDERAL CREDIT UNION',
  ['ALCOA PITTSBURGH F.C.U.']: 'ALCOA PITTSBURGH F.C.U.',
  ['ALCOA TENN F.C.U.']: 'ALCOA TENN F.C.U.',
  ['ALDEN C.U.']: 'ALDEN C.U.',
  ['ALERUS FINANCIAL, N.A.']: 'ALERUS FINANCIAL, N.A.',
  ['ALINMA BANK']: 'ALINMA BANK',
  ['ALIOR BANK SPOLKA AKCYJNA']: 'ALIOR BANK SPOLKA AKCYJNA',
  ['ALIPAY SINGAPORE E-COMMERCE PRIVATE LIMITED']: 'ALIPAY SINGAPORE E-COMMERCE PRIVATE LIMITED',
  ['ALL TRANS FINANCIAL SERVICES CREDIT UNION, LTD.']: 'ALL TRANS FINANCIAL SERVICES CREDIT UNION, LTD.',
  ['ALLEGACY F.C.U.']: 'ALLEGACY F.C.U.',
  ['ALLEGENT COMMUNITY F.C.U.']: 'ALLEGENT COMMUNITY F.C.U.',
  ['ALLEGIANCE C.U.']: 'ALLEGIANCE C.U.',
  ['ALLGEMEINE PRIVATKUNDENBANK AG']: 'ALLGEMEINE PRIVATKUNDENBANK AG',
  ['ALLIANCE BANK AND TRUST COMPANY']: 'ALLIANCE BANK AND TRUST COMPANY',
  ['ALLIANCE BANK CORPORATION']: 'ALLIANCE BANK CORPORATION',
  ['ALLIANCE BANK MALAYSIA BERHAD']: 'ALLIANCE BANK MALAYSIA BERHAD',
  ['ALLIANCE C.U.']: 'ALLIANCE C.U.',
  ['ALLIANCE COMMUNITY BANK']: 'ALLIANCE COMMUNITY BANK',
  ['ALLIANCE DATA SYSTEMS']: 'ALLIANCE DATA SYSTEMS',
  ['ALLIANCE F.C.U.']: 'ALLIANCE F.C.U.',
  ['ALLIANT C.U.']: 'ALLIANT C.U.',
  ['ALLIANZ BANK BULGARIA AD']: 'ALLIANZ BANK BULGARIA AD',
  ['ALLIED IRISH BANKS PLC']: 'ALLIED IRISH BANKS PLC',
  ['ALLIED IRISH BANKS, PLC']: 'ALLIED IRISH BANKS, PLC',
  ['ALLIED WALLET LTD']: 'ALLIED WALLET LTD',
  ['ALLPAY LIMITED']: 'ALLPAY LIMITED',
  ['ALLSOUTH F.C.U.']: 'ALLSOUTH F.C.U.',
  ['ALLY BANK']: 'ALLY BANK',
  ['ALMAZERGIENBANK']: 'ALMAZERGIENBANK',
  ['ALOHA PACIFIC F.C.U.']: 'ALOHA PACIFIC F.C.U.',
  ['ALPHA BANK']: 'ALPHA BANK',
  ['ALPHA BANK ROMANIA S.A.']: 'ALPHA BANK ROMANIA S.A.',
  ['ALPINE BANK']: 'ALPINE BANK',
  ['ALPINE BANK AND TRUST CO.']: 'ALPINE BANK AND TRUST CO.',
  ['ALTABANK']: 'ALTABANK',
  ['ALTAMAHA F.C.U.']: 'ALTAMAHA F.C.U.',
  ['ALTANA F.C.U.']: 'ALTANA F.C.U.',
  ['ALTAONE F.C.U.']: 'ALTAONE F.C.U.',
  ['ALTONIZED F.C.U.']: 'ALTONIZED F.C.U.',
  ['ALTRA F.C.U.']: 'ALTRA F.C.U.',
  ['ALTURA C.U.']: 'ALTURA C.U.',
  ['ALTURA CREDIT UNION']: 'ALTURA CREDIT UNION',
  ['AM BANK S.A.L.']: 'AM BANK S.A.L.',
  ['AMALGAMATED BANK']: 'AMALGAMATED BANK',
  ['AMALGAMATED BANK OF CHICAGO']: 'AMALGAMATED BANK OF CHICAGO',
  ['AMARILLO NATIONAL BANK']: 'AMARILLO NATIONAL BANK',
  ['AMBANK (M) BERHAD']: 'AMBANK (M) BERHAD',
  ['AMERICA FIRST C.U.']: 'AMERICA FIRST C.U.',
  ["AMERICA'S C.U."]: "AMERICA'S C.U.",
  ["AMERICA'S CHRISTIAN C.U."]: "AMERICA'S CHRISTIAN C.U.",
  ["AMERICA'S CREDIT UNION, A F.C.U."]: "AMERICA'S CREDIT UNION, A F.C.U.",
  ['AMERICAN BANK']: 'AMERICAN BANK',
  ['AMERICAN BANK AND TRUST COMPANY']: 'AMERICAN BANK AND TRUST COMPANY',
  ['AMERICAN BANK CENTER FIRST']: 'AMERICAN BANK CENTER FIRST',
  ['AMERICAN BANK, N.A.']: 'AMERICAN BANK, N.A.',
  ['AMERICAN BROADCAST EMPLOYEES F.C.U.']: 'AMERICAN BROADCAST EMPLOYEES F.C.U.',
  ['AMERICAN EAGLE BANK']: 'AMERICAN EAGLE BANK',
  ['AMERICAN EAGLE F.C.U.']: 'AMERICAN EAGLE F.C.U.',
  ['AMERICAN FEDERAL BANK']: 'AMERICAN FEDERAL BANK',
  ['AMERICAN FIRST CREDIT UNION']: 'AMERICAN FIRST CREDIT UNION',
  ['AMERICAN HERITAGE BANK']: 'AMERICAN HERITAGE BANK',
  ['AMERICAN HERITAGE FEDERAL CREDIT UNION']: 'AMERICAN HERITAGE FEDERAL CREDIT UNION',
  ['AMERICAN INTERNATIONAL BANK']: 'AMERICAN INTERNATIONAL BANK',
  ['AMERICAN MOMENTUM BANK']: 'AMERICAN MOMENTUM BANK',
  ['AMERICAN NATIONAL BANK']: 'AMERICAN NATIONAL BANK',
  ['AMERICAN NATIONAL BANK AND TRUST COMPANY']: 'AMERICAN NATIONAL BANK AND TRUST COMPANY',
  ['AMERICAN NATIONAL BANK OF TEXAS']: 'AMERICAN NATIONAL BANK OF TEXAS',
  ['AMERICAN PARTNERS F.C.U.']: 'AMERICAN PARTNERS F.C.U.',
  ['AMERICAN SAVINGS, F.S.B.']: 'AMERICAN SAVINGS, F.S.B.',
  ['AMERICAN STATE BANK']: 'AMERICAN STATE BANK',
  ['AMERICAN TRUST & SAVINGS BANK']: 'AMERICAN TRUST & SAVINGS BANK',
  ['AMERICAN TRUST AND SAVINGS BANK']: 'AMERICAN TRUST AND SAVINGS BANK',
  ['AMERICAN UNITED F.C.U.']: 'AMERICAN UNITED F.C.U.',
  ['AMERICAS C.U.']: 'AMERICAS C.U.',
  ['AMERICAS C.U. A F.C.U.']: 'AMERICAS C.U. A F.C.U.',
  ['AMERICAS FIRST F.C.U.']: 'AMERICAS FIRST F.C.U.',
  ['AMERIS BANK']: 'AMERIS BANK',
  ['AMERISERV FINANCIAL BANK']: 'AMERISERV FINANCIAL BANK',
  ['AMERISTATE BANK']: 'AMERISTATE BANK',
  ['AMFIRST BANK, N.A.']: 'AMFIRST BANK, N.A.',
  ['AMHERST F.C.U.']: 'AMHERST F.C.U.',
  ['AMPLIFY C.U.']: 'AMPLIFY C.U.',
  ['AMPLIFY CREDIT UNION']: 'AMPLIFY CREDIT UNION',
  ['AMRAHBANK JSB']: 'AMRAHBANK JSB',
  ['AMSOUTH BANK']: 'AMSOUTH BANK',
  ['AN POST']: 'AN POST',
  ['ANADOLUBANK, A.S.']: 'ANADOLUBANK, A.S.',
  ['ANDERSON BROTHERS BANK']: 'ANDERSON BROTHERS BANK',
  ['ANDIGO C.U.']: 'ANDIGO C.U.',
  ['ANDOVER F.C.U.']: 'ANDOVER F.C.U.',
  ['ANDREWS F.C.U.']: 'ANDREWS F.C.U.',
  ['ANIMAS C.U.']: 'ANIMAS C.U.',
  ['ANTIGUA BARBUDA INVESTMENT BANK, LTD.']: 'ANTIGUA BARBUDA INVESTMENT BANK, LTD.',
  ['ANZ - AUSTRALIA AND NEW ZEALAND BANKING GROUP']: 'ANZ - AUSTRALIA AND NEW ZEALAND BANKING GROUP',
  ['ANZ BANK NEW ZEALAND LTD']: 'ANZ BANK NEW ZEALAND LTD',
  ['ANZ BANK, LTD.']: 'ANZ BANK, LTD.',
  ['ANZ BANKING GROUP']: 'ANZ BANKING GROUP',
  ['ANZ NATIONAL BANK, LTD.']: 'ANZ NATIONAL BANK, LTD.',
  ['AO RAIFFEISENBANK']: 'AO RAIFFEISENBANK',
  ['AOGIN CARD SERVICE COMPANY LIMITED']: 'AOGIN CARD SERVICE COMPANY LIMITED',
  ['AOYAMA CAPITAL CO., LTD.']: 'AOYAMA CAPITAL CO., LTD.',
  ['APCI F.C.U.']: 'APCI F.C.U.',
  ['APCO EMPLOYEES C.U.']: 'APCO EMPLOYEES C.U.',
  ['APLUS FINANCIAL CO., LTD.']: 'APLUS FINANCIAL CO., LTD.',
  ['APPALACHIAN COMMUNITY F.C.U.']: 'APPALACHIAN COMMUNITY F.C.U.',
  ['APPLE BANK FOR SAVINGS']: 'APPLE BANK FOR SAVINGS',
  ['APPLE F.C.U.']: 'APPLE F.C.U.',
  ['APS FINANCIAL LIMITED']: 'APS FINANCIAL LIMITED',
  ['ARAB AFRICAN INTERNATIONAL BANK']: 'ARAB AFRICAN INTERNATIONAL BANK',
  ['ARAB BANK PLC']: 'ARAB BANK PLC',
  ['ARAB BANKING CORPORATION (JORDAN)']: 'ARAB BANKING CORPORATION (JORDAN)',
  ['ARAB BANKING CORPORATION TUNISIE']: 'ARAB BANKING CORPORATION TUNISIE',
  ['ARAB FINANCIAL SERVICES COMPANY']: 'ARAB FINANCIAL SERVICES COMPANY',
  ['ARAB INTERNATIONAL BANK']: 'ARAB INTERNATIONAL BANK',
  ['ARAB JORDAN INVESTMENT BANK']: 'ARAB JORDAN INVESTMENT BANK',
  ['ARAB NATIONAL BANK']: 'ARAB NATIONAL BANK',
  ['ARCHA LIMITED']: 'ARCHA LIMITED',
  ['ARDENT C.U.']: 'ARDENT C.U.',
  ['AREEBA S.A.L']: 'AREEBA S.A.L',
  ['ARGENT F.C.U.']: 'ARGENT F.C.U.',
  ['ARGENTA SPAARBANK']: 'ARGENTA SPAARBANK',
  ['ARIZONA F.C.U.']: 'ARIZONA F.C.U.',
  ['ARKANSAS COUNTY BANK']: 'ARKANSAS COUNTY BANK',
  ['ARKANSAS F.C.U.']: 'ARKANSAS F.C.U.',
  ['ARKANSAS FEDERAL CREDIT UNION']: 'ARKANSAS FEDERAL CREDIT UNION',
  ['ARLINGTON VIRGINIA F.C.U.']: 'ARLINGTON VIRGINIA F.C.U.',
  ['ARMCO C.U.']: 'ARMCO C.U.',
  ['ARMED FORCES BANK OF CALIFORNIA']: 'ARMED FORCES BANK OF CALIFORNIA',
  ['ARMED FORCES BANK, N.A.']: 'ARMED FORCES BANK, N.A.',
  ['ARMENIAN CARD CJSC']: 'ARMENIAN CARD CJSC',
  ['ARMOR BANK']: 'ARMOR BANK',
  ['ARMSTRONG BANK']: 'ARMSTRONG BANK',
  ['ARRHA C.U.']: 'ARRHA C.U.',
  ['ARROWHEAD CENTRAL C.U.']: 'ARROWHEAD CENTRAL C.U.',
  ['ARSENAL C.U.']: 'ARSENAL C.U.',
  ['ARVEST BANK']: 'ARVEST BANK',
  ['AS DNB NORD BANKA']: 'AS DNB NORD BANKA',
  ['AS INDUSTRA BANK (INDUSTRA)']: 'AS INDUSTRA BANK (INDUSTRA)',
  ['AS LHV PANK']: 'AS LHV PANK',
  ['AS PNB BANKA']: 'AS PNB BANKA',
  ['AS POCOPAY']: 'AS POCOPAY',
  ['AS SEB PANK']: 'AS SEB PANK',
  ['ASCEND F.C.U.']: 'ASCEND F.C.U.',
  ['ASCENT C.U.']: 'ASCENT C.U.',
  ['ASHLAND C.U.']: 'ASHLAND C.U.',
  ['ASIA COMMERCIAL BANK']: 'ASIA COMMERCIAL BANK',
  ['ASIA UNITED BANK CORPORATION']: 'ASIA UNITED BANK CORPORATION',
  ['ASIAN PACIFIC BANK OJSC']: 'ASIAN PACIFIC BANK OJSC',
  ['ASIAN-PACIFIC BANK (PUBLIC JOINT STOCK COMPANY)']: 'ASIAN-PACIFIC BANK (PUBLIC JOINT STOCK COMPANY)',
  ['ASOCIACION COOPERATIVA DE AHORRO Y CREDITO DEL COLEGIO MEDICO DE EL SA']:
    'ASOCIACION COOPERATIVA DE AHORRO Y CREDITO DEL COLEGIO MEDICO DE EL SA',
  ['ASOCIACION GREMIAL DE INSTITUCIONES FINANCIERAS - CREDIBANCO']:
    'ASOCIACION GREMIAL DE INSTITUCIONES FINANCIERAS - CREDIBANCO',
  ['ASOCIACION LA NACIONAL DE AHORROS Y PRESTAMOS']: 'ASOCIACION LA NACIONAL DE AHORROS Y PRESTAMOS',
  ['ASSEMBLIES OF GOD C.U.']: 'ASSEMBLIES OF GOD C.U.',
  ['ASSOCIATED BANK']: 'ASSOCIATED BANK',
  ['ASSOCIATED C.U.']: 'ASSOCIATED C.U.',
  ['ASSOCIATED CARD SERVICES BANK, N.A.']: 'ASSOCIATED CARD SERVICES BANK, N.A.',
  ['ASSOCIATES NATIONAL BANK (DELAWARE)']: 'ASSOCIATES NATIONAL BANK (DELAWARE)',
  ['ATLANTA POSTAL C.U.']: 'ATLANTA POSTAL C.U.',
  ['ATLANTIC F.C.U.']: 'ATLANTIC F.C.U.',
  ['ATLANTIC FINANCIAL F.C.U.']: 'ATLANTIC FINANCIAL F.C.U.',
  ['ATLANTIC UNION BANK']: 'ATLANTIC UNION BANK',
  ['ATLAS BANKA A.D.']: 'ATLAS BANKA A.D.',
  ['ATOMIC CREDIT UNION, INC.']: 'ATOMIC CREDIT UNION, INC.',
  ['ATTIJARIWAFA BANK']: 'ATTIJARIWAFA BANK',
  ['ATTIJARIWAFA BANK EUROPE']: 'ATTIJARIWAFA BANK EUROPE',
  ['AUBURN UNIVERSITY F.C.U.']: 'AUBURN UNIVERSITY F.C.U.',
  ['AUBURNBANK']: 'AUBURNBANK',
  ['AUDUBON F.C.U.']: 'AUDUBON F.C.U.',
  ['AURGROUP FINANCIAL C.U.']: 'AURGROUP FINANCIAL C.U.',
  ['AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED']: 'AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED',
  ['AUSTRALIA AND NEW ZEALAND BANKING GROUP, LTD.']: 'AUSTRALIA AND NEW ZEALAND BANKING GROUP, LTD.',
  ['AVADIAN C.U.']: 'AVADIAN C.U.',
  ['AVADIAN CREDIT UNION']: 'AVADIAN CREDIT UNION',
  ['AVAL CARD']: 'AVAL CARD',
  ['AVAL CARD (COSTA RICA)']: 'AVAL CARD (COSTA RICA)',
  ['AVANTCARD LIMITED']: 'AVANTCARD LIMITED',
  ['AVIDIA BANK']: 'AVIDIA BANK',
  ['AVISTA SA CREDITO FINANCIAMENTO E INVESTIMENTO']: 'AVISTA SA CREDITO FINANCIAMENTO E INVESTIMENTO',
  ['AWAGIN CARD CO., LTD., THE']: 'AWAGIN CARD CO., LTD., THE',
  ['AWAKON F.C.U.']: 'AWAKON F.C.U.',
  ['AXIOM BANK']: 'AXIOM BANK',
  ['AXIS BANK LIMITED']: 'AXIS BANK LIMITED',
  ['AXOS BANK']: 'AXOS BANK',
  ['AZALEA CITY C.U.']: 'AZALEA CITY C.U.',
  ['AZERIGAZBANK OJSC']: 'AZERIGAZBANK OJSC',
  ['B1BANK']: 'B1BANK',
  ['BA MERCHANT SERVICES, INC.']: 'BA MERCHANT SERVICES, INC.',
  ['BAC INTERNATIONAL BANK INC']: 'BAC INTERNATIONAL BANK INC',
  ['BAHRAIN COMMERCIAL FACILITIES COMPANY BSC']: 'BAHRAIN COMMERCIAL FACILITIES COMPANY BSC',
  ['BAHRAIN ISLAMIC BANK BSC']: 'BAHRAIN ISLAMIC BANK BSC',
  ['BAIDURI BANK BERHAD']: 'BAIDURI BANK BERHAD',
  ['BAIDURI BANK BHD']: 'BAIDURI BANK BHD',
  ['BAKER-BOYER NATIONAL BANK']: 'BAKER-BOYER NATIONAL BANK',
  ['BANAMEX']: 'BANAMEX',
  ['BANC OF CALIFORNIA, N.A.']: 'BANC OF CALIFORNIA, N.A.',
  ['BANC POST, S.A.']: 'BANC POST, S.A.',
  ['BANCA AFIRME, S.A.']: 'BANCA AFIRME, S.A.',
  ['BANCA DI SASSARI S.P.A.']: 'BANCA DI SASSARI S.P.A.',
  ['BANCA INTESA']: 'BANCA INTESA',
  ['BANCA INTESA AD BEOGRAD']: 'BANCA INTESA AD BEOGRAD',
  ['BANCA MARCH, S.A.']: 'BANCA MARCH, S.A.',
  ['BANCA MONTE DEI PASCHI DI SIENA']: 'BANCA MONTE DEI PASCHI DI SIENA',
  ['BANCA NAZIONALE DEL LAVORO S.P.A.']: 'BANCA NAZIONALE DEL LAVORO S.P.A.',
  ["BANCA POPOLARE DELL'ALTO ADIGE SPA"]: "BANCA POPOLARE DELL'ALTO ADIGE SPA",
  ['BANCA ROMANA DE CREDITE SI INVESTITII S.A.']: 'BANCA ROMANA DE CREDITE SI INVESTITII S.A.',
  ['BANCA ROMANESCA S.A.']: 'BANCA ROMANESCA S.A.',
  ['BANCA SELLA SPA']: 'BANCA SELLA SPA',
  ['BANCA TRANSILVANIA S.A.']: 'BANCA TRANSILVANIA S.A.',
  ['BANCAR TECNOLOGIA SA U']: 'BANCAR TECNOLOGIA SA U',
  ['BANCARD, S.A.']: 'BANCARD, S.A.',
  ['BANCFIRST']: 'BANCFIRST',
  ['BANCO ACTINVER, S.A.']: 'BANCO ACTINVER, S.A.',
  ['BANCO ALCALA']: 'BANCO ALCALA',
  ['BANCO AMAMBAY, S.A.']: 'BANCO AMAMBAY, S.A.',
  ['BANCO ATLANTICO DE AHORRO Y CREDITO S A']: 'BANCO ATLANTICO DE AHORRO Y CREDITO S A',
  ['BANCO ATLANTIDA, S.A.']: 'BANCO ATLANTIDA, S.A.',
  ['BANCO AZTECA S.A. INSTITUCION DE BANCA MULTIPLE']: 'BANCO AZTECA S.A. INSTITUCION DE BANCA MULTIPLE',
  ['BANCO BAC SAN JOSE, S.A.']: 'BANCO BAC SAN JOSE, S.A.',
  ['BANCO BANDEIRANTES S.A.']: 'BANCO BANDEIRANTES S.A.',
  ['BANCO BANDES URUGUAY, S.A.']: 'BANCO BANDES URUGUAY, S.A.',
  ['BANCO BHD']: 'BANCO BHD',
  ['BANCO BICE']: 'BANCO BICE',
  ['BANCO BILBAO VIZCAYA ARGENTARIA CHILE']: 'BANCO BILBAO VIZCAYA ARGENTARIA CHILE',
  ['BANCO BILBAO VIZCAYA ARGENTARIA COLOMBIA S.A.']: 'BANCO BILBAO VIZCAYA ARGENTARIA COLOMBIA S.A.',
  ['BANCO BILBAO VIZCAYA ARGENTARIA S.A.']: 'BANCO BILBAO VIZCAYA ARGENTARIA S.A.',
  ['BANCO BILBAO VIZCAYA ARGENTARIA URUGUAY, S.A.']: 'BANCO BILBAO VIZCAYA ARGENTARIA URUGUAY, S.A.',
  ['BANCO BILBAO VIZCAYA ARGENTARIA, CHILE']: 'BANCO BILBAO VIZCAYA ARGENTARIA, CHILE',
  ['BANCO BMD S.A.']: 'BANCO BMD S.A.',
  ['BANCO BNP PARIBAS PERSONAL FINANCE SA']: 'BANCO BNP PARIBAS PERSONAL FINANCE SA',
  ['BANCO BONSUCESSO, S.A.']: 'BANCO BONSUCESSO, S.A.',
  ['BANCO BPM SOCIETA PER AZIONI']: 'BANCO BPM SOCIETA PER AZIONI',
  ['BANCO BRADESCO CARTOES, S.A.']: 'BANCO BRADESCO CARTOES, S.A.',
  ['BANCO BRADESCO S.A.']: 'BANCO BRADESCO S.A.',
  ['BANCO BS2 S.A.']: 'BANCO BS2 S.A.',
  ['BANCO BTG PACTUAL SA']: 'BANCO BTG PACTUAL SA',
  ['BANCO C6 SA']: 'BANCO C6 SA',
  ['BANCO CETELEM S.A']: 'BANCO CETELEM S.A',
  ['BANCO CITIBANK DE EL SALVADOR, S.A.']: 'BANCO CITIBANK DE EL SALVADOR, S.A.',
  ['BANCO CITIBANK DE GUATEMALA, S.A.']: 'BANCO CITIBANK DE GUATEMALA, S.A.',
  ['BANCO COMERCIAL DE MACAU S.A.']: 'BANCO COMERCIAL DE MACAU S.A.',
  ['BANCO COMERCIAL E DE INVESTIMENTOS SARL']: 'BANCO COMERCIAL E DE INVESTIMENTOS SARL',
  ['BANCO COMERCIAL PORTUGUES S.A.']: 'BANCO COMERCIAL PORTUGUES S.A.',
  ['BANCO CONTINENTAL']: 'BANCO CONTINENTAL',
  ['BANCO COOPERATIVO DE PUERTO RICO']: 'BANCO COOPERATIVO DE PUERTO RICO',
  ['BANCO COOPERATIVO DO BRASIL S/A']: 'BANCO COOPERATIVO DO BRASIL S/A',
  ['BANCO COOPERATIVO ESPANOL, S.A.']: 'BANCO COOPERATIVO ESPANOL, S.A.',
  ['BANCO COOPERATIVO SICREDI SA']: 'BANCO COOPERATIVO SICREDI SA',
  ['BANCO COOPERATIVO VISIONARIO DE RL']: 'BANCO COOPERATIVO VISIONARIO DE RL',
  ['BANCO CREDITO INVERSIONES']: 'BANCO CREDITO INVERSIONES',
  ['BANCO CSF S/A']: 'BANCO CSF S/A',
  ['BANCO DAVIVIENDA COSTA RICA S.A.']: 'BANCO DAVIVIENDA COSTA RICA S.A.',
  ['BANCO DE BALCARCE COOPERATIVO LTDO.']: 'BANCO DE BALCARCE COOPERATIVO LTDO.',
  ['BANCO DE BOGOTA S.A.']: 'BANCO DE BOGOTA S.A.',
  ['BANCO DE BRASILIA S.A.']: 'BANCO DE BRASILIA S.A.',
  ['BANCO DE COSTA RICA']: 'BANCO DE COSTA RICA',
  ['BANCO DE CREDITO DE BOLIVIA, S.A.']: 'BANCO DE CREDITO DE BOLIVIA, S.A.',
  ['BANCO DE CREDITO DEL PERU']: 'BANCO DE CREDITO DEL PERU',
  ['BANCO DE CREDITO E INVERSIONES']: 'BANCO DE CREDITO E INVERSIONES',
  ['BANCO DE GALICIA Y BUENOS AIRES, S.A.']: 'BANCO DE GALICIA Y BUENOS AIRES, S.A.',
  ['BANCO DE LA NACION ARGENTINA']: 'BANCO DE LA NACION ARGENTINA',
  ['BANCO DE LA PAMPA']: 'BANCO DE LA PAMPA',
  ['BANCO DE LA PRODUCCION, S.A.']: 'BANCO DE LA PRODUCCION, S.A.',
  ['BANCO DE LA PROVINCIA DE BUENOS AIRES']: 'BANCO DE LA PROVINCIA DE BUENOS AIRES',
  ['BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY']: 'BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY',
  ['BANCO DE LA REPUBLICA, S.A.']: 'BANCO DE LA REPUBLICA, S.A.',
  ['BANCO DE LIMA SUDAMERIS']: 'BANCO DE LIMA SUDAMERIS',
  ['BANCO DE NEGOCIOS INTERNACIONAL, SA']: 'BANCO DE NEGOCIOS INTERNACIONAL, SA',
  ['BANCO DE OCCIDENTE, S.A.']: 'BANCO DE OCCIDENTE, S.A.',
  ['BANCO DE ORO UNIBANK INC.']: 'BANCO DE ORO UNIBANK INC.',
  ['BANCO DE RESERVAS DE LA REPUBLICA DOMINICANA']: 'BANCO DE RESERVAS DE LA REPUBLICA DOMINICANA',
  ['BANCO DE SOLUCIONES BANSOL DE COSTA RICA, S.A.']: 'BANCO DE SOLUCIONES BANSOL DE COSTA RICA, S.A.',
  ['BANCO DE VENEZUELA S.A.']: 'BANCO DE VENEZUELA S.A.',
  ['BANCO DEL BAJIO, S.A.']: 'BANCO DEL BAJIO, S.A.',
  ['BANCO DEL CARIBE, C.A. BANCO UNIVERSAL']: 'BANCO DEL CARIBE, C.A. BANCO UNIVERSAL',
  ['BANCO DEL ESTADO S.A.']: 'BANCO DEL ESTADO S.A.',
  ['BANCO DEL PACIFICO, S.A.']: 'BANCO DEL PACIFICO, S.A.',
  ['BANCO DEL PAIS, S.A.']: 'BANCO DEL PAIS, S.A.',
  ['BANCO DEL TRABAJO']: 'BANCO DEL TRABAJO',
  ['BANCO DO BRASIL AMERICAS']: 'BANCO DO BRASIL AMERICAS',
  ['BANCO DO BRASIL S.A.']: 'BANCO DO BRASIL S.A.',
  ['BANCO DO ESTADO DO PARA S.A.']: 'BANCO DO ESTADO DO PARA S.A.',
  ['BANCO DO ESTADO DO RIO GRANDE DO SUL S.A. (BANRISUL S.A.)']:
    'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A. (BANRISUL S.A.)',
  ['BANCO ECONOMICO, S.A.']: 'BANCO ECONOMICO, S.A.',
  ['BANCO ELCA S.A.']: 'BANCO ELCA S.A.',
  ['BANCO ESPIRITO SANTO DOS ACORES, S.A.']: 'BANCO ESPIRITO SANTO DOS ACORES, S.A.',
  ['BANCO FALABELLA']: 'BANCO FALABELLA',
  ['BANCO G AND T CONTINENTAL, S.A.']: 'BANCO G AND T CONTINENTAL, S.A.',
  ['BANCO GENERAL']: 'BANCO GENERAL',
  ['BANCO GUIPUZCOANO']: 'BANCO GUIPUZCOANO',
  ['BANCO HSBC COLOMBIA, S.A.']: 'BANCO HSBC COLOMBIA, S.A.',
  ['BANCO INBURSA S.A. INSTITUCION DE BANCA MULTIPLE GRUPO FINANCIERO INBURSA']:
    'BANCO INBURSA S.A. INSTITUCION DE BANCA MULTIPLE GRUPO FINANCIERO INBURSA',
  ['BANCO INBURSA, S.A.']: 'BANCO INBURSA, S.A.',
  ['BANCO INDUSTRIAL, S.A.']: 'BANCO INDUSTRIAL, S.A.',
  ['BANCO INMOBILIARIO, S.A.']: 'BANCO INMOBILIARIO, S.A.',
  ['BANCO INTER S.A.']: 'BANCO INTER S.A.',
  ['BANCO INTERNACIONAL, S.A.']: 'BANCO INTERNACIONAL, S.A.',
  ['BANCO INVEX, S.A. INSTITUCION DE BANCA MULTIPLE, INVEX GRUPO FINANCIER']:
    'BANCO INVEX, S.A. INSTITUCION DE BANCA MULTIPLE, INVEX GRUPO FINANCIER',
  ['BANCO ITAU ARGENTINA S.A.']: 'BANCO ITAU ARGENTINA S.A.',
  ['BANCO ITAU PARAGUAY S.A.']: 'BANCO ITAU PARAGUAY S.A.',
  ['BANCO ITAU URUGUAY, S.A.']: 'BANCO ITAU URUGUAY, S.A.',
  ['BANCO LAFISE PANAMA, S.A.']: 'BANCO LAFISE PANAMA, S.A.',
  ['BANCO MACRO, S.A.']: 'BANCO MACRO, S.A.',
  ['BANCO MELLO S.A']: 'BANCO MELLO S.A',
  ['BANCO MERCANTIL DEL NORTE']: 'BANCO MERCANTIL DEL NORTE',
  ['BANCO MERCANTIL S.A.']: 'BANCO MERCANTIL S.A.',
  ['BANCO MULTIPLE BHD LEON, S.A.']: 'BANCO MULTIPLE BHD LEON, S.A.',
  ['BANCO MULTIPLE LEON, S.A.']: 'BANCO MULTIPLE LEON, S.A.',
  ['BANCO MULTIPLE LOPEZ DE HARO, S.A.']: 'BANCO MULTIPLE LOPEZ DE HARO, S.A.',
  ['BANCO MULTIPLE SANTA CRUZ, S.A.']: 'BANCO MULTIPLE SANTA CRUZ, S.A.',
  ['BANCO NACIONAL DE COSTA RICA']: 'BANCO NACIONAL DE COSTA RICA',
  ['BANCO NACIONAL DE CREDITO']: 'BANCO NACIONAL DE CREDITO',
  ['BANCO NACIONAL DE MEXICO, S.A.']: 'BANCO NACIONAL DE MEXICO, S.A.',
  ['BANCO NACIONAL DEL EJERCITO, FUERZA AEREA Y ARMADA, S.N.C.']:
    'BANCO NACIONAL DEL EJERCITO, FUERZA AEREA Y ARMADA, S.N.C.',
  ['BANCO NACIONAL ULTRAMARINO S.A.']: 'BANCO NACIONAL ULTRAMARINO S.A.',
  ['BANCO NEON, S.A.']: 'BANCO NEON, S.A.',
  ['BANCO ORIGINAL']: 'BANCO ORIGINAL',
  ['BANCO PAN SA']: 'BANCO PAN SA',
  ['BANCO PATAGONIA S.A.']: 'BANCO PATAGONIA S.A.',
  ['BANCO PICHINCHA, S.A.']: 'BANCO PICHINCHA, S.A.',
  ['BANCO PINTO & SOTTO MAYOR']: 'BANCO PINTO & SOTTO MAYOR',
  ['BANCO POPULAR DE PUERTO RICO']: 'BANCO POPULAR DE PUERTO RICO',
  ['BANCO POPULAR DOMINICANO']: 'BANCO POPULAR DOMINICANO',
  ['BANCO POPULAR DOMINICANO, C. POR A.']: 'BANCO POPULAR DOMINICANO, C. POR A.',
  ['BANCO POPULAR NORTH AMERICA']: 'BANCO POPULAR NORTH AMERICA',
  ['BANCO POPULAR Y DE DESARROLLO COMUNAL']: 'BANCO POPULAR Y DE DESARROLLO COMUNAL',
  ['BANCO PROCREDIT ECUADOR S.A.']: 'BANCO PROCREDIT ECUADOR S.A.',
  ['BANCO PROMERICA , S.A.']: 'BANCO PROMERICA , S.A.',
  ['BANCO PROMERICA DE COSTA RICA S.A.']: 'BANCO PROMERICA DE COSTA RICA S.A.',
  ['BANCO PROMERICA S.A.']: 'BANCO PROMERICA S.A.',
  ['BANCO PROMOTOR DEL NORTE']: 'BANCO PROMOTOR DEL NORTE',
  ['BANCO REFORMADOR, S.A.']: 'BANCO REFORMADOR, S.A.',
  ['BANCO REGIONAL DE MONTERREY S.A. BANREGIO']: 'BANCO REGIONAL DE MONTERREY S.A. BANREGIO',
  ['BANCO RENDIMENTO S.A.']: 'BANCO RENDIMENTO S.A.',
  ['BANCO RIPLEY']: 'BANCO RIPLEY',
  ['BANCO SABADELL S.A.']: 'BANCO SABADELL S.A.',
  ['BANCO SAFRA S/A']: 'BANCO SAFRA S/A',
  ['BANCO SANTANDER (BRASIL) S.A.']: 'BANCO SANTANDER (BRASIL) S.A.',
  ['BANCO SANTANDER CHILE']: 'BANCO SANTANDER CHILE',
  ['BANCO SANTANDER MEXICANO, S.A.']: 'BANCO SANTANDER MEXICANO, S.A.',
  ['BANCO SANTANDER PORTUGAL']: 'BANCO SANTANDER PORTUGAL',
  ['BANCO SANTANDER PUERTO RICO']: 'BANCO SANTANDER PUERTO RICO',
  ['BANCO SANTANDER RIO, S.A.']: 'BANCO SANTANDER RIO, S.A.',
  ['BANCO SANTANDER S.A.']: 'BANCO SANTANDER S.A.',
  ['BANCO SANTANDER TOTTA S.A.']: 'BANCO SANTANDER TOTTA S.A.',
  ['BANCO SANTANDER USA']: 'BANCO SANTANDER USA',
  ['BANCO SANTANDER-CHILE']: 'BANCO SANTANDER-CHILE',
  ['BANCO SOCIAL DE CORDOBA']: 'BANCO SOCIAL DE CORDOBA',
  ['BANCO SOFITASA, C.A.']: 'BANCO SOFITASA, C.A.',
  ['BANCO SOL S.A.']: 'BANCO SOL S.A.',
  ['BANCO SUPERVIELLE S.A.']: 'BANCO SUPERVIELLE S.A.',
  ['BANCO TEQUENDAMA']: 'BANCO TEQUENDAMA',
  ['BANCO UNION, C.A.']: 'BANCO UNION, C.A.',
  ['BANCO UNO, S.A.']: 'BANCO UNO, S.A.',
  ['BANCO VALOR S.A']: 'BANCO VALOR S.A',
  ['BANCO VOTORANTIM S/A']: 'BANCO VOTORANTIM S/A',
  ['BANCO WENG HANG, S.A.']: 'BANCO WENG HANG, S.A.',
  ['BANCOLOMBIA S.A.']: 'BANCOLOMBIA S.A.',
  ['BANCOP, S.A.']: 'BANCOP, S.A.',
  ['BANCORP']: 'BANCORP',
  ['BANCORPSOUTH BANK']: 'BANCORPSOUTH BANK',
  ['BANESCO BANCO MULTIPLE S.A.']: 'BANESCO BANCO MULTIPLE S.A.',
  ['BANEX INVERSIONES S.A.']: 'BANEX INVERSIONES S.A.',
  ['BANGKOK BANK PUBLIC CO., LTD.']: 'BANGKOK BANK PUBLIC CO., LTD.',
  ['BANGOR SAVINGS BANK']: 'BANGOR SAVINGS BANK',
  ['BANK - OLDHAM COUNTY, INC.']: 'BANK - OLDHAM COUNTY, INC.',
  ['BANK 1 SAAR EG']: 'BANK 1 SAAR EG',
  ['BANK AGROROS ZAO CJSC']: 'BANK AGROROS ZAO CJSC',
  ['BANK AL JAZIRA']: 'BANK AL JAZIRA',
  ['BANK ALFALAH, LTD.']: 'BANK ALFALAH, LTD.',
  ['BANK ALJAZIRA']: 'BANK ALJAZIRA',
  ['BANK ASIA LTD.']: 'BANK ASIA LTD.',
  ['BANK AUDI S.A.L. - AUDI SARADAR GROUP']: 'BANK AUDI S.A.L. - AUDI SARADAR GROUP',
  ['BANK BGZ BNP PARIBAS SPOLKA AKCYJNA']: 'BANK BGZ BNP PARIBAS SPOLKA AKCYJNA',
  ['BANK CENTER CREDIT']: 'BANK CENTER CREDIT',
  ['BANK CENTER FIRST']: 'BANK CENTER FIRST',
  ['BANK DABRABYT']: 'BANK DABRABYT',
  ['BANK DHOFAR SAOG']: 'BANK DHOFAR SAOG',
  ['BANK DOM.RF']: 'BANK DOM.RF',
  ['BANK FIVE NINE']: 'BANK FIVE NINE',
  ['BANK GOSPODARKI ZYWNOSCIOWEJ, S.A.']: 'BANK GOSPODARKI ZYWNOSCIOWEJ, S.A.',
  ['BANK HANDLOWY W WARSZAWIE S.A.']: 'BANK HANDLOWY W WARSZAWIE S.A.',
  ['BANK HAPOALIM B.M.']: 'BANK HAPOALIM B.M.',
  ['BANK INDEPENDENT']: 'BANK INDEPENDENT',
  ['BANK INTESA']: 'BANK INTESA',
  ['BANK IOWA']: 'BANK IOWA',
  ['BANK ISLAM BRUNEI DARUSSALAM BERHAD']: 'BANK ISLAM BRUNEI DARUSSALAM BERHAD',
  ['BANK ISLAM MALAYSIA BERHAD']: 'BANK ISLAM MALAYSIA BERHAD',
  ['BANK KERJASAMA RAKYAT MALAYSIA BERHAD']: 'BANK KERJASAMA RAKYAT MALAYSIA BERHAD',
  ['BANK LEUMI LE-ISRAEL BM']: 'BANK LEUMI LE-ISRAEL BM',
  ['BANK LEVOBEREZHNY']: 'BANK LEVOBEREZHNY',
  ['BANK MIDWEST']: 'BANK MIDWEST',
  ['BANK MILLENNIUM S.A.']: 'BANK MILLENNIUM S.A.',
  ['BANK MUAMALAT MALAYSIA BERHAD']: 'BANK MUAMALAT MALAYSIA BERHAD',
  ['BANK MUSCAT (SAOG)']: 'BANK MUSCAT (SAOG)',
  ['BANK OCHRONY SRODOWISKA S.A. (BOS S.A.)']: 'BANK OCHRONY SRODOWISKA S.A. (BOS S.A.)',
  ['BANK OF AKRON']: 'BANK OF AKRON',
  ['BANK OF AMERICA']: 'BANK OF AMERICA',
  ['BANK OF AMERICA CANADA BRANCH']: 'BANK OF AMERICA CANADA BRANCH',
  ['BANK OF AMERICA CORPORATION']: 'BANK OF AMERICA CORPORATION',
  ['BANK OF AMERICA EUROPE DAC']: 'BANK OF AMERICA EUROPE DAC',
  ['BANK OF AMERICA MERRILL LYNCH INTERNATIONAL DAC']: 'BANK OF AMERICA MERRILL LYNCH INTERNATIONAL DAC',
  ['BANK OF AMERICA, N.A.']: 'BANK OF AMERICA, N.A.',
  ['BANK OF AMERICAN FORK']: 'BANK OF AMERICAN FORK',
  ['BANK OF ANDERSON, N.A.']: 'BANK OF ANDERSON, N.A.',
  ['BANK OF ANN ARBOR']: 'BANK OF ANN ARBOR',
  ['BANK OF ANTIGUA, LTD.']: 'BANK OF ANTIGUA, LTD.',
  ['BANK OF AYDHYA PUBLIC CO., LTD.']: 'BANK OF AYDHYA PUBLIC CO., LTD.',
  ['BANK OF BARODA']: 'BANK OF BARODA',
  ['BANK OF BARTLETT']: 'BANK OF BARTLETT',
  ['BANK OF BEIRUT S.A.L.']: 'BANK OF BEIRUT S.A.L.',
  ['BANK OF BOTETOURT']: 'BANK OF BOTETOURT',
  ['BANK OF BOURBONNAIS']: 'BANK OF BOURBONNAIS',
  ['BANK OF CASHTON']: 'BANK OF CASHTON',
  ['BANK OF CASTILE, THE']: 'BANK OF CASTILE, THE',
  ['BANK OF CHINA (MALAYSIA) BERHAD']: 'BANK OF CHINA (MALAYSIA) BERHAD',
  ['BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED']: 'BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
  ['BANK OF CHINA LIMITED']: 'BANK OF CHINA LIMITED',
  ['BANK OF CLARKE COUNTY']: 'BANK OF CLARKE COUNTY',
  ['BANK OF CLEVELAND']: 'BANK OF CLEVELAND',
  ['BANK OF COMMERCE']: 'BANK OF COMMERCE',
  ['BANK OF COMMUNICATIONS']: 'BANK OF COMMUNICATIONS',
  ['BANK OF CYPRUS PUBLIC COMPANY LIMITED']: 'BANK OF CYPRUS PUBLIC COMPANY LIMITED',
  ['BANK OF DWIGHT']: 'BANK OF DWIGHT',
  ['BANK OF EAST ASIA, LIMITED, THE']: 'BANK OF EAST ASIA, LIMITED, THE',
  ['BANK OF EAST ASIA, LTD.']: 'BANK OF EAST ASIA, LTD.',
  ['BANK OF EAST ASIA(CHINA), LTD.']: 'BANK OF EAST ASIA(CHINA), LTD.',
  ['BANK OF EDMONSON COUNTY']: 'BANK OF EDMONSON COUNTY',
  ['BANK OF EDWARDSVILLE, THE']: 'BANK OF EDWARDSVILLE, THE',
  ['BANK OF ENGLAND']: 'BANK OF ENGLAND',
  ['BANK OF FUKUOKA, LTD.']: 'BANK OF FUKUOKA, LTD.',
  ['BANK OF GEORGE']: 'BANK OF GEORGE',
  ['BANK OF GERMANTOWN']: 'BANK OF GERMANTOWN',
  ['BANK OF GREENE COUNTY']: 'BANK OF GREENE COUNTY',
  ['BANK OF HAWAII']: 'BANK OF HAWAII',
  ['BANK OF HOPE']: 'BANK OF HOPE',
  ['BANK OF INDIA']: 'BANK OF INDIA',
  ['BANK OF IRELAND']: 'BANK OF IRELAND',
  ['BANK OF LABOR']: 'BANK OF LABOR',
  ['BANK OF MEAD']: 'BANK OF MEAD',
  ['BANK OF MISSOURI, THE']: 'BANK OF MISSOURI, THE',
  ['BANK OF MONTREAL']: 'BANK OF MONTREAL',
  ['BANK OF N.T. BUTTERFIELD & SON LIMITED']: 'BANK OF N.T. BUTTERFIELD & SON LIMITED',
  ['BANK OF NEW JERSEY']: 'BANK OF NEW JERSEY',
  ['BANK OF NINGBO CO., LTD.']: 'BANK OF NINGBO CO., LTD.',
  ['BANK OF NOVA SCOTIA']: 'BANK OF NOVA SCOTIA',
  ['BANK OF NOVA SCOTIA JAMAICA LIMITED, THE']: 'BANK OF NOVA SCOTIA JAMAICA LIMITED, THE',
  ['BANK OF OKLAHOMA, N.A.']: 'BANK OF OKLAHOMA, N.A.',
  ['BANK OF PALESTINE PLC']: 'BANK OF PALESTINE PLC',
  ['BANK OF PRAIRIE DU SAC']: 'BANK OF PRAIRIE DU SAC',
  ['BANK OF SCOTLAND']: 'BANK OF SCOTLAND',
  ['BANK OF SCOTLAND PLC']: 'BANK OF SCOTLAND PLC',
  ['BANK OF SHANGHAI']: 'BANK OF SHANGHAI',
  ['BANK OF SOUTHSIDE VIRGINIA, THE']: 'BANK OF SOUTHSIDE VIRGINIA, THE',
  ['BANK OF SPRINGFIELD']: 'BANK OF SPRINGFIELD',
  ['BANK OF SUFFOLK']: 'BANK OF SUFFOLK',
  ['BANK OF TAIWAN']: 'BANK OF TAIWAN',
  ['BANK OF TENNESSEE']: 'BANK OF TENNESSEE',
  ['BANK OF THE BAHAMAS, LTD.']: 'BANK OF THE BAHAMAS, LTD.',
  ['BANK OF THE JAMES']: 'BANK OF THE JAMES',
  ['BANK OF THE OZARKS']: 'BANK OF THE OZARKS',
  ['BANK OF THE PHILIPPINE ISLANDS']: 'BANK OF THE PHILIPPINE ISLANDS',
  ['BANK OF THE SOUTH']: 'BANK OF THE SOUTH',
  ['BANK OF THE WEST']: 'BANK OF THE WEST',
  ['BANK OF TRAVELERS REST']: 'BANK OF TRAVELERS REST',
  ['BANK OF UTAH']: 'BANK OF UTAH',
  ['BANK OF VALLETTA PLC']: 'BANK OF VALLETTA PLC',
  ['BANK OF VICI']: 'BANK OF VICI',
  ['BANK OF WESTERN AUSTRALIA, LTD.']: 'BANK OF WESTERN AUSTRALIA, LTD.',
  ['BANK OF YOKOHAMA, LTD.']: 'BANK OF YOKOHAMA, LTD.',
  ['BANK ONE']: 'BANK ONE',
  ['BANK OZK']: 'BANK OZK',
  ['BANK POCZTOWY SPOLKA AKCYJNA']: 'BANK POCZTOWY SPOLKA AKCYJNA',
  ['BANK POLSKA KASA OPIEKI S.A. - (BANK PEKAO S.A.)']: 'BANK POLSKA KASA OPIEKI S.A. - (BANK PEKAO S.A.)',
  ['BANK POLSKIEJ SPOLDZIELCZOSCI SA W WARSZAWIE']: 'BANK POLSKIEJ SPOLDZIELCZOSCI SA W WARSZAWIE',
  ['BANK RESPUBLIKA OPEN JOINT STOCK COMPANY']: 'BANK RESPUBLIKA OPEN JOINT STOCK COMPANY',
  ['BANK RHODE ISLAND']: 'BANK RHODE ISLAND',
  ['BANK SAINT PETERSBURG OJSC']: 'BANK SAINT PETERSBURG OJSC',
  ['BANK SIMPANAN NASIONAL']: 'BANK SIMPANAN NASIONAL',
  ['BANK SINOPAC']: 'BANK SINOPAC',
  ['BANK SOHAR (S.A.O.G.)']: 'BANK SOHAR (S.A.O.G.)',
  ['BANK SPOLDZIELCZY RZEMIOSLA W KRAKOWIE']: 'BANK SPOLDZIELCZY RZEMIOSLA W KRAKOWIE',
  ['BANK SPOLDZIELCZY W BRODNICY']: 'BANK SPOLDZIELCZY W BRODNICY',
  ['BANK VOZROZHDENIE OJSC']: 'BANK VOZROZHDENIE OJSC',
  ['BANK ZENIT']: 'BANK ZENIT',
  ['BANK-FUND STAFF F.C.U.']: 'BANK-FUND STAFF F.C.U.',
  ['BANK-VERLAG GMBH']: 'BANK-VERLAG GMBH',
  ['BANKA CREDINS SH. A.']: 'BANKA CREDINS SH. A.',
  ['BANKA CREDITAS A.S.']: 'BANKA CREDITAS A.S.',
  ['BANKA INTESA SANPAOLO D.D.']: 'BANKA INTESA SANPAOLO D.D.',
  ['BANKA KOMBETARE TREGTARE SH.A.']: 'BANKA KOMBETARE TREGTARE SH.A.',
  ['BANKA OTP ALBANIA SH.A']: 'BANKA OTP ALBANIA SH.A',
  ['BANKA SPARKASSE DD']: 'BANKA SPARKASSE DD',
  ['BANKABLE ISSUED BY R RAPHAEL AND SONS PLC']: 'BANKABLE ISSUED BY R RAPHAEL AND SONS PLC',
  ['BANKAOOL, S.A., INSTITUCION DE BANCA MULTIPLE']: 'BANKAOOL, S.A., INSTITUCION DE BANCA MULTIPLE',
  ['BANKCARD SERVICE JAPAN CO.']: 'BANKCARD SERVICE JAPAN CO.',
  ['BANKCHAMPAIGN, N.A.']: 'BANKCHAMPAIGN, N.A.',
  ["BANKER'S BANK OF KANSAS, N.A."]: "BANKER'S BANK OF KANSAS, N.A.",
  ['BANKERS BANK']: 'BANKERS BANK',
  ['BANKERS BANK OF THE WEST']: 'BANKERS BANK OF THE WEST',
  ['BANKERS TRUST COMPANY']: 'BANKERS TRUST COMPANY',
  ['BANKFINANCIAL']: 'BANKFINANCIAL',
  ['BANKFIRST']: 'BANKFIRST',
  ['BANKFIRST FINANCIAL SERVICES']: 'BANKFIRST FINANCIAL SERVICES',
  ['BANKIA,  S.A.']: 'BANKIA,  S.A.',
  ['BANKINTER S.A.']: 'BANKINTER S.A.',
  ['BANKMED S.A.L.']: 'BANKMED S.A.L.',
  ['BANKMUSCAT LTD. (S.A.O.G.)']: 'BANKMUSCAT LTD. (S.A.O.G.)',
  ['BANKNEWPORT']: 'BANKNEWPORT',
  ['BANKNORTH, N.A.']: 'BANKNORTH, N.A.',
  ['BANKPLUS']: 'BANKPLUS',
  ['BANKWELL']: 'BANKWELL',
  ['BANNER BANK']: 'BANNER BANK',
  ['BANPLUS BANCO UNIVERSAL, C.A.']: 'BANPLUS BANCO UNIVERSAL, C.A.',
  ['BANQI INSTITUICAO DE PAGAMENTO']: 'BANQI INSTITUICAO DE PAGAMENTO',
  ['BANQUE AL WAVA MAURITANIENNE ISLAMIQUE BAMIS']: 'BANQUE AL WAVA MAURITANIENNE ISLAMIQUE BAMIS',
  ['BANQUE CANTONALE NEUCHATELOISE']: 'BANQUE CANTONALE NEUCHATELOISE',
  ['BANQUE CENTRALE POPULAIRE']: 'BANQUE CENTRALE POPULAIRE',
  ['BANQUE COMMERCIALE DU RWANDA, S.A.']: 'BANQUE COMMERCIALE DU RWANDA, S.A.',
  ['BANQUE DE KIGALI']: 'BANQUE DE KIGALI',
  ['BANQUE DE LUXEMBOURG']: 'BANQUE DE LUXEMBOURG',
  ['BANQUE DU CAIRE']: 'BANQUE DU CAIRE',
  ["BANQUE ET CAISSE D'EPARGNE DE L'ETAT"]: "BANQUE ET CAISSE D'EPARGNE DE L'ETAT",
  ['BANQUE FEDERATIVE DU CREDIT MUTUEL']: 'BANQUE FEDERATIVE DU CREDIT MUTUEL',
  ["BANQUE INTERNATIONALE POUR L'AFRIQUE AU CONGO"]: "BANQUE INTERNATIONALE POUR L'AFRIQUE AU CONGO",
  ['BANQUE INVIK, S.A.']: 'BANQUE INVIK, S.A.',
  ['BANQUE LAURENTIENNE DU CANADA']: 'BANQUE LAURENTIENNE DU CANADA',
  ['BANQUE LIBANO - FRANCAISE SAL']: 'BANQUE LIBANO - FRANCAISE SAL',
  ['BANQUE MISR']: 'BANQUE MISR',
  ['BANQUE NATIONALE DE PARIS']: 'BANQUE NATIONALE DE PARIS',
  ['BANQUE POPULAIRE']: 'BANQUE POPULAIRE',
  ['BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC']: 'BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC',
  ['BANQUE SAUDI FRANSI']: 'BANQUE SAUDI FRANSI',
  ['BANQUE TRAVELEX S.A.']: 'BANQUE TRAVELEX S.A.',
  ['BANREGIO']: 'BANREGIO',
  ['BANRISUL']: 'BANRISUL',
  ['BANSICREDI']: 'BANSICREDI',
  ['BANTERRA BANK']: 'BANTERRA BANK',
  ['BAR HARBOR BANK & TRUST COMPANY']: 'BAR HARBOR BANK & TRUST COMPANY',
  ['BARABOO STATE BANK']: 'BARABOO STATE BANK',
  ['BARCLAYS']: 'BARCLAYS',
  ['BARCLAYS BANK DELAWARE']: 'BARCLAYS BANK DELAWARE',
  ['BARCLAYS BANK OF KENYA, LTD.']: 'BARCLAYS BANK OF KENYA, LTD.',
  ['BARCLAYS BANK PLC']: 'BARCLAYS BANK PLC',
  ['BARKSDALE F.C.U.']: 'BARKSDALE F.C.U.',
  ['BARNETT BANK, N.A.']: 'BARNETT BANK, N.A.',
  ['BARWA BANK']: 'BARWA BANK',
  ['BASISBANK JSC']: 'BASISBANK JSC',
  ['BATON ROUGE TELCO F.C.U.']: 'BATON ROUGE TELCO F.C.U.',
  ['BAWAG P.S.K. BANK']: 'BAWAG P.S.K. BANK',
  ['BAXTER C.U.']: 'BAXTER C.U.',
  ['BAXTER CREDIT UNION']: 'BAXTER CREDIT UNION',
  ['BAY ATLANTIC F.C.U.']: 'BAY ATLANTIC F.C.U.',
  ['BAY C.U.']: 'BAY C.U.',
  ['BAY FIRST BANK, N.A.']: 'BAY FIRST BANK, N.A.',
  ['BAYER HERITAGE F.C.U.']: 'BAYER HERITAGE F.C.U.',
  ['BAYO PAY M SDN BHD']: 'BAYO PAY M SDN BHD',
  ['BAYOU F.C.U.']: 'BAYOU F.C.U.',
  ['BAYPORT C.U.']: 'BAYPORT C.U.',
  ['BAYPORT CREDIT UNION']: 'BAYPORT CREDIT UNION',
  ['BB AND T FINANCIAL, F.S.B.']: 'BB AND T FINANCIAL, F.S.B.',
  ['BB&T BANK']: 'BB&T BANK',
  ['BBAC S.A.L']: 'BBAC S.A.L',
  ['BBVA BANCO CONTINENTAL']: 'BBVA BANCO CONTINENTAL',
  ['BBVA BANCO FRANCES']: 'BBVA BANCO FRANCES',
  ['BBVA BANCO GANADERO, S.A.']: 'BBVA BANCO GANADERO, S.A.',
  ['BBVA BANCOMER USA']: 'BBVA BANCOMER USA',
  ['BBVA BANCOMER, SA INSTIT. DE BANCA MULTIPLE GRUPO FINANCIER']:
    'BBVA BANCOMER, SA INSTIT. DE BANCA MULTIPLE GRUPO FINANCIER',
  ['BBVA USA']: 'BBVA USA',
  ['BC CARD CO., LTD.']: 'BC CARD CO., LTD.',
  ['BC VICTORIABANK SA']: 'BC VICTORIABANK SA',
  ['BCB COMMUNITY BANK']: 'BCB COMMUNITY BANK',
  ['BDO UNIBANK, INC.']: 'BDO UNIBANK, INC.',
  ['BEACON C.U.']: 'BEACON C.U.',
  ['BEAVER VALLEY F.C.U.']: 'BEAVER VALLEY F.C.U.',
  ['BEEHIVE FEDERAL CREDIT UNION']: 'BEEHIVE FEDERAL CREDIT UNION',
  ['BELARUSIAN-RUSSIAN BELGAZPROMBANK JS']: 'BELARUSIAN-RUSSIAN BELGAZPROMBANK JS',
  ['BELARUSSIAN BANK OF DEVELOPMENT AND RECONSTRUCTION BELINVESTBANK JSC']:
    'BELARUSSIAN BANK OF DEVELOPMENT AND RECONSTRUCTION BELINVESTBANK JSC',
  ['BELFIUS BANK N.V. / BELFIUS BANQUE S.A.']: 'BELFIUS BANK N.V. / BELFIUS BANQUE S.A.',
  ['BELGAZPROMBANK']: 'BELGAZPROMBANK',
  ['BELIZE BANK LIMITED, THE']: 'BELIZE BANK LIMITED, THE',
  ['BELL BANK']: 'BELL BANK',
  ['BELLCO F.C.U.']: 'BELLCO F.C.U.',
  ['BELSWISS BANK']: 'BELSWISS BANK',
  ['BELVNESHECONOMBANK']: 'BELVNESHECONOMBANK',
  ['BENCHMARK COMMUNITY BANK']: 'BENCHMARK COMMUNITY BANK',
  ['BENCHMARK F.C.U.']: 'BENCHMARK F.C.U.',
  ['BENCHMARK FEDERAL CREDIT UNION']: 'BENCHMARK FEDERAL CREDIT UNION',
  ['BENDIGO AND ADELAIDE BANK LIMITED']: 'BENDIGO AND ADELAIDE BANK LIMITED',
  ['BENEFICIAL STATE BANK']: 'BENEFICIAL STATE BANK',
  ['BENJAMIN FRANKLIN BANK']: 'BENJAMIN FRANKLIN BANK',
  ['BEOBANK NV/SA']: 'BEOBANK NV/SA',
  ['BEOBANKA A.D.']: 'BEOBANKA A.D.',
  ['BERKSHIRE BANK']: 'BERKSHIRE BANK',
  ['BEST FINANCIAL C.U.']: 'BEST FINANCIAL C.U.',
  ['BEST SOURCE CREDIT UNION']: 'BEST SOURCE CREDIT UNION',
  ['BETHPAGE F.C.U.']: 'BETHPAGE F.C.U.',
  ['BETTER BANKS']: 'BETTER BANKS',
  ['BFG F.C.U.']: 'BFG F.C.U.',
  ['BGFIBANK, S.A.']: 'BGFIBANK, S.A.',
  ['BGL BNP PARIBAS S.A.']: 'BGL BNP PARIBAS S.A.',
  ['BIBANCA S.P.A.']: 'BIBANCA S.P.A.',
  ['BIC BANK LAO CO., LTD']: 'BIC BANK LAO CO., LTD',
  ['BIDVEST BANK']: 'BIDVEST BANK',
  ['BIGPAY MALAYSIA SDN. BHD.']: 'BIGPAY MALAYSIA SDN. BHD.',
  ['BILLINGS F.C.U.']: 'BILLINGS F.C.U.',
  ['BLACK HILLS F.C.U.']: 'BLACK HILLS F.C.U.',
  ['BLACKHAWK BANK AND TRUST']: 'BLACKHAWK BANK AND TRUST',
  ['BLACKHAWK NETWORK (UK) LTD']: 'BLACKHAWK NETWORK (UK) LTD',
  ['BLOM BANK EGYPT']: 'BLOM BANK EGYPT',
  ['BLOM BANK S.A.L.']: 'BLOM BANK S.A.L.',
  ['BLUCURRENT C.U.']: 'BLUCURRENT C.U.',
  ['BLUE FEDERAL CREDIT UNION']: 'BLUE FEDERAL CREDIT UNION',
  ['BMI F.C.U.']: 'BMI F.C.U.',
  ['BMO HARRIS BANK']: 'BMO HARRIS BANK',
  ['BMW BANK OF NORTH AMERICA']: 'BMW BANK OF NORTH AMERICA',
  ['BNB BANK']: 'BNB BANK',
  ['BNC NATIONAL BANK']: 'BNC NATIONAL BANK',
  ['BNEXT ELECTRONIC MONEY ISSUER SL']: 'BNEXT ELECTRONIC MONEY ISSUER SL',
  ['BNP PARIBAS']: 'BNP PARIBAS',
  ['BNP PARIBAS BANK POLSKA S.A.']: 'BNP PARIBAS BANK POLSKA S.A.',
  ['BNP PARIBAS FORTIS']: 'BNP PARIBAS FORTIS',
  ['BNY MELLON, N.A.']: 'BNY MELLON, N.A.',
  ['BNY MELLON, NATIONAL ASSOCIATION']: 'BNY MELLON, NATIONAL ASSOCIATION',
  ['BOC CREDIT CARD (INTERNATIONAL) LIMITED']: 'BOC CREDIT CARD (INTERNATIONAL) LIMITED',
  ['BOEING EMPLOYEES CREDIT UNION']: 'BOEING EMPLOYEES CREDIT UNION',
  ['BOEING HELICOPTERS C.U.']: 'BOEING HELICOPTERS C.U.',
  ['BOFI FEDERAL BANK']: 'BOFI FEDERAL BANK',
  ['BOK FINANCIAL']: 'BOK FINANCIAL',
  ['BOKF NATIONAL ASSOCIATION']: 'BOKF NATIONAL ASSOCIATION',
  ['BOKIS']: 'BOKIS',
  ['BONUSCARD.CH AG']: 'BONUSCARD.CH AG',
  ['BORGUN H.F.']: 'BORGUN H.F.',
  ['BOSTON FIREFIGHTERS CREDIT UNION']: 'BOSTON FIREFIGHTERS CREDIT UNION',
  ['BOUBYAN BANK']: 'BOUBYAN BANK',
  ['BOULDER DAM C.U.']: 'BOULDER DAM C.U.',
  ['BPCE']: 'BPCE',
  ['BPS-SBERBANK']: 'BPS-SBERBANK',
  ['BRAC BANK LIMITED']: 'BRAC BANK LIMITED',
  ['BRANCH BANKING AND TRUST COMPANY']: 'BRANCH BANKING AND TRUST COMPANY',
  ['BRASIL PREPAGOS']: 'BRASIL PREPAGOS',
  ['BRAUND CARD LIMITED']: 'BRAUND CARD LIMITED',
  ['BRB-BANCO DE BRASILIA, S.A.']: 'BRB-BANCO DE BRASILIA, S.A.',
  ['BRD GROUPE SOCIETE GENERALE']: 'BRD GROUPE SOCIETE GENERALE',
  ['BREMER BANK, N.A.']: 'BREMER BANK, N.A.',
  ['BREWER F.C.U.']: 'BREWER F.C.U.',
  ['BRIGHTSTAR C.U.']: 'BRIGHTSTAR C.U.',
  ['BRIM FINANCIAL INC.']: 'BRIM FINANCIAL INC.',
  ['BROADWAY NATIONAL BANK']: 'BROADWAY NATIONAL BANK',
  ['BRONCO F.C.U.']: 'BRONCO F.C.U.',
  ['BROWN COUNTY STATE BANK']: 'BROWN COUNTY STATE BANK',
  ['BRUNING STATE BANK']: 'BRUNING STATE BANK',
  ['BRYANT BANK']: 'BRYANT BANK',
  ['BRYN MAWR TRUST BANK']: 'BRYN MAWR TRUST BANK',
  ['BSB BANK']: 'BSB BANK',
  ['BUDAPEST BANK LTD.']: 'BUDAPEST BANK LTD.',
  ['BUFFALO SERVICE C.U.']: 'BUFFALO SERVICE C.U.',
  ['BUNQ B.V.']: 'BUNQ B.V.',
  ['BURGAN BANK, S.A.K.']: 'BURGAN BANK, S.A.K.',
  ['BUSEY BANK']: 'BUSEY BANK',
  ['BUSINESS FIRST BANK']: 'BUSINESS FIRST BANK',
  ['BUY WAY PERSONAL FINANCE SA']: 'BUY WAY PERSONAL FINANCE SA',
  ['BYBLOS BANK - SYRIA']: 'BYBLOS BANK - SYRIA',
  ['BYBLOS BANK S.A.L.']: 'BYBLOS BANK S.A.L.',
  ['BYLINE BANK']: 'BYLINE BANK',
  ['BYRON BANK']: 'BYRON BANK',
  ['C.U. CARD SERVICES, INC.']: 'C.U. CARD SERVICES, INC.',
  ['C.U. OF COLORADO']: 'C.U. OF COLORADO',
  ['C.W.A. LONG ISLAND F.C.U.']: 'C.W.A. LONG ISLAND F.C.U.',
  ['C24 BANK GMBH']: 'C24 BANK GMBH',
  ['CACHE VALLEY BANK']: 'CACHE VALLEY BANK',
  ['CADENCE BANK']: 'CADENCE BANK',
  ['CAIRO AMMAN BANK PLC']: 'CAIRO AMMAN BANK PLC',
  ['CAISSE CENTRALE DE CREDIT MUTUEL']: 'CAISSE CENTRALE DE CREDIT MUTUEL',
  ['CAISSE NATIONALE DE CREDIT AGRICOLE']: 'CAISSE NATIONALE DE CREDIT AGRICOLE',
  ["CAISSE NATIONALE DES CAISSES D'EPARGNE (CNCE)"]: "CAISSE NATIONALE DES CAISSES D'EPARGNE (CNCE)",
  ['CAIXA CENTRAL DE CREDITO AGRICOLA MUTUO']: 'CAIXA CENTRAL DE CREDITO AGRICOLA MUTUO',
  ['CAIXA ECONOMICA FEDERAL']: 'CAIXA ECONOMICA FEDERAL',
  ['CAIXA GERAL DE DEPOSITOS SA']: 'CAIXA GERAL DE DEPOSITOS SA',
  ['CAIXABANK S.A.']: 'CAIXABANK S.A.',
  ['CALDWELL BANK AND TRUST COMPANY']: 'CALDWELL BANK AND TRUST COMPANY',
  ['CALIFORNIA BANK AND TRUST']: 'CALIFORNIA BANK AND TRUST',
  ['CALIFORNIA BUSINESS BANK']: 'CALIFORNIA BUSINESS BANK',
  ['CALIFORNIA C.U.']: 'CALIFORNIA C.U.',
  ['CALIFORNIA COAST C.U.']: 'CALIFORNIA COAST C.U.',
  ['CALIFORNIA COMMUNITY C.U.']: 'CALIFORNIA COMMUNITY C.U.',
  ['CALL F.C.U.']: 'CALL F.C.U.',
  ['CALTECH EMPLOYEES FEDERAL CREDIT UNION']: 'CALTECH EMPLOYEES FEDERAL CREDIT UNION',
  ['CAMBODIA MEKONG BANK']: 'CAMBODIA MEKONG BANK',
  ['CAMBODIAN PUBLIC BANK PLC.']: 'CAMBODIAN PUBLIC BANK PLC.',
  ['CAMBRIDGE SAVINGS BANK']: 'CAMBRIDGE SAVINGS BANK',
  ['CAMBRIDGE TRUST']: 'CAMBRIDGE TRUST',
  ['CAMDEN NATIONAL BANK']: 'CAMDEN NATIONAL BANK',
  ['CAMINO F.C.U.']: 'CAMINO F.C.U.',
  ['CAMPCO F.C.U.']: 'CAMPCO F.C.U.',
  ['CAMPUS FEDERAL CREDIT UNION']: 'CAMPUS FEDERAL CREDIT UNION',
  ['CAMPUS USA C.U.']: 'CAMPUS USA C.U.',
  ['CANADA TRUST']: 'CANADA TRUST',
  ['CANADIA BANK PLC.']: 'CANADIA BANK PLC.',
  ['CANADIAN IMPERIAL BANK OF COMMERCE']: 'CANADIAN IMPERIAL BANK OF COMMERCE',
  ['CANADIAN TIRE BANK']: 'CANADIAN TIRE BANK',
  ['CANANDAIGUA NATIONAL BANK & TRUST COMPANY']: 'CANANDAIGUA NATIONAL BANK & TRUST COMPANY',
  ['CANNON F.C.U.']: 'CANNON F.C.U.',
  ['CANTON SCHOOL EMPLOYEES F.C.U.']: 'CANTON SCHOOL EMPLOYEES F.C.U.',
  ['CANVAS C.U.']: 'CANVAS C.U.',
  ['CAPE COD FIVE CENTS SAVINGS BANK']: 'CAPE COD FIVE CENTS SAVINGS BANK',
  ['CAPITAL AREA F.C.U.']: 'CAPITAL AREA F.C.U.',
  ['CAPITAL BANK']: 'CAPITAL BANK',
  ['CAPITAL BANK CORPORATION']: 'CAPITAL BANK CORPORATION',
  ['CAPITAL BANK OF MONGOLIA']: 'CAPITAL BANK OF MONGOLIA',
  ['CAPITAL BANK, INC.']: 'CAPITAL BANK, INC.',
  ['CAPITAL C.U.']: 'CAPITAL C.U.',
  ['CAPITAL CITY BANK']: 'CAPITAL CITY BANK',
  ['CAPITAL COMMUNICATIONS F.C.U.']: 'CAPITAL COMMUNICATIONS F.C.U.',
  ['CAPITAL FINANCIAL SERVICES S.A.']: 'CAPITAL FINANCIAL SERVICES S.A.',
  ['CAPITAL ONE (EUROPE) PLC']: 'CAPITAL ONE (EUROPE) PLC',
  ['CAPITAL ONE BANK']: 'CAPITAL ONE BANK',
  ['CAPITAL ONE BANK (CANADA BRANCH)']: 'CAPITAL ONE BANK (CANADA BRANCH)',
  ['CAPITAL ONE BANK (USA), N.A.']: 'CAPITAL ONE BANK (USA), N.A.',
  ['CAPITALBANK']: 'CAPITALBANK',
  ['CAPITEC BANK LIMITED']: 'CAPITEC BANK LIMITED',
  ['CAPITOL FEDERAL SAVINGS BANK']: 'CAPITOL FEDERAL SAVINGS BANK',
  ['CAPITOL VIEW C.U.']: 'CAPITOL VIEW C.U.',
  ['CAPTEX BANK']: 'CAPTEX BANK',
  ['CAR S.A.']: 'CAR S.A.',
  ['CARD COMPLETE SERVICE BANK AG']: 'CARD COMPLETE SERVICE BANK AG',
  ['CARD SERVICES FOR CREDIT UNIONS']: 'CARD SERVICES FOR CREDIT UNIONS',
  ['CARDINAL BANK']: 'CARDINAL BANK',
  ['CARDPAY EUROPE LTD']: 'CARDPAY EUROPE LTD',
  ['CARGILLS BANK LIMITED']: 'CARGILLS BANK LIMITED',
  ['CARIBBEAN CREDIT CARD CORPORATION']: 'CARIBBEAN CREDIT CARD CORPORATION',
  ['CAROLINA BANK']: 'CAROLINA BANK',
  ['CAROLINA F.C.U.']: 'CAROLINA F.C.U.',
  ['CARREFOUR BANQUE']: 'CARREFOUR BANQUE',
  ['CARROLL COUNTY TRUST COMPANY OF CARROLLTON, MISSOURI']: 'CARROLL COUNTY TRUST COMPANY OF CARROLLTON, MISSOURI',
  ['CARROLLTON BANK']: 'CARROLLTON BANK',
  ['CARUANA S.A. - SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO']:
    'CARUANA S.A. - SOCIEDADE DE CREDITO, FINANCIAMENTO E INVESTIMENTO',
  ['CASH STATION, INC.']: 'CASH STATION, INC.',
  ['CASHFLOWS EUROPE LIMITED']: 'CASHFLOWS EUROPE LIMITED',
  ['CASHMERE VALLEY BANK']: 'CASHMERE VALLEY BANK',
  ['CASSA CENTRALE BANCA - CREDITO COOPERATIVO DEL NORD EST SPA']:
    'CASSA CENTRALE BANCA - CREDITO COOPERATIVO DEL NORD EST SPA',
  ['CAT ADMINISTRADORA DE TARJETAS S.A.']: 'CAT ADMINISTRADORA DE TARJETAS S.A.',
  ['CATALYST CORPORATE F.C.U.']: 'CATALYST CORPORATE F.C.U.',
  ['CATELLA BANK S.A.']: 'CATELLA BANK S.A.',
  ['CATHAY UNITED BANK']: 'CATHAY UNITED BANK',
  ['CATHAY UNITED BANK (CAMBODIA) CORPORATION LIMITED']: 'CATHAY UNITED BANK (CAMBODIA) CORPORATION LIMITED',
  ['CATHOLIC & COMMUNITY C.U.']: 'CATHOLIC & COMMUNITY C.U.',
  ['CATHOLIC F.C.U.']: 'CATHOLIC F.C.U.',
  ['CAXTON FX CARD BY R RAPHAEL & SONS PLC']: 'CAXTON FX CARD BY R RAPHAEL & SONS PLC',
  ['CB ADMIRALTEISKY LTD']: 'CB ADMIRALTEISKY LTD',
  ['CB BANK PCL']: 'CB BANK PCL',
  ['CB CENTER-INVEST']: 'CB CENTER-INVEST',
  ['CB ENERGOTRANSBANK OJSC']: 'CB ENERGOTRANSBANK OJSC',
  ['CB KUBAN KREDIT LLC']: 'CB KUBAN KREDIT LLC',
  ['CB LOCKO BANK']: 'CB LOCKO BANK',
  ['CB MKB UNIONBANK A.D.']: 'CB MKB UNIONBANK A.D.',
  ['CB MOLDOVA-AGROINDBANK S.A.']: 'CB MOLDOVA-AGROINDBANK S.A.',
  ['CB MOSKOMMERTSBANK']: 'CB MOSKOMMERTSBANK',
  ['CB OF CONVERSION SNEZHINSKIY, LTD.']: 'CB OF CONVERSION SNEZHINSKIY, LTD.',
  ['CB OTKRITIE CJSC']: 'CB OTKRITIE CJSC',
  ['CB PRIVATBANK']: 'CB PRIVATBANK',
  ['CB RENAISSANCE CREDIT (LLC)']: 'CB RENAISSANCE CREDIT (LLC)',
  ['CBH - COMPAGNIE BANCAIRE HELVETIQUE, S.A.']: 'CBH - COMPAGNIE BANCAIRE HELVETIQUE, S.A.',
  ['CBW BANK']: 'CBW BANK',
  ['CCB BRASIL']: 'CCB BRASIL',
  ['CDT SOLUCOES EM MEIOS PAGAMENTO LTDA']: 'CDT SOLUCOES EM MEIOS PAGAMENTO LTDA',
  ['CEC BANK S.A.']: 'CEC BANK S.A.',
  ['CECILIAN BANK']: 'CECILIAN BANK',
  ['CELTIC BANK CORPORATION']: 'CELTIC BANK CORPORATION',
  ['CEMBRA MONEY BANK AG']: 'CEMBRA MONEY BANK AG',
  ['CENCOSUD S.A.']: 'CENCOSUD S.A.',
  ['CENTENNIAL BANK']: 'CENTENNIAL BANK',
  ['CENTER BANK']: 'CENTER BANK',
  ['CENTER NATIONAL BANK']: 'CENTER NATIONAL BANK',
  ['CENTERSTATE BANK']: 'CENTERSTATE BANK',
  ['CENTERSTATE BANK, N.A.']: 'CENTERSTATE BANK, N.A.',
  ['CENTRA C.U.']: 'CENTRA C.U.',
  ['CENTRA CREDIT UNION']: 'CENTRA CREDIT UNION',
  ['CENTRAL BANK']: 'CENTRAL BANK',
  ['CENTRAL BANK AND TRUST CO.']: 'CENTRAL BANK AND TRUST CO.',
  ['CENTRAL BANK OF INDIA']: 'CENTRAL BANK OF INDIA',
  ['CENTRAL BANK OF KANSAS CITY']: 'CENTRAL BANK OF KANSAS CITY',
  ['CENTRAL COOPERATIVE BANK AD SKOPJE']: 'CENTRAL COOPERATIVE BANK AD SKOPJE',
  ['CENTRAL COOPERATIVE BANK PLC']: 'CENTRAL COOPERATIVE BANK PLC',
  ['CENTRAL CREDIT UNION OF MARYLAND']: 'CENTRAL CREDIT UNION OF MARYLAND',
  ['CENTRAL ILLINOIS BANK']: 'CENTRAL ILLINOIS BANK',
  ['CENTRAL MAINE F.C.U.']: 'CENTRAL MAINE F.C.U.',
  ['CENTRAL NATIONAL BANK']: 'CENTRAL NATIONAL BANK',
  ['CENTRAL ONE F.C.U.']: 'CENTRAL ONE F.C.U.',
  ['CENTRAL PACIFIC BANK']: 'CENTRAL PACIFIC BANK',
  ['CENTRAL SOYA F.C.U.']: 'CENTRAL SOYA F.C.U.',
  ['CENTRAL STATE BANK']: 'CENTRAL STATE BANK',
  ['CENTRAL SUNBELT F.C.U.']: 'CENTRAL SUNBELT F.C.U.',
  ['CENTRAL TRUST BANK']: 'CENTRAL TRUST BANK',
  ['CENTRAL TRUST BANK, THE']: 'CENTRAL TRUST BANK, THE',
  ['CENTRAL VALLEY COMMUNITY BANK']: 'CENTRAL VALLEY COMMUNITY BANK',
  ['CENTRAL VIRGINIA F.C.U.']: 'CENTRAL VIRGINIA F.C.U.',
  ['CENTRAL-EUROPEAN INTERNATIONAL BANK (CIB BANK) RT.']: 'CENTRAL-EUROPEAN INTERNATIONAL BANK (CIB BANK) RT.',
  ["CENTRE NATIONAL DES CAISSES D'EPARGNE ET DE PREVOYANCE"]: "CENTRE NATIONAL DES CAISSES D'EPARGNE ET DE PREVOYANCE",
  ['CENTRIC F.C.U.']: 'CENTRIC F.C.U.',
  ['CENTRIS F.C.U.']: 'CENTRIS F.C.U.',
  ['CENTURY BANK']: 'CENTURY BANK',
  ['CENTURY BANK, A FEDERAL SAVINGS BANK']: 'CENTURY BANK, A FEDERAL SAVINGS BANK',
  ['CENTURY C.U.']: 'CENTURY C.U.',
  ['CENTURY NATIONAL BANK']: 'CENTURY NATIONAL BANK',
  ['CENTURY NEXT']: 'CENTURY NEXT',
  ['CERTEGY EZI-PAY PTY LTD']: 'CERTEGY EZI-PAY PTY LTD',
  ['CERTIFIED F.C.U.']: 'CERTIFIED F.C.U.',
  ['CESKA SPORITELNA, A.S.']: 'CESKA SPORITELNA, A.S.',
  ['CESKOSLOVENSKA OBCHODNA BANKA A.S.']: 'CESKOSLOVENSKA OBCHODNA BANKA A.S.',
  ['CFC STANBIC BANK LTD']: 'CFC STANBIC BANK LTD',
  ['CFCU COMMUNITY CREDIT UNION']: 'CFCU COMMUNITY CREDIT UNION',
  ['CFS-ZIPP LIMITED']: 'CFS-ZIPP LIMITED',
  ['CHACO CREDIT UNION, INC.']: 'CHACO CREDIT UNION, INC.',
  ['CHAMPAIGN NATIONAL BANK & TRUST']: 'CHAMPAIGN NATIONAL BANK & TRUST',
  ['CHAMPION CREDIT UNION, INC.']: 'CHAMPION CREDIT UNION, INC.',
  ['CHANG HWA COMMERCIAL BANK LTD.']: 'CHANG HWA COMMERCIAL BANK LTD.',
  ['CHARLEVOIX STATE BANK']: 'CHARLEVOIX STATE BANK',
  ['CHARLOTTE METRO F.C.U.']: 'CHARLOTTE METRO F.C.U.',
  ['CHARLOTTE STATE BANK & TRUST']: 'CHARLOTTE STATE BANK & TRUST',
  ['CHARTER OAK F.C.U.']: 'CHARTER OAK F.C.U.',
  ['CHARTWAY F.C.U.']: 'CHARTWAY F.C.U.',
  ['CHARTWAY FEDERAL CREDIT UNION']: 'CHARTWAY FEDERAL CREDIT UNION',
  ['CHASE BANK KENYA, LTD.']: 'CHASE BANK KENYA, LTD.',
  ['CHASE BANK USA, N.A.']: 'CHASE BANK USA, N.A.',
  ['CHASE MANHATTAN BANK']: 'CHASE MANHATTAN BANK',
  ['CHEBANCA! SPA']: 'CHEBANCA! SPA',
  ['CHECKOUT LTD']: 'CHECKOUT LTD',
  ['CHELINDBANK']: 'CHELINDBANK',
  ['CHELYABINSK JOINT STOCK INVESTMENT BANK CHELYABINVESTBANK']:
    'CHELYABINSK JOINT STOCK INVESTMENT BANK CHELYABINVESTBANK',
  ['CHEMICAL BANK']: 'CHEMICAL BANK',
  ['CHEMICAL BANK,A DIVISION OF TCF NB']: 'CHEMICAL BANK,A DIVISION OF TCF NB',
  ['CHEMUNG CANAL TRUST COMPANY']: 'CHEMUNG CANAL TRUST COMPANY',
  ['CHESTERFIELD F.C.U.']: 'CHESTERFIELD F.C.U.',
  ['CHETCO F.C.U.']: 'CHETCO F.C.U.',
  ['CHETWOOD FINANCIAL LIMITED']: 'CHETWOOD FINANCIAL LIMITED',
  ['CHEVRON F.C.U.']: 'CHEVRON F.C.U.',
  ['CHEVRON FEDERAL CREDIT UNION']: 'CHEVRON FEDERAL CREDIT UNION',
  ['CHEYENNE-LARAMIE COUNTY EMPLOYEES F.C.U.']: 'CHEYENNE-LARAMIE COUNTY EMPLOYEES F.C.U.',
  ['CHICAGO MUNICIPAL EMPLOYEES C.U.']: 'CHICAGO MUNICIPAL EMPLOYEES C.U.',
  ['CHIEF FINANCIAL FEDERAL CREDIT UNION']: 'CHIEF FINANCIAL FEDERAL CREDIT UNION',
  ['CHIKUHO BANK, LTD.']: 'CHIKUHO BANK, LTD.',
  ['CHINA BANKING CORPORATION']: 'CHINA BANKING CORPORATION',
  ['CHINA CITIC BANK']: 'CHINA CITIC BANK',
  ['CHINA CONSTRUCTION BANK']: 'CHINA CONSTRUCTION BANK',
  ['CHINA EVERBRIGHT BANK']: 'CHINA EVERBRIGHT BANK',
  ['CHINA GUANGFA BANK CO., LTD']: 'CHINA GUANGFA BANK CO., LTD',
  ['CHINA MERCHANTS BANK']: 'CHINA MERCHANTS BANK',
  ['CHINA MINSHENG BANKING CORP., LTD.']: 'CHINA MINSHENG BANKING CORP., LTD.',
  ['CHINA YINSHENG FINANCE (HOLDING) LIMITED']: 'CHINA YINSHENG FINANCE (HOLDING) LIMITED',
  ['CHINATRUST COMMERCIAL BANK']: 'CHINATRUST COMMERCIAL BANK',
  ['CHOICE BANK, LTD.']: 'CHOICE BANK, LTD.',
  ['CHOICE FINANCIAL GROUP']: 'CHOICE FINANCIAL GROUP',
  ['CHOICE ONE COMMUNITY F.C.U.']: 'CHOICE ONE COMMUNITY F.C.U.',
  ['CHONG HING BANK LIMITED']: 'CHONG HING BANK LIMITED',
  ['CHRISTIAN FINANCIAL C.U.']: 'CHRISTIAN FINANCIAL C.U.',
  ['CHROME F.C.U.']: 'CHROME F.C.U.',
  ['CHUGOKU SHINKIN CARD CO., LTD.']: 'CHUGOKU SHINKIN CARD CO., LTD.',
  ['CHUNG-SHING BANK']: 'CHUNG-SHING BANK',
  ['CI BANCO, S.A.']: 'CI BANCO, S.A.',
  ['CIAGROUP']: 'CIAGROUP',
  ['CIBC']: 'CIBC',
  ['CIBC BANK']: 'CIBC BANK',
  ['CIBC BANK USA']: 'CIBC BANK USA',
  ['CIMB BANK BERHAD']: 'CIMB BANK BERHAD',
  ['CINCINNATI INTERAGENCY F.C.U.']: 'CINCINNATI INTERAGENCY F.C.U.',
  ['CINCINNATI POLICE F.C.U.']: 'CINCINNATI POLICE F.C.U.',
  ['CINFED F.C.U.']: 'CINFED F.C.U.',
  ['CINFED FEDERAL CREDIT UNION']: 'CINFED FEDERAL CREDIT UNION',
  ['CIT BANK']: 'CIT BANK',
  ['CITADEL FEDERAL CREDIT UNION']: 'CITADEL FEDERAL CREDIT UNION',
  ['CITI CARDS JAPAN, INC.']: 'CITI CARDS JAPAN, INC.',
  ['CITI HANDLOWY BANK']: 'CITI HANDLOWY BANK',
  ['CITIBANK']: 'CITIBANK',
  ['CITIBANK (CHINA) CO., LTD']: 'CITIBANK (CHINA) CO., LTD',
  ['CITIBANK (HONG KONG) LIMITED']: 'CITIBANK (HONG KONG) LIMITED',
  ['CITIBANK (SOUTH DAKOTA)']: 'CITIBANK (SOUTH DAKOTA)',
  ['CITIBANK A.S.']: 'CITIBANK A.S.',
  ['CITIBANK BERHAD']: 'CITIBANK BERHAD',
  ['CITIBANK CANADA']: 'CITIBANK CANADA',
  ['CITIBANK DEL PERU, S.A.']: 'CITIBANK DEL PERU, S.A.',
  ['CITIBANK EUROPE PLC']: 'CITIBANK EUROPE PLC',
  ['CITIBANK EUROPE PUBLIC LIMITED COMPANY']: 'CITIBANK EUROPE PUBLIC LIMITED COMPANY',
  ['CITIBANK INTERNATIONAL PLC']: 'CITIBANK INTERNATIONAL PLC',
  ['CITIBANK KOREA INC.']: 'CITIBANK KOREA INC.',
  ['CITIBANK N.A.']: 'CITIBANK N.A.',
  ['CITIBANK N.A., SINGAPORE BRANCH']: 'CITIBANK N.A., SINGAPORE BRANCH',
  ['CITIBANK NA KENYA']: 'CITIBANK NA KENYA',
  ['CITIBANK NIGERIA, LTD.']: 'CITIBANK NIGERIA, LTD.',
  ['CITIBANK SINGAPORE LIMITED']: 'CITIBANK SINGAPORE LIMITED',
  ['CITIBANK SINGAPORE, LTD.']: 'CITIBANK SINGAPORE, LTD.',
  ['CITIBANK TAIWAN LTD.']: 'CITIBANK TAIWAN LTD.',
  ['CITIBANK TAIWAN, LTD.']: 'CITIBANK TAIWAN, LTD.',
  ['CITIBANK, N.A. SOUTH AFRICA']: 'CITIBANK, N.A. SOUTH AFRICA',
  ['CITIBANK, N.A., PHILIPPINES']: 'CITIBANK, N.A., PHILIPPINES',
  ['CITIC BANK INTERNATIONAL, LTD.']: 'CITIC BANK INTERNATIONAL, LTD.',
  ['CITIGROUP PTY LIMITED']: 'CITIGROUP PTY LIMITED',
  ['CITIZENS AND NORTHERN BANK']: 'CITIZENS AND NORTHERN BANK',
  ['CITIZENS BANK']: 'CITIZENS BANK',
  ['CITIZENS BANK & TRUST COMPANY']: 'CITIZENS BANK & TRUST COMPANY',
  ['CITIZENS BANK OF BLOUNT COUNTY']: 'CITIZENS BANK OF BLOUNT COUNTY',
  ['CITIZENS BANK OF CANADA']: 'CITIZENS BANK OF CANADA',
  ['CITIZENS BANK OF CUMBERLAND COUNTY INC.']: 'CITIZENS BANK OF CUMBERLAND COUNTY INC.',
  ['CITIZENS BANK OF EDINBURG']: 'CITIZENS BANK OF EDINBURG',
  ['CITIZENS BANK OF EDMOND']: 'CITIZENS BANK OF EDMOND',
  ['CITIZENS BANK OF MASSACHUSETTS']: 'CITIZENS BANK OF MASSACHUSETTS',
  ['CITIZENS BANK OF MUKWONAGO']: 'CITIZENS BANK OF MUKWONAGO',
  ['CITIZENS BANK OF PHILADELPHIA, MISS.']: 'CITIZENS BANK OF PHILADELPHIA, MISS.',
  ['CITIZENS BANK OF RHODE ISLAND']: 'CITIZENS BANK OF RHODE ISLAND',
  ['CITIZENS BANK OF WASHINGTON COUNTY']: 'CITIZENS BANK OF WASHINGTON COUNTY',
  ['CITIZENS BUSINESS BANK']: 'CITIZENS BUSINESS BANK',
  ['CITIZENS COMMERCE NATIONAL BANK']: 'CITIZENS COMMERCE NATIONAL BANK',
  ['CITIZENS COMMUNITY C.U.']: 'CITIZENS COMMUNITY C.U.',
  ['CITIZENS COMMUNITY FEDERAL']: 'CITIZENS COMMUNITY FEDERAL',
  ['CITIZENS DEPOSIT BANK OF ARLINGTON, INC.']: 'CITIZENS DEPOSIT BANK OF ARLINGTON, INC.',
  ['CITIZENS EQUITY FIRST C.U.']: 'CITIZENS EQUITY FIRST C.U.',
  ['CITIZENS EQUITY FIRST CREDIT UNION']: 'CITIZENS EQUITY FIRST CREDIT UNION',
  ['CITIZENS GUARANTY BANK']: 'CITIZENS GUARANTY BANK',
  ['CITIZENS INDEPENDENT BANK']: 'CITIZENS INDEPENDENT BANK',
  ['CITIZENS NATIONAL BANK']: 'CITIZENS NATIONAL BANK',
  ['CITIZENS NATIONAL BANK OF BLUFFTON']: 'CITIZENS NATIONAL BANK OF BLUFFTON',
  ['CITIZENS NATIONAL BANK OF SOMERSET']: 'CITIZENS NATIONAL BANK OF SOMERSET',
  ['CITIZENS NATIONAL BANK OF TEXAS']: 'CITIZENS NATIONAL BANK OF TEXAS',
  ['CITIZENS SAVINGS BANK AND TRUST COMPANY']: 'CITIZENS SAVINGS BANK AND TRUST COMPANY',
  ['CITIZENS STATE BANK']: 'CITIZENS STATE BANK',
  ['CITIZENS STATE BANK OF NEW CASTLE, INDIANA']: 'CITIZENS STATE BANK OF NEW CASTLE, INDIANA',
  ['CITIZENS TRUST BANK']: 'CITIZENS TRUST BANK',
  ['CITIZENS UNION BANK OF SHELBYVILLE']: 'CITIZENS UNION BANK OF SHELBYVILLE',
  ['CITY & COUNTY CREDIT UNION']: 'CITY & COUNTY CREDIT UNION',
  ['CITY BANK']: 'CITY BANK',
  ['CITY BANK AND TRUST COMPANY']: 'CITY BANK AND TRUST COMPANY',
  ['CITY FIRST BANK OF D.C., N.A.']: 'CITY FIRST BANK OF D.C., N.A.',
  ['CITY NATIONAL BANK']: 'CITY NATIONAL BANK',
  ['CITY NATIONAL BANK OF FLORIDA']: 'CITY NATIONAL BANK OF FLORIDA',
  ['CITY NATIONAL BANK OF NEW JERSEY']: 'CITY NATIONAL BANK OF NEW JERSEY',
  ['CITY NATIONAL BANK OF SULPHUR SPRINGS']: 'CITY NATIONAL BANK OF SULPHUR SPRINGS',
  ['CITY NATIONAL BANK OF TAYLOR']: 'CITY NATIONAL BANK OF TAYLOR',
  ['CITY NATIONAL BANK OF WEST VIRGINIA']: 'CITY NATIONAL BANK OF WEST VIRGINIA',
  ['CITY STATE BANK']: 'CITY STATE BANK',
  ['CITY UNION BANK LTD.']: 'CITY UNION BANK LTD.',
  ['CITYWIDE BANKS']: 'CITYWIDE BANKS',
  ['CIVISTA BANK']: 'CIVISTA BANK',
  ['CJSC AKTSENT BANK']: 'CJSC AKTSENT BANK',
  ['CJSC ALFA-BANK']: 'CJSC ALFA-BANK',
  ['CJSC BINBANK']: 'CJSC BINBANK',
  ['CJSC CITIBANK KAZAKHSTAN']: 'CJSC CITIBANK KAZAKHSTAN',
  ['CJSC COMMERCIAL BANK CITIBANK']: 'CJSC COMMERCIAL BANK CITIBANK',
  ['CJSC CREDEXBANK']: 'CJSC CREDEXBANK',
  ['CJSC CREDIT EUROPE BANK']: 'CJSC CREDIT EUROPE BANK',
  ['CJSC KYRGYZ INVESTMENT AND CREDIT BANK']: 'CJSC KYRGYZ INVESTMENT AND CREDIT BANK',
  ['CJSC OTP BANK']: 'CJSC OTP BANK',
  ['CJSC UNICREDIT BANK']: 'CJSC UNICREDIT BANK',
  ['CJSC VTB BANK (BELARUS)']: 'CJSC VTB BANK (BELARUS)',
  ['CJSCOMPANY BANK RESERVE FINANCE AND INVESTMENTS']: 'CJSCOMPANY BANK RESERVE FINANCE AND INVESTMENTS',
  ['CLACKAMAS COUNTY BANK']: 'CLACKAMAS COUNTY BANK',
  ['CLAREMONT SAVINGS BANK']: 'CLAREMONT SAVINGS BANK',
  ['CLARK COUNTY C.U.']: 'CLARK COUNTY C.U.',
  ['CLEAR MOUNTAIN BANK']: 'CLEAR MOUNTAIN BANK',
  ['CLEARPATH F.C.U.']: 'CLEARPATH F.C.U.',
  ['CLEARVIEW F.C.U.']: 'CLEARVIEW F.C.U.',
  ['CLEVELAND STATE BANK']: 'CLEVELAND STATE BANK',
  ['CLINTON BANK']: 'CLINTON BANK',
  ['CLOSED JOINT STOCK COMPANY ALFA-BANK']: 'CLOSED JOINT STOCK COMPANY ALFA-BANK',
  ['CLYDESDALE BANK PLC.']: 'CLYDESDALE BANK PLC.',
  ['CMB WING LUNG BANK LIMITED']: 'CMB WING LUNG BANK LIMITED',
  ['CME F.C.U.']: 'CME F.C.U.',
  ['CNB BANK']: 'CNB BANK',
  ['CO-OP CREDIT UNION']: 'CO-OP CREDIT UNION',
  ['CO-OPERATIVE BANK LIMITED']: 'CO-OPERATIVE BANK LIMITED',
  ['CO-OPERATIVE BANK OF KENYA, LTD.']: 'CO-OPERATIVE BANK OF KENYA, LTD.',
  ['CO-OPERATIVE CENTRAL BANK, LTD.']: 'CO-OPERATIVE CENTRAL BANK, LTD.',
  ['COAST CENTRAL C.U.']: 'COAST CENTRAL C.U.',
  ['COAST HILLS F.C.U.']: 'COAST HILLS F.C.U.',
  ['COASTAL COMMUNITY BANK']: 'COASTAL COMMUNITY BANK',
  ['COASTAL COMMUNITY F.C.U.']: 'COASTAL COMMUNITY F.C.U.',
  ['COASTAL F.C.U.']: 'COASTAL F.C.U.',
  ['COASTAL FEDERAL BANK']: 'COASTAL FEDERAL BANK',
  ['COASTHILLS F.C.U.']: 'COASTHILLS F.C.U.',
  ['COASTLINE F.C.U.']: 'COASTLINE F.C.U.',
  ['COBALT C.U.']: 'COBALT C.U.',
  ['COLASDATOS']: 'COLASDATOS',
  ['COLEMAN COUNTY STATE BANK']: 'COLEMAN COUNTY STATE BANK',
  ['COLLABRIA FINANCIAL SERVICES']: 'COLLABRIA FINANCIAL SERVICES',
  ['COLLINS COMMUNITY C.U.']: 'COLLINS COMMUNITY C.U.',
  ['COLONIAL FEDERAL SAVINGS BANK']: 'COLONIAL FEDERAL SAVINGS BANK',
  ['COLORADO C.U.']: 'COLORADO C.U.',
  ['COLORADO SPRINGS CREDIT UNION']: 'COLORADO SPRINGS CREDIT UNION',
  ['COLUMBIA BANK']: 'COLUMBIA BANK',
  ['COLUMBIA C.U.']: 'COLUMBIA C.U.',
  ['COLUMBIA COMMUNITY C.U.']: 'COLUMBIA COMMUNITY C.U.',
  ['COLUMBIA STATE BANK']: 'COLUMBIA STATE BANK',
  ['COLUMBUS BANK AND TRUST']: 'COLUMBUS BANK AND TRUST',
  ['COMENITY BANK']: 'COMENITY BANK',
  ['COMENITY CAPITAL BANK']: 'COMENITY CAPITAL BANK',
  ['COMERICA BANK']: 'COMERICA BANK',
  ['COMERICA BANK-MIDWEST']: 'COMERICA BANK-MIDWEST',
  ['COMMERCE BANCSHARES, INC.']: 'COMMERCE BANCSHARES, INC.',
  ['COMMERCE BANK']: 'COMMERCE BANK',
  ['COMMERCIAL AND SAVINGS BANK OF MILLERSBURG, OHIO']: 'COMMERCIAL AND SAVINGS BANK OF MILLERSBURG, OHIO',
  ['COMMERCIAL BANK']: 'COMMERCIAL BANK',
  ['COMMERCIAL BANK & TRUST CO.']: 'COMMERCIAL BANK & TRUST CO.',
  ['COMMERCIAL BANK OF AFRICA']: 'COMMERCIAL BANK OF AFRICA',
  ['COMMERCIAL BANK OF CEYLON PLC']: 'COMMERCIAL BANK OF CEYLON PLC',
  ['COMMERCIAL BANK OF DUBAI']: 'COMMERCIAL BANK OF DUBAI',
  ['COMMERCIAL BANK OF DUBAI, LTD.']: 'COMMERCIAL BANK OF DUBAI, LTD.',
  ['COMMERCIAL BANK OF GREECE']: 'COMMERCIAL BANK OF GREECE',
  ['COMMERCIAL BANK OF KUWAIT S.A.K., THE']: 'COMMERCIAL BANK OF KUWAIT S.A.K., THE',
  ['COMMERCIAL BANK OF QATAR Q.S.C']: 'COMMERCIAL BANK OF QATAR Q.S.C',
  ['COMMERCIAL BANK OF ZIMBABWE, LTD.']: 'COMMERCIAL BANK OF ZIMBABWE, LTD.',
  ['COMMERCIAL BANK PRIVATBANK']: 'COMMERCIAL BANK PRIVATBANK',
  ['COMMERCIAL BANK RENAISSANCE CREDIT (LIMITED LIABILITY COMPANY)']:
    'COMMERCIAL BANK RENAISSANCE CREDIT (LIMITED LIABILITY COMPANY)',
  ['COMMERCIAL BANKING COMPANY']: 'COMMERCIAL BANKING COMPANY',
  ['COMMERCIAL INTERNATIONAL BANK']: 'COMMERCIAL INTERNATIONAL BANK',
  ['COMMERCIAL INTERNATIONAL BANK (EGYPT) S.A.E.']: 'COMMERCIAL INTERNATIONAL BANK (EGYPT) S.A.E.',
  ['COMMERCIAL STATE BANK, OF WAGNER']: 'COMMERCIAL STATE BANK, OF WAGNER',
  ['COMMERCIAL TRUST CO']: 'COMMERCIAL TRUST CO',
  ['COMMERZBANK AG']: 'COMMERZBANK AG',
  ['COMMERZBANK AKTIENGESELLSCHAFT PRAGUE BRANCH']: 'COMMERZBANK AKTIENGESELLSCHAFT PRAGUE BRANCH',
  ['COMMONWEALTH BANK AND TRUST COMPANY']: 'COMMONWEALTH BANK AND TRUST COMPANY',
  ['COMMONWEALTH BANK OF AUSTRALIA']: 'COMMONWEALTH BANK OF AUSTRALIA',
  ['COMMONWEALTH C.U.']: 'COMMONWEALTH C.U.',
  ['COMMONWEALTH ONE F.C.U.']: 'COMMONWEALTH ONE F.C.U.',
  ['COMMUNICATION F.C.U.']: 'COMMUNICATION F.C.U.',
  ['COMMUNITY 1ST C.U.']: 'COMMUNITY 1ST C.U.',
  ['COMMUNITY AMERICA C.U.']: 'COMMUNITY AMERICA C.U.',
  ['COMMUNITY BANK']: 'COMMUNITY BANK',
  ['COMMUNITY BANK AND TRUST']: 'COMMUNITY BANK AND TRUST',
  ['COMMUNITY BANK AND TRUST - ALABAMA']: 'COMMUNITY BANK AND TRUST - ALABAMA',
  ['COMMUNITY BANK AND TRUST, WACO, TEXAS']: 'COMMUNITY BANK AND TRUST, WACO, TEXAS',
  ['COMMUNITY BANK OF ELMHURST']: 'COMMUNITY BANK OF ELMHURST',
  ['COMMUNITY BANK OF MISSISSIPPI']: 'COMMUNITY BANK OF MISSISSIPPI',
  ['COMMUNITY BANK OF PARKERSBURG']: 'COMMUNITY BANK OF PARKERSBURG',
  ['COMMUNITY BANK OF RAYMORE']: 'COMMUNITY BANK OF RAYMORE',
  ['COMMUNITY BANK, N.A.']: 'COMMUNITY BANK, N.A.',
  ['COMMUNITY C.U.']: 'COMMUNITY C.U.',
  ['COMMUNITY C.U. OF LYNN']: 'COMMUNITY C.U. OF LYNN',
  ['COMMUNITY CHOICE C.U.']: 'COMMUNITY CHOICE C.U.',
  ['COMMUNITY EDUCATORSCREDIT UNION OF BREVARD']: 'COMMUNITY EDUCATORSCREDIT UNION OF BREVARD',
  ['COMMUNITY FEDERAL SAVINGS BANK']: 'COMMUNITY FEDERAL SAVINGS BANK',
  ['COMMUNITY FINANCIAL CREDIT UNION']: 'COMMUNITY FINANCIAL CREDIT UNION',
  ['COMMUNITY FINANCIAL F.C.U.']: 'COMMUNITY FINANCIAL F.C.U.',
  ['COMMUNITY FINANCIAL MEMBERS F.C.U.']: 'COMMUNITY FINANCIAL MEMBERS F.C.U.',
  ['COMMUNITY FINANCIAL SERVICES F.C.U.']: 'COMMUNITY FINANCIAL SERVICES F.C.U.',
  ['COMMUNITY FIRST BANK']: 'COMMUNITY FIRST BANK',
  ['COMMUNITY FIRST CREDIT UNION']: 'COMMUNITY FIRST CREDIT UNION',
  ['COMMUNITY FIRST CREDIT UNION OF FLORIDA']: 'COMMUNITY FIRST CREDIT UNION OF FLORIDA',
  ['COMMUNITY LINK F.C.U.']: 'COMMUNITY LINK F.C.U.',
  ['COMMUNITY NATIONAL BANK']: 'COMMUNITY NATIONAL BANK',
  ['COMMUNITY NATIONAL BANK & TRUST OF TEXAS']: 'COMMUNITY NATIONAL BANK & TRUST OF TEXAS',
  ['COMMUNITY NATIONAL BANK AND TRUST']: 'COMMUNITY NATIONAL BANK AND TRUST',
  ['COMMUNITY ONE CREDIT UNION OF OHIO']: 'COMMUNITY ONE CREDIT UNION OF OHIO',
  ['COMMUNITY PLUS F.C.U.']: 'COMMUNITY PLUS F.C.U.',
  ['COMMUNITY RESOURCE BANK, N.A.']: 'COMMUNITY RESOURCE BANK, N.A.',
  ['COMMUNITY STATE BANK']: 'COMMUNITY STATE BANK',
  ['COMMUNITY TRUST BANK']: 'COMMUNITY TRUST BANK',
  ['COMMUNITY TRUST BANK INC.']: 'COMMUNITY TRUST BANK INC.',
  ['COMMUNITY TRUST BANK, INC.']: 'COMMUNITY TRUST BANK, INC.',
  ['COMMUNITY TRUST CREDIT UNION']: 'COMMUNITY TRUST CREDIT UNION',
  ['COMMUNITY WEST C.U.']: 'COMMUNITY WEST C.U.',
  ['COMMUNITY WEST CREDIT UNION']: 'COMMUNITY WEST CREDIT UNION',
  ['COMPANIA DE FINANCIAMIENTO TUYA S.A.']: 'COMPANIA DE FINANCIAMIENTO TUYA S.A.',
  ['COMPASS BANK']: 'COMPASS BANK',
  ['COMPUTER SERVICES, INC.']: 'COMPUTER SERVICES, INC.',
  ['CONCORDIA BANK AND TRUST COMPANY']: 'CONCORDIA BANK AND TRUST COMPANY',
  ['CONFIDENCE CORRETORA DE CAMBIO, S.A.']: 'CONFIDENCE CORRETORA DE CAMBIO, S.A.',
  ['CONISTER BANK, LTD.']: 'CONISTER BANK, LTD.',
  ['CONNECTED C.U.']: 'CONNECTED C.U.',
  ['CONNECTION BANK']: 'CONNECTION BANK',
  ['CONNECTONE BANK']: 'CONNECTONE BANK',
  ['CONNEXUS C.U.']: 'CONNEXUS C.U.',
  ["CONSERVATION EMPLOYEES' C.U."]: "CONSERVATION EMPLOYEES' C.U.",
  ['CONSOL EMPLOYEES C.U.']: 'CONSOL EMPLOYEES C.U.',
  ['CONSOLIDATED BANK GHANA LIMITED']: 'CONSOLIDATED BANK GHANA LIMITED',
  ['CONSOLIDATED F.C.U.']: 'CONSOLIDATED F.C.U.',
  ['CONSUMERS C.U.']: 'CONSUMERS C.U.',
  ['CONSUMERS NATIONAL BANK']: 'CONSUMERS NATIONAL BANK',
  ['CONSUMERS PROFESSIONAL C.U.']: 'CONSUMERS PROFESSIONAL C.U.',
  ['CONTIS FINANCIAL']: 'CONTIS FINANCIAL',
  ['CONWAY NATIONAL BANK']: 'CONWAY NATIONAL BANK',
  ['COOP PANK AS']: 'COOP PANK AS',
  ['COOPERATIEVE RABOBANK U.A.']: 'COOPERATIEVE RABOBANK U.A.',
  ['COOPERATIVA DE AHORRO Y CREDITO COOPROGRESO LTDA']: 'COOPERATIVA DE AHORRO Y CREDITO COOPROGRESO LTDA',
  ['COOPERATIVA DE AHORRO Y CREDITO OSCUS LTDA']: 'COOPERATIVA DE AHORRO Y CREDITO OSCUS LTDA',
  ['COOPERATIVA DE TRABAJO LA ALDEA LTDA']: 'COOPERATIVA DE TRABAJO LA ALDEA LTDA',
  ['COOPERATIVA NACIONAL DE EDUCADORES, R.L.(COOPENAE RL)']: 'COOPERATIVA NACIONAL DE EDUCADORES, R.L.(COOPENAE RL)',
  ['COOSA VALLEY C.U.']: 'COOSA VALLEY C.U.',
  ['COPOCO COMMUNITY C.U.']: 'COPOCO COMMUNITY C.U.',
  ['COPPER STATE CREDIT UNION']: 'COPPER STATE CREDIT UNION',
  ['CORE BANK']: 'CORE BANK',
  ['COREFIRST BANK & TRUST']: 'COREFIRST BANK & TRUST',
  ['COREPLUS F.C.U.']: 'COREPLUS F.C.U.',
  ['CORNER BANCA S.A.']: 'CORNER BANCA S.A.',
  ['CORNERCARD UK LIMITED']: 'CORNERCARD UK LIMITED',
  ['CORNERSTONE BANK']: 'CORNERSTONE BANK',
  ['CORNERSTONE COMMUNITY F.C.U.']: 'CORNERSTONE COMMUNITY F.C.U.',
  ['CORNERSTONE FINANCIAL C.U.']: 'CORNERSTONE FINANCIAL C.U.',
  ['CORNHUSKER BANK']: 'CORNHUSKER BANK',
  ['CORNING F.C.U.']: 'CORNING F.C.U.',
  ['CORPORATE AMERICA FAMILY C.U.']: 'CORPORATE AMERICA FAMILY C.U.',
  ['CORTRUST BANK NATIONAL ASSOCIATION']: 'CORTRUST BANK NATIONAL ASSOCIATION',
  ['CORTRUST BANK, N.A.']: 'CORTRUST BANK, N.A.',
  ['COUNTRY BANK FOR SAVINGS']: 'COUNTRY BANK FOR SAVINGS',
  ['COUNTY BANK']: 'COUNTY BANK',
  ['COUNTY BANK OF CHESTERFIELD']: 'COUNTY BANK OF CHESTERFIELD',
  ['COUNTY C.U.']: 'COUNTY C.U.',
  ['COUNTY F.C.U.']: 'COUNTY F.C.U.',
  ['COVANTAGE C.U.']: 'COVANTAGE C.U.',
  ['COVANTAGE CREDIT UNION']: 'COVANTAGE CREDIT UNION',
  ['COVENANT HEALTH F.C.U.']: 'COVENANT HEALTH F.C.U.',
  ['CPM F.C.U.']: 'CPM F.C.U.',
  ['CRANE F.C.U']: 'CRANE F.C.U',
  ['CREATION FINANCIAL SERVICES LIMITED']: 'CREATION FINANCIAL SERVICES LIMITED',
  ['CRED-SYSTEM ADMINISTRADORA DE CARTOES DE CREDITO LTDA']: 'CRED-SYSTEM ADMINISTRADORA DE CARTOES DE CREDITO LTDA',
  ['CREDENCIAL PROCESSING S.A.DE']: 'CREDENCIAL PROCESSING S.A.DE',
  ['CREDICARD, S.A.']: 'CREDICARD, S.A.',
  ['CREDICORP BANK, S.A.']: 'CREDICORP BANK, S.A.',
  ['CREDIMAX BSC (CLOSED)']: 'CREDIMAX BSC (CLOSED)',
  ['CREDIT AGRICOLE BANK JSC']: 'CREDIT AGRICOLE BANK JSC',
  ['CREDIT AGRICOLE BANK POLSKA SPOLKA AKCYJNA']: 'CREDIT AGRICOLE BANK POLSKA SPOLKA AKCYJNA',
  ['CREDIT AGRICOLE BANK ROMANIA S.A.']: 'CREDIT AGRICOLE BANK ROMANIA S.A.',
  ['CREDIT AGRICOLE EGYPT S.A.E.']: 'CREDIT AGRICOLE EGYPT S.A.E.',
  ['CREDIT AGRICOLE S.A.']: 'CREDIT AGRICOLE S.A.',
  ['CREDIT ANDORRA S.A.']: 'CREDIT ANDORRA S.A.',
  ['CREDIT BANK OF IRAQ']: 'CREDIT BANK OF IRAQ',
  ['CREDIT BANK OF MOSCOW']: 'CREDIT BANK OF MOSCOW',
  ['CREDIT DU MAROC, S.A.']: 'CREDIT DU MAROC, S.A.',
  ['CREDIT DU NORD']: 'CREDIT DU NORD',
  ['CREDIT EUROPE BANK']: 'CREDIT EUROPE BANK',
  ['CREDIT HUMAN FEDERAL CREDIT UNION']: 'CREDIT HUMAN FEDERAL CREDIT UNION',
  ['CREDIT IMMOBILIER ET. HOTELIER']: 'CREDIT IMMOBILIER ET. HOTELIER',
  ['CREDIT INDUSTRIEL ET COMMERCIAL']: 'CREDIT INDUSTRIEL ET COMMERCIAL',
  ['CREDIT LIBANAIS S.A.L.']: 'CREDIT LIBANAIS S.A.L.',
  ['CREDIT LYONNAIS']: 'CREDIT LYONNAIS',
  ['CREDIT LYONNAIS BANK NEDERLAND, N.V.']: 'CREDIT LYONNAIS BANK NEDERLAND, N.V.',
  ['CREDIT MUTUEL ARKEA']: 'CREDIT MUTUEL ARKEA',
  ['CREDIT ONE BANK, N.A.']: 'CREDIT ONE BANK, N.A.',
  ['CREDIT SAISON CO., LTD.']: 'CREDIT SAISON CO., LTD.',
  ['CREDIT SUISSE ( LUXEMBOURG) S.A.']: 'CREDIT SUISSE ( LUXEMBOURG) S.A.',
  ['CREDIT UNION 1']: 'CREDIT UNION 1',
  ['CREDIT UNION CARD SERVICE']: 'CREDIT UNION CARD SERVICE',
  ['CREDIT UNION OF AMERICA']: 'CREDIT UNION OF AMERICA',
  ['CREDIT UNION OF ATLANTA']: 'CREDIT UNION OF ATLANTA',
  ['CREDIT UNION OF COLORADO']: 'CREDIT UNION OF COLORADO',
  ['CREDIT UNION OF NEW JERSEY']: 'CREDIT UNION OF NEW JERSEY',
  ['CREDIT UNION OF TEXAS']: 'CREDIT UNION OF TEXAS',
  ['CREDIT UNION ONE']: 'CREDIT UNION ONE',
  ['CREDIT UNION PAYMENT CENTER (LIMITED LIABILITY COMPANY)']:
    'CREDIT UNION PAYMENT CENTER (LIMITED LIABILITY COMPANY)',
  ['CREDIT UNION PAYMENT CENTER (RNKO)']: 'CREDIT UNION PAYMENT CENTER (RNKO)',
  ['CREDIT UNION PLUS']: 'CREDIT UNION PLUS',
  ['CREDIT UNION WEST']: 'CREDIT UNION WEST',
  ['CREDIT URAL BANK']: 'CREDIT URAL BANK',
  ['CREDITO EMILIANO S.P.A.']: 'CREDITO EMILIANO S.P.A.',
  ['CREDITO, S.A.']: 'CREDITO, S.A.',
  ['CREDOMATIC DE COSTA RICA S.A.']: 'CREDOMATIC DE COSTA RICA S.A.',
  ['CREDOMATIC DE EL SALVADOR S.A.']: 'CREDOMATIC DE EL SALVADOR S.A.',
  ['CREDOMATIC DE GUATEMALA S.A.']: 'CREDOMATIC DE GUATEMALA S.A.',
  ['CREDOMATIC DE HONDURAS S.A.']: 'CREDOMATIC DE HONDURAS S.A.',
  ['CREDOMATIC DEL ISTMO, S.A.']: 'CREDOMATIC DEL ISTMO, S.A.',
  ['CREDOMATIC LATINO AMERICANA']: 'CREDOMATIC LATINO AMERICANA',
  ['CREFISA SA CREDITO FINANCIAMENTO E INVESTIMENTOS']: 'CREFISA SA CREDITO FINANCIAMENTO E INVESTIMENTOS',
  ['CREIGHTON F.C.U.']: 'CREIGHTON F.C.U.',
  ['CREWS BANK & TRUST']: 'CREWS BANK & TRUST',
  ['CRNOGORSKA KOMERCIJALNA BANKA A.D., PODGORICA']: 'CRNOGORSKA KOMERCIJALNA BANKA A.D., PODGORICA',
  ['CROSS KEYS BANK']: 'CROSS KEYS BANK',
  ['CROSS RIVER BANK']: 'CROSS RIVER BANK',
  ['CROSSFIRST BANK']: 'CROSSFIRST BANK',
  ['CROSSROADS BANK']: 'CROSSROADS BANK',
  ['CSCBANK S.A.L.']: 'CSCBANK S.A.L.',
  ['CTBC BANK CO., LTD.']: 'CTBC BANK CO., LTD.',
  ['CTRIP FINANCIAL PAYMENT (HONG KONG) CO., LIMITED']: 'CTRIP FINANCIAL PAYMENT (HONG KONG) CO., LIMITED',
  ['CU COOPERATIVE SYSTEMS']: 'CU COOPERATIVE SYSTEMS',
  ['CUMBERLAND COUNTY F.C.U.']: 'CUMBERLAND COUNTY F.C.U.',
  ['CUMBERLAND SECURITY BANK, INC.']: 'CUMBERLAND SECURITY BANK, INC.',
  ['CURRENSEA LTD']: 'CURRENSEA LTD',
  ['CURVE OS LIMITED']: 'CURVE OS LIMITED',
  ['CUSB BANK']: 'CUSB BANK',
  ['CUSCAL LIMITED']: 'CUSCAL LIMITED',
  ['CUSTOMERS BANK']: 'CUSTOMERS BANK',
  ['CY-FAIR FEDERAL CREDIT UNION']: 'CY-FAIR FEDERAL CREDIT UNION',
  ['DACOTAH BANK']: 'DACOTAH BANK',
  ['DADE COUNTY F.C.U.']: 'DADE COUNTY F.C.U.',
  ['DAH SING BANK LTD.']: 'DAH SING BANK LTD.',
  ['DAKOTA PRAIRIE BANK']: 'DAKOTA PRAIRIE BANK',
  ['DANE COUNTY CREDIT UNION']: 'DANE COUNTY CREDIT UNION',
  ['DANSKE BANK  A/S']: 'DANSKE BANK  A/S',
  ['DANSKE BANK AKTIESELSKAB DENM']: 'DANSKE BANK AKTIESELSKAB DENM',
  ['DANSKE BANK AKTIESELSKAB, DENMARK, SWEDEN BRANCH']: 'DANSKE BANK AKTIESELSKAB, DENMARK, SWEDEN BRANCH',
  ['DANSKE BANK OYJ']: 'DANSKE BANK OYJ',
  ['DARDEN EMPLOYEES F.C.U.']: 'DARDEN EMPLOYEES F.C.U.',
  ['DATA CENTER INCORPORATED']: 'DATA CENTER INCORPORATED',
  ['DATCU CREDIT UNION']: 'DATCU CREDIT UNION',
  ['DBS BANK (HONG KONG) LIMITED']: 'DBS BANK (HONG KONG) LIMITED',
  ['DBS BANK (TAIWAN) LTD.']: 'DBS BANK (TAIWAN) LTD.',
  ['DBS BANK LTD']: 'DBS BANK LTD',
  ['DE VOLKSBANK N.V.']: 'DE VOLKSBANK N.V.',
  ['DECATUR COUNTY BANK']: 'DECATUR COUNTY BANK',
  ['DECATUR EARTHMOVER C.U.']: 'DECATUR EARTHMOVER C.U.',
  ['DECTA LIMITED']: 'DECTA LIMITED',
  ['DEEM FINANCE L.L.C.']: 'DEEM FINANCE L.L.C.',
  ['DEEPWATER INDUSTRIES F.C.U.']: 'DEEPWATER INDUSTRIES F.C.U.',
  ['DEER VALLEY C.U.']: 'DEER VALLEY C.U.',
  ['DEERE EMPLOYEES C.U.']: 'DEERE EMPLOYEES C.U.',
  ['DEGUSSA BANK GMBH']: 'DEGUSSA BANK GMBH',
  ['DEL NORTE BANK']: 'DEL NORTE BANK',
  ['DEL-ONE F.C.U.']: 'DEL-ONE F.C.U.',
  ['DELAVSKA HRANILNICA D.D. LJUBLJANA']: 'DELAVSKA HRANILNICA D.D. LJUBLJANA',
  ['DELAWARE F.C.U.']: 'DELAWARE F.C.U.',
  ['DELTA COMMUNITY C.U.']: 'DELTA COMMUNITY C.U.',
  ['DEMIRBANK OJSC']: 'DEMIRBANK OJSC',
  ['DENALI ALASKAN F.C.U.']: 'DENALI ALASKAN F.C.U.',
  ['DENIZBANK A.S.']: 'DENIZBANK A.S.',
  ['DENVER COMMUNITY C.U.']: 'DENVER COMMUNITY C.U.',
  ['DENVER FIRE DEPARTMENT F.C.U.']: 'DENVER FIRE DEPARTMENT F.C.U.',
  ['DEPARTMENT OF COMMERCE F.C.U.']: 'DEPARTMENT OF COMMERCE F.C.U.',
  ['DEPARTMENT OF THE INTERIOR F.C.U.']: 'DEPARTMENT OF THE INTERIOR F.C.U.',
  ['DESERET FIRST C.U.']: 'DESERET FIRST C.U.',
  ['DESERET FIRST CREDIT UNION']: 'DESERET FIRST CREDIT UNION',
  ['DESERT FINANCIAL C.U.']: 'DESERT FINANCIAL C.U.',
  ['DEUTSCHE BANK AG']: 'DEUTSCHE BANK AG',
  ['DEUTSCHE BANK S.P.A.']: 'DEUTSCHE BANK S.P.A.',
  ['DEUTSCHE BANK SOCIEDAD ANONIMA ESPANOLA']: 'DEUTSCHE BANK SOCIEDAD ANONIMA ESPANOLA',
  ['DEUTSCHE BANK USA']: 'DEUTSCHE BANK USA',
  ['DEUTSCHE KREDITBANK AKTIENGESELLSCHAFT']: 'DEUTSCHE KREDITBANK AKTIENGESELLSCHAFT',
  ['DEUTSCHER SPARKASSEN UND GIROVERBAND']: 'DEUTSCHER SPARKASSEN UND GIROVERBAND',
  ['DEZELNA BANKA SLOVENIJE D.D.']: 'DEZELNA BANKA SLOVENIJE D.D.',
  ['DFCU FINANCIAL']: 'DFCU FINANCIAL',
  ['DIABLO VALLEY F.C.U.']: 'DIABLO VALLEY F.C.U.',
  ['DIAMOND BANK PLC']: 'DIAMOND BANK PLC',
  ['DIAMOND C.U.']: 'DIAMOND C.U.',
  ['DIAMOND TRUST BANK KENYA LIMITED']: 'DIAMOND TRUST BANK KENYA LIMITED',
  ['DIETERICH BANK']: 'DIETERICH BANK',
  ['DIGITAL BANKS PAGAMENTO SA']: 'DIGITAL BANKS PAGAMENTO SA',
  ['DIGITAL F.C.U.']: 'DIGITAL F.C.U.',
  ['DIME BANK']: 'DIME BANK',
  ['DIME COMMUNITY BANK']: 'DIME COMMUNITY BANK',
  ['DIPOCKET LIMITED']: 'DIPOCKET LIMITED',
  ['DIRECT F.C.U.']: 'DIRECT F.C.U.',
  ['DIRECTIONS C.U.']: 'DIRECTIONS C.U.',
  ['DIREKTNA BANKA AD KRAGUJEVAC']: 'DIREKTNA BANKA AD KRAGUJEVAC',
  ['DISCOVER BANK']: 'DISCOVER BANK',
  ['DISCOVER NETWORK']: 'DISCOVER NETWORK',
  ['DISCOVERY BANK']: 'DISCOVERY BANK',
  ['DIVERSIFIED MEMBERS C.U.']: 'DIVERSIFIED MEMBERS C.U.',
  ['DNB BANK ASA']: 'DNB BANK ASA',
  ['DNBNOR']: 'DNBNOR',
  ['DOHA BANK Q.S.C']: 'DOHA BANK Q.S.C',
  ['DOLLAR BANK, A FEDERAL SAVINGS BANK']: 'DOLLAR BANK, A FEDERAL SAVINGS BANK',
  ['DONGGUAN RURAL COMMERCIAL BANK CO LTD']: 'DONGGUAN RURAL COMMERCIAL BANK CO LTD',
  ['DORT F.C.U.']: 'DORT F.C.U.',
  ['DOUGLAS NATIONAL BANK']: 'DOUGLAS NATIONAL BANK',
  ['DOVER FEDERAL CREDIT UNION']: 'DOVER FEDERAL CREDIT UNION',
  ['DOW CHEMICAL EMPLOYEES C.U.']: 'DOW CHEMICAL EMPLOYEES C.U.',
  ['DOWNRIVER COMMUNITY F.C.U.']: 'DOWNRIVER COMMUNITY F.C.U.',
  ['DRYADES SAVINGS BANK, F.S.B.']: 'DRYADES SAVINGS BANK, F.S.B.',
  ['DSK BANK PLC']: 'DSK BANK PLC',
  ['DUBAI BANK PJSC']: 'DUBAI BANK PJSC',
  ['DUBAI ISLAMIC BANK']: 'DUBAI ISLAMIC BANK',
  ['DUBUQUE BANK AND TRUST COMPANY']: 'DUBUQUE BANK AND TRUST COMPANY',
  ['DUKE C.U.']: 'DUKE C.U.',
  ['DUO BANK OF CANADA']: 'DUO BANK OF CANADA',
  ['DUPACO COMMUNITY C.U.']: 'DUPACO COMMUNITY C.U.',
  ['DUPAGE C.U.']: 'DUPAGE C.U.',
  ['DUPONT COMMUNITY C.U.']: 'DUPONT COMMUNITY C.U.',
  ['DUTRAC COMMUNITY CREDIT UNION']: 'DUTRAC COMMUNITY CREDIT UNION',
  ['DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK']: 'DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK',
  ['DZING FINANCE LTD']: 'DZING FINANCE LTD',
  ['E-CENTRAL C.U.']: 'E-CENTRAL C.U.',
  ['E. SUN COMMERCIAL BANK CO., LTD.']: 'E. SUN COMMERCIAL BANK CO., LTD.',
  ['E*TRADE BANK']: 'E*TRADE BANK',
  ['EAGLEBANK']: 'EAGLEBANK',
  ['EARTHMOVER C.U.']: 'EARTHMOVER C.U.',
  ['EAST BOSTON SAVINGS BANK']: 'EAST BOSTON SAVINGS BANK',
  ['EAST IDAHO C.U.']: 'EAST IDAHO C.U.',
  ['EAST TRAVERSE CATHOLIC F.C.U.']: 'EAST TRAVERSE CATHOLIC F.C.U.',
  ['EAST WEST BANK']: 'EAST WEST BANK',
  ['EAST WISCONSIN SAVINGS BANK S.A.']: 'EAST WISCONSIN SAVINGS BANK S.A.',
  ['EASTERN BANK']: 'EASTERN BANK',
  ['EASTHAMPTON SAVINGS BANK']: 'EASTHAMPTON SAVINGS BANK',
  ['EASTMAN C.U.']: 'EASTMAN C.U.',
  ['EASY PAYMENT SERVICES EOOD']: 'EASY PAYMENT SERVICES EOOD',
  ['EASYPAY AD']: 'EASYPAY AD',
  ['EATON FAMILY C.U.']: 'EATON FAMILY C.U.',
  ['EBS BUILDING SOCIETY']: 'EBS BUILDING SOCIETY',
  ['ECCOUNT MONEY ISSUED BY IDT FINANCIAL SERVICES']: 'ECCOUNT MONEY ISSUED BY IDT FINANCIAL SERVICES',
  ['ECOBANK']: 'ECOBANK',
  ['ECOBANK GHANA, LTD.']: 'ECOBANK GHANA, LTD.',
  ['ECOBANK NIGERIA PLC']: 'ECOBANK NIGERIA PLC',
  ['ECOBANK SENEGAL']: 'ECOBANK SENEGAL',
  ['ECOBANK ZAMBIA, LTD.']: 'ECOBANK ZAMBIA, LTD.',
  ['ECONSTAR SA']: 'ECONSTAR SA',
  ['ECU C.U., A DIVISION OF ECKERD C.U.']: 'ECU C.U., A DIVISION OF ECKERD C.U.',
  ['EDDY F.C.U.']: 'EDDY F.C.U.',
  ['EDENRED ARGENTINA SA']: 'EDENRED ARGENTINA SA',
  ['EDENRED MEXICO S.A DE C.V']: 'EDENRED MEXICO S.A DE C.V',
  ['EDUCATION C.U.']: 'EDUCATION C.U.',
  ['EDUCATIONAL COMMUNITY C.U.']: 'EDUCATIONAL COMMUNITY C.U.',
  ['EDUCATIONAL EMPLOYEES C.U.']: 'EDUCATIONAL EMPLOYEES C.U.',
  ['EDUCATIONAL SYSTEMS FEDERAL CREDIT UNION']: 'EDUCATIONAL SYSTEMS FEDERAL CREDIT UNION',
  ['EECU']: 'EECU',
  ['EFCU FINANCIAL']: 'EFCU FINANCIAL',
  ['EFCU FINANCIAL FEDERAL CREDIT UNION']: 'EFCU FINANCIAL FEDERAL CREDIT UNION',
  ['EFG EUROBANK ERGASIAS, S.A.']: 'EFG EUROBANK ERGASIAS, S.A.',
  ['EFUNDS CORPORATION']: 'EFUNDS CORPORATION',
  ['EGLIN FEDERAL CREDIT UNION']: 'EGLIN FEDERAL CREDIT UNION',
  ['EGYPTIAN NATIONAL POST ORGANISATION']: 'EGYPTIAN NATIONAL POST ORGANISATION',
  ['EIKA KREDITTBANK AS']: 'EIKA KREDITTBANK AS',
  ['EKSPRES BANK, A.S.']: 'EKSPRES BANK, A.S.',
  ['ELAN FINANCIAL SERVICES']: 'ELAN FINANCIAL SERVICES',
  ['ELECTRIC COOPERATIVES F.C.U.']: 'ELECTRIC COOPERATIVES F.C.U.',
  ['ELECTRIC F.C.U.']: 'ELECTRIC F.C.U.',
  ['ELECTRICAL WORKERS C.U.']: 'ELECTRICAL WORKERS C.U.',
  ['ELECTRO SAVINGS C.U.']: 'ELECTRO SAVINGS C.U.',
  ['ELEMENTS FINANCIAL F.C.U.']: 'ELEMENTS FINANCIAL F.C.U.',
  ['ELEVATIONS C.U.']: 'ELEVATIONS C.U.',
  ['ELGA C.U.']: 'ELGA C.U.',
  ['EMBERS C.U.']: 'EMBERS C.U.',
  ['EMBERS CREDIT UNION']: 'EMBERS CREDIT UNION',
  ['EMERCHANTPAY LIMITED']: 'EMERCHANTPAY LIMITED',
  ['EMIGRANT BANK']: 'EMIGRANT BANK',
  ['EMIRATES BANK INTERNATIONAL PJSC']: 'EMIRATES BANK INTERNATIONAL PJSC',
  ['EMIRATES ISLAMIC']: 'EMIRATES ISLAMIC',
  ['EMIRATES NBD']: 'EMIRATES NBD',
  ['EML MONEY DAC']: 'EML MONEY DAC',
  ['EML PAYMENT SOLUTIONS LIMITED']: 'EML PAYMENT SOLUTIONS LIMITED',
  ['EML PAYMENTS EUROPE LIMITED']: 'EML PAYMENTS EUROPE LIMITED',
  ['EMPIRE ONE F.C.U.']: 'EMPIRE ONE F.C.U.',
  ['EMPORIKI BANK - CYPRUS, LTD.']: 'EMPORIKI BANK - CYPRUS, LTD.',
  ['EMPOWER FEDERAL CREDIT UNION']: 'EMPOWER FEDERAL CREDIT UNION',
  ['EMPRISE BANK']: 'EMPRISE BANK',
  ['ENDURANCE F.C.U.']: 'ENDURANCE F.C.U.',
  ['ENERGY CAPITAL CREDIT UNION']: 'ENERGY CAPITAL CREDIT UNION',
  ['ENGAGE F.C.U.']: 'ENGAGE F.C.U.',
  ['ENRICHMENT F.C.U.']: 'ENRICHMENT F.C.U.',
  ['ENTERCARD GROUP AB']: 'ENTERCARD GROUP AB',
  ['ENTERPRISE BANK & TRUST']: 'ENTERPRISE BANK & TRUST',
  ['ENTERPRISE NATIONAL BANK']: 'ENTERPRISE NATIONAL BANK',
  ['ENTIE COMMERCIAL BANK']: 'ENTIE COMMERCIAL BANK',
  ['ENTREPRISE DES POSTES ET TELECOMMUNICATIONS']: 'ENTREPRISE DES POSTES ET TELECOMMUNICATIONS',
  ['ENTROPAY LIMITED']: 'ENTROPAY LIMITED',
  ['ENUMIS LTD']: 'ENUMIS LTD',
  ['ENVISION C.U.']: 'ENVISION C.U.',
  ['EPAYLINKS TECHNOLOGY CO., LIMITED']: 'EPAYLINKS TECHNOLOGY CO., LIMITED',
  ['EPAYMENTS SYSTEMS LIMITED']: 'EPAYMENTS SYSTEMS LIMITED',
  ['EPICA']: 'EPICA',
  ['EQUA BANK A.S.']: 'EQUA BANK A.S.',
  ['EQUITABLE BANK']: 'EQUITABLE BANK',
  ['EQUITY BANK']: 'EQUITY BANK',
  ['EREL BANK']: 'EREL BANK',
  ['ERSTE & STEIERMARKISCHE BANK D.D.']: 'ERSTE & STEIERMARKISCHE BANK D.D.',
  ['ERSTE BANK AD NOVI SAD']: 'ERSTE BANK AD NOVI SAD',
  ['ERSTE BANK DER OSTERREICHISCHEN SPARKASSEN AG']: 'ERSTE BANK DER OSTERREICHISCHEN SPARKASSEN AG',
  ['ERSTE BANK HUNGARY ZRT.']: 'ERSTE BANK HUNGARY ZRT.',
  ['ERZSEBET UTALVANYFORGALMAZO ZRT. (EUF)']: 'ERZSEBET UTALVANYFORGALMAZO ZRT. (EUF)',
  ['ESSENTIAL F.C.U.']: 'ESSENTIAL F.C.U.',
  ['ESSEX BANK']: 'ESSEX BANK',
  ['EUFISERV']: 'EUFISERV',
  ['EURO KARTENSYSTEME GMBH']: 'EURO KARTENSYSTEME GMBH',
  ['EUROBANK  BULGARIA A.D.']: 'EUROBANK  BULGARIA A.D.',
  ['EUROBANK ERGASIAS S.A.']: 'EUROBANK ERGASIAS S.A.',
  ['EUROBANK GREECE']: 'EUROBANK GREECE',
  ['EURONET 360 FINANCE LTD']: 'EURONET 360 FINANCE LTD',
  ['EUROPAY (EUROCARD) ISRAEL LTD.']: 'EUROPAY (EUROCARD) ISRAEL LTD.',
  ['EUROPAY 6000']: 'EUROPAY 6000',
  ['EUROPAY BELGIUM S.C.R.L.']: 'EUROPAY BELGIUM S.C.R.L.',
  ['EUROPAY LUXEMBOURG S.C.']: 'EUROPAY LUXEMBOURG S.C.',
  ['EUROPEAN AMERICAN BANK']: 'EUROPEAN AMERICAN BANK',
  ['EUROSTANDARD BANK AD SKOPJE']: 'EUROSTANDARD BANK AD SKOPJE',
  ['EVANGELICAL CHRISTIAN C.U.']: 'EVANGELICAL CHRISTIAN C.U.',
  ['EVANS BANK, N.A.']: 'EVANS BANK, N.A.',
  ['EVANSVILLE F.C.U.']: 'EVANSVILLE F.C.U.',
  ['EVANSVILLE TEACHERS F.C.U.']: 'EVANSVILLE TEACHERS F.C.U.',
  ['EVERGREEN C.U.']: 'EVERGREEN C.U.',
  ['EVERTEC CENTROAMERICA, S.A.']: 'EVERTEC CENTROAMERICA, S.A.',
  ['EVOCABANK']: 'EVOCABANK',
  ['EVOLVE BANK AND TRUST']: 'EVOLVE BANK AND TRUST',
  ['EVOLVE FEDERAL CREDIT UNION']: 'EVOLVE FEDERAL CREDIT UNION',
  ['EXCEL F.C.U.']: 'EXCEL F.C.U.',
  ['EXCHANGE BANK OF ALABAMA']: 'EXCHANGE BANK OF ALABAMA',
  ['EXCHANGE BANK OF MISSOURI']: 'EXCHANGE BANK OF MISSOURI',
  ['EXIM BANK (TANZANIA) LTD']: 'EXIM BANK (TANZANIA) LTD',
  ['EXPOBANK CZ A.S.']: 'EXPOBANK CZ A.S.',
  ['EXPREE C.U.']: 'EXPREE C.U.',
  ['EXPRESSBANK AD']: 'EXPRESSBANK AD',
  ['EXTRA C.U.']: 'EXTRA C.U.',
  ['EZ-LINK PTE LTD.']: 'EZ-LINK PTE LTD.',
  ['F AND A F.C.U.']: 'F AND A F.C.U.',
  ['F AND M BANK']: 'F AND M BANK',
  ['FAA TECHNICAL CENTER FEDERAL CREDIT UNION']: 'FAA TECHNICAL CENTER FEDERAL CREDIT UNION',
  ['FALL RIVER MUNICIPAL EMPLOYEES C.U.']: 'FALL RIVER MUNICIPAL EMPLOYEES C.U.',
  ['FAMILY FINANCIAL C.U.']: 'FAMILY FINANCIAL C.U.',
  ['FAMILY FIRST C.U.']: 'FAMILY FIRST C.U.',
  ['FAMILY FIRST OF NY F.C.U.']: 'FAMILY FIRST OF NY F.C.U.',
  ['FAMILY HORIZONS C.U.']: 'FAMILY HORIZONS C.U.',
  ['FAMILY SAVINGS F.C.U.']: 'FAMILY SAVINGS F.C.U.',
  ['FAMILY SECURITY C.U.']: 'FAMILY SECURITY C.U.',
  ['FAMILY TRUST F.C.U.']: 'FAMILY TRUST F.C.U.',
  ['FANNIN BANK']: 'FANNIN BANK',
  ['FAR EASTERN INTERNATIONAL BANK']: 'FAR EASTERN INTERNATIONAL BANK',
  ['FARM BUREAU BANK FSB']: 'FARM BUREAU BANK FSB',
  ['FARMERS & MERCHANTS BANK OF LONG BEACH']: 'FARMERS & MERCHANTS BANK OF LONG BEACH',
  ['FARMERS AND MERCHANTS BANK']: 'FARMERS AND MERCHANTS BANK',
  ['FARMERS BANK & TRUST COMPANY']: 'FARMERS BANK & TRUST COMPANY',
  ['FARMERS NATIONAL BANK']: 'FARMERS NATIONAL BANK',
  ['FARMERS STATE BANK']: 'FARMERS STATE BANK',
  ['FASTERPAY LIMITED']: 'FASTERPAY LIMITED',
  ['FAYSAL BANK LIMITED']: 'FAYSAL BANK LIMITED',
  ['FCB BANKS']: 'FCB BANKS',
  ['FD COMMUNITY F.C.U.']: 'FD COMMUNITY F.C.U.',
  ['FEDERAL BANK LIMITED, THE']: 'FEDERAL BANK LIMITED, THE',
  ['FEDERATED EMPLOYEES C.U.']: 'FEDERATED EMPLOYEES C.U.',
  ['FEDERATION DES CAISSES DESJARDINS DU QUEBEC']: 'FEDERATION DES CAISSES DESJARDINS DU QUEBEC',
  ['FEDEX EMPLOYEES CREDIT ASSOCIATION F.C.U.']: 'FEDEX EMPLOYEES CREDIT ASSOCIATION F.C.U.',
  ['FERRATUM BANK LIMITED']: 'FERRATUM BANK LIMITED',
  ['FFG CARD CO., LTD.']: 'FFG CARD CO., LTD.',
  ['FIDELIS CATHOLIC C.U.']: 'FIDELIS CATHOLIC C.U.',
  ['FIDELITY BANK']: 'FIDELITY BANK',
  ['FIDELITY BANK GHANA LIMITED']: 'FIDELITY BANK GHANA LIMITED',
  ['FIDELITY BANK PLC']: 'FIDELITY BANK PLC',
  ['FIDELITY DEPOSIT AND DISCOUNT BANK']: 'FIDELITY DEPOSIT AND DISCOUNT BANK',
  ['FIDELITY FEDERAL SAVINGS BANK']: 'FIDELITY FEDERAL SAVINGS BANK',
  ['FIDELITY INFORMATION SERVICES']: 'FIDELITY INFORMATION SERVICES',
  ['FIDELITY NATIONAL CARD SERVICES']: 'FIDELITY NATIONAL CARD SERVICES',
  ['FIDOR BANK AG']: 'FIDOR BANK AG',
  ['FIELD & MAIN BANK']: 'FIELD & MAIN BANK',
  ['FIELDSTONE C.U.']: 'FIELDSTONE C.U.',
  ['FIFTH DISTRICT SAVINGS BANK']: 'FIFTH DISTRICT SAVINGS BANK',
  ['FIFTH THIRD BANK']: 'FIFTH THIRD BANK',
  ['FINANCE AND TRADE BANK - FINCOMBANK']: 'FINANCE AND TRADE BANK - FINCOMBANK',
  ['FINANCE CENTER F.C.U.']: 'FINANCE CENTER F.C.U.',
  ['FINANCE HOUSE']: 'FINANCE HOUSE',
  ['FINANCE INCORPORATED LTD']: 'FINANCE INCORPORATED LTD',
  ['FINANCIAL HORIZONS C.U.']: 'FINANCIAL HORIZONS C.U.',
  ['FINANCIAL PARTNERS C.U.']: 'FINANCIAL PARTNERS C.U.',
  ['FINANCIAL PLUS C.U.']: 'FINANCIAL PLUS C.U.',
  ['FINANCIAL RESOURCES FEDERAL CREDIT UNION']: 'FINANCIAL RESOURCES FEDERAL CREDIT UNION',
  ['FINANCIAL TRUST F.C.U.']: 'FINANCIAL TRUST F.C.U.',
  ['FINANCIERA EL CORTE INGLES EFC SA']: 'FINANCIERA EL CORTE INGLES EFC SA',
  ['FINANSBANK A.S.']: 'FINANSBANK A.S.',
  ['FINCOFEX LIMITED']: 'FINCOFEX LIMITED',
  ['FINDOMESTIC BANCA SPA']: 'FINDOMESTIC BANCA SPA',
  ['FINECOBANK SPA']: 'FINECOBANK SPA',
  ['FINEXUS CARDS SDN BHD']: 'FINEXUS CARDS SDN BHD',
  ['FINGER LAKES F.C.U.']: 'FINGER LAKES F.C.U.',
  ['FIO BANKA A.S.']: 'FIO BANKA A.S.',
  ['FIRE FINANCIAL SERVICES LIMITED']: 'FIRE FINANCIAL SERVICES LIMITED',
  ['FIRE POLICE CITY COUNTY F.C.U.']: 'FIRE POLICE CITY COUNTY F.C.U.',
  ['FIREFIGHTERS FIRST C.U.']: 'FIREFIGHTERS FIRST C.U.',
  ['FIRST A NATIONAL BANKING ASSOCIATION']: 'FIRST A NATIONAL BANKING ASSOCIATION',
  ['FIRST ABU DHABI BANK PJSC']: 'FIRST ABU DHABI BANK PJSC',
  ['FIRST AMERICAN BANK']: 'FIRST AMERICAN BANK',
  ['FIRST AMERICAN BANK TEXAS']: 'FIRST AMERICAN BANK TEXAS',
  ['FIRST AMERICAN NATIONAL BANK']: 'FIRST AMERICAN NATIONAL BANK',
  ['FIRST AND FARMERS NATIONAL BANK, INC.']: 'FIRST AND FARMERS NATIONAL BANK, INC.',
  ['FIRST ARKANSAS BANK AND TRUST']: 'FIRST ARKANSAS BANK AND TRUST',
  ['FIRST ATLANTIC F.C.U.']: 'FIRST ATLANTIC F.C.U.',
  ['FIRST BANK']: 'FIRST BANK',
  ['FIRST BANK KANSAS']: 'FIRST BANK KANSAS',
  ['FIRST BANK OF ALABAMA']: 'FIRST BANK OF ALABAMA',
  ['FIRST BANK OF BERNE']: 'FIRST BANK OF BERNE',
  ['FIRST BANK OF MISSOURI']: 'FIRST BANK OF MISSOURI',
  ['FIRST BANK OF NIGERIA PLC']: 'FIRST BANK OF NIGERIA PLC',
  ['FIRST BANK PUERTO RICO']: 'FIRST BANK PUERTO RICO',
  ['FIRST BANK RICHMOND, N.A.']: 'FIRST BANK RICHMOND, N.A.',
  ['FIRST BANK, UPPER MICHIGAN']: 'FIRST BANK, UPPER MICHIGAN',
  ['FIRST BANKERS TRUST COMPANY NATIONAL ASSOCIATION']: 'FIRST BANKERS TRUST COMPANY NATIONAL ASSOCIATION',
  ['FIRST BASIN C.U.']: 'FIRST BASIN C.U.',
  ['FIRST BRISTOL F.C.U.']: 'FIRST BRISTOL F.C.U.',
  ['FIRST CALIFORNIA F.C.U.']: 'FIRST CALIFORNIA F.C.U.',
  ['FIRST CENTRAL BANK']: 'FIRST CENTRAL BANK',
  ['FIRST CHOICE C.U.']: 'FIRST CHOICE C.U.',
  ['FIRST CINCINATTI']: 'FIRST CINCINATTI',
  ['FIRST CITIZENS BANK AND TRUST COMPANY']: 'FIRST CITIZENS BANK AND TRUST COMPANY',
  ['FIRST CITIZENS NATIONAL BANK']: 'FIRST CITIZENS NATIONAL BANK',
  ['FIRST CITIZENS NATIONAL BANK OF UPPER SANDUSKY']: 'FIRST CITIZENS NATIONAL BANK OF UPPER SANDUSKY',
  ['FIRST CITIZENS STATE BANK']: 'FIRST CITIZENS STATE BANK',
  ['FIRST CITY MONUMENT BANK PLC']: 'FIRST CITY MONUMENT BANK PLC',
  ['FIRST CLASS AMERICAN C.U.']: 'FIRST CLASS AMERICAN C.U.',
  ['FIRST CLOVER LEAF BANK, F.S.B.']: 'FIRST CLOVER LEAF BANK, F.S.B.',
  ['FIRST COMMAND BANK']: 'FIRST COMMAND BANK',
  ['FIRST COMMERCE BANK']: 'FIRST COMMERCE BANK',
  ['FIRST COMMERCIAL BANK']: 'FIRST COMMERCIAL BANK',
  ['FIRST COMMONS BANK, N.A.']: 'FIRST COMMONS BANK, N.A.',
  ['FIRST COMMONWEALTH BANK']: 'FIRST COMMONWEALTH BANK',
  ['FIRST COMMUNITY BANK']: 'FIRST COMMUNITY BANK',
  ['FIRST COMMUNITY BANK OF HILLSBORO']: 'FIRST COMMUNITY BANK OF HILLSBORO',
  ['FIRST COMMUNITY C.U.']: 'FIRST COMMUNITY C.U.',
  ['FIRST COMMUNITY CREDIT UNION OF HOUSTON']: 'FIRST COMMUNITY CREDIT UNION OF HOUSTON',
  ['FIRST DATA RESOURCES, INC.']: 'FIRST DATA RESOURCES, INC.',
  ['FIRST EDUCATION F.C.U.']: 'FIRST EDUCATION F.C.U.',
  ['FIRST ELECTRONIC BANK']: 'FIRST ELECTRONIC BANK',
  ['FIRST EXCHANGE BANK']: 'FIRST EXCHANGE BANK',
  ['FIRST FARMERS AND MERCHANTS BANK']: 'FIRST FARMERS AND MERCHANTS BANK',
  ['FIRST FARMERS BANK & TRUST']: 'FIRST FARMERS BANK & TRUST',
  ['FIRST FARMERS STATE BANK OF MINIER']: 'FIRST FARMERS STATE BANK OF MINIER',
  ['FIRST FEDERAL BANK']: 'FIRST FEDERAL BANK',
  ['FIRST FEDERAL BANK OF FLORIDA']: 'FIRST FEDERAL BANK OF FLORIDA',
  ['FIRST FEDERAL OF SOUTH CAROLINA, FEDERAL SAVINGS BANK']: 'FIRST FEDERAL OF SOUTH CAROLINA, FEDERAL SAVINGS BANK',
  ['FIRST FEDERAL SAVINGS & LOAN ASSOCIATION OF LAKEWOOD']: 'FIRST FEDERAL SAVINGS & LOAN ASSOCIATION OF LAKEWOOD',
  ['FIRST FEDERAL SAVINGS AND LOAN ASSOCIATION OF CHARLESTON']:
    'FIRST FEDERAL SAVINGS AND LOAN ASSOCIATION OF CHARLESTON',
  ['FIRST FEDERAL SAVINGS AND LOAN ASSOCIATION OF MCMINNVILLE']:
    'FIRST FEDERAL SAVINGS AND LOAN ASSOCIATION OF MCMINNVILLE',
  ['FIRST FEDERAL SAVINGS BANK']: 'FIRST FEDERAL SAVINGS BANK',
  ['FIRST FEDERAL SAVINGS BANK OF TWIN FALLS']: 'FIRST FEDERAL SAVINGS BANK OF TWIN FALLS',
  ['FIRST FIDELITY BANK, N.A.']: 'FIRST FIDELITY BANK, N.A.',
  ['FIRST FINANCIAL BANK']: 'FIRST FINANCIAL BANK',
  ['FIRST FINANCIAL BANKSHARES, INC.']: 'FIRST FINANCIAL BANKSHARES, INC.',
  ['FIRST FINANCIAL C.U.']: 'FIRST FINANCIAL C.U.',
  ['FIRST FINANCIAL OF MARYLAND F.C.U.']: 'FIRST FINANCIAL OF MARYLAND F.C.U.',
  ['FIRST GULF BANK PJSC']: 'FIRST GULF BANK PJSC',
  ['FIRST HAWAIIAN BANK']: 'FIRST HAWAIIAN BANK',
  ['FIRST HEARTLAND JYSAN BANK JOINT STOCK COMPANY']: 'FIRST HEARTLAND JYSAN BANK JOINT STOCK COMPANY',
  ['FIRST HERITAGE BANK']: 'FIRST HERITAGE BANK',
  ['FIRST HORIZON']: 'FIRST HORIZON',
  ['FIRST INDEPENDENT BANK']: 'FIRST INDEPENDENT BANK',
  ['FIRST INTERNATIONAL BANK AND TRUST']: 'FIRST INTERNATIONAL BANK AND TRUST',
  ['FIRST INTERNET BANK OF INDIANA']: 'FIRST INTERNET BANK OF INDIANA',
  ['FIRST INTERSTATE BANK']: 'FIRST INTERSTATE BANK',
  ['FIRST INVESTMENT BANK LTD']: 'FIRST INVESTMENT BANK LTD',
  ['FIRST KANSAS BANK']: 'FIRST KANSAS BANK',
  ['FIRST KENTUCKY BANK, INC.']: 'FIRST KENTUCKY BANK, INC.',
  ['FIRST KEYSTONE COMMUNITY BANK']: 'FIRST KEYSTONE COMMUNITY BANK',
  ['FIRST MERCHANTS BANK']: 'FIRST MERCHANTS BANK',
  ['FIRST MID BANK & TRUST']: 'FIRST MID BANK & TRUST',
  ['FIRST MID-ILLINOIS BANK AND TRUST, N.A.']: 'FIRST MID-ILLINOIS BANK AND TRUST, N.A.',
  ['FIRST MIDWEST BANK']: 'FIRST MIDWEST BANK',
  ['FIRST NATIONAL BANK']: 'FIRST NATIONAL BANK',
  ['FIRST NATIONAL BANK ALASKA']: 'FIRST NATIONAL BANK ALASKA',
  ['FIRST NATIONAL BANK AND TRUST COMPANY OF NEWTOWN']: 'FIRST NATIONAL BANK AND TRUST COMPANY OF NEWTOWN',
  ['FIRST NATIONAL BANK IN FAIRFIELD']: 'FIRST NATIONAL BANK IN FAIRFIELD',
  ['FIRST NATIONAL BANK IN MONTEVIDEO']: 'FIRST NATIONAL BANK IN MONTEVIDEO',
  ['FIRST NATIONAL BANK IN SIOUX FALLS']: 'FIRST NATIONAL BANK IN SIOUX FALLS',
  ['FIRST NATIONAL BANK OF ABILENE']: 'FIRST NATIONAL BANK OF ABILENE',
  ['FIRST NATIONAL BANK OF AMARILLO']: 'FIRST NATIONAL BANK OF AMARILLO',
  ['FIRST NATIONAL BANK OF AMERICA']: 'FIRST NATIONAL BANK OF AMERICA',
  ['FIRST NATIONAL BANK OF BEARDSTOWN']: 'FIRST NATIONAL BANK OF BEARDSTOWN',
  ['FIRST NATIONAL BANK OF CARROLLTON']: 'FIRST NATIONAL BANK OF CARROLLTON',
  ['FIRST NATIONAL BANK OF CATLIN']: 'FIRST NATIONAL BANK OF CATLIN',
  ['FIRST NATIONAL BANK OF CENTRAL TEXAS']: 'FIRST NATIONAL BANK OF CENTRAL TEXAS',
  ['FIRST NATIONAL BANK OF CHADRON']: 'FIRST NATIONAL BANK OF CHADRON',
  ['FIRST NATIONAL BANK OF CLARKSDALE']: 'FIRST NATIONAL BANK OF CLARKSDALE',
  ['FIRST NATIONAL BANK OF FORT SMITH']: 'FIRST NATIONAL BANK OF FORT SMITH',
  ['FIRST NATIONAL BANK OF GRANBURY']: 'FIRST NATIONAL BANK OF GRANBURY',
  ['FIRST NATIONAL BANK OF GROTON']: 'FIRST NATIONAL BANK OF GROTON',
  ['FIRST NATIONAL BANK OF HUTCHINSON']: 'FIRST NATIONAL BANK OF HUTCHINSON',
  ['FIRST NATIONAL BANK OF LA GRANGE']: 'FIRST NATIONAL BANK OF LA GRANGE',
  ['FIRST NATIONAL BANK OF MCMINNVILLE']: 'FIRST NATIONAL BANK OF MCMINNVILLE',
  ['FIRST NATIONAL BANK OF MOUNT DORA']: 'FIRST NATIONAL BANK OF MOUNT DORA',
  ['FIRST NATIONAL BANK OF MUSCATINE']: 'FIRST NATIONAL BANK OF MUSCATINE',
  ['FIRST NATIONAL BANK OF OKLAHOMA']: 'FIRST NATIONAL BANK OF OKLAHOMA',
  ['FIRST NATIONAL BANK OF OMAHA']: 'FIRST NATIONAL BANK OF OMAHA',
  ['FIRST NATIONAL BANK OF PANA']: 'FIRST NATIONAL BANK OF PANA',
  ['FIRST NATIONAL BANK OF PENNSYLVANIA']: 'FIRST NATIONAL BANK OF PENNSYLVANIA',
  ['FIRST NATIONAL BANK OF RUIDOSO']: 'FIRST NATIONAL BANK OF RUIDOSO',
  ['FIRST NATIONAL BANK OF SCOTIA']: 'FIRST NATIONAL BANK OF SCOTIA',
  ['FIRST NATIONAL BANK OF SONORA']: 'FIRST NATIONAL BANK OF SONORA',
  ['FIRST NATIONAL BANK OF TEXHOMA']: 'FIRST NATIONAL BANK OF TEXHOMA',
  ['FIRST NATIONAL BANK OF THOMAS']: 'FIRST NATIONAL BANK OF THOMAS',
  ['FIRST NATIONAL BANK TEXAS']: 'FIRST NATIONAL BANK TEXAS',
  ['FIRST NATIONAL BANKING CO']: 'FIRST NATIONAL BANKING CO',
  ['FIRST NATIONS BANK']: 'FIRST NATIONS BANK',
  ['FIRST NBC']: 'FIRST NBC',
  ['FIRST NORTHEAST BANK OF NEBRASKA']: 'FIRST NORTHEAST BANK OF NEBRASKA',
  ['FIRST NORTHERN C.U.']: 'FIRST NORTHERN C.U.',
  ['FIRST OPTION BANK']: 'FIRST OPTION BANK',
  ['FIRST PEOPLES COMMUNITY F.C.U.']: 'FIRST PEOPLES COMMUNITY F.C.U.',
  ['FIRST PIEDMONT FEDERAL SAVINGS']: 'FIRST PIEDMONT FEDERAL SAVINGS',
  ['FIRST PREMIER BANK']: 'FIRST PREMIER BANK',
  ['FIRST RATE EXCHANGE SERVICES LIMITED']: 'FIRST RATE EXCHANGE SERVICES LIMITED',
  ['FIRST REPUBLIC BANK']: 'FIRST REPUBLIC BANK',
  ['FIRST ROBINSON SAVINGS BANK']: 'FIRST ROBINSON SAVINGS BANK',
  ['FIRST SAVINGS BANK NORTHWEST']: 'FIRST SAVINGS BANK NORTHWEST',
  ['FIRST SECURITY BANK']: 'FIRST SECURITY BANK',
  ['FIRST SOURCE F.C.U.']: 'FIRST SOURCE F.C.U.',
  ['FIRST SOUTH FINANCIAL C.U.']: 'FIRST SOUTH FINANCIAL C.U.',
  ['FIRST SOUTHERN NATIONAL']: 'FIRST SOUTHERN NATIONAL',
  ['FIRST STATE BANK']: 'FIRST STATE BANK',
  ['FIRST STATE BANK AND TRUST']: 'FIRST STATE BANK AND TRUST',
  ['FIRST STATE BANK OF MOBEETIE']: 'FIRST STATE BANK OF MOBEETIE',
  ['FIRST STATE BANK OF PORTER']: 'FIRST STATE BANK OF PORTER',
  ['FIRST STATE BANK SHANNON-POLO']: 'FIRST STATE BANK SHANNON-POLO',
  ['FIRST STATE COMMUNITY BANK']: 'FIRST STATE COMMUNITY BANK',
  ['FIRST TECHNOLOGY F.C.U.']: 'FIRST TECHNOLOGY F.C.U.',
  ['FIRST TECHNOLOGY FEDERAL CREDIT UNION']: 'FIRST TECHNOLOGY FEDERAL CREDIT UNION',
  ['FIRST TENNESSEE BANK N.A.']: 'FIRST TENNESSEE BANK N.A.',
  ['FIRST TEXAS BANK']: 'FIRST TEXAS BANK',
  ['FIRST U.S. COMMUNITY C.U.']: 'FIRST U.S. COMMUNITY C.U.',
  ['FIRST UKRAINIAN INTERNATIONAL BANK']: 'FIRST UKRAINIAN INTERNATIONAL BANK',
  ['FIRST UNION DIRECT BANK']: 'FIRST UNION DIRECT BANK',
  ['FIRST UNITED BANK AND TRUST']: 'FIRST UNITED BANK AND TRUST',
  ['FIRST UNITED SECURITY BANK']: 'FIRST UNITED SECURITY BANK',
  ['FIRST USA BANK']: 'FIRST USA BANK',
  ['FIRST UTAH BANK']: 'FIRST UTAH BANK',
  ['FIRST VOLUNTEER BANK']: 'FIRST VOLUNTEER BANK',
  ['FIRST WESTERN BANK & TRUST']: 'FIRST WESTERN BANK & TRUST',
  ['FIRST-CITIZENS BANK AND TRUST COMPANY']: 'FIRST-CITIZENS BANK AND TRUST COMPANY',
  ['FIRSTAR BANK']: 'FIRSTAR BANK',
  ['FIRSTBANK']: 'FIRSTBANK',
  ['FIRSTCARIBBEAN INTERNATIONAL BANK']: 'FIRSTCARIBBEAN INTERNATIONAL BANK',
  ['FIRSTCARIBBEAN INTERNATIONAL BANK (BARBADOS), LTD.']: 'FIRSTCARIBBEAN INTERNATIONAL BANK (BARBADOS), LTD.',
  ['FIRSTLIGHT F.C.U.']: 'FIRSTLIGHT F.C.U.',
  ['FIRSTLIGHT FEDERAL C.U.']: 'FIRSTLIGHT FEDERAL C.U.',
  ['FIRSTMARK C.U.']: 'FIRSTMARK C.U.',
  ['FIRSTMERIT BANK']: 'FIRSTMERIT BANK',
  ['FIRSTRAND BANK INDIA']: 'FIRSTRAND BANK INDIA',
  ['FIRSTRAND BANK LIMITED']: 'FIRSTRAND BANK LIMITED',
  ['FIRSTRUST SAVINGS BANK']: 'FIRSTRUST SAVINGS BANK',
  ['FISERV SOLUTIONS LLC']: 'FISERV SOLUTIONS LLC',
  ['FIVE COUNTY C.U.']: 'FIVE COUNTY C.U.',
  ['FIVE POINTS BANK']: 'FIVE POINTS BANK',
  ['FIVE STAR C.U.']: 'FIVE STAR C.U.',
  ['FLAGSTAR BANK, F.S.B.']: 'FLAGSTAR BANK, F.S.B.',
  ['FLEUR-DE-LIS F.C.U.']: 'FLEUR-DE-LIS F.C.U.',
  ['FLEXCARD ISSUED BY IDT FINANCIAL SERVICES, LTD.']: 'FLEXCARD ISSUED BY IDT FINANCIAL SERVICES, LTD.',
  ['FLEXI CARDS LIMITED']: 'FLEXI CARDS LIMITED',
  ['FLORENCE SAVINGS BANK']: 'FLORENCE SAVINGS BANK',
  ['FLORIDA C.U.']: 'FLORIDA C.U.',
  ['FLORIDA CAPITAL BANK, N.A.']: 'FLORIDA CAPITAL BANK, N.A.',
  ['FLOWE SPA SB']: 'FLOWE SPA SB',
  ['FM BANK PBP, S.A.']: 'FM BANK PBP, S.A.',
  ['FNB']: 'FNB',
  ['FNBT BANK']: 'FNBT BANK',
  ['FNCB BANK']: 'FNCB BANK',
  ['FOCUS BANK']: 'FOCUS BANK',
  ['FOCUS C.U.']: 'FOCUS C.U.',
  ['FOOTHILLS C.U.']: 'FOOTHILLS C.U.',
  ['FORABANK']: 'FORABANK',
  ['FORCHT BANK, N.A.']: 'FORCHT BANK, N.A.',
  ['FORT FINANCIAL C.U.']: 'FORT FINANCIAL C.U.',
  ['FORT HOOD NATIONAL BANK']: 'FORT HOOD NATIONAL BANK',
  ['FORT MCPHERSON C.U.']: 'FORT MCPHERSON C.U.',
  ['FORT SILL F.C.U.']: 'FORT SILL F.C.U.',
  ['FORT WORTH COMMUNITY C.U.']: 'FORT WORTH COMMUNITY C.U.',
  ['FORTBRASIL ADMINISTRADORA DE CARTOES DE CREDITO SA']: 'FORTBRASIL ADMINISTRADORA DE CARTOES DE CREDITO SA',
  ['FORTEBANK JSC']: 'FORTEBANK JSC',
  ['FORTERA FEDERAL CREDIT UNION']: 'FORTERA FEDERAL CREDIT UNION',
  ['FORTIS BANQUE - FORTIS BANK']: 'FORTIS BANQUE - FORTIS BANK',
  ['FORUM CREDIT UNION']: 'FORUM CREDIT UNION',
  ['FOUNDERS F.C.U.']: 'FOUNDERS F.C.U.',
  ['FOUR CORNERS COMMUNITY BANK']: 'FOUR CORNERS COMMUNITY BANK',
  ['FOUR SEASONS F.C.U.']: 'FOUR SEASONS F.C.U.',
  ['FOX COMMUNITIES C.U.']: 'FOX COMMUNITIES C.U.',
  ['FRANKLIN BANK AND TRUST COMPANY']: 'FRANKLIN BANK AND TRUST COMPANY',
  ['FRANKLIN MINT F.C.U.']: 'FRANKLIN MINT F.C.U.',
  ['FRANKLIN SAVINGS BANK']: 'FRANKLIN SAVINGS BANK',
  ['FRANKLIN-OIL REGION C.U.']: 'FRANKLIN-OIL REGION C.U.',
  ['FRANKLIN-SOMERSET F.C.U.']: 'FRANKLIN-SOMERSET F.C.U.',
  ['FRANSABANK SAL']: 'FRANSABANK SAL',
  ['FREDERICK COUNTY BANK']: 'FREDERICK COUNTY BANK',
  ['FREEDOM BANK']: 'FREEDOM BANK',
  ['FREEDOM C.U.']: 'FREEDOM C.U.',
  ['FREEDOM FIRST F.C.U.']: 'FREEDOM FIRST F.C.U.',
  ['FREEDOM NORTHWEST C.U.']: 'FREEDOM NORTHWEST C.U.',
  ['FREEDOM OF MARYLAND F.C.U.']: 'FREEDOM OF MARYLAND F.C.U.',
  ['FREEDOM UNITED F.C.U.']: 'FREEDOM UNITED F.C.U.',
  ['FREMONT BANK']: 'FREMONT BANK',
  ['FRIENDSHIP STATE BANK']: 'FRIENDSHIP STATE BANK',
  ['FRONTIER COMMUNITY C.U.']: 'FRONTIER COMMUNITY C.U.',
  ['FRONTWAVE C.U.']: 'FRONTWAVE C.U.',
  ['FROST NATIONAL BANK']: 'FROST NATIONAL BANK',
  ['FUBON BANK (HONG KONG) LIMITED']: 'FUBON BANK (HONG KONG) LIMITED',
  ['FULTON BANK']: 'FULTON BANK',
  ['FVCBANK']: 'FVCBANK',
  ['G-XCHANGE, INC.']: 'G-XCHANGE, INC.',
  ['GARANT-INVEST BANK CJS']: 'GARANT-INVEST BANK CJS',
  ['GARDEN STATE F.C.U.']: 'GARDEN STATE F.C.U.',
  ['GAS AND ELECTRIC C.U.']: 'GAS AND ELECTRIC C.U.',
  ['GATHER FEDERAL C.U']: 'GATHER FEDERAL C.U',
  ['GAZPROMBANK']: 'GAZPROMBANK',
  ['GCS F.C.U.']: 'GCS F.C.U.',
  ['GE CAPITAL CONSUMER CARD CO.']: 'GE CAPITAL CONSUMER CARD CO.',
  ['GE CAPITAL FINANCIAL, INC.']: 'GE CAPITAL FINANCIAL, INC.',
  ['GE MONEY BANK']: 'GE MONEY BANK',
  ['GE MONEY BANK - WALMART']: 'GE MONEY BANK - WALMART',
  ['GECU']: 'GECU',
  ['GENBANK CB (LTD)']: 'GENBANK CB (LTD)',
  ['GENERAL CARD SERVICES LTD.']: 'GENERAL CARD SERVICES LTD.',
  ['GENERAL ELECTRIC C.U.']: 'GENERAL ELECTRIC C.U.',
  ['GENISYS C.U.']: 'GENISYS C.U.',
  ['GENISYS CREDIT UNION']: 'GENISYS CREDIT UNION',
  ['GEORGIA HERITAGE F.C.U.']: 'GEORGIA HERITAGE F.C.U.',
  ['GEORGIA UNITED C.U.']: 'GEORGIA UNITED C.U.',
  ["GEORGIA'S OWN C.U."]: "GEORGIA'S OWN C.U.",
  ['GEORGIAS OWN C.U.']: 'GEORGIAS OWN C.U.',
  ['GEOVISTA C.U.']: 'GEOVISTA C.U.',
  ['GERBER F.C.U.']: 'GERBER F.C.U.',
  ['GERMAN AMERICAN BANCORP']: 'GERMAN AMERICAN BANCORP',
  ['GESA C.U.']: 'GESA C.U.',
  ['GETIN NOBLE BANK S.A.']: 'GETIN NOBLE BANK S.A.',
  ['GHS F.C.U.']: 'GHS F.C.U.',
  ['GIBSLAND BANK AND TRUST COMPANY']: 'GIBSLAND BANK AND TRUST COMPANY',
  ['GLACIER BANK']: 'GLACIER BANK',
  ['GLACIER HILLS C.U.']: 'GLACIER HILLS C.U.',
  ['GLASFORD STATE BANK']: 'GLASFORD STATE BANK',
  ['GLASS CAP F.C.U.']: 'GLASS CAP F.C.U.',
  ['GLASS CITY F.C.U.']: 'GLASS CITY F.C.U.',
  ['GLENVIEW STATE BANK']: 'GLENVIEW STATE BANK',
  ['GLINT PAY SERVICES LTD1']: 'GLINT PAY SERVICES LTD1',
  ['GLOBAL BANK OF COMMERCE LIMITE']: 'GLOBAL BANK OF COMMERCE LIMITE',
  ['GLOBAL CARD']: 'GLOBAL CARD',
  ['GLOBAL PROCESSING SA']: 'GLOBAL PROCESSING SA',
  ['GOHENRY CARD ISSUED BY IDT FINANCIAL SERVICES, LTD.']: 'GOHENRY CARD ISSUED BY IDT FINANCIAL SERVICES, LTD.',
  ['GOLD COUNTRY NATIONAL BANK']: 'GOLD COUNTRY NATIONAL BANK',
  ['GOLDEN 1 C.U.']: 'GOLDEN 1 C.U.',
  ['GOLDEN PLAINS C.U.']: 'GOLDEN PLAINS C.U.',
  ['GOLDMAN SACHS BANK USA']: 'GOLDMAN SACHS BANK USA',
  ['GOLOMT BANK OF MONGOLIA']: 'GOLOMT BANK OF MONGOLIA',
  ['GORENJSKA BANKA D.D.']: 'GORENJSKA BANKA D.D.',
  ['GOVERNMENT SAVINGS BANK']: 'GOVERNMENT SAVINGS BANK',
  ['GOVERNMENTAL EMPLOYEES C.U.']: 'GOVERNMENTAL EMPLOYEES C.U.',
  ['GPAY NETWORK (S) PTE. LTD']: 'GPAY NETWORK (S) PTE. LTD',
  ['GPAY NETWORK PH INC']: 'GPAY NETWORK PH INC',
  ['GR CONSUMERS CREDIT UNION']: 'GR CONSUMERS CREDIT UNION',
  ['GRAND BANK AND TRUST OF FLORIDA']: 'GRAND BANK AND TRUST OF FLORIDA',
  ['GRAND JUNCTION F.C.U.']: 'GRAND JUNCTION F.C.U.',
  ['GRAND RAPIDS STATE BANK']: 'GRAND RAPIDS STATE BANK',
  ['GRAND VALLEY BANK']: 'GRAND VALLEY BANK',
  ['GRANIT BANK ZRT.']: 'GRANIT BANK ZRT.',
  ['GRANITE STATE C.U.']: 'GRANITE STATE C.U.',
  ['GRANT COUNTY BANK']: 'GRANT COUNTY BANK',
  ['GREAT ERIE F.C.U.']: 'GREAT ERIE F.C.U.',
  ['GREAT LAKES C.U.']: 'GREAT LAKES C.U.',
  ['GREAT PLAINS NATIONAL BANK']: 'GREAT PLAINS NATIONAL BANK',
  ['GREAT RIVER F.C.U.']: 'GREAT RIVER F.C.U.',
  ['GREAT SOUTHERN BANK']: 'GREAT SOUTHERN BANK',
  ['GREAT WESTERN BANK']: 'GREAT WESTERN BANK',
  ['GREATER BAY BANK, N.A.']: 'GREATER BAY BANK, N.A.',
  ['GREATER IOWA CREDIT UNION']: 'GREATER IOWA CREDIT UNION',
  ['GREATER NEVADA C.U.']: 'GREATER NEVADA C.U.',
  ['GREATER OMAHA F.C.U.']: 'GREATER OMAHA F.C.U.',
  ['GREATER WATERTOWN F.C.U.']: 'GREATER WATERTOWN F.C.U.',
  ['GREEN BANK, N.A.']: 'GREEN BANK, N.A.',
  ['GREEN DOT']: 'GREEN DOT',
  ['GREENFIELD SAVINGS BANK']: 'GREENFIELD SAVINGS BANK',
  ['GREENSTATE CREDIT UNION']: 'GREENSTATE CREDIT UNION',
  ['GREENVILLE F.C.U.']: 'GREENVILLE F.C.U.',
  ['GREENVILLE HERITAGE F.C.U.']: 'GREENVILLE HERITAGE F.C.U.',
  ['GREENVILLE NATIONAL BANK']: 'GREENVILLE NATIONAL BANK',
  ['GREENWOOD C.U.']: 'GREENWOOD C.U.',
  ['GRETAER NIAGARA F.C.U.']: 'GRETAER NIAGARA F.C.U.',
  ['GREYLOCK F.C.U.']: 'GREYLOCK F.C.U.',
  ['GRIFFLAND COMMUNITY F.C.U.']: 'GRIFFLAND COMMUNITY F.C.U.',
  ['GROUPE BPCE']: 'GROUPE BPCE',
  ['GROUPEMENT CARTE BLEUE']: 'GROUPEMENT CARTE BLEUE',
  ['GROW FINANCIAL F.C.U.']: 'GROW FINANCIAL F.C.U.',
  ['GRUPO FINANCIERO BNS DE COSTA RICA S.A.']: 'GRUPO FINANCIERO BNS DE COSTA RICA S.A.',
  ['GRUPO INTERNACIONAL DE FINANZAS S.A.E.C.A. (GRUPO INTERFISA)']:
    'GRUPO INTERNACIONAL DE FINANZAS S.A.E.C.A. (GRUPO INTERFISA)',
  ['GTE F.C.U.']: 'GTE F.C.U.',
  ['GTE FEDERAL CREDIT UNION']: 'GTE FEDERAL CREDIT UNION',
  ['GUARANTY BANK & TRUST CO.']: 'GUARANTY BANK & TRUST CO.',
  ['GUARANTY BANK AND TRUST COMPANY OF DELHI, LOUISIANA']: 'GUARANTY BANK AND TRUST COMPANY OF DELHI, LOUISIANA',
  ['GUARANTY TRUST BANK PLC']: 'GUARANTY TRUST BANK PLC',
  ['GUARDIAN C.U.']: 'GUARDIAN C.U.',
  ['GULF BANK K.S.C., THE']: 'GULF BANK K.S.C., THE',
  ['GULF COAST BANK']: 'GULF COAST BANK',
  ['GULF INTERNATIONAL BANK BSC']: 'GULF INTERNATIONAL BANK BSC',
  ['GULF WINDS F.C.U.']: 'GULF WINDS F.C.U.',
  ['GUNDERSEN LUTHERAN C.U.']: 'GUNDERSEN LUTHERAN C.U.',
  ['GUNGIN CARD CO., LTD., THE']: 'GUNGIN CARD CO., LTD., THE',
  ['GUYANA BANK FOR TRADE AND INDUSTRY, LTD.']: 'GUYANA BANK FOR TRADE AND INDUSTRY, LTD.',
  ['GVS PREPAID, LTD.']: 'GVS PREPAID, LTD.',
  ['HABIB BANK AG ZURICH']: 'HABIB BANK AG ZURICH',
  ['HALKBANK AD SKOPJE']: 'HALKBANK AD SKOPJE',
  ['HALKBANK JSC BELGRADE']: 'HALKBANK JSC BELGRADE',
  ['HALYK BANK TAJIKISTAN CJSC']: 'HALYK BANK TAJIKISTAN CJSC',
  ['HALYK SAVINGS BANK OF KAZAKHSTAN']: 'HALYK SAVINGS BANK OF KAZAKHSTAN',
  ['HAMBURG COMMERCIAL BANK']: 'HAMBURG COMMERCIAL BANK',
  ['HAMPDEN & CO. PLC']: 'HAMPDEN & CO. PLC',
  ['HANA BANK']: 'HANA BANK',
  ['HANA CARD']: 'HANA CARD',
  ['HANCOCK F.C.U.']: 'HANCOCK F.C.U.',
  ['HANCOCK WHITNEY BANK']: 'HANCOCK WHITNEY BANK',
  ['HANDELS-KREDIET-EN INDUSTRIEBANK N.V']: 'HANDELS-KREDIET-EN INDUSTRIEBANK N.V',
  ['HANG SENG BANK LIMITED']: 'HANG SENG BANK LIMITED',
  ['HANMI BANK']: 'HANMI BANK',
  ['HANSCOM FEDERAL CREDIT UNION']: 'HANSCOM FEDERAL CREDIT UNION',
  ['HANSEATIC BANK GMBH AND CO KG']: 'HANSEATIC BANK GMBH AND CO KG',
  ['HAPO COMMUNITY C.U.']: 'HAPO COMMUNITY C.U.',
  ['HAPPY STATE BANK']: 'HAPPY STATE BANK',
  ['HARBIN BANK CO., LTD.']: 'HARBIN BANK CO., LTD.',
  ['HARBOR BANK OF MARYLAND']: 'HARBOR BANK OF MARYLAND',
  ['HARBORONE BANK']: 'HARBORONE BANK',
  ['HARBORSTONE C.U.']: 'HARBORSTONE C.U.',
  ['HARTFORD F.C.U.']: 'HARTFORD F.C.U.',
  ['HASTINGS F.C.U.']: 'HASTINGS F.C.U.',
  ['HATCH BANK']: 'HATCH BANK',
  ['HAWAII STATE F.C.U.']: 'HAWAII STATE F.C.U.',
  ['HAWTHORN BANK']: 'HAWTHORN BANK',
  ['HDFC BANK LIMITED']: 'HDFC BANK LIMITED',
  ['HEALTH ADVANTAGE C.U.']: 'HEALTH ADVANTAGE C.U.',
  ['HEALTH CARE C.U.']: 'HEALTH CARE C.U.',
  ['HEALTHCARE EMPLOYEES F.C.U.']: 'HEALTHCARE EMPLOYEES F.C.U.',
  ['HEALTHCARE FINANCIAL F.C.U.']: 'HEALTHCARE FINANCIAL F.C.U.',
  ['HEALTHCARE FIRST C.U.']: 'HEALTHCARE FIRST C.U.',
  ['HEARTLAND BANK']: 'HEARTLAND BANK',
  ['HEIGHTS AUTO WORKERS C.U.']: 'HEIGHTS AUTO WORKERS C.U.',
  ['HELLENIC BANK PUBLIC CO., LTD.']: 'HELLENIC BANK PUBLIC CO., LTD.',
  ['HENRICO F.C.U.']: 'HENRICO F.C.U.',
  ['HERCULES C.U.']: 'HERCULES C.U.',
  ['HERITAGE BANK']: 'HERITAGE BANK',
  ['HERRING BANK']: 'HERRING BANK',
  ['HERSHEY F.C.U.']: 'HERSHEY F.C.U.',
  ['HFC BANK PLC']: 'HFC BANK PLC',
  ['HFS F.C.U.']: 'HFS F.C.U.',
  ['HICKAM FEDERAL CREDIT UNION']: 'HICKAM FEDERAL CREDIT UNION',
  ['HIDDEN RIVER C.U.']: 'HIDDEN RIVER C.U.',
  ['HIGH COUNTRY BANK']: 'HIGH COUNTRY BANK',
  ['HIGHLAND BANK']: 'HIGHLAND BANK',
  ['HILLCREST BANK, N.A.']: 'HILLCREST BANK, N.A.',
  ['HILLS BANK AND TRUST COMPANY']: 'HILLS BANK AND TRUST COMPANY',
  ['HIPOTEKARNA BANKA AD PODGORICA']: 'HIPOTEKARNA BANKA AD PODGORICA',
  ['HITACHI CAPITAL CORPORATION']: 'HITACHI CAPITAL CORPORATION',
  ['HIWAY F.C.U.']: 'HIWAY F.C.U.',
  ['HKT PAYMENT LIMITED']: 'HKT PAYMENT LIMITED',
  ['HO CHI MINH CITY DEVELOPMENT JOINT STOCK COMMERCIAL BANK']:
    'HO CHI MINH CITY DEVELOPMENT JOINT STOCK COMMERCIAL BANK',
  ['HOBOKEN SCHOOL EMPLOYEES F.C.U.']: 'HOBOKEN SCHOOL EMPLOYEES F.C.U.',
  ['HOKKOKU CREDIT SERVICE CO., LTD., THE']: 'HOKKOKU CREDIT SERVICE CO., LTD., THE',
  ['HOKURIKU CARD CO., LTD.']: 'HOKURIKU CARD CO., LTD.',
  ['HOLSTON METHODIST F.C.U.']: 'HOLSTON METHODIST F.C.U.',
  ['HOLVI PAYMENT SERVICES OY']: 'HOLVI PAYMENT SERVICES OY',
  ['HOLY ROSARY C.U.']: 'HOLY ROSARY C.U.',
  ['HOME NATIONAL BANK OF THORNTOWN']: 'HOME NATIONAL BANK OF THORNTOWN',
  ['HOME SAVINGS AND LOAN COMPANY']: 'HOME SAVINGS AND LOAN COMPANY',
  ['HOME STATE BANK']: 'HOME STATE BANK',
  ['HOME TRUST COMPANY']: 'HOME TRUST COMPANY',
  ['HOMEBANK']: 'HOMEBANK',
  ['HOMELAND CREDIT UNION INC.']: 'HOMELAND CREDIT UNION INC.',
  ['HOMESTREET BANK']: 'HOMESTREET BANK',
  ['HOMETOWN BANK']: 'HOMETOWN BANK',
  ['HOMETOWN BANK OF ALABAMA']: 'HOMETOWN BANK OF ALABAMA',
  ['HOMETOWN COMMUNITY BANKS']: 'HOMETOWN COMMUNITY BANKS',
  ['HONDA F.C.U.']: 'HONDA F.C.U.',
  ['HONDO NATIONAL BANK']: 'HONDO NATIONAL BANK',
  ['HONESDALE NATIONAL BANK']: 'HONESDALE NATIONAL BANK',
  ['HONG KONG AND SHANGHAI BANKING CORP., LTD.']: 'HONG KONG AND SHANGHAI BANKING CORP., LTD.',
  ['HONG LEONG BANK BERHAD']: 'HONG LEONG BANK BERHAD',
  ['HONG LEONG BANK CAMBODIA PLC']: 'HONG LEONG BANK CAMBODIA PLC',
  ['HONGKONG AND SHANGHAI BANKING CORPORATION, LTD.']: 'HONGKONG AND SHANGHAI BANKING CORPORATION, LTD.',
  ['HONOR C.U.']: 'HONOR C.U.',
  ['HOPEWELL F.C.U.']: 'HOPEWELL F.C.U.',
  ['HORICON BANK']: 'HORICON BANK',
  ['HORIZON BANK']: 'HORIZON BANK',
  ['HOUSEHOLD BANK']: 'HOUSEHOLD BANK',
  ['HOUSING BANK FOR TRADE AND FINANCE']: 'HOUSING BANK FOR TRADE AND FINANCE',
  ['HOUSTON F.C.U.']: 'HOUSTON F.C.U.',
  ['HOUSTON POLICE FEDERAL CREDIT UNION']: 'HOUSTON POLICE FEDERAL CREDIT UNION',
  ['HOUSTON TEXAS FIRE FIGHTERS F.C.U.']: 'HOUSTON TEXAS FIRE FIGHTERS F.C.U.',
  ['HOWARD BANK']: 'HOWARD BANK',
  ['HSBC']: 'HSBC',
  ['HSBC BANK (SINGAPORE) LIMITED']: 'HSBC BANK (SINGAPORE) LIMITED',
  ['HSBC BANK (TAIWAN) LIMITED']: 'HSBC BANK (TAIWAN) LIMITED',
  ['HSBC BANK (VIETNAM) LTD.']: 'HSBC BANK (VIETNAM) LTD.',
  ['HSBC BANK ARGENTINA S.A.']: 'HSBC BANK ARGENTINA S.A.',
  ['HSBC BANK ARMENIA CJSC']: 'HSBC BANK ARMENIA CJSC',
  ['HSBC BANK AUSTRALIA LIMITED']: 'HSBC BANK AUSTRALIA LIMITED',
  ['HSBC BANK BERMUDA LIMITED']: 'HSBC BANK BERMUDA LIMITED',
  ['HSBC BANK CANADA']: 'HSBC BANK CANADA',
  ['HSBC BANK MALAYSIA BERHAD']: 'HSBC BANK MALAYSIA BERHAD',
  ['HSBC BANK MIDDLE EAST']: 'HSBC BANK MIDDLE EAST',
  ['HSBC BANK PLC']: 'HSBC BANK PLC',
  ['HSBC BANK USA']: 'HSBC BANK USA',
  ['HSBC CONTINENTAL EUROPE']: 'HSBC CONTINENTAL EUROPE',
  ['HSBC FRANCE']: 'HSBC FRANCE',
  ['HSBC MEXICO, S.A.']: 'HSBC MEXICO, S.A.',
  ['HSBC UK BANK PLC']: 'HSBC UK BANK PLC',
  ['HTTP://WWW.USECU.ORG']: 'HTTP://WWW.USECU.ORG',
  ['HUA NAN COMMERCIAL BANK']: 'HUA NAN COMMERCIAL BANK',
  ['HUA XIA BANK CO. LTD.']: 'HUA XIA BANK CO. LTD.',
  ['HUDSON RIVER COMMUNITY C.U.']: 'HUDSON RIVER COMMUNITY C.U.',
  ['HUDSON VALLEY C.U.']: 'HUDSON VALLEY C.U.',
  ['HUMBOLDT BANK']: 'HUMBOLDT BANK',
  ['HUMM CARDS AUSTRALIA PTY LTD']: 'HUMM CARDS AUSTRALIA PTY LTD',
  ['HUMM PRO LIMITED']: 'HUMM PRO LIMITED',
  ['HUNTINGTON NATIONAL BANK']: 'HUNTINGTON NATIONAL BANK',
  ['HYPOTHEKARBANK LENZBURG']: 'HYPOTHEKARBANK LENZBURG',
  ['HYUNDAI CARD']: 'HYUNDAI CARD',
  ['I AND M BANK, LTD.']: 'I AND M BANK, LTD.',
  ['I-C FEDERAL CREDIT UNION']: 'I-C FEDERAL CREDIT UNION',
  ['I. H. MISSISSIPPI VALLEY C.U.']: 'I. H. MISSISSIPPI VALLEY C.U.',
  ['IAA C.U.']: 'IAA C.U.',
  ['IBERIABANK']: 'IBERIABANK',
  ['IBEW AND UNITED WORKERS F.C.U.']: 'IBEW AND UNITED WORKERS F.C.U.',
  ['ICA BANKEN AB']: 'ICA BANKEN AB',
  ['ICARD AD']: 'ICARD AD',
  ['ICBA BANCARD']: 'ICBA BANCARD',
  ['ICBC (LONDON) PLC']: 'ICBC (LONDON) PLC',
  ['ICBC INDIA']: 'ICBC INDIA',
  ['ICEPAY']: 'ICEPAY',
  ['ICICI BANK LIMITED']: 'ICICI BANK LIMITED',
  ['ICON F.C.U.']: 'ICON F.C.U.',
  ['IDAHO CENTRAL C.U.']: 'IDAHO CENTRAL C.U.',
  ['IDB BANK']: 'IDB BANK',
  ['IDEA BANK S.A.']: 'IDEA BANK S.A.',
  ['IDEAL CREDIT UNION']: 'IDEAL CREDIT UNION',
  ['IDT FINANCIAL  SERVICES LIMITED']: 'IDT FINANCIAL  SERVICES LIMITED',
  ['IGORIA TRADE']: 'IGORIA TRADE',
  ['IH C.U.']: 'IH C.U.',
  ['IKANO BANK SE']: 'IKANO BANK SE',
  ['ILLIANA FINANCIAL C.U.']: 'ILLIANA FINANCIAL C.U.',
  ['ILLINOIS COMMUNITY C.U.']: 'ILLINOIS COMMUNITY C.U.',
  ['ILLINOIS EDUCATORS C.U.']: 'ILLINOIS EDUCATORS C.U.',
  ['ILWU C.U.']: 'ILWU C.U.',
  ['IMAGOR, S.A.']: 'IMAGOR, S.A.',
  ['IMB, LTD.']: 'IMB, LTD.',
  ['INB N.A.']: 'INB N.A.',
  ['INBANK AS']: 'INBANK AS',
  ['INCREDIBLEBANK']: 'INCREDIBLEBANK',
  ['INDEPENDENCE BANK OF KENTUCKY']: 'INDEPENDENCE BANK OF KENTUCKY',
  ['INDEPENDENT BANK']: 'INDEPENDENT BANK',
  ['INDIANA MEMBERS C.U.']: 'INDIANA MEMBERS C.U.',
  ['INDIANA UNIVERSITY C.U.']: 'INDIANA UNIVERSITY C.U.',
  ['INDUE, LTD.']: 'INDUE, LTD.',
  ['INDUSIND BANK LIMITED']: 'INDUSIND BANK LIMITED',
  ['INDUSTRIAL & COMMERCIAL BANK OF CHINA, LTD.']: 'INDUSTRIAL & COMMERCIAL BANK OF CHINA, LTD.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ARGENTINA) S.A.']:
    'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ARGENTINA) S.A.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA), LTD.']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA), LTD.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (EUROPE) S.A.']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (EUROPE) S.A.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MACAU) LIMITED']:
    'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MACAU) LIMITED',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD']:
    'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (NEW ZEALAND), LTD.']:
    'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (NEW ZEALAND), LTD.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY, LTD.']:
    'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY, LTD.',
  ['INDUSTRIAL AND COMMERCIAL BANK OF CHINA ASIA), LTD.']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA ASIA), LTD.',
  ['INDUSTRIAL BANK CO., LTD']: 'INDUSTRIAL BANK CO., LTD',
  ['INDUSTRIAL CONSTRUCTION BANK CLOSED JOINT-STOCK COMPANY (ARDSHINBANK']:
    'INDUSTRIAL CONSTRUCTION BANK CLOSED JOINT-STOCK COMPANY (ARDSHINBANK',
  ['INDUSTRIAL F.C.U.']: 'INDUSTRIAL F.C.U.',
  ['INFIBANK']: 'INFIBANK',
  ['INFINITY F.C.U.']: 'INFINITY F.C.U.',
  ['ING BANK (AUSTRALIA), LTD.']: 'ING BANK (AUSTRALIA), LTD.',
  ['ING BANK N.V.']: 'ING BANK N.V.',
  ['ING BANK N.V. AMSTERDAM - BUCHAREST BRANCH']: 'ING BANK N.V. AMSTERDAM - BUCHAREST BRANCH',
  ['ING BANK SLASKI S.A.']: 'ING BANK SLASKI S.A.',
  ['ING BELGIUM']: 'ING BELGIUM',
  ['INNERLAKES F.C.U.']: 'INNERLAKES F.C.U.',
  ['INNOVATIONS F.C.U.']: 'INNOVATIONS F.C.U.',
  ['INOVA F.C.U.']: 'INOVA F.C.U.',
  ['INSIGNIA BANK MALTA']: 'INSIGNIA BANK MALTA',
  ['INSOUTH BANK']: 'INSOUTH BANK',
  ['INSPIRE F.C.U.']: 'INSPIRE F.C.U.',
  ['INSTAPAY TECHNOLOGIES SDN BHD']: 'INSTAPAY TECHNOLOGIES SDN BHD',
  ['INSTITUTION FOR SAVINGS IN NEWBURYPORT AND ITS VICINITY']:
    'INSTITUTION FOR SAVINGS IN NEWBURYPORT AND ITS VICINITY',
  ['INTEGRA FIRST F.C.U.']: 'INTEGRA FIRST F.C.U.',
  ['INTELIGENCIA EN FINANZAS SAPI DE CV']: 'INTELIGENCIA EN FINANZAS SAPI DE CV',
  ['INTELIGO BANK, LTD.']: 'INTELIGO BANK, LTD.',
  ['INTERAUDI BANK']: 'INTERAUDI BANK',
  ['INTERBANK - BANCO INTERNACIONAL DEL PERU']: 'INTERBANK - BANCO INTERNACIONAL DEL PERU',
  ['INTERBANK A.S.']: 'INTERBANK A.S.',
  ['INTERCARD FINANCE A.D.']: 'INTERCARD FINANCE A.D.',
  ['INTERCOMMERCIAL BANK, LTD.']: 'INTERCOMMERCIAL BANK, LTD.',
  ['INTERCREDIT BANK, N.A.']: 'INTERCREDIT BANK, N.A.',
  ['INTERGIRO INTL AB (PUBL)']: 'INTERGIRO INTL AB (PUBL)',
  ['INTERNATIONAL BANK OF AZERBAIJAN']: 'INTERNATIONAL BANK OF AZERBAIJAN',
  ['INTERNATIONAL BANK OF COMMERCE']: 'INTERNATIONAL BANK OF COMMERCE',
  ['INTERNATIONAL BANK OF QATAR QSC']: 'INTERNATIONAL BANK OF QATAR QSC',
  ['INTERNATIONAL BANK OF SOMALIA']: 'INTERNATIONAL BANK OF SOMALIA',
  ['INTERNATIONAL CARD SERVICES BV']: 'INTERNATIONAL CARD SERVICES BV',
  ['INTERNATIONAL HARVESTER EMPLOYEE CREDIT UNION, INC.']: 'INTERNATIONAL HARVESTER EMPLOYEE CREDIT UNION, INC.',
  ['INTERNATIONAL ISLAMIC BANK']: 'INTERNATIONAL ISLAMIC BANK',
  ['INTERPAYMENT SERVICES']: 'INTERPAYMENT SERVICES',
  ['INTERRA C.U.']: 'INTERRA C.U.',
  ['INTERSTATE UNLIMITED F.C.U.']: 'INTERSTATE UNLIMITED F.C.U.',
  ['INTESA SANPAOLO BANK ALBANIA SHA.']: 'INTESA SANPAOLO BANK ALBANIA SHA.',
  ['INTESA SANPAOLO SPA']: 'INTESA SANPAOLO SPA',
  ['INTOUCH C.U.']: 'INTOUCH C.U.',
  ['INTRUST BANK, N.A.']: 'INTRUST BANK, N.A.',
  ['INTRUST FINANCIAL CORP.']: 'INTRUST FINANCIAL CORP.',
  ['INVERSIONES FEDEBAN S.A.']: 'INVERSIONES FEDEBAN S.A.',
  ['INVERSIONES ITSMICAS BANCRECEN S.A.']: 'INVERSIONES ITSMICAS BANCRECEN S.A.',
  ['INVESTAR BANK']: 'INVESTAR BANK',
  ['INVESTEC BANK, LTD.']: 'INVESTEC BANK, LTD.',
  ['INVESTMENT BANK OF CHELYABINSK JS CHELYABINVESTBANK']: 'INVESTMENT BANK OF CHELYABINSK JS CHELYABINVESTBANK',
  ['INVESTORS COMMUNITY BANK']: 'INVESTORS COMMUNITY BANK',
  ['INVESTORS SAVINGS BANK']: 'INVESTORS SAVINGS BANK',
  ['IOWA LEAGUE CORPORATE CENTRAL C.U.']: 'IOWA LEAGUE CORPORATE CENTRAL C.U.',
  ['IQ C.U.']: 'IQ C.U.',
  ['ISABELLA BANK']: 'ISABELLA BANK',
  ['ISABELLA COMMUNITY C.U.']: 'ISABELLA COMMUNITY C.U.',
  ['ISLAND FEDERAL CREDIT UNION']: 'ISLAND FEDERAL CREDIT UNION',
  ['ISRACARD LTD.']: 'ISRACARD LTD.',
  ['ISRAEL CREDIT CARDS LTD.']: 'ISRAEL CREDIT CARDS LTD.',
  ['ISRAEL POSTAL BANK COMPANY LTD']: 'ISRAEL POSTAL BANK COMPANY LTD',
  ['ISTITUTO CENTRALE DELLE BANCHE DI CREDITO COOPERATIVO (ICCREA)']:
    'ISTITUTO CENTRALE DELLE BANCHE DI CREDITO COOPERATIVO (ICCREA)',
  ['ITAU CORPBANCA']: 'ITAU CORPBANCA',
  ['ITAU UNIBANCO S.A.']: 'ITAU UNIBANCO S.A.',
  ['ITHINK FINANCIAL']: 'ITHINK FINANCIAL',
  ['ITHMAAR BANK B.S.C.']: 'ITHMAAR BANK B.S.C.',
  ['ITS BANK']: 'ITS BANK',
  ['IWAGIN CREDIT SERVICE CO., LTD, THE']: 'IWAGIN CREDIT SERVICE CO., LTD, THE',
  ['IXE BANCO, S.A.']: 'IXE BANCO, S.A.',
  ['J P MORGAN EUROPE LTD']: 'J P MORGAN EUROPE LTD',
  ['JACCS CO., LTD.']: 'JACCS CO., LTD.',
  ['JACK HENRY & ASSOCIATES']: 'JACK HENRY & ASSOCIATES',
  ['JAJA FINANCE LIMITED']: 'JAJA FINANCE LIMITED',
  ['JAMMU & KASHMIR BANK LTD., THE']: 'JAMMU & KASHMIR BANK LTD., THE',
  ['JAPAN POST BANK']: 'JAPAN POST BANK',
  ['JAX F.C.U.']: 'JAX F.C.U.',
  ['JD BANK']: 'JD BANK',
  ["JEANNE D'ARC C.U."]: "JEANNE D'ARC C.U.",
  ['JEFFERSON FINANCIAL C.U.']: 'JEFFERSON FINANCIAL C.U.',
  ['JEFFERSON SECURITY BANK']: 'JEFFERSON SECURITY BANK',
  ['JERSEY SHORE F.C.U.']: 'JERSEY SHORE F.C.U.',
  ['JERSEY SHORE STATE BANK']: 'JERSEY SHORE STATE BANK',
  ['JETSTREAM F.C.U.']: 'JETSTREAM F.C.U.',
  ['JHA PAYMENT PROCESSING SOLUTIONS']: 'JHA PAYMENT PROCESSING SOLUTIONS',
  ['JIFITI.COM INC']: 'JIFITI.COM INC',
  ['JOHNS HOPKINS F.C.U.']: 'JOHNS HOPKINS F.C.U.',
  ['JOHNSON FINANCIAL GROUP']: 'JOHNSON FINANCIAL GROUP',
  ['JOINT STOCK BANK UKRGASBANK']: 'JOINT STOCK BANK UKRGASBANK',
  ['JOINT STOCK COMMERCIAL BANK - TBC BANK']: 'JOINT STOCK COMMERCIAL BANK - TBC BANK',
  ['JOINT STOCK COMMERCIAL BANK AK BARS']: 'JOINT STOCK COMMERCIAL BANK AK BARS',
  ['JOINT STOCK COMMERCIAL BANK AVANGARD']: 'JOINT STOCK COMMERCIAL BANK AVANGARD',
  ['JOINT STOCK COMMERCIAL BANK EXIMBANK']: 'JOINT STOCK COMMERCIAL BANK EXIMBANK',
  ['JOINT STOCK COMMERCIAL BANK FOR FOREIGN TRADE OF VIETNAM']:
    'JOINT STOCK COMMERCIAL BANK FOR FOREIGN TRADE OF VIETNAM',
  ['JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT OF VIETNAM']:
    'JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT OF VIETNAM',
  ['JOINT STOCK COMMERCIAL BANK INDUSTRIALBANK']: 'JOINT STOCK COMMERCIAL BANK INDUSTRIALBANK',
  ['JOINT STOCK COMMERCIAL BANK MOLDINDCONBANK S.A.']: 'JOINT STOCK COMMERCIAL BANK MOLDINDCONBANK S.A.',
  ['JOINT STOCK COMMERCIAL BANK MOSCOW INDUSTRIAL BANK']: 'JOINT STOCK COMMERCIAL BANK MOSCOW INDUSTRIAL BANK',
  ['JOINT STOCK COMMERCIAL BANK UNEX']: 'JOINT STOCK COMMERCIAL BANK UNEX',
  ['JOINT STOCK COMPANY ALFA-BANK']: 'JOINT STOCK COMPANY ALFA-BANK',
  ['JOINT STOCK COMPANY ASAKABANK']: 'JOINT STOCK COMPANY ASAKABANK',
  ['JOINT STOCK COMPANY ASIAN-PACIFIC BANK']: 'JOINT STOCK COMPANY ASIAN-PACIFIC BANK',
  ['JOINT STOCK COMPANY BALTIC INTERNATIONAL BANK']: 'JOINT STOCK COMPANY BALTIC INTERNATIONAL BANK',
  ['JOINT STOCK COMPANY BANK CENTERCREDIT']: 'JOINT STOCK COMPANY BANK CENTERCREDIT',
  ['JOINT STOCK COMPANY BANK DOM.RF']: 'JOINT STOCK COMPANY BANK DOM.RF',
  ['JOINT STOCK COMPANY BELAGROPROMBANK']: 'JOINT STOCK COMPANY BELAGROPROMBANK',
  ['JOINT STOCK COMPANY BELARUSIAN-SWISS BANK BSB BANK']: 'JOINT STOCK COMPANY BELARUSIAN-SWISS BANK BSB BANK',
  ['JOINT STOCK COMPANY COMMERCIAL BANK CITIBANK']: 'JOINT STOCK COMPANY COMMERCIAL BANK CITIBANK',
  ['JOINT STOCK COMPANY FIRST UKRAINIAN INTERNATIONAL BANK']: 'JOINT STOCK COMPANY FIRST UKRAINIAN INTERNATIONAL BANK',
  ['JOINT STOCK COMPANY KREDOBANK']: 'JOINT STOCK COMPANY KREDOBANK',
  ['JOINT STOCK COMPANY OTP BANK']: 'JOINT STOCK COMPANY OTP BANK',
  ['JOINT STOCK COMPANY PROCREDIT BANK']: 'JOINT STOCK COMPANY PROCREDIT BANK',
  ['JOINT STOCK COMPANY REGIONALA INVESTICIJU BANKA']: 'JOINT STOCK COMPANY REGIONALA INVESTICIJU BANKA',
  ['JOINT STOCK COMPANY RUSSIAN AGRICULTURAL BANK']: 'JOINT STOCK COMPANY RUSSIAN AGRICULTURAL BANK',
  ['JOINT STOCK COMPANY RUSSIAN STANDARD BANK']: 'JOINT STOCK COMPANY RUSSIAN STANDARD BANK',
  ['JOINT STOCK COMPANY SIAULIU BANKAS']: 'JOINT STOCK COMPANY SIAULIU BANKAS',
  ['JOINT STOCK COMPANY STATE SAVINGS BANK OF UKRAINE (OSCHADBANK)']:
    'JOINT STOCK COMPANY STATE SAVINGS BANK OF UKRAINE (OSCHADBANK)',
  ['JOINT STOCK COMPANY SUBSIDIARY BANK ALFA-BANK']: 'JOINT STOCK COMPANY SUBSIDIARY BANK ALFA-BANK',
  ['JOINT STOCK COMPANY SURGUTNEFTEGASBANK']: 'JOINT STOCK COMPANY SURGUTNEFTEGASBANK',
  ['JOINT STOCK COMPANY UKRSOTSBANK']: 'JOINT STOCK COMPANY UKRSOTSBANK',
  ['JOINT STOCK COMPANY VTB BANK (GEORGIA)']: 'JOINT STOCK COMPANY VTB BANK (GEORGIA)',
  ['JOINT STOCK INNOVATION COMMERCIAL BANK IPAK YULI']: 'JOINT STOCK INNOVATION COMMERCIAL BANK IPAK YULI',
  ['JOINT STOCK SAVINGS BANK BELARUSBANK']: 'JOINT STOCK SAVINGS BANK BELARUSBANK',
  ['JOINT STOCK WEST-SIBERIAN COMMERCIAL BANK']: 'JOINT STOCK WEST-SIBERIAN COMMERCIAL BANK',
  ['JOINT-STOCK BANK PIVDENNYI (JSB PIVDENNYI)']: 'JOINT-STOCK BANK PIVDENNYI (JSB PIVDENNYI)',
  ['JOINT-STOCK COMMERCIAL BANK RYSGAL']: 'JOINT-STOCK COMMERCIAL BANK RYSGAL',
  ['JOINT-STOCK COMPANY BANK OF GEORGIA']: 'JOINT-STOCK COMPANY BANK OF GEORGIA',
  ['JOINT-STOCK COMPANY BANK SOYUZ']: 'JOINT-STOCK COMPANY BANK SOYUZ',
  ['JOINT-STOCK COMPANY MINSK TRANSIT BANK']: 'JOINT-STOCK COMPANY MINSK TRANSIT BANK',
  ['JOINT-STOCK COMPANY RUSSIAN REGIONAL DEVELOPMENT BANK (RRDB)']:
    'JOINT-STOCK COMPANY RUSSIAN REGIONAL DEVELOPMENT BANK (RRDB)',
  ['JOINT-STOCK COMPANY SEVERGAZBANK']: 'JOINT-STOCK COMPANY SEVERGAZBANK',
  ['JOINT-STOCK HALYK SAVINGS BANK OF KAZAKHSTAN']: 'JOINT-STOCK HALYK SAVINGS BANK OF KAZAKHSTAN',
  ['JORDAN AHLI BANK']: 'JORDAN AHLI BANK',
  ['JORDAN COMMERCIAL BANK']: 'JORDAN COMMERCIAL BANK',
  ['JORDAN ISLAMIC BANK CO.']: 'JORDAN ISLAMIC BANK CO.',
  ['JOVIA FINANCIAL C.U.']: 'JOVIA FINANCIAL C.U.',
  ['JPMORGAN CHASE AND CO.']: 'JPMORGAN CHASE AND CO.',
  ['JPMORGAN CHASE BANK']: 'JPMORGAN CHASE BANK',
  ['JPMORGAN CHASE BANK, N.A.']: 'JPMORGAN CHASE BANK, N.A.',
  ['JS BANK ROSEVROBANK']: 'JS BANK ROSEVROBANK',
  ['JS BANK SEVERGAZBANK']: 'JS BANK SEVERGAZBANK',
  ['JS CB OF SUPPORT TO COMMERCE AND BUSINESS SKB-BANK']: 'JS CB OF SUPPORT TO COMMERCE AND BUSINESS SKB-BANK',
  ['JS COMMERCIAL BANK FOR FOREIGN TRADE OF VIETNAM']: 'JS COMMERCIAL BANK FOR FOREIGN TRADE OF VIETNAM',
  ['JS COMMERCIAL BANK ROSBANK']: 'JS COMMERCIAL BANK ROSBANK',
  ['JS SAVINGS BANK BELARUSBANK']: 'JS SAVINGS BANK BELARUSBANK',
  ['JSB AVANGARD']: 'JSB AVANGARD',
  ['JSB DEVON-KREDIT']: 'JSB DEVON-KREDIT',
  ['JSB INTERPROGRESSBANK (CJSC)']: 'JSB INTERPROGRESSBANK (CJSC)',
  ['JSB PIVDENNYI']: 'JSB PIVDENNYI',
  ['JSC ALTYN BANK']: 'JSC ALTYN BANK',
  ['JSC ATF BANK']: 'JSC ATF BANK',
  ['JSC BANK ALEKSANDROVSKY']: 'JSC BANK ALEKSANDROVSKY',
  ['JSC BANK FINSERVICE']: 'JSC BANK FINSERVICE',
  ['JSC BANK FORWARD']: 'JSC BANK FORWARD',
  ['JSC BANK OF GEORGIA']: 'JSC BANK OF GEORGIA',
  ['JSC BANK REPUBLIC']: 'JSC BANK REPUBLIC',
  ['JSC BYSTROBANK']: 'JSC BYSTROBANK',
  ['JSC CAPITAL BANK KAZAKHSTAN']: 'JSC CAPITAL BANK KAZAKHSTAN',
  ['JSC CARTU BANK']: 'JSC CARTU BANK',
  ['JSC CB PRIVATBANK']: 'JSC CB PRIVATBANK',
  ['JSC EURASIAN BANK']: 'JSC EURASIAN BANK',
  ['JSC FORTEBANK']: 'JSC FORTEBANK',
  ['JSC INDUSTRIAL AND INVESTMENT BANK (CSC)']: 'JSC INDUSTRIAL AND INVESTMENT BANK (CSC)',
  ['JSC IZHCOMBANK']: 'JSC IZHCOMBANK',
  ['JSC JSCB CONCORD']: 'JSC JSCB CONCORD',
  ['JSC KASPI BANK']: 'JSC KASPI BANK',
  ['JSC KAZPOST']: 'JSC KAZPOST',
  ['JSC LIBERTY BANK']: 'JSC LIBERTY BANK',
  ['JSC MINSK TRANSIT BANK']: 'JSC MINSK TRANSIT BANK',
  ['JSC OSCHADBANK']: 'JSC OSCHADBANK',
  ['JSC POST BANK']: 'JSC POST BANK',
  ['JSC PRIVATBANK']: 'JSC PRIVATBANK',
  ['JSC RUSSIAN STANDARD BANK']: 'JSC RUSSIAN STANDARD BANK',
  ['JSC SEB BANKA']: 'JSC SEB BANKA',
  ['JSC STATE SAVINGS BANK OF UKRAINE (JSC OSCHADBANK)']: 'JSC STATE SAVINGS BANK OF UKRAINE (JSC OSCHADBANK)',
  ['JSC SUBSIDIARY BANK ALFA-BANK']: 'JSC SUBSIDIARY BANK ALFA-BANK',
  ['JSC TBC BANK']: 'JSC TBC BANK',
  ['JSC TBS BANK']: 'JSC TBS BANK',
  ['JSC UNIVERSAL BANK']: 'JSC UNIVERSAL BANK',
  ['JSC VTB BANK (GEORGIA)']: 'JSC VTB BANK (GEORGIA)',
  ['JSCB AK BARS']: 'JSCB AK BARS',
  ['JSCB BINBANK']: 'JSCB BINBANK',
  ['JSCB FORA BANK']: 'JSCB FORA BANK',
  ['JSCB INDUSTRIALBANK']: 'JSCB INDUSTRIALBANK',
  ['JSCB MOSCOW INDUSTRIAL BANK']: 'JSCB MOSCOW INDUSTRIAL BANK',
  ['JSCB OF SUPPORT TO COMMERCE AND BUSINESS SKB BANK']: 'JSCB OF SUPPORT TO COMMERCE AND BUSINESS SKB BANK',
  ['JSCB ROSBANK']: 'JSCB ROSBANK',
  ['JSCB ROSSIYSKY KAPITAL']: 'JSCB ROSSIYSKY KAPITAL',
  ['JSCB SOYUZ']: 'JSCB SOYUZ',
  ['JSCB TRANSCAPITALBANK']: 'JSCB TRANSCAPITALBANK',
  ['JSTC EMPLOYEES F.C.U.']: 'JSTC EMPLOYEES F.C.U.',
  ['JTB CORP.']: 'JTB CORP.',
  ['K&H BANK ZRT']: 'K&H BANK ZRT',
  ['KALIXA PAY, LTD.']: 'KALIXA PAY, LTD.',
  ['KANBAWZA BANK LIMITED']: 'KANBAWZA BANK LIMITED',
  ['KANE COUNTY TEACHERS C.U.']: 'KANE COUNTY TEACHERS C.U.',
  ['KANSAI CREDIT SERVICE CO., LTD., THE']: 'KANSAI CREDIT SERVICE CO., LTD., THE',
  ['KANSAS CORPORATE C.U.']: 'KANSAS CORPORATE C.U.',
  ['KAPITAL BANK']: 'KAPITAL BANK',
  ['KAPITAL BANK JSB']: 'KAPITAL BANK JSB',
  ['KASIKORNBANK PUBLIC CO., LTD.']: 'KASIKORNBANK PUBLIC CO., LTD.',
  ['KASIKORNBANK PUBLIC COMPANY LIMITED']: 'KASIKORNBANK PUBLIC COMPANY LIMITED',
  ['KASPI BANK JSC']: 'KASPI BANK JSC',
  ['KATAHDIN F.C.U.']: 'KATAHDIN F.C.U.',
  ['KATAHDIN TRUST COMPANY']: 'KATAHDIN TRUST COMPANY',
  ['KAW VALLEY BANK']: 'KAW VALLEY BANK',
  ['KB KOOKMIN']: 'KB KOOKMIN',
  ['KBC BANK IRELAND PLC']: 'KBC BANK IRELAND PLC',
  ['KBC BANKVERZEKERINGSHOLDING (KBC BANK N.V.)']: 'KBC BANKVERZEKERINGSHOLDING (KBC BANK N.V.)',
  ['KEARNY BANK']: 'KEARNY BANK',
  ['KEB HANA CARD CO., LTD.']: 'KEB HANA CARD CO., LTD.',
  ['KELLOGG COMMUNITY F.C.U.']: 'KELLOGG COMMUNITY F.C.U.',
  ['KEMBA DELTA F.C.U.']: 'KEMBA DELTA F.C.U.',
  ['KEMBA FINANCIAL C.U.']: 'KEMBA FINANCIAL C.U.',
  ['KEMBA INDIANAPOLIS C.U.']: 'KEMBA INDIANAPOLIS C.U.',
  ['KENNEBUNK SAVINGS BANK']: 'KENNEBUNK SAVINGS BANK',
  ['KENOWA COMMUNITY F.C.U.']: 'KENOWA COMMUNITY F.C.U.',
  ['KENTUCKY BANK']: 'KENTUCKY BANK',
  ['KENYA COMMERCIAL BANK']: 'KENYA COMMERCIAL BANK',
  ['KEY BANK']: 'KEY BANK',
  ['KEY SOLUTION VENTURE LIMITED']: 'KEY SOLUTION VENTURE LIMITED',
  ['KEYBANK NATIONAL ASSOCIATION']: 'KEYBANK NATIONAL ASSOCIATION',
  ['KGI BANK']: 'KGI BANK',
  ['KHAN BANK']: 'KHAN BANK',
  ['KIEN LONG COMMERCIAL JSB']: 'KIEN LONG COMMERCIAL JSB',
  ['KINECTA F.C.U.']: 'KINECTA F.C.U.',
  ['KINETIC C.U.']: 'KINETIC C.U.',
  ['KINGDOM BANK AFRICA LIMITED']: 'KINGDOM BANK AFRICA LIMITED',
  ['KINGS PEAK C.U.']: 'KINGS PEAK C.U.',
  ['KINKI SHINKIN CARD CO., LTD.']: 'KINKI SHINKIN CARD CO., LTD.',
  ['KIRABOSHI BANK CREDIT SERVICE CO., LTD.']: 'KIRABOSHI BANK CREDIT SERVICE CO., LTD.',
  ['KIRTLAND F.C.U.']: 'KIRTLAND F.C.U.',
  ['KITSAP BANK']: 'KITSAP BANK',
  ['KIWIBANK LIMITED']: 'KIWIBANK LIMITED',
  ['KIYO CARD CO., LTD., THE']: 'KIYO CARD CO., LTD., THE',
  ['KLEINWORT HAMBROS BANK']: 'KLEINWORT HAMBROS BANK',
  ['KNOXVILLE TVA EMPLOYEES C.U.']: 'KNOXVILLE TVA EMPLOYEES C.U.',
  ['KOCHI CARD CO., LTD.']: 'KOCHI CARD CO., LTD.',
  ['KOHLER C.U.']: 'KOHLER C.U.',
  ['KOMERCIJALNA BANKA A.D. BEOGRAD']: 'KOMERCIJALNA BANKA A.D. BEOGRAD',
  ['KOMERCIJALNA BANKA A.D. SKOPJE']: 'KOMERCIJALNA BANKA A.D. SKOPJE',
  ['KOMERCNI BANKA A.S.']: 'KOMERCNI BANKA A.S.',
  ['KONE EMPLOYEES C.U.']: 'KONE EMPLOYEES C.U.',
  ['KRAJOWA SPOLDZIELCZA KASA OSZCZEDNOSCIOWO KREDYTOWA']: 'KRAJOWA SPOLDZIELCZA KASA OSZCZEDNOSCIOWO KREDYTOWA',
  ['KROGER REWARDS PREPAID DEBIT CARD BY U.S. BANK']: 'KROGER REWARDS PREPAID DEBIT CARD BY U.S. BANK',
  ['KRUNG THAI BANK PUBLIC CO., LTD.']: 'KRUNG THAI BANK PUBLIC CO., LTD.',
  ['KRUNGSRIAYUDHYA CARD CO. LTD.']: 'KRUNGSRIAYUDHYA CARD CO. LTD.',
  ['KRUNGTHAI CARD PUBLIC CO., LTD.']: 'KRUNGTHAI CARD PUBLIC CO., LTD.',
  ['KRUNGTHAI CARD PUBLIC COMPANY LIMITED']: 'KRUNGTHAI CARD PUBLIC COMPANY LIMITED',
  ['KT BANK AG']: 'KT BANK AG',
  ['KURSK INDUSTRIAL BANK (JSC) KURSKPROMBANK']: 'KURSK INDUSTRIAL BANK (JSC) KURSKPROMBANK',
  ['KUWAIT FINANCE HOUSE']: 'KUWAIT FINANCE HOUSE',
  ['KUWAIT INTERNATIONAL BANK']: 'KUWAIT INTERNATIONAL BANK',
  ['KYODO CREDIT SERVICE CO.']: 'KYODO CREDIT SERVICE CO.',
  ['KYUSHU CARD CO., LTD.']: 'KYUSHU CARD CO., LTD.',
  ['LA BANQUE POSTALE']: 'LA BANQUE POSTALE',
  ['LA CAPITOL F.C.U.']: 'LA CAPITOL F.C.U.',
  ["LA CONFEDERATION DES CAISSES POPULAIRES ET D'ECONOMIE DESJARDINS DU QUEBEC"]:
    "LA CONFEDERATION DES CAISSES POPULAIRES ET D'ECONOMIE DESJARDINS DU QUEBEC",
  ['LA FEDERATION DES CAISSES DESJARDINS DU QUEBEC']: 'LA FEDERATION DES CAISSES DESJARDINS DU QUEBEC',
  ['LAKE CITY BANK']: 'LAKE CITY BANK',
  ['LAKE COMMUNITY BANK']: 'LAKE COMMUNITY BANK',
  ['LAKE FOREST BANK & TRUST COMPANY, N.A.']: 'LAKE FOREST BANK & TRUST COMPANY, N.A.',
  ['LAKE MICHIGAN C.U.']: 'LAKE MICHIGAN C.U.',
  ['LAKE SUNAPEE BANK FSB']: 'LAKE SUNAPEE BANK FSB',
  ['LAKE SUNAPEE BANK, F.S.B.']: 'LAKE SUNAPEE BANK, F.S.B.',
  ['LAKE TRUST C.U.']: 'LAKE TRUST C.U.',
  ['LAKELAND BANK']: 'LAKELAND BANK',
  ['LAND BANK OF TAIWAN']: 'LAND BANK OF TAIWAN',
  ['LAND BANK OF THE PHILIPPINES']: 'LAND BANK OF THE PHILIPPINES',
  ['LAND OF LINCOLN C.U.']: 'LAND OF LINCOLN C.U.',
  ['LANDESBANK BERLIN AG']: 'LANDESBANK BERLIN AG',
  ['LANDESBANK SAAR']: 'LANDESBANK SAAR',
  ['LANDINGS C.U.']: 'LANDINGS C.U.',
  ['LANDMARK BANK, N.A.']: 'LANDMARK BANK, N.A.',
  ['LANSFORSAKRINGAR BANK AB']: 'LANSFORSAKRINGAR BANK AB',
  ['LANSING AUTOMAKERS F.C.U.']: 'LANSING AUTOMAKERS F.C.U.',
  ['LARI EXCHANGE']: 'LARI EXCHANGE',
  ['LATITUDE FINANCE AUSTRALIA']: 'LATITUDE FINANCE AUSTRALIA',
  ['LAYBUY HOLDINGS LIMITED']: 'LAYBUY HOLDINGS LIMITED',
  ['LCL BANQUE']: 'LCL BANQUE',
  ['LCNB NATIONAL BANK']: 'LCNB NATIONAL BANK',
  ['LEADERS C.U.']: 'LEADERS C.U.',
  ['LEADERS CREDIT UNION']: 'LEADERS CREDIT UNION',
  ['LEATHERSTOCKING C.U.']: 'LEATHERSTOCKING C.U.',
  ['LEBANON CITIZENS NATIONAL BANK']: 'LEBANON CITIZENS NATIONAL BANK',
  ['LEBANON F.C.U.']: 'LEBANON F.C.U.',
  ['LEDYARD NATIONAL BANK']: 'LEDYARD NATIONAL BANK',
  ['LEGACY COMMUNITY F.C.U.']: 'LEGACY COMMUNITY F.C.U.',
  ['LENCO C.U.']: 'LENCO C.U.',
  ['LEOMINSTER C.U.']: 'LEOMINSTER C.U.',
  ['LES BOIS F.C.U.']: 'LES BOIS F.C.U.',
  ['LES F.C.U.']: 'LES F.C.U.',
  ['LES PEOPLES F.C.U.']: 'LES PEOPLES F.C.U.',
  ['LEUMI CARD']: 'LEUMI CARD',
  ['LEWISBURG BANKING COMPANY']: 'LEWISBURG BANKING COMPANY',
  ['LEXINGTON STATE BANK']: 'LEXINGTON STATE BANK',
  ['LEYDEN C.U.']: 'LEYDEN C.U.',
  ['LGE COMMUNITY C.U.']: 'LGE COMMUNITY C.U.',
  ['LIBERTY BANK']: 'LIBERTY BANK',
  ['LIBERTY FIRST C.U.']: 'LIBERTY FIRST C.U.',
  ['LIBERTY SAVINGS BANK F.S.B.']: 'LIBERTY SAVINGS BANK F.S.B.',
  ['LIBRA INTERNET BANK SA']: 'LIBRA INTERNET BANK SA',
  ['LIBYAN ISLAMIC BANK']: 'LIBYAN ISLAMIC BANK',
  ['LIENVIET POST JOINT STOCK COMMERCIAL BANK']: 'LIENVIET POST JOINT STOCK COMMERCIAL BANK',
  ['LIFECARD CO.,LTD.']: 'LIFECARD CO.,LTD.',
  ['LIMITED LIABILITY COMPANY HOME CREDIT & FINANCE BANK']: 'LIMITED LIABILITY COMPANY HOME CREDIT & FINANCE BANK',
  ['LINCOLN MAINE F.C.U.']: 'LINCOLN MAINE F.C.U.',
  ['LINCOLN SAVINGS BANK']: 'LINCOLN SAVINGS BANK',
  ['LINCOLNWAY COMMUNITY BANK']: 'LINCOLNWAY COMMUNITY BANK',
  ['LINDELL BANK']: 'LINDELL BANK',
  ['LINKBANK']: 'LINKBANK',
  ['LINKSER SERVICIOS BANCARIOS AUXILIARES, S.A.']: 'LINKSER SERVICIOS BANCARIOS AUXILIARES, S.A.',
  ['LINN AREA C.U.']: 'LINN AREA C.U.',
  ["LION'S SHARE F.C.U."]: "LION'S SHARE F.C.U.",
  ['LIVE OAK BANKING COMPANY']: 'LIVE OAK BANKING COMPANY',
  ['LIVI BANK LIMITED']: 'LIVI BANK LIMITED',
  ['LLC BANK ROUND']: 'LLC BANK ROUND',
  ['LLC HOME CREDIT AND FINANCE BANK']: 'LLC HOME CREDIT AND FINANCE BANK',
  ['LLOYDS BANK PLC']: 'LLOYDS BANK PLC',
  ['LLOYDS BANK USA']: 'LLOYDS BANK USA',
  ['LLOYDS TSB BANK PLC']: 'LLOYDS TSB BANK PLC',
  ['LOCAL 804 F.C.U.']: 'LOCAL 804 F.C.U.',
  ['LOCKO-BANK']: 'LOCKO-BANK',
  ['LOGAN COUNTY BANK']: 'LOGAN COUNTY BANK',
  ['LOGIX FEDERAL CREDIT UNION']: 'LOGIX FEDERAL CREDIT UNION',
  ['LOLC FINANCE PLC']: 'LOLC FINANCE PLC',
  ['LONE STAR BANK, S.S.B.']: 'LONE STAR BANK, S.S.B.',
  ['LONE STAR NATIONAL BANK']: 'LONE STAR NATIONAL BANK',
  ['LOOKOUT FEDERAL CREDIT UNION']: 'LOOKOUT FEDERAL CREDIT UNION',
  ['LORMET COMMUNITY F.C.U.']: 'LORMET COMMUNITY F.C.U.',
  ['LOS ANGELES POLICE F.C.U.']: 'LOS ANGELES POLICE F.C.U.',
  ['LOTTE CARD CO., LTD.']: 'LOTTE CARD CO., LTD.',
  ['LOWA TRUST & SAVINGS BANK']: 'LOWA TRUST & SAVINGS BANK',
  ['LOWELL FIVE CENT SAVINGS BANK, THE']: 'LOWELL FIVE CENT SAVINGS BANK, THE',
  ['LOYAL BANK, LTD.']: 'LOYAL BANK, LTD.',
  ['LOYOLA UNIVERSITY EMPLOYEES F.C.U.']: 'LOYOLA UNIVERSITY EMPLOYEES F.C.U.',
  ['LUFTHANSA AIRPLUS SERVICEKARTEN GMBH']: 'LUFTHANSA AIRPLUS SERVICEKARTEN GMBH',
  ['LUMINOR BANK AS']: 'LUMINOR BANK AS',
  ['LUNAR A/S']: 'LUNAR A/S',
  ['LUSO F.C.U.']: 'LUSO F.C.U.',
  ['LUSO INTERNATIONAL BANKING LIMITED']: 'LUSO INTERNATIONAL BANKING LIMITED',
  ['LUTHER BURBANK SAVINGS']: 'LUTHER BURBANK SAVINGS',
  ["LYNN FIREMEN'S F.C.U."]: "LYNN FIREMEN'S F.C.U.",
  ['LYNNVILLE NATIONAL BANK']: 'LYNNVILLE NATIONAL BANK',
  ['LYONS NATIONAL BANK']: 'LYONS NATIONAL BANK',
  ['M AND T BANK, N.A.']: 'M AND T BANK, N.A.',
  ['M BANK, F.S.B.']: 'M BANK, F.S.B.',
  ['MAA CARDS SDN BHD']: 'MAA CARDS SDN BHD',
  ['MABREY BANK']: 'MABREY BANK',
  ['MACHIAS SAVINGS BANK']: 'MACHIAS SAVINGS BANK',
  ['MACQUARIE BANK LIMITED']: 'MACQUARIE BANK LIMITED',
  ['MADISON CF UK LIMITED']: 'MADISON CF UK LIMITED',
  ["MADURO & CURIEL'S BANK N.V."]: "MADURO & CURIEL'S BANK N.V.",
  ['MAESTRO INTERNATIONAL']: 'MAESTRO INTERNATIONAL',
  ['MAGNET MAGYAR KOZOSSEGI BANK ZRT.']: 'MAGNET MAGYAR KOZOSSEGI BANK ZRT.',
  ['MAGYAR CETELEM BANK RT.']: 'MAGYAR CETELEM BANK RT.',
  ['MAHOPAC BANK']: 'MAHOPAC BANK',
  ['MAHOPAC NATIONAL BANK']: 'MAHOPAC NATIONAL BANK',
  ['MAIN STREET BANK']: 'MAIN STREET BANK',
  ['MAINE HIGHLANDS F.C.U.']: 'MAINE HIGHLANDS F.C.U.',
  ['MAINE SAVINGS F.C.U.']: 'MAINE SAVINGS F.C.U.',
  ['MAINE STATE C.U.']: 'MAINE STATE C.U.',
  ['MAINSTREET BANK']: 'MAINSTREET BANK',
  ['MAINSTREET CREDIT UNION']: 'MAINSTREET CREDIT UNION',
  ['MAJID AL FUTTAIM FINANCE LLC']: 'MAJID AL FUTTAIM FINANCE LLC',
  ['MALAYAN BANKING BERHAD']: 'MALAYAN BANKING BERHAD',
  ['MANAGEPAY SERVICES SDN BHD']: 'MANAGEPAY SERVICES SDN BHD',
  ['MARGINALEN BANK BANKAKTIEBOLAG']: 'MARGINALEN BANK BANKAKTIEBOLAG',
  ['MARIES COUNTY BANK']: 'MARIES COUNTY BANK',
  ['MARINE BANK AND TRUST']: 'MARINE BANK AND TRUST',
  ['MARINE BANK SPRINGFIELD']: 'MARINE BANK SPRINGFIELD',
  ['MARINE F.C.U.']: 'MARINE F.C.U.',
  ['MARION & POLK SCHOOLS CREDIT UNION']: 'MARION & POLK SCHOOLS CREDIT UNION',
  ['MARITIME BANK']: 'MARITIME BANK',
  ['MARKET USA F.C.U.']: 'MARKET USA F.C.U.',
  ['MARQUETTE BANK']: 'MARQUETTE BANK',
  ['MARQUETTE COMMUNITY F.C.U.']: 'MARQUETTE COMMUNITY F.C.U.',
  ['MARRIOTT EMPLOYEES F.C.U.']: 'MARRIOTT EMPLOYEES F.C.U.',
  ['MARSHALL COMMUNITY C.U.']: 'MARSHALL COMMUNITY C.U.',
  ['MASCOMA BANK']: 'MASCOMA BANK',
  ['MASHREQ BANK']: 'MASHREQ BANK',
  ['MASHREQBANK']: 'MASHREQBANK',
  ['MASRAF AL RAYAN']: 'MASRAF AL RAYAN',
  ['MASSENA SAVINGS AND LOAN']: 'MASSENA SAVINGS AND LOAN',
  ['MASTER RED EUROPA S.L.']: 'MASTER RED EUROPA S.L.',
  ['MASTERCAJAS S.A.']: 'MASTERCAJAS S.A.',
  ['MASTERCARD - OPERATIONS TEAM AND TECHNOLOGIES - BUSINESS OPERATIONS']:
    'MASTERCARD - OPERATIONS TEAM AND TECHNOLOGIES - BUSINESS OPERATIONS',
  ['MASTERCARD - PREPAID DEBIT CARD']: 'MASTERCARD - PREPAID DEBIT CARD',
  ['MASTERCARD - TEST ICAS']: 'MASTERCARD - TEST ICAS',
  ['MATCHMOVE PAY PTE. LTD.']: 'MATCHMOVE PAY PTE. LTD.',
  ['MAWARID FINANCE PJSC']: 'MAWARID FINANCE PJSC',
  ['MAX C.U.']: 'MAX C.U.',
  ['MAX CREDIT UNION']: 'MAX CREDIT UNION',
  ['MAX IT FINANCE LTD']: 'MAX IT FINANCE LTD',
  ['MAYBANK']: 'MAYBANK',
  ['MAYBANK PHILIPPINES, INCORPORATED']: 'MAYBANK PHILIPPINES, INCORPORATED',
  ['MAYBANK SINGAPORE LIMITED']: 'MAYBANK SINGAPORE LIMITED',
  ['MAZUMA C.U.']: 'MAZUMA C.U.',
  ['MB FINANCIAL BANK, N.A.']: 'MB FINANCIAL BANK, N.A.',
  ['MBANK']: 'MBANK',
  ['MBILLS DOO']: 'MBILLS DOO',
  ['MBNA AMERICA (DELAWARE), N.A.']: 'MBNA AMERICA (DELAWARE), N.A.',
  ['MBNA AMERICA BANK']: 'MBNA AMERICA BANK',
  ['MBNA CANADA BANK']: 'MBNA CANADA BANK',
  ['MBNA EUROPE BANK, LTD.']: 'MBNA EUROPE BANK, LTD.',
  ['MBNA LIMITED']: 'MBNA LIMITED',
  ['MCCLAIN BANK']: 'MCCLAIN BANK',
  ['MCCOY F.C.U.']: 'MCCOY F.C.U.',
  ['MCKESSON EMPLOYEES F.C.U.']: 'MCKESSON EMPLOYEES F.C.U.',
  ['MCREDIT']: 'MCREDIT',
  ['ME BANKING']: 'ME BANKING',
  ['MECHANICS BANK']: 'MECHANICS BANK',
  ['MEEM BANK']: 'MEEM BANK',
  ['MEEZAN BANK LIMITED']: 'MEEZAN BANK LIMITED',
  ['MEGABANK JOINT-STOCK COMPANY (MEGABANK, JSC)']: 'MEGABANK JOINT-STOCK COMPANY (MEGABANK, JSC)',
  ['MEIJER C.U.']: 'MEIJER C.U.',
  ['MEMBER ONE F.C.U.']: 'MEMBER ONE F.C.U.',
  ['MEMBER SUPPORT SERVICES, LLC']: 'MEMBER SUPPORT SERVICES, LLC',
  ['MEMBERS 1ST F.C.U.']: 'MEMBERS 1ST F.C.U.',
  ['MEMBERS C.U.']: 'MEMBERS C.U.',
  ['MEMBERS CHOICE C.U.']: 'MEMBERS CHOICE C.U.',
  ['MEMBERS COMMUNITY C.U.']: 'MEMBERS COMMUNITY C.U.',
  ['MEMBERS EQUITY BANK LIMITED']: 'MEMBERS EQUITY BANK LIMITED',
  ['MEMBERS EXCHANGE C.U.']: 'MEMBERS EXCHANGE C.U.',
  ['MEMBERS FIRST COMMUNITY C.U.']: 'MEMBERS FIRST COMMUNITY C.U.',
  ['MEMBERS FIRST CREDIT UNION OF FLORIDA']: 'MEMBERS FIRST CREDIT UNION OF FLORIDA',
  ['MEMBERS FIRST CT F.C.U.']: 'MEMBERS FIRST CT F.C.U.',
  ['MEMBERS HERITAGE C.U.']: 'MEMBERS HERITAGE C.U.',
  ['MEMBERS PLUS CREDIT UNION']: 'MEMBERS PLUS CREDIT UNION',
  ['MEMBERS SOURCE C.U.']: 'MEMBERS SOURCE C.U.',
  ['MEMBERSALLIANCE C.U.']: 'MEMBERSALLIANCE C.U.',
  ['MEMBERSFIRST C.U.']: 'MEMBERSFIRST C.U.',
  ['MEMPHIS CITY EMPLOYEES CREDIT UNION']: 'MEMPHIS CITY EMPLOYEES CREDIT UNION',
  ['MENLO SURVEY F.C.U.']: 'MENLO SURVEY F.C.U.',
  ['MERCADOLIBRE SA DE CV INSTITUCION DE FONDOS DE PAGO ELECTRONICO']:
    'MERCADOLIBRE SA DE CV INSTITUCION DE FONDOS DE PAGO ELECTRONICO',
  ['MERCADOLIBRE SRL']: 'MERCADOLIBRE SRL',
  ['MERCANTILE BANCORPORATION, INC.']: 'MERCANTILE BANCORPORATION, INC.',
  ['MERCANTILE BANK']: 'MERCANTILE BANK',
  ['MERCANTILE BANK OF MICHIGAN']: 'MERCANTILE BANK OF MICHIGAN',
  ['MERCEDES-BENZ BANK AG']: 'MERCEDES-BENZ BANK AG',
  ['MERCHANTS AND MARINE BANK']: 'MERCHANTS AND MARINE BANK',
  ['MERCHANTS AND PLANTERS BANK']: 'MERCHANTS AND PLANTERS BANK',
  ['MERCHANTS BANK, N.A.']: 'MERCHANTS BANK, N.A.',
  ['MERHO F.C.U.']: 'MERHO F.C.U.',
  ['MERIDIAN BANK']: 'MERIDIAN BANK',
  ['MERITRUST C.U.']: 'MERITRUST C.U.',
  ['MERIWEST CREDIT UNION']: 'MERIWEST CREDIT UNION',
  ['MERRICK BANK CORPORATION']: 'MERRICK BANK CORPORATION',
  ['MERRILL LYNCH BANK USA']: 'MERRILL LYNCH BANK USA',
  ['MERRIMACK VALLEY F.C.U.']: 'MERRIMACK VALLEY F.C.U.',
  ['METABANK']: 'METABANK',
  ['METRO BANK']: 'METRO BANK',
  ['METRO C.U.']: 'METRO C.U.',
  ['METRO EMPLOYEES C.U.']: 'METRO EMPLOYEES C.U.',
  ['METROBANK']: 'METROBANK',
  ['METROBANK CARD CORPORATION (A FINANCE COMPANY)']: 'METROBANK CARD CORPORATION (A FINANCE COMPANY)',
  ['METROPOLITAN BANK AND TRUST COMPANY (METROBANK)']: 'METROPOLITAN BANK AND TRUST COMPANY (METROBANK)',
  ['METROPOLITAN COMMERCIAL BANK']: 'METROPOLITAN COMMERCIAL BANK',
  ['MIAMI POSTAL SERVICE C.U.']: 'MIAMI POSTAL SERVICE C.U.',
  ['MICARD CO., LTD.']: 'MICARD CO., LTD.',
  ['MICHIGAN EDUCATIONAL C.U.']: 'MICHIGAN EDUCATIONAL C.U.',
  ['MICHIGAN FIRST C.U.']: 'MICHIGAN FIRST C.U.',
  ['MICHIGAN LEGACY C.U.']: 'MICHIGAN LEGACY C.U.',
  ['MICHIGAN SCHOOLS AND GOVERNMENT C.U.']: 'MICHIGAN SCHOOLS AND GOVERNMENT C.U.',
  ['MICHIGAN STATE UNIVERSITY F.C.U.']: 'MICHIGAN STATE UNIVERSITY F.C.U.',
  ['MID AMERICA BANK']: 'MID AMERICA BANK',
  ['MID CAROLINA C.U.']: 'MID CAROLINA C.U.',
  ['MID MINNESOTA F.C.U.']: 'MID MINNESOTA F.C.U.',
  ['MID PENN BANK']: 'MID PENN BANK',
  ['MID-ATLANTIC F.C.U.']: 'MID-ATLANTIC F.C.U.',
  ['MID-CITIES C.U.']: 'MID-CITIES C.U.',
  ['MID-HUDSON VALLEY F.C.U.']: 'MID-HUDSON VALLEY F.C.U.',
  ['MID-ILLINI C.U.']: 'MID-ILLINI C.U.',
  ['MIDCOAST F.C.U.']: 'MIDCOAST F.C.U.',
  ['MIDCOUNTRY BANK']: 'MIDCOUNTRY BANK',
  ['MIDDLE EAST PAYMENT SERVICES LIMITED CO.']: 'MIDDLE EAST PAYMENT SERVICES LIMITED CO.',
  ['MIDDLESEX SAVINGS BANK']: 'MIDDLESEX SAVINGS BANK',
  ['MIDFIRST BANK']: 'MIDFIRST BANK',
  ['MIDFLORIDA C.U.']: 'MIDFLORIDA C.U.',
  ['MIDLAND FEDERAL SAVINGS AND LOAN ASSOCIATION']: 'MIDLAND FEDERAL SAVINGS AND LOAN ASSOCIATION',
  ['MIDLAND STATES BANK']: 'MIDLAND STATES BANK',
  ['MIDSOUTH BANK, N.A.']: 'MIDSOUTH BANK, N.A.',
  ['MIDWAY S.A. - CREDITO, FINANCIAMENTO E INVESTIMENTO']: 'MIDWAY S.A. - CREDITO, FINANCIAMENTO E INVESTIMENTO',
  ['MIDWEST BANK']: 'MIDWEST BANK',
  ['MIDWEST C.U.']: 'MIDWEST C.U.',
  ['MIDWEST CARPENTERS AND MILLWRIGHTS F.C.U.']: 'MIDWEST CARPENTERS AND MILLWRIGHTS F.C.U.',
  ['MIDWEST COALITION OF LABOR C.U.']: 'MIDWEST COALITION OF LABOR C.U.',
  ['MIDWEST MEMBERS C.U.']: 'MIDWEST MEMBERS C.U.',
  ['MIDWEST PAYMENT SYSTEMS, INC.']: 'MIDWEST PAYMENT SYSTEMS, INC.',
  ['MIEGIN CARD CO., LTD., THE']: 'MIEGIN CARD CO., LTD., THE',
  ['MILITARY COMMERCIAL JOINT STOCK BANK']: 'MILITARY COMMERCIAL JOINT STOCK BANK',
  ['MILITARY COMMERCIAL JSB']: 'MILITARY COMMERCIAL JSB',
  ['MILLEDGEVILLE STATE BANK']: 'MILLEDGEVILLE STATE BANK',
  ['MILLINGTON SAVINGS BANK']: 'MILLINGTON SAVINGS BANK',
  ['MINATO CARD COMPANY LIMITED']: 'MINATO CARD COMPANY LIMITED',
  ['MINNCO C.U.']: 'MINNCO C.U.',
  ['MINNEQUA WORKS C.U.']: 'MINNEQUA WORKS C.U.',
  ['MINNESOTA BUILDING TRADES F.C.U.']: 'MINNESOTA BUILDING TRADES F.C.U.',
  ['MINNESOTA VALLEY FEDERAL CREDIT UNION']: 'MINNESOTA VALLEY FEDERAL CREDIT UNION',
  ['MINNWEST BANK METRO']: 'MINNWEST BANK METRO',
  ['MISSION BANK']: 'MISSION BANK',
  ['MISSION CITY F.C.U.']: 'MISSION CITY F.C.U.',
  ['MISSION FEDERAL CREDIT UNION']: 'MISSION FEDERAL CREDIT UNION',
  ['MISSISSIPPI F.C.U.']: 'MISSISSIPPI F.C.U.',
  ['MITSUBISHI UFJ FINANCIAL GROUP, INC.']: 'MITSUBISHI UFJ FINANCIAL GROUP, INC.',
  ['MITSUBISHI UFJ NICOS CO., LTD.']: 'MITSUBISHI UFJ NICOS CO., LTD.',
  ['MKB BANK NYRT.']: 'MKB BANK NYRT.',
  ['MKB BANK ZRT.']: 'MKB BANK ZRT.',
  ['MOAMALAT FINANCIAL SERVICES CO']: 'MOAMALAT FINANCIAL SERVICES CO',
  ['MOBIASBANCA - OTP GRUP SA']: 'MOBIASBANCA - OTP GRUP SA',
  ['MOCSE F.C.U.']: 'MOCSE F.C.U.',
  ['MODERN TREUHAND CORPORATE SERVICES, LTD.']: 'MODERN TREUHAND CORPORATE SERVICES, LTD.',
  ['MODULBANK']: 'MODULBANK',
  ['MODULR FS LIMITED']: 'MODULR FS LIMITED',
  ['MOLINE MUNICIPAL C.U.']: 'MOLINE MUNICIPAL C.U.',
  ['MONAVATE LIMITED']: 'MONAVATE LIMITED',
  ['MONETA MONEY BANK, A.S.']: 'MONETA MONEY BANK, A.S.',
  ['MONEY CARD ASSOCIATION PR LEAGUE, INC.']: 'MONEY CARD ASSOCIATION PR LEAGUE, INC.',
  ['MONEY MAIL RU']: 'MONEY MAIL RU',
  ['MONONA STATE BANK']: 'MONONA STATE BANK',
  ['MONROE COUNTY COMMUNITY C.U.']: 'MONROE COUNTY COMMUNITY C.U.',
  ['MONROE TELCO F.C.U.']: 'MONROE TELCO F.C.U.',
  ['MONTEPIO GERAL - CAIXA ECONOMICA DE LISBOA']: 'MONTEPIO GERAL - CAIXA ECONOMICA DE LISBOA',
  ['MONTEREY C.U.']: 'MONTEREY C.U.',
  ['MONTEREY COUNTY BANK']: 'MONTEREY COUNTY BANK',
  ['MONZO BANK LIMITED']: 'MONZO BANK LIMITED',
  ['MOORWAND LTD']: 'MOORWAND LTD',
  ['MORGAN STANLEY PRIVATE BANK NA']: 'MORGAN STANLEY PRIVATE BANK NA',
  ['MORNING']: 'MORNING',
  ['MOTION F.C.U.']: 'MOTION F.C.U.',
  ['MOUND CITY BANK']: 'MOUND CITY BANK',
  ['MOUNTAIN AMERICA C.U.']: 'MOUNTAIN AMERICA C.U.',
  ['MOUNTAIN VALLEY BANK']: 'MOUNTAIN VALLEY BANK',
  ['MOUNTAINCREST C.U.']: 'MOUNTAINCREST C.U.',
  ['MOUNTAINONE BANK']: 'MOUNTAINONE BANK',
  ['MOX BANK LIMITED']: 'MOX BANK LIMITED',
  ['MOZA BANCO']: 'MOZA BANCO',
  ['MPECU']: 'MPECU',
  ['MRV BANKS']: 'MRV BANKS',
  ['MTB BANK']: 'MTB BANK',
  ['MTB MAGYAR TAKAREKSZOVETKEZETI BANK ZRT']: 'MTB MAGYAR TAKAREKSZOVETKEZETI BANK ZRT',
  ['MTC FEDERAL CREDIT UNION']: 'MTC FEDERAL CREDIT UNION',
  ['MUFG UNION BANK']: 'MUFG UNION BANK',
  ['MULTIBANK, INC.']: 'MULTIBANK, INC.',
  ['MULTIPLI C.U.']: 'MULTIPLI C.U.',
  ['MUNICIPAL EMPLOYEES CREDIT UNION OF BALTIMORE, INC.']: 'MUNICIPAL EMPLOYEES CREDIT UNION OF BALTIMORE, INC.',
  ['MUNICIPAL EMPLOYEES CREDIT UNION OF OKLAHOMA CITY']: 'MUNICIPAL EMPLOYEES CREDIT UNION OF OKLAHOMA CITY',
  ['MUTUAL C.U.']: 'MUTUAL C.U.',
  ['MUTUAL FEDERAL SAVINGS BANK']: 'MUTUAL FEDERAL SAVINGS BANK',
  ['MUTUAL SAVINGS BANK, F.S.B.']: 'MUTUAL SAVINGS BANK, F.S.B.',
  ['MUTUAL SAVINGS C.U.']: 'MUTUAL SAVINGS C.U.',
  ['MUTUAL SECURITY CREDIT UNION, INC.']: 'MUTUAL SECURITY CREDIT UNION, INC.',
  ['MVB BANK INC']: 'MVB BANK INC',
  ['MY C.U.']: 'MY C.U.',
  ['MYANMA APEX BANK LIMITED']: 'MYANMA APEX BANK LIMITED',
  ['N26 GMBH']: 'N26 GMBH',
  ['NAB BANK']: 'NAB BANK',
  ['NAM A COMMERCIAL JOINT STOCK BANK']: 'NAM A COMMERCIAL JOINT STOCK BANK',
  ['NANTO CARD SERVICE CO., LTD']: 'NANTO CARD SERVICE CO., LTD',
  ['NASA F.C.U.']: 'NASA F.C.U.',
  ['NASSAU FINANCIAL F.C.U.']: 'NASSAU FINANCIAL F.C.U.',
  ['NATCO C.U.']: 'NATCO C.U.',
  ['NATIONAL AUSTRALIA BANK, LTD.']: 'NATIONAL AUSTRALIA BANK, LTD.',
  ['NATIONAL BANK FOR FOREIGN ECONOMIC ACTIVITY OF THE REPUBLIC OF UZBEKIS']:
    'NATIONAL BANK FOR FOREIGN ECONOMIC ACTIVITY OF THE REPUBLIC OF UZBEKIS',
  ['NATIONAL BANK OF BAHRAIN']: 'NATIONAL BANK OF BAHRAIN',
  ['NATIONAL BANK OF BLACKSBURG']: 'NATIONAL BANK OF BLACKSBURG',
  ['NATIONAL BANK OF CANADA']: 'NATIONAL BANK OF CANADA',
  ['NATIONAL BANK OF COMMERCE']: 'NATIONAL BANK OF COMMERCE',
  ['NATIONAL BANK OF DOMINICA LTD.']: 'NATIONAL BANK OF DOMINICA LTD.',
  ['NATIONAL BANK OF DUBAI PUBLIC JSC']: 'NATIONAL BANK OF DUBAI PUBLIC JSC',
  ['NATIONAL BANK OF EGYPT']: 'NATIONAL BANK OF EGYPT',
  ['NATIONAL BANK OF GREECE S.A.']: 'NATIONAL BANK OF GREECE S.A.',
  ['NATIONAL BANK OF KUWAIT (S.A.K.)']: 'NATIONAL BANK OF KUWAIT (S.A.K.)',
  ['NATIONAL BANK OF KUWAIT, S.A.K.']: 'NATIONAL BANK OF KUWAIT, S.A.K.',
  ['NATIONAL BANK OF NEW ZEALAND, LTD.']: 'NATIONAL BANK OF NEW ZEALAND, LTD.',
  ['NATIONAL BANK OF OMAN (SAOG)']: 'NATIONAL BANK OF OMAN (SAOG)',
  ['NATIONAL BANK OF RAS AL-KHAIMAH (RAKBANK)']: 'NATIONAL BANK OF RAS AL-KHAIMAH (RAKBANK)',
  ['NATIONAL BANK OF SALLISAW']: 'NATIONAL BANK OF SALLISAW',
  ['NATIONAL BANK OF UMM AL-QAIWAIN PSC.']: 'NATIONAL BANK OF UMM AL-QAIWAIN PSC.',
  ['NATIONAL CITY BANK']: 'NATIONAL CITY BANK',
  ['NATIONAL CITY BANK OF KENTUCKY']: 'NATIONAL CITY BANK OF KENTUCKY',
  ['NATIONAL COMMERCIAL BANK']: 'NATIONAL COMMERCIAL BANK',
  ['NATIONAL COMMERCIAL BANK JAMAICA LIMITED']: 'NATIONAL COMMERCIAL BANK JAMAICA LIMITED',
  ['NATIONAL CREDIT CARD CENTER']: 'NATIONAL CREDIT CARD CENTER',
  ['NATIONAL DEVELOPMENT BANK PLC']: 'NATIONAL DEVELOPMENT BANK PLC',
  ['NATIONAL EXCHANGE BANK AND TRUST']: 'NATIONAL EXCHANGE BANK AND TRUST',
  ['NATIONAL SOCIETE GENERALE BANK S.A.E.']: 'NATIONAL SOCIETE GENERALE BANK S.A.E.',
  ['NATIONAL WESTMINSTER BANK PLC']: 'NATIONAL WESTMINSTER BANK PLC',
  ['NATIONS TRUST BANK PLC']: 'NATIONS TRUST BANK PLC',
  ['NATIXIS']: 'NATIXIS',
  ['NAVAL RESEARCH LAB F.C.U.']: 'NAVAL RESEARCH LAB F.C.U.',
  ['NAVIGATOR C.U.']: 'NAVIGATOR C.U.',
  ['NAVY ARMY COMMUNITY CREDIT UNION']: 'NAVY ARMY COMMUNITY CREDIT UNION',
  ['NAVY F.C.U.']: 'NAVY F.C.U.',
  ['NAVY FEDERAL CREDIT UNION']: 'NAVY FEDERAL CREDIT UNION',
  ['NBH BANK, N.A.']: 'NBH BANK, N.A.',
  ['NCBA BANK KENYA PLC']: 'NCBA BANK KENYA PLC',
  ['NCMIC FINANCE CORPORATION']: 'NCMIC FINANCE CORPORATION',
  ['NEC PAYMENTS BSC']: 'NEC PAYMENTS BSC',
  ['NECHES F.C.U.']: 'NECHES F.C.U.',
  ['NEDBANK LIMITED']: 'NEDBANK LIMITED',
  ['NEDCOR BANK LIMITED']: 'NEDCOR BANK LIMITED',
  ['NEIGHBORHOOD C.U.']: 'NEIGHBORHOOD C.U.',
  ['NEIGHBORS C.U.']: 'NEIGHBORS C.U.',
  ['NEKOOSA PORT EDWARDS STATE BANK']: 'NEKOOSA PORT EDWARDS STATE BANK',
  ['NEPAL GRINDLAYS BANK LTD.']: 'NEPAL GRINDLAYS BANK LTD.',
  ['NEPAL INVESTMENT BANK, LTD.']: 'NEPAL INVESTMENT BANK, LTD.',
  ['NESC F.C.U.']: 'NESC F.C.U.',
  ['NET SPEND']: 'NET SPEND',
  ['NETS DENMARK A S']: 'NETS DENMARK A S',
  ['NETSPEND']: 'NETSPEND',
  ['NETWORK INTERNATIONAL LLC']: 'NETWORK INTERNATIONAL LLC',
  ['NETWORK INTERNATIONAL PAYMENT SERVICES']: 'NETWORK INTERNATIONAL PAYMENT SERVICES',
  ['NETWORK ONLY']: 'NETWORK ONLY',
  ['NEW CENTURY BANK']: 'NEW CENTURY BANK',
  ['NEW DIMENSIONS F.C.U.']: 'NEW DIMENSIONS F.C.U.',
  ['NEW ENGLAND BANKCARD ASSOCIATION, INC.']: 'NEW ENGLAND BANKCARD ASSOCIATION, INC.',
  ['NEW ENGLAND F.C.U.']: 'NEW ENGLAND F.C.U.',
  ['NEW ENGLAND TEAMSTERS F.C.U.']: 'NEW ENGLAND TEAMSTERS F.C.U.',
  ['NEW ERA BANK']: 'NEW ERA BANK',
  ['NEW FRONTIER BANK']: 'NEW FRONTIER BANK',
  ['NEW HORIZONS CREDIT UNION, INC.']: 'NEW HORIZONS CREDIT UNION, INC.',
  ['NEW JERSEY COMMUNITY F.C.U.']: 'NEW JERSEY COMMUNITY F.C.U.',
  ['NEW JERSEY LAW AND PUBLIC SAFETY C.U.']: 'NEW JERSEY LAW AND PUBLIC SAFETY C.U.',
  ['NEW PEOPLES BANK, INC.']: 'NEW PEOPLES BANK, INC.',
  ['NEW SYMBOL BANK NSB']: 'NEW SYMBOL BANK NSB',
  ['NEW YORK COMMERCIAL BANK']: 'NEW YORK COMMERCIAL BANK',
  ['NEW YORK COMMUNITY BANK']: 'NEW YORK COMMUNITY BANK',
  ['NEW YORK COMMUNITY BANK (OHIO SAVINGS BANK)']: 'NEW YORK COMMUNITY BANK (OHIO SAVINGS BANK)',
  ['NEW YORK UNIVERSITY F.C.U.']: 'NEW YORK UNIVERSITY F.C.U.',
  ['NEW ZEALAND ASSOCIATION OF CREDIT UNIONS']: 'NEW ZEALAND ASSOCIATION OF CREDIT UNIONS',
  ['NEWDAY LTD']: 'NEWDAY LTD',
  ['NEXI PAYMENTS SPA']: 'NEXI PAYMENTS SPA',
  ['NEXTIER BANK, N.A.']: 'NEXTIER BANK, N.A.',
  ['NEYVA BANK LLC']: 'NEYVA BANK LLC',
  ['NGFCU']: 'NGFCU',
  ['NIB BANK, LTD.']: 'NIB BANK, LTD.',
  ['NICOLET NATIONAL BANK']: 'NICOLET NATIONAL BANK',
  ['NICOM C.U.']: 'NICOM C.U.',
  ['NLB BANKA AD BEOGRAD']: 'NLB BANKA AD BEOGRAD',
  ['NLB BANKA AD PODGORICA']: 'NLB BANKA AD PODGORICA',
  ['NLB BANKA AD SKOPJE']: 'NLB BANKA AD SKOPJE',
  ['NLB BANKA D.D. SARAJEVO']: 'NLB BANKA D.D. SARAJEVO',
  ['NLB BANKA SH.A.']: 'NLB BANKA SH.A.',
  ['NOBLE C.U.']: 'NOBLE C.U.',
  ['NODAWAY VALLEY BANK']: 'NODAWAY VALLEY BANK',
  ['NONGHYUP BANK']: 'NONGHYUP BANK',
  ['NOOR BANK PJSC']: 'NOOR BANK PJSC',
  ['NORDDEUTSCHE LANDESBANK GIROZENTRALE NORD LB']: 'NORDDEUTSCHE LANDESBANK GIROZENTRALE NORD LB',
  ['NORDEA BANK AB']: 'NORDEA BANK AB',
  ['NORDEA BANK ABP']: 'NORDEA BANK ABP',
  ['NORDEA BANK NORGE ASA HK']: 'NORDEA BANK NORGE ASA HK',
  ['NORRISTOWN BELL C.U.']: 'NORRISTOWN BELL C.U.',
  ['NORSTATE F.C.U.']: 'NORSTATE F.C.U.',
  ['NORTH AMERICAN SAVINGS BANK, F.S.B.']: 'NORTH AMERICAN SAVINGS BANK, F.S.B.',
  ["NORTH CAROLINA STATE EMPLOYEES' C.U."]: "NORTH CAROLINA STATE EMPLOYEES' C.U.",
  ['NORTH HAWAII COMMUNITY F.C.U.']: 'NORTH HAWAII COMMUNITY F.C.U.',
  ['NORTH ISLAND FINANCIAL C.U.']: 'NORTH ISLAND FINANCIAL C.U.',
  ['NORTH JERSEY F.C.U.']: 'NORTH JERSEY F.C.U.',
  ['NORTH SALEM STATE BANK']: 'NORTH SALEM STATE BANK',
  ['NORTH SHORE BANK, FSB']: 'NORTH SHORE BANK, FSB',
  ['NORTH STAR COMMUNITY C.U.']: 'NORTH STAR COMMUNITY C.U.',
  ['NORTH STATE BANK']: 'NORTH STATE BANK',
  ['NORTHEAST C.U.']: 'NORTHEAST C.U.',
  ['NORTHERN BANK &TRUST COMPANY']: 'NORTHERN BANK &TRUST COMPANY',
  ['NORTHERN F.C.U.']: 'NORTHERN F.C.U.',
  ['NORTHERN SKIES F.C.U.']: 'NORTHERN SKIES F.C.U.',
  ['NORTHERN STATE BANK']: 'NORTHERN STATE BANK',
  ['NORTHERN TRUST, N.A.']: 'NORTHERN TRUST, N.A.',
  ['NORTHERN UNITED F.C.U.']: 'NORTHERN UNITED F.C.U.',
  ['NORTHFIELD BANK']: 'NORTHFIELD BANK',
  ['NORTHLAND AREA F.C.U.']: 'NORTHLAND AREA F.C.U.',
  ['NORTHPOINTE BANK']: 'NORTHPOINTE BANK',
  ['NORTHRIM BANK']: 'NORTHRIM BANK',
  ['NORTHSTAR C.U.']: 'NORTHSTAR C.U.',
  ['NORTHWEST BANK']: 'NORTHWEST BANK',
  ['NORTHWEST COMMUNITY C.U.']: 'NORTHWEST COMMUNITY C.U.',
  ['NORTHWEST F.C.U.']: 'NORTHWEST F.C.U.',
  ['NORTHWEST HILLS C.U.']: 'NORTHWEST HILLS C.U.',
  ['NORTHWEST SAVINGS BANK']: 'NORTHWEST SAVINGS BANK',
  ['NORTHWOODS C.U.']: 'NORTHWOODS C.U.',
  ['NOTHERN MASSACHUSETTS TELEPHONE WORKERS COMMUNITY C.U.']: 'NOTHERN MASSACHUSETTS TELEPHONE WORKERS COMMUNITY C.U.',
  ['NOTRE DAME F.C.U.']: 'NOTRE DAME F.C.U.',
  ['NOVA BANKA AD BANJA LUKA']: 'NOVA BANKA AD BANJA LUKA',
  ['NOVA C.U.']: 'NOVA C.U.',
  ['NOVA KREDITNA BANKA MARIBOR D.D. MARIBOR']: 'NOVA KREDITNA BANKA MARIBOR D.D. MARIBOR',
  ['NOVA LJUBLJANSKA BANKA D.D., LJUBLJANA']: 'NOVA LJUBLJANSKA BANKA D.D., LJUBLJANA',
  ['NOVO BANCO S.A.']: 'NOVO BANCO S.A.',
  ['NOVUM BANK LIMITED']: 'NOVUM BANK LIMITED',
  ['NSWC F.C.U.']: 'NSWC F.C.U.',
  ['NTT FINANCE CORPORATION']: 'NTT FINANCE CORPORATION',
  ['NTT SMART TRADE INC.']: 'NTT SMART TRADE INC.',
  ['NU PAGAMENTOS SA']: 'NU PAGAMENTOS SA',
  ['NUEVO BANCO COMERCIAL, S.A.']: 'NUEVO BANCO COMERCIAL, S.A.',
  ['NUMARK C.U.']: 'NUMARK C.U.',
  ['NUMBER26 MAESTRO ISSUED BY WIRECARD BANK AG']: 'NUMBER26 MAESTRO ISSUED BY WIRECARD BANK AG',
  ['NUMERICA C.U.']: 'NUMERICA C.U.',
  ['NURBANK JSC']: 'NURBANK JSC',
  ['NUSENDA FEDERAL CREDIT UNION']: 'NUSENDA FEDERAL CREDIT UNION',
  ['NUVISION C.U.']: 'NUVISION C.U.',
  ['NUVISTA F.C.U.']: 'NUVISTA F.C.U.',
  ['NVAYO LIMITED']: 'NVAYO LIMITED',
  ['NW PREFERRED F.C.U.']: 'NW PREFERRED F.C.U.',
  ['NW PRIORITY C.U.']: 'NW PRIORITY C.U.',
  ['NYCE PAYMENTS NETWORK LLC']: 'NYCE PAYMENTS NETWORK LLC',
  ['NYMEO F.C.U.']: 'NYMEO F.C.U.',
  ['O BEE C.U.']: 'O BEE C.U.',
  ['OAK HILL BANKS']: 'OAK HILL BANKS',
  ['OAKLAND COUNTY C.U.']: 'OAKLAND COUNTY C.U.',
  ['OAS STAFF F.C.U.']: 'OAS STAFF F.C.U.',
  ['OCA S.A.']: 'OCA S.A.',
  ['OCBC BANK (MALAYSIA) BERHAD']: 'OCBC BANK (MALAYSIA) BERHAD',
  ['OCBC WING HANG BANK LIMITED']: 'OCBC WING HANG BANK LIMITED',
  ['OCEAN BANK']: 'OCEAN BANK',
  ['OCEAN FINANCIAL F.C.U.']: 'OCEAN FINANCIAL F.C.U.',
  ['OCEAN PAY ISSUED BY THE BANCORP BANK']: 'OCEAN PAY ISSUED BY THE BANCORP BANK',
  ['OCEANFIRST BANK']: 'OCEANFIRST BANK',
  ['OCONEE STATE BANK']: 'OCONEE STATE BANK',
  ['OCTOPUS CARDS LIMITED']: 'OCTOPUS CARDS LIMITED',
  ['ODEABANK']: 'ODEABANK',
  ['OE F.C.U.']: 'OE F.C.U.',
  ['OHIO CENTRAL SAVINGS']: 'OHIO CENTRAL SAVINGS',
  ['OHIO HEALTHCARE F.C.U.']: 'OHIO HEALTHCARE F.C.U.',
  ['OHIO UNIVERSITY C.U.']: 'OHIO UNIVERSITY C.U.',
  ['OHIO VALLEY BANK COMPANY']: 'OHIO VALLEY BANK COMPANY',
  ['OHRIDSKA BANKA A.D. - OHRID']: 'OHRIDSKA BANKA A.D. - OHRID',
  ['OJSC AGROINVESTBANK']: 'OJSC AGROINVESTBANK',
  ['OJSC BANK URALSIB']: 'OJSC BANK URALSIB',
  ['OJSC CB ACCEPT']: 'OJSC CB ACCEPT',
  ['OJSC DEMIRBANK']: 'OJSC DEMIRBANK',
  ['OJSC EUROPEAN INDUSTRIAL BANK']: 'OJSC EUROPEAN INDUSTRIAL BANK',
  ['OJSC FINEXBANK']: 'OJSC FINEXBANK',
  ['OJSC KYRGYZKOMMERTSBANK']: 'OJSC KYRGYZKOMMERTSBANK',
  ['OJSC MOTOR BANK']: 'OJSC MOTOR BANK',
  ['OJSC MTS-BANK']: 'OJSC MTS-BANK',
  ['OJSC OTP BANK']: 'OJSC OTP BANK',
  ['OJSC PROMSVYAZBANK']: 'OJSC PROMSVYAZBANK',
  ['OJSC RUSSIAN AGRICULTURAL BANK']: 'OJSC RUSSIAN AGRICULTURAL BANK',
  ['OJSC SEB BANK']: 'OJSC SEB BANK',
  ['OJSC SOCIAL COMMERCIAL BANK OF PRIMORYE PRIMSOTSBANK']: 'OJSC SOCIAL COMMERCIAL BANK OF PRIMORYE PRIMSOTSBANK',
  ['OJSC UNICREDIT BANK']: 'OJSC UNICREDIT BANK',
  ['OKLAHOMA CENTRAL C.U.']: 'OKLAHOMA CENTRAL C.U.',
  ['OKLAHOMA HERITAGE BANK']: 'OKLAHOMA HERITAGE BANK',
  ['OLD FORT BANKING COMPANY']: 'OLD FORT BANKING COMPANY',
  ['OLD NATIONAL BANK']: 'OLD NATIONAL BANK',
  ['OLD SECOND NATIONAL BANK']: 'OLD SECOND NATIONAL BANK',
  ['OLDENBURGISCHE LANDESBANK AG']: 'OLDENBURGISCHE LANDESBANK AG',
  ['OMC EMPLOYEES CREDIT UNION']: 'OMC EMPLOYEES CREDIT UNION',
  ['OMEGA F.C.U.']: 'OMEGA F.C.U.',
  ['OMNI COMMUNITY C.U.']: 'OMNI COMMUNITY C.U.',
  ['ON TAP C.U.']: 'ON TAP C.U.',
  ['ONEAZ C.U.']: 'ONEAZ C.U.',
  ['ONEUNITED BANK']: 'ONEUNITED BANK',
  ['ONEY BANK']: 'ONEY BANK',
  ['ONEY SERVICIOS FINANCIEROS EFC S.A.']: 'ONEY SERVICIOS FINANCIEROS EFC S.A.',
  ['ONPATH']: 'ONPATH',
  ['ONPOINT COMMUNITY C.U.']: 'ONPOINT COMMUNITY C.U.',
  ['ONTARIO MONTCLAIR SCHOOL EMPLOYEES F.C.U.']: 'ONTARIO MONTCLAIR SCHOOL EMPLOYEES F.C.U.',
  ['OP CARD COMPANY PLC']: 'OP CARD COMPANY PLC',
  ['OPEN BANK S.A.']: 'OPEN BANK S.A.',
  ['OPEN JOINT-STOCK COMPANY BPS-SBERBANK']: 'OPEN JOINT-STOCK COMPANY BPS-SBERBANK',
  ['OPEN JOINT-STOCK COMPANY PARITETBANK']: 'OPEN JOINT-STOCK COMPANY PARITETBANK',
  ['OPEN JOINT-STOCK SOCIETY AZER-TURK BANK']: 'OPEN JOINT-STOCK SOCIETY AZER-TURK BANK',
  ['OPTAL ASIA LIMITED']: 'OPTAL ASIA LIMITED',
  ['OPTAL AUSTRALIA PTY LTD']: 'OPTAL AUSTRALIA PTY LTD',
  ['OPTAL FINANCIAL EUROPE LTD']: 'OPTAL FINANCIAL EUROPE LTD',
  ['OPTAL FINANCIAL LIMITED']: 'OPTAL FINANCIAL LIMITED',
  ['OPTAL JAPAN KABUSHIKI KAISHA']: 'OPTAL JAPAN KABUSHIKI KAISHA',
  ['OPTAL SINGAPORE PTE LTD']: 'OPTAL SINGAPORE PTE LTD',
  ['OPTIMUS CARDS UK LIMITED']: 'OPTIMUS CARDS UK LIMITED',
  ['OPTUM BANK, INC.']: 'OPTUM BANK, INC.',
  ['ORANGE BANK']: 'ORANGE BANK',
  ['OREGON COMMUNITY C.U.']: 'OREGON COMMUNITY C.U.',
  ['ORIENT BANK, LTD.']: 'ORIENT BANK, LTD.',
  ['ORIENT COMMERCIAL JOINT STOCK BANK']: 'ORIENT COMMERCIAL JOINT STOCK BANK',
  ['ORIENT CORPORATION']: 'ORIENT CORPORATION',
  ['ORIENT EXPRESS BANK OJSC (OAO KB ORIENT)']: 'ORIENT EXPRESS BANK OJSC (OAO KB ORIENT)',
  ['ORIENTAL BANK']: 'ORIENTAL BANK',
  ['ORION F.C.U.']: 'ORION F.C.U.',
  ['ORLANDO F.C.U.']: 'ORLANDO F.C.U.',
  ['ORNL F.C.U.']: 'ORNL F.C.U.',
  ['OTIS F.C.U.']: 'OTIS F.C.U.',
  ['OTKRITIE BANK']: 'OTKRITIE BANK',
  ['OTP BANK JSC']: 'OTP BANK JSC',
  ['OTP BANK PLC']: 'OTP BANK PLC',
  ['OTP BANK ROMANIA S.A.']: 'OTP BANK ROMANIA S.A.',
  ['OTP BANKA D.D.']: 'OTP BANKA D.D.',
  ['OTP BANKA HRVATSKA D.D.']: 'OTP BANKA HRVATSKA D.D.',
  ['OTP BANKA SLOVENSKO, A.S.']: 'OTP BANKA SLOVENSKO, A.S.',
  ['OTP BANKA SRBIJA AD BEOGRAD']: 'OTP BANKA SRBIJA AD BEOGRAD',
  ['OUR C.U.']: 'OUR C.U.',
  ['OUR COMMUNITY C.U.']: 'OUR COMMUNITY C.U.',
  ['OVERSEA-CHINESE BANKING CORP., LTD.']: 'OVERSEA-CHINESE BANKING CORP., LTD.',
  ['OVERSEA-CHINESE BANKING CORPORATION LIMITED']: 'OVERSEA-CHINESE BANKING CORPORATION LIMITED',
  ['OXFORD BANK & TRUST']: 'OXFORD BANK & TRUST',
  ['OZARK F.C.U.']: 'OZARK F.C.U.',
  ['OZARK HERITAGE BANK']: 'OZARK HERITAGE BANK',
  ['P AND G MEHOOPANY EMPLOYEES F.C.U.']: 'P AND G MEHOOPANY EMPLOYEES F.C.U.',
  ['PACE SAVINGS & CREDIT UNION LIMITED']: 'PACE SAVINGS & CREDIT UNION LIMITED',
  ['PACIFIC CENTURY BANK']: 'PACIFIC CENTURY BANK',
  ['PACIFIC COMMUNITY C.U.']: 'PACIFIC COMMUNITY C.U.',
  ['PACIFIC HORIZON C.U.']: 'PACIFIC HORIZON C.U.',
  ['PACIFIC NW F.C.U.']: 'PACIFIC NW F.C.U.',
  ['PACIFIC POSTAL C.U.']: 'PACIFIC POSTAL C.U.',
  ['PACIFIC PREMIER BANK']: 'PACIFIC PREMIER BANK',
  ['PACIFIC WESTERN BANK']: 'PACIFIC WESTERN BANK',
  ['PALMETTO CITIZENS F.C.U.']: 'PALMETTO CITIZENS F.C.U.',
  ['PANCRETAN COOPERATIVE BANK LTD']: 'PANCRETAN COOPERATIVE BANK LTD',
  ['PANTEX F.C.U.']: 'PANTEX F.C.U.',
  ['PAPARA ELEKTRONIK PARA VE ODEME HIZMETLERI AS']: 'PAPARA ELEKTRONIK PARA VE ODEME HIZMETLERI AS',
  ['PARAMOUNT BANK']: 'PARAMOUNT BANK',
  ['PARK BANK']: 'PARK BANK',
  ['PARK CARD SERVICES LIMITED']: 'PARK CARD SERVICES LIMITED',
  ['PARK COMMUNITY CREDIT UNION INC.']: 'PARK COMMUNITY CREDIT UNION INC.',
  ['PARK NATIONAL BANK']: 'PARK NATIONAL BANK',
  ['PARK STATE BANK AND TRUST']: 'PARK STATE BANK AND TRUST',
  ['PARKSIDE F.C.U.']: 'PARKSIDE F.C.U.',
  ['PARTNER COLORADO C.U.']: 'PARTNER COLORADO C.U.',
  ['PARTNERS F.C.U.']: 'PARTNERS F.C.U.',
  ['PASADENA F.C.U.']: 'PASADENA F.C.U.',
  ['PASHA BANK']: 'PASHA BANK',
  ['PATELCO CREDIT UNION']: 'PATELCO CREDIT UNION',
  ['PATHFINDER BANK']: 'PATHFINDER BANK',
  ['PATHWAY BANK']: 'PATHWAY BANK',
  ['PATRIA BANK S.A.']: 'PATRIA BANK S.A.',
  ['PATRIOT BANK']: 'PATRIOT BANK',
  ['PATTERSON BANK']: 'PATTERSON BANK',
  ['PATTERSON STATE BANK']: 'PATTERSON STATE BANK',
  ['PAWTUCKET C.U.']: 'PAWTUCKET C.U.',
  ['PAY2D CARD ISSUED BY WIRECARD']: 'PAY2D CARD ISSUED BY WIRECARD',
  ['PAYBOX BANK AG']: 'PAYBOX BANK AG',
  ['PAYMENT CARD SOLUTIONS UK LTD']: 'PAYMENT CARD SOLUTIONS UK LTD',
  ['PAYMENT SYSTEMS FOR CREDIT UNIONS, INC.']: 'PAYMENT SYSTEMS FOR CREDIT UNIONS, INC.',
  ['PAYNETICS EAD']: 'PAYNETICS EAD',
  ['PAYONE GMBH']: 'PAYONE GMBH',
  ['PAYONEER EUROPE LIMITED']: 'PAYONEER EUROPE LIMITED',
  ['PAYPAL (EUROPE) S.A.R.L & CIE, S.C.A']: 'PAYPAL (EUROPE) S.A.R.L & CIE, S.C.A',
  ['PAYRNET LIMITED']: 'PAYRNET LIMITED',
  ['PAYSAFE FINANCIAL SERVICES LIMITED']: 'PAYSAFE FINANCIAL SERVICES LIMITED',
  ['PAYSEND PLC']: 'PAYSEND PLC',
  ['PBK BANK, INC.']: 'PBK BANK, INC.',
  ['PCKT MONEY OYJ']: 'PCKT MONEY OYJ',
  ['PEACH STATE F.C.U.']: 'PEACH STATE F.C.U.',
  ['PEGASUS BANK']: 'PEGASUS BANK',
  ['PELICAN STATE C.U.']: 'PELICAN STATE C.U.',
  ['PEN AIR F.C.U.']: 'PEN AIR F.C.U.',
  ['PENDLETON COMMUNITY BANK']: 'PENDLETON COMMUNITY BANK',
  ['PENFED']: 'PENFED',
  ['PENINSULA F.C.U.']: 'PENINSULA F.C.U.',
  ['PENN COMMUNITY C.U.']: 'PENN COMMUNITY C.U.',
  ['PENN STATE F.C.U.']: 'PENN STATE F.C.U.',
  ['PENNIAN BANK']: 'PENNIAN BANK',
  ['PENNSYLVANIA STATE EMPLOYEES C.U.']: 'PENNSYLVANIA STATE EMPLOYEES C.U.',
  ['PENOBSCOT COUNTY F.C.U.']: 'PENOBSCOT COUNTY F.C.U.',
  ['PENTAGON F.C.U.']: 'PENTAGON F.C.U.',
  ['PEOPLE FIRST F.C.U.']: 'PEOPLE FIRST F.C.U.',
  ['PEOPLES BANK']: 'PEOPLES BANK',
  ['PEOPLES BANK AND TRUST COMPANY']: 'PEOPLES BANK AND TRUST COMPANY',
  ['PEOPLES BANK, A CODORUS VALLEY COMPANY']: 'PEOPLES BANK, A CODORUS VALLEY COMPANY',
  ['PEOPLES BANK, BILOXI, MISSISSIPPI']: 'PEOPLES BANK, BILOXI, MISSISSIPPI',
  ['PEOPLES EXCHANGE BANK']: 'PEOPLES EXCHANGE BANK',
  ['PEOPLES NATIONAL BANK']: 'PEOPLES NATIONAL BANK',
  ['PEOPLES SAVINGS BANK OF TROY']: 'PEOPLES SAVINGS BANK OF TROY',
  ['PEOPLES SECURITY BANK AND TRUST COMPANY']: 'PEOPLES SECURITY BANK AND TRUST COMPANY',
  ['PEOPLES STATE BANK OF WYALUSING, PENNSYLVANIA']: 'PEOPLES STATE BANK OF WYALUSING, PENNSYLVANIA',
  ['PEOPLES TRUST COMPANY']: 'PEOPLES TRUST COMPANY',
  ['PEOPLES UNITED BANK']: 'PEOPLES UNITED BANK',
  ['PEOPLESBANK']: 'PEOPLESBANK',
  ['PERFECT CIRCLE C.U.']: 'PERFECT CIRCLE C.U.',
  ['PERFECTCARD DAC']: 'PERFECTCARD DAC',
  ['PERSONA HOUSE']: 'PERSONA HOUSE',
  ['PHEPLE F.C.U.']: 'PHEPLE F.C.U.',
  ['PHILADELPHIA F.C.U.']: 'PHILADELPHIA F.C.U.',
  ['PHILIPPINE BANK OF COMMUNICATIONS']: 'PHILIPPINE BANK OF COMMUNICATIONS',
  ['PHILIPPINE NATIONAL BANK']: 'PHILIPPINE NATIONAL BANK',
  ['PHILLIP BANK PLC']: 'PHILLIP BANK PLC',
  ['PHOENIXVILLE FEDERAL BANK AND TRUST']: 'PHOENIXVILLE FEDERAL BANK AND TRUST',
  ['PHONGSAVANH BANK']: 'PHONGSAVANH BANK',
  ['PICATINNY F.C.U.']: 'PICATINNY F.C.U.',
  ['PIEDMONT ADVANTAGE CREDIT UNION']: 'PIEDMONT ADVANTAGE CREDIT UNION',
  ['PINE COUNTRY BANK']: 'PINE COUNTRY BANK',
  ['PINELLAS F.C.U.']: 'PINELLAS F.C.U.',
  ['PING AN BANK CO., LTD.']: 'PING AN BANK CO., LTD.',
  ['PINNACLE']: 'PINNACLE',
  ['PIONEER C.U.']: 'PIONEER C.U.',
  ['PIONEER TRUST BANK, N.A.']: 'PIONEER TRUST BANK, N.A.',
  ['PIRAEUS BANK A.D. BEOGRAD']: 'PIRAEUS BANK A.D. BEOGRAD',
  ['PIRAEUS BANK ROMANIA']: 'PIRAEUS BANK ROMANIA',
  ['PIRAEUS BANK S.A.']: 'PIRAEUS BANK S.A.',
  ['PJSC ALFA-BANK']: 'PJSC ALFA-BANK',
  ['PJSC BANK 3/4']: 'PJSC BANK 3/4',
  ['PJSC BANK ALLIANCE']: 'PJSC BANK ALLIANCE',
  ['PJSC BANK CREDIT DNEPR']: 'PJSC BANK CREDIT DNEPR',
  ['PJSC BANK FOR INVESTMENTS AND SAVINGS']: 'PJSC BANK FOR INVESTMENTS AND SAVINGS',
  ['PJSC BANK VOSTOK']: 'PJSC BANK VOSTOK',
  ['PJSC CREDIT AGRICOLE BANK']: 'PJSC CREDIT AGRICOLE BANK',
  ['PJSC KONVERSBANK']: 'PJSC KONVERSBANK',
  ['PJSC MTS BANK']: 'PJSC MTS BANK',
  ['PJSC ORIENT FINANS']: 'PJSC ORIENT FINANS',
  ['PJSC PIRAEUS BANK ICB']: 'PJSC PIRAEUS BANK ICB',
  ['PJSC ROSBANK']: 'PJSC ROSBANK',
  ['PJSC TASCOMBANK']: 'PJSC TASCOMBANK',
  ['PJSC UKRSOTSBANK']: 'PJSC UKRSOTSBANK',
  ['PKO BANK POLSKI, S.A.']: 'PKO BANK POLSKI, S.A.',
  ['PLACER SIERRA BANK']: 'PLACER SIERRA BANK',
  ['PLAIN DEALER F.C.U.']: 'PLAIN DEALER F.C.U.',
  ['PLAINSCAPITAL BANK']: 'PLAINSCAPITAL BANK',
  ['PLANTERSFIRST']: 'PLANTERSFIRST',
  ['PLATINUM BANK']: 'PLATINUM BANK',
  ['PLATTE VALLEY BANK']: 'PLATTE VALLEY BANK',
  ['PLATTE VALLEY NATIONAL BANK']: 'PLATTE VALLEY NATIONAL BANK',
  ['PLEO FINANCIAL SERVICES APS']: 'PLEO FINANCIAL SERVICES APS',
  ['PLUMAS BANK']: 'PLUMAS BANK',
  ['PLUS BANK S.A.']: 'PLUS BANK S.A.',
  ['PNC BANK']: 'PNC BANK',
  ['PNC BANK GLOBAL INVESTMENT SERVICING']: 'PNC BANK GLOBAL INVESTMENT SERVICING',
  ['PNC BANK, DELAWARE']: 'PNC BANK, DELAWARE',
  ['PNC BANK, KENTUCKY, INC.']: 'PNC BANK, KENTUCKY, INC.',
  ['POCHTA BANK']: 'POCHTA BANK',
  ['POCKET CARD CO., LTD.']: 'POCKET CARD CO., LTD.',
  ['PODRAVSKA BANKA D.D. KOPRIVNICA']: 'PODRAVSKA BANKA D.D. KOPRIVNICA',
  ['POINT WEST C.U.']: 'POINT WEST C.U.',
  ['POINTBANK']: 'POINTBANK',
  ['POLICE AND FIRE F.C.U.']: 'POLICE AND FIRE F.C.U.',
  ['POLISH AND SLAVIC F.C.U.']: 'POLISH AND SLAVIC F.C.U.',
  ['POLISH-AMERICAN F.C.U.']: 'POLISH-AMERICAN F.C.U.',
  ['POPULAR BANK']: 'POPULAR BANK',
  ['PORTLAND F.C.U.']: 'PORTLAND F.C.U.',
  ['PORTOSEG S.A. CREDITO FINANCIAMENTO E INVESTIMENTO']: 'PORTOSEG S.A. CREDITO FINANCIAMENTO E INVESTIMENTO',
  ['POSTAL SAVINGS BANK JSC']: 'POSTAL SAVINGS BANK JSC',
  ['POSTEL FAMILY C.U.']: 'POSTEL FAMILY C.U.',
  ['POSTEPAY S.P.A']: 'POSTEPAY S.P.A',
  ['POSTFINANCE AG']: 'POSTFINANCE AG',
  ['POSTOVA BANKA A.S.']: 'POSTOVA BANKA A.S.',
  ['POTLATCH NO1 FINANCIAL CREDIT UNION']: 'POTLATCH NO1 FINANCIAL CREDIT UNION',
  ['POWER FINANCIAL C.U.']: 'POWER FINANCIAL C.U.',
  ['POWSZECHNA KASA OSZCZEDNOSCI BANK POLSKI S.A. (PKO BANK POLSKI S.A.)']:
    'POWSZECHNA KASA OSZCZEDNOSCI BANK POLSKI S.A. (PKO BANK POLSKI S.A.)',
  ['POWSZECHNA KASA OSZCZEDNOSCI BANK POLSKI SA (PKO BANK POLSKI SA)']:
    'POWSZECHNA KASA OSZCZEDNOSCI BANK POLSKI SA (PKO BANK POLSKI SA)',
  ['PPF BANKA A.S.']: 'PPF BANKA A.S.',
  ['PPRO FINANCIAL LTD.']: 'PPRO FINANCIAL LTD.',
  ['PRAIRIE STATE BANK & TRUST']: 'PRAIRIE STATE BANK & TRUST',
  ['PREFERRED BANK']: 'PREFERRED BANK',
  ['PREFERRED FINANCIAL SERVICES']: 'PREFERRED FINANCIAL SERVICES',
  ['PREMIER AMERICA CREDIT UNION']: 'PREMIER AMERICA CREDIT UNION',
  ['PREMIER BANK']: 'PREMIER BANK',
  ['PREMIER COMMUNITY C.U.']: 'PREMIER COMMUNITY C.U.',
  ['PREMIER FINANCIAL C.U.']: 'PREMIER FINANCIAL C.U.',
  ['PREMIER MEMBERS C.U.']: 'PREMIER MEMBERS C.U.',
  ['PREMIERONE C.U.']: 'PREMIERONE C.U.',
  ['PREPAID FINANCIAL SERVICES LTD']: 'PREPAID FINANCIAL SERVICES LTD',
  ['PREPAY TECHNOLOGIES LTD']: 'PREPAY TECHNOLOGIES LTD',
  ["PRESIDENT'S CHOICE BANK"]: "PRESIDENT'S CHOICE BANK",
  ['PRIMA BANKA SLOVENSKO, A.S.']: 'PRIMA BANKA SLOVENSKO, A.S.',
  ['PRIME FINANCIAL C.U.']: 'PRIME FINANCIAL C.U.',
  ['PRIMESOUTH BANK']: 'PRIMESOUTH BANK',
  ['PRIMEWAY FEDERAL CREDIT UNION']: 'PRIMEWAY FEDERAL CREDIT UNION',
  ['PRINCE BANK PLC']: 'PRINCE BANK PLC',
  ['PRINCETON F.C.U.']: 'PRINCETON F.C.U.',
  ['PRIORBANK JOINT-STOCK COMPANY']: 'PRIORBANK JOINT-STOCK COMPANY',
  ['PRIORBANK JSCB']: 'PRIORBANK JSCB',
  ['PRIVREDNA BANKA ZAGREB D.D.']: 'PRIVREDNA BANKA ZAGREB D.D.',
  ['PROCARD S.A.']: 'PROCARD S.A.',
  ['PROCESOS DE MEDIOS DE PAGO S.A.']: 'PROCESOS DE MEDIOS DE PAGO S.A.',
  ['PROCREDIT BANK']: 'PROCREDIT BANK',
  ['PROCREDIT BANK AD SKOPJE']: 'PROCREDIT BANK AD SKOPJE',
  ['PROCREDIT BANK KOSOVO']: 'PROCREDIT BANK KOSOVO',
  ['PROCREDIT BANK SH.A.']: 'PROCREDIT BANK SH.A.',
  ['PROCREDIT BANK, LTD.']: 'PROCREDIT BANK, LTD.',
  ['PROFESSIONAL F.C.U.']: 'PROFESSIONAL F.C.U.',
  ['PROMEDICA F.C.U.']: 'PROMEDICA F.C.U.',
  ['PROMOCION Y OPERACION S.A. DE C.V.']: 'PROMOCION Y OPERACION S.A. DE C.V.',
  ['PROMOTORA CMR FALABELLA S.A.']: 'PROMOTORA CMR FALABELLA S.A.',
  ['PROPONENT F.C.U']: 'PROPONENT F.C.U',
  ['PROSPERITY BANK']: 'PROSPERITY BANK',
  ['PROVIDENCE BANK & TRUST']: 'PROVIDENCE BANK & TRUST',
  ['PROVIDENT BANK']: 'PROVIDENT BANK',
  ['PROVIDIAN BANK']: 'PROVIDIAN BANK',
  ['PROVIDUS BANK PLC']: 'PROVIDUS BANK PLC',
  ['PRUDENTIAL BANK']: 'PRUDENTIAL BANK',
  ['PRVA BANKA CG AD']: 'PRVA BANKA CG AD',
  ['PSA PAYMENT SERVICES AUSTRIA GMBH']: 'PSA PAYMENT SERVICES AUSTRIA GMBH',
  ['PSC JOINT-STOCK COMMERCIAL INDUSTRIAL & INVESTMENT BANK']:
    'PSC JOINT-STOCK COMMERCIAL INDUSTRIAL & INVESTMENT BANK',
  ['PSCU FINANCIAL SERVICES, INC.']: 'PSCU FINANCIAL SERVICES, INC.',
  ['PSCU INCORPORATED']: 'PSCU INCORPORATED',
  ['PSE CREDIT UNION, INC.']: 'PSE CREDIT UNION, INC.',
  ['PSI- PAY LIMITED']: 'PSI- PAY LIMITED',
  ['PT BANK HSBC INDONESIA']: 'PT BANK HSBC INDONESIA',
  ['PT BANK KB BUKOPIN TBK']: 'PT BANK KB BUKOPIN TBK',
  ['PT BANK MANDIRI (PERSERO) TBK']: 'PT BANK MANDIRI (PERSERO) TBK',
  ['PT BANK MEGA TBK']: 'PT BANK MEGA TBK',
  ['PT BANK NATIONALNOBU TBK']: 'PT BANK NATIONALNOBU TBK',
  ['PT BANK UOB INDONESIA']: 'PT BANK UOB INDONESIA',
  ['PT. BANK BUKOPIN']: 'PT. BANK BUKOPIN',
  ['PT. BANK CENTRAL ASIA']: 'PT. BANK CENTRAL ASIA',
  ['PT. BANK CIMB NIAGA TBK.']: 'PT. BANK CIMB NIAGA TBK.',
  ['PT. BANK COMMONWEALTH']: 'PT. BANK COMMONWEALTH',
  ['PT. BANK DANAMON INDONESIA']: 'PT. BANK DANAMON INDONESIA',
  ['PT. BANK DBS INDONESIA']: 'PT. BANK DBS INDONESIA',
  ['PT. BANK MANDIRI (PERSERO) TBK.']: 'PT. BANK MANDIRI (PERSERO) TBK.',
  ['PT. BANK MAYBANK INDONESIA TBK']: 'PT. BANK MAYBANK INDONESIA TBK',
  ['PT. BANK NEGARA INDONESIA (PERSERO) TBK.']: 'PT. BANK NEGARA INDONESIA (PERSERO) TBK.',
  ['PT. BANK OCBC NISP TBK.']: 'PT. BANK OCBC NISP TBK.',
  ['PT. BANK PERMATA']: 'PT. BANK PERMATA',
  ['PT. BANK RAKYAT INDONESIA (PERSERO)']: 'PT. BANK RAKYAT INDONESIA (PERSERO)',
  ['PT. BANK TABUNGAN NEGARA (PERSERO)']: 'PT. BANK TABUNGAN NEGARA (PERSERO)',
  ['PT. PAN INDONESIA BANK TBK. (PT. BANK PANIN TBK)']: 'PT. PAN INDONESIA BANK TBK. (PT. BANK PANIN TBK)',
  ['PUBLIC BANK BERHAD']: 'PUBLIC BANK BERHAD',
  ['PUBLIC JOINT STOCK COMPANY ALFA-BANK']: 'PUBLIC JOINT STOCK COMPANY ALFA-BANK',
  ['PUBLIC JOINT STOCK COMPANY BANK URALSIB']: 'PUBLIC JOINT STOCK COMPANY BANK URALSIB',
  ['PUBLIC JOINT STOCK COMPANY IBOXBANK']: 'PUBLIC JOINT STOCK COMPANY IBOXBANK',
  ['PUBLIC JOINT STOCK COMPANY JOINT STOCK BANK UKRGASBANK']: 'PUBLIC JOINT STOCK COMPANY JOINT STOCK BANK UKRGASBANK',
  ['PUBLIC JOINT STOCK COMPANY PROMSVYAZBANK']: 'PUBLIC JOINT STOCK COMPANY PROMSVYAZBANK',
  ['PUBLIC JOINT STOCK COMPANY TASCOMBANK']: 'PUBLIC JOINT STOCK COMPANY TASCOMBANK',
  ['PUBLIC JOINT-STOCK COMPANY BANK OTKRITIE FINANCIAL CORPORATION']:
    'PUBLIC JOINT-STOCK COMPANY BANK OTKRITIE FINANCIAL CORPORATION',
  ['PUBLIC JOINT-STOCK COMPANY NORVIK BANK']: 'PUBLIC JOINT-STOCK COMPANY NORVIK BANK',
  ['PUBLIC JOINT-STOCK COMPANY ROSGOSSTRAKH BANK']: 'PUBLIC JOINT-STOCK COMPANY ROSGOSSTRAKH BANK',
  ['PUBLIC JOINT-STOCK COMPANY UKRSIBBANK']: 'PUBLIC JOINT-STOCK COMPANY UKRSIBBANK',
  ['PUBLIC JSC ACCENT-BANK']: 'PUBLIC JSC ACCENT-BANK',
  ['PUBLIC JSC COMMERCIAL BANK PRAVEX BANK']: 'PUBLIC JSC COMMERCIAL BANK PRAVEX BANK',
  ['PUBLIC JSC FIRST UKRAINIAN INTERNATIONAL BANK']: 'PUBLIC JSC FIRST UKRAINIAN INTERNATIONAL BANK',
  ['PUBLIC JSC INVESTMENT COMMERCIAL BANK SOVCOMBANK']: 'PUBLIC JSC INVESTMENT COMMERCIAL BANK SOVCOMBANK',
  ['PUBLIC JSC RAIFFEISEN BANK AVAL']: 'PUBLIC JSC RAIFFEISEN BANK AVAL',
  ['PUBLIC JSC VTB BANK']: 'PUBLIC JSC VTB BANK',
  ['PUBLIC SERVICE C.U.']: 'PUBLIC SERVICE C.U.',
  ['PUBLIX EMPLOYEES F.C.U.']: 'PUBLIX EMPLOYEES F.C.U.',
  ['PUJSC FIDOBANK']: 'PUJSC FIDOBANK',
  ['PULLMAN BANK AND TRUST COMPANY']: 'PULLMAN BANK AND TRUST COMPANY',
  ['PUNJAB & SIND BANK']: 'PUNJAB & SIND BANK',
  ['PURDUE F.C.U.']: 'PURDUE F.C.U.',
  ['PUTNAM BANK']: 'PUTNAM BANK',
  ['QATAR INTERNATIONAL ISLAMIC BANK']: 'QATAR INTERNATIONAL ISLAMIC BANK',
  ['QATAR ISLAMIC BANK']: 'QATAR ISLAMIC BANK',
  ['QATAR NATIONAL BANK']: 'QATAR NATIONAL BANK',
  ['QDOS']: 'QDOS',
  ['QIWI BANK (JSC)']: 'QIWI BANK (JSC)',
  ['QNB BANK']: 'QNB BANK',
  ['QSIDE F.C.U.']: 'QSIDE F.C.U.',
  ['QUAD CITY BANK AND TRUST COMPANY']: 'QUAD CITY BANK AND TRUST COMPANY',
  ['QUALSTAR C.U.']: 'QUALSTAR C.U.',
  ['QUICKO SP Z OO']: 'QUICKO SP Z OO',
  ['QUORUM FEDERAL CREDIT UNION']: 'QUORUM FEDERAL CREDIT UNION',
  ['R RAPHAEL AND SONS PLC']: 'R RAPHAEL AND SONS PLC',
  ['RABITABANK OJSC']: 'RABITABANK OJSC',
  ['RABOBANK']: 'RABOBANK',
  ['RADIO, TELEVISION AND COMMUNICATIONS F.C.U.']: 'RADIO, TELEVISION AND COMMUNICATIONS F.C.U.',
  ['RADIUS BANK']: 'RADIUS BANK',
  ['RAIFFEISEN BANK AVAL PJSC']: 'RAIFFEISEN BANK AVAL PJSC',
  ['RAIFFEISEN BANK DD BOSNIA HERZEGOVINA']: 'RAIFFEISEN BANK DD BOSNIA HERZEGOVINA',
  ['RAIFFEISEN BANK INTERNATIONAL AG']: 'RAIFFEISEN BANK INTERNATIONAL AG',
  ['RAIFFEISEN BANK KOSOVO JSC']: 'RAIFFEISEN BANK KOSOVO JSC',
  ['RAIFFEISEN BANK LTD.']: 'RAIFFEISEN BANK LTD.',
  ['RAIFFEISENBANK (BULGARIA) AD']: 'RAIFFEISENBANK (BULGARIA) AD',
  ['RAIFFEISENBANK A.D. BEOGRAD']: 'RAIFFEISENBANK A.D. BEOGRAD',
  ['RAIFFEISENBANK A.D., BEOGRAD']: 'RAIFFEISENBANK A.D., BEOGRAD',
  ['RAIFFEISENBANK A.S.']: 'RAIFFEISENBANK A.S.',
  ['RAIFFEISENBANK AUSTRIA D.D.']: 'RAIFFEISENBANK AUSTRIA D.D.',
  ['RAILROAD AND INDUSTRIAL F.C.U.']: 'RAILROAD AND INDUSTRIAL F.C.U.',
  ['RAKUTEN BANK']: 'RAKUTEN BANK',
  ['RAND MERCHANT BANK']: 'RAND MERCHANT BANK',
  ['RANDOLPH BROOKS F.C.U.']: 'RANDOLPH BROOKS F.C.U.',
  ['RAWBANK']: 'RAWBANK',
  ['RAY F.C.U.']: 'RAY F.C.U.',
  ['RAYMOND JAMES BANK, F.S.B.']: 'RAYMOND JAMES BANK, F.S.B.',
  ['RBC CENTURA BANK']: 'RBC CENTURA BANK',
  ['RBC ROYAL BANK (BAHAMAS) LIMITED']: 'RBC ROYAL BANK (BAHAMAS) LIMITED',
  ['RBC ROYAL BANK (JAMAICA), LTD.']: 'RBC ROYAL BANK (JAMAICA), LTD.',
  ['RBL BANK LTD.']: 'RBL BANK LTD.',
  ['RCB BANK LTD']: 'RCB BANK LTD',
  ['RED CANOE C.U.']: 'RED CANOE C.U.',
  ['RED CROWN FEDERAL CREDIT UNION']: 'RED CROWN FEDERAL CREDIT UNION',
  ['RED ROCKS C.U.']: 'RED ROCKS C.U.',
  ['REDNECK BANK']: 'REDNECK BANK',
  ['REDSTONE F.C.U.']: 'REDSTONE F.C.U.',
  ['REDWOOD BANK']: 'REDWOOD BANK',
  ['REGION TRADE BANK FOR INVESTMENT AND FINANCE']: 'REGION TRADE BANK FOR INVESTMENT AND FINANCE',
  ['REGIONAL BANK']: 'REGIONAL BANK',
  ['REGIONAL F.C.U.']: 'REGIONAL F.C.U.',
  ['REGIONAL FEDERAL SAVINGS BANK']: 'REGIONAL FEDERAL SAVINGS BANK',
  ['REGIONS BANK']: 'REGIONS BANK',
  ['RELIANT BANK']: 'RELIANT BANK',
  ['RELIANT COMMUNITY F.C.U.']: 'RELIANT COMMUNITY F.C.U.',
  ['RELYANCE BANK']: 'RELYANCE BANK',
  ['RENASANT BANK']: 'RENASANT BANK',
  ['REPUBLIC BANK, LTD.']: 'REPUBLIC BANK, LTD.',
  ['RESONA BANK, LTD.']: 'RESONA BANK, LTD.',
  ['RESOURCE BANK']: 'RESOURCE BANK',
  ['RESURS BANK AB']: 'RESURS BANK AB',
  ['REV FEDERAL CREDIT UNION']: 'REV FEDERAL CREDIT UNION',
  ['REVOLUT']: 'REVOLUT',
  ['REVOLUT LTD']: 'REVOLUT LTD',
  ['REVOLUT PAYMENTS UAB']: 'REVOLUT PAYMENTS UAB',
  ['REVOLUT TECHNOLOGIES JAPAN, INC.']: 'REVOLUT TECHNOLOGIES JAPAN, INC.',
  ['REVOLUT TECHNOLOGIES SINGAPORE PTE LTD.']: 'REVOLUT TECHNOLOGIES SINGAPORE PTE LTD.',
  ['REVOLUT TECHNOLOGIES SINGAPORE PTE. LTD.']: 'REVOLUT TECHNOLOGIES SINGAPORE PTE. LTD.',
  ['RHB BANK BERHAD']: 'RHB BANK BERHAD',
  ['RHINEBECK BANK']: 'RHINEBECK BANK',
  ['RIAS REDBANC, S.A.']: 'RIAS REDBANC, S.A.',
  ['RICHWOOD BANK']: 'RICHWOOD BANK',
  ['RIDGEWOOD SAVINGS BANK']: 'RIDGEWOOD SAVINGS BANK',
  ['RIETUMU BANKA']: 'RIETUMU BANKA',
  ['RIO BANK']: 'RIO BANK',
  ['RIVER BANK AND TRUST']: 'RIVER BANK AND TRUST',
  ['RIVER CITY BANK']: 'RIVER CITY BANK',
  ['RIVER REGION C.U.']: 'RIVER REGION C.U.',
  ['RIVER VALLEY C.U.']: 'RIVER VALLEY C.U.',
  ['RIVERS AREA C.U.']: 'RIVERS AREA C.U.',
  ['RIVERVIEW BANK']: 'RIVERVIEW BANK',
  ['RIVERVIEW COMMUNITY BANK']: 'RIVERVIEW COMMUNITY BANK',
  ['RIVERVIEW COMMUNITY FED CU']: 'RIVERVIEW COMMUNITY FED CU',
  ['RIYAD BANK']: 'RIYAD BANK',
  ['RIZAL COMMERCIAL BANKING CORPORATION']: 'RIZAL COMMERCIAL BANKING CORPORATION',
  ['ROBINSONS BANK CORPORATION']: 'ROBINSONS BANK CORPORATION',
  ['ROCHESTER STATE BANK']: 'ROCHESTER STATE BANK',
  ['ROCK VALLEY F.C.U.']: 'ROCK VALLEY F.C.U.',
  ['ROCKFORD MUNICIPAL EMPLOYEES C.U.']: 'ROCKFORD MUNICIPAL EMPLOYEES C.U.',
  ['ROCKLAND F.C.U.']: 'ROCKLAND F.C.U.',
  ['ROCKY MOUNTAIN BANK']: 'ROCKY MOUNTAIN BANK',
  ['ROGERS BANK']: 'ROGERS BANK',
  ['ROGUE F.C.U.']: 'ROGUE F.C.U.',
  ['ROMANIAN COMMERCIAL BANK S.A. - BANCA COMERCIALA ROMANA S.A.']:
    'ROMANIAN COMMERCIAL BANK S.A. - BANCA COMERCIALA ROMANA S.A.',
  ['ROME C.U.']: 'ROME C.U.',
  ['ROME TEACHERS F.C.U.']: 'ROME TEACHERS F.C.U.',
  ['RONA']: 'RONA',
  ['ROYAL BANK']: 'ROYAL BANK',
  ['ROYAL BANK OF CANADA']: 'ROYAL BANK OF CANADA',
  ['ROYAL BANK OF SCOTLAND']: 'ROYAL BANK OF SCOTLAND',
  ['ROYAL BUSINESS BANK']: 'ROYAL BUSINESS BANK',
  ['ROYAL C.U.']: 'ROYAL C.U.',
  ['RSI BANK']: 'RSI BANK',
  ['RTN F.C.U.']: 'RTN F.C.U.',
  ['RUSSIAN JSC ROADS BANK PJSC ROSDORBANK']: 'RUSSIAN JSC ROADS BANK PJSC ROSDORBANK',
  ['S AND T BANK']: 'S AND T BANK',
  ['S C TELCO F.C.U.']: 'S C TELCO F.C.U.',
  ['S. C. STATE F.C.U.']: 'S. C. STATE F.C.U.',
  ['S.F. POLICE C.U.']: 'S.F. POLICE C.U.',
  ['SABINE STATE BANK & TRUST COMPANY']: 'SABINE STATE BANK & TRUST COMPANY',
  ['SABINE STATE BANK AND TRUST COMPANY']: 'SABINE STATE BANK AND TRUST COMPANY',
  ['SACOMBANK']: 'SACOMBANK',
  ['SAFE C.U.']: 'SAFE C.U.',
  ['SAFECHARGE LIMITED']: 'SAFECHARGE LIMITED',
  ['SAFRA NATIONAL BANK OF NEW YORK']: 'SAFRA NATIONAL BANK OF NEW YORK',
  ['SAHARA BANK']: 'SAHARA BANK',
  ['SAI GON - HA NOI COMMERCIAL JOINT STOCK BANK']: 'SAI GON - HA NOI COMMERCIAL JOINT STOCK BANK',
  ['SAI GON JOINT STOCK COMMERCIAL BANK']: 'SAI GON JOINT STOCK COMMERCIAL BANK',
  ['SAIGON THUONG TIN COMMERCIAL JOINT STOCK BANK']: 'SAIGON THUONG TIN COMMERCIAL JOINT STOCK BANK',
  ["SAINSBURY'S BANK PLC"]: "SAINSBURY'S BANK PLC",

  ['SALAAM AFRICAN BANK']: 'SALAAM AFRICAN BANK',
  ['SALAL C.U.']: 'SALAL C.U.',
  ['SALEM FIVE CENTS SAVINGS BANK']: 'SALEM FIVE CENTS SAVINGS BANK',
  ['SALISBURY BANK AND TRUST COMPANY']: 'SALISBURY BANK AND TRUST COMPANY',
  ['SALLIE MAE BANK']: 'SALLIE MAE BANK',
  ['SAMBA FINANCIAL GROUP']: 'SAMBA FINANCIAL GROUP',
  ['SAMSUNG CARD']: 'SAMSUNG CARD',
  ['SAN ANTONIO F.C.U.']: 'SAN ANTONIO F.C.U.',
  ['SAN DIEGO COUNTY C.U.']: 'SAN DIEGO COUNTY C.U.',
  ['SAN DIEGO METROPOLITAN CREDIT UNION']: 'SAN DIEGO METROPOLITAN CREDIT UNION',
  ['SAN JUAN C.U.']: 'SAN JUAN C.U.',
  ['SAN MATEO C.U.']: 'SAN MATEO C.U.',
  ['SAN-IN GODO BANK, LTD., THE']: 'SAN-IN GODO BANK, LTD., THE',
  ['SANDIA AREA FEDERAL CREDIT UNION']: 'SANDIA AREA FEDERAL CREDIT UNION',
  ['SANDIA LABORATORY F.C.U.']: 'SANDIA LABORATORY F.C.U.',
  ['SANDIA LABORATORY FEDERAL CREDIT UNION']: 'SANDIA LABORATORY FEDERAL CREDIT UNION',
  ['SANDY SPRING BANK']: 'SANDY SPRING BANK',
  ['SANTA BARBARA COUNTY F.C.U.']: 'SANTA BARBARA COUNTY F.C.U.',
  ['SANTA CLARA COUNTY F.C.U.']: 'SANTA CLARA COUNTY F.C.U.',
  ['SANTANDER BANK']: 'SANTANDER BANK',
  ['SANTANDER BANK POLSKA S.A.']: 'SANTANDER BANK POLSKA S.A.',
  ['SANTANDER UK PLC']: 'SANTANDER UK PLC',
  ['SATABANK PLC']: 'SATABANK PLC',
  ['SATCHELPAY UAB']: 'SATCHELPAY UAB',
  ['SAUDI BRITISH BANK']: 'SAUDI BRITISH BANK',
  ['SAUDI INVESTMENT BANK']: 'SAUDI INVESTMENT BANK',
  ['SAVANNAH BANK, N.A.']: 'SAVANNAH BANK, N.A.',
  ['SAVINGS BANK OF DANBURY']: 'SAVINGS BANK OF DANBURY',
  ['SAVINGS BANK OF MONGOLIA']: 'SAVINGS BANK OF MONGOLIA',
  ['SAVINGS BANK OF THE RUSSIAN FEDERATION (SBERBANK)']: 'SAVINGS BANK OF THE RUSSIAN FEDERATION (SBERBANK)',
  ['SB SBERBANK JSC']: 'SB SBERBANK JSC',
  ['SBERBANK BANKA D.D.']: 'SBERBANK BANKA D.D.',
  ['SBERBANK BH D.D']: 'SBERBANK BH D.D',
  ['SBERBANK CZ, A.S.']: 'SBERBANK CZ, A.S.',
  ['SBERBANK HUNGARY LTD']: 'SBERBANK HUNGARY LTD',
  ['SBERBANK OF RUSSIA']: 'SBERBANK OF RUSSIA',
  ['SBERBANK PUBLIC JOINT-STOCK COMPANY']: 'SBERBANK PUBLIC JOINT-STOCK COMPANY',
  ['SBERBANK SLOVENSKO, A.S.S']: 'SBERBANK SLOVENSKO, A.S.S',
  ['SBERBANK SRBIJA A.D. BEOGRAD']: 'SBERBANK SRBIJA A.D. BEOGRAD',
  ['SBI BANK LLC']: 'SBI BANK LLC',
  ['SBI CARDS & PAYMENT SERVICES PVT. LTD']: 'SBI CARDS & PAYMENT SERVICES PVT. LTD',
  ['SBI SUMISHIN NET BANK, LTD.']: 'SBI SUMISHIN NET BANK, LTD.',
  ['SBM BANK (MAURITIUS) LTD']: 'SBM BANK (MAURITIUS) LTD',
  ['SC CITADELE BANKA']: 'SC CITADELE BANKA',
  ['SCE F.C.U.']: 'SCE F.C.U.',
  ['SCHOOL EMPLOYEES LORAIN COUNTY CREDIT UNION, INC.']: 'SCHOOL EMPLOYEES LORAIN COUNTY CREDIT UNION, INC.',
  ['SCHOOL SYSTEMS F.C.U.']: 'SCHOOL SYSTEMS F.C.U.',
  ['SCHOOLS F.C.U.']: 'SCHOOLS F.C.U.',
  ['SCHOOLSFIRST FEDERAL CREDIT UNION']: 'SCHOOLSFIRST FEDERAL CREDIT UNION',
  ['SCIENT F.C.U.']: 'SCIENT F.C.U.',
  ['SCOTIABANK']: 'SCOTIABANK',
  ['SCOTIABANK (BARBADOS) LIMITED']: 'SCOTIABANK (BARBADOS) LIMITED',
  ['SCOTIABANK (TURKS & CAICOS) LTD.']: 'SCOTIABANK (TURKS & CAICOS) LTD.',
  ['SCOTIABANK CARIBBEAN HOLDING LTD']: 'SCOTIABANK CARIBBEAN HOLDING LTD',
  ['SCOTIABANK COLPATRIA S.A.']: 'SCOTIABANK COLPATRIA S.A.',
  ['SCOTIABANK DE COSTA RICA, S.A.']: 'SCOTIABANK DE COSTA RICA, S.A.',
  ['SCOTIABANK DE PUERTO RICO']: 'SCOTIABANK DE PUERTO RICO',
  ['SCOTIABANK INVERLAT, S.A.']: 'SCOTIABANK INVERLAT, S.A.',
  ['SCOTIABANK PERU S.A.A.']: 'SCOTIABANK PERU S.A.A.',
  ['SCOTIABANK TRINIDAD AND TOBAGO LIMITED']: 'SCOTIABANK TRINIDAD AND TOBAGO LIMITED',
  ['SCOTT C.U.']: 'SCOTT C.U.',
  ['SDM BANK']: 'SDM BANK',
  ['SEA COMM F.C.U.']: 'SEA COMM F.C.U.',
  ['SEA WEST COAST GUARD F.C.U.']: 'SEA WEST COAST GUARD F.C.U.',
  ['SEABOARD C.U.']: 'SEABOARD C.U.',
  ['SEACOAST COMMERCE BANK']: 'SEACOAST COMMERCE BANK',
  ["SEAMEN'S BANK"]: "SEAMEN'S BANK",
  ['SEASONS F.C.U.']: 'SEASONS F.C.U.',
  ['SEATTLE METROPOLITAN C.U.']: 'SEATTLE METROPOLITAN C.U.',
  ['SEB BANKAS AB']: 'SEB BANKAS AB',
  ['SEB KORT BANK AB']: 'SEB KORT BANK AB',
  ['SEBASTICOOK VALLEY F.C.U.']: 'SEBASTICOOK VALLEY F.C.U.',
  ['SECNY FEDERAL CREDIT UNION']: 'SECNY FEDERAL CREDIT UNION',
  ['SECURED ADVANTAGE F.C.U.']: 'SECURED ADVANTAGE F.C.U.',
  ['SECURITY BANK']: 'SECURITY BANK',
  ['SECURITY BANK OF KANSAS CITY']: 'SECURITY BANK OF KANSAS CITY',
  ['SECURITY F.C.U.']: 'SECURITY F.C.U.',
  ['SECURITY FEDERAL BANK']: 'SECURITY FEDERAL BANK',
  ['SECURITY FIRST BANK']: 'SECURITY FIRST BANK',
  ['SECURITY FIRST NETWORK BANK']: 'SECURITY FIRST NETWORK BANK',
  ['SECURITY NATIONAL BANK']: 'SECURITY NATIONAL BANK',
  ['SECURITY NATIONAL BANK OF OMAHA']: 'SECURITY NATIONAL BANK OF OMAHA',
  ['SECURITY NATIONAL BANK OF SIOUX CITY, IOWA']: 'SECURITY NATIONAL BANK OF SIOUX CITY, IOWA',
  ['SECURITY SERVICE F.C.U.']: 'SECURITY SERVICE F.C.U.',
  ['SECURITY STATE BANK']: 'SECURITY STATE BANK',
  ['SECURITYPLUS F.C.U.']: 'SECURITYPLUS F.C.U.',
  ['SELCO COMMUNITY C.U.']: 'SELCO COMMUNITY C.U.',
  ['SELECT EMPLOYEES C.U.']: 'SELECT EMPLOYEES C.U.',
  ['SELECT SEVEN CREDIT UNIOIN']: 'SELECT SEVEN CREDIT UNIOIN',
  ['SELF-HELP C.U.']: 'SELF-HELP C.U.',
  ['SELFRELIANCE F.C.U.']: 'SELFRELIANCE F.C.U.',
  ['SELFRELIANCE UKRAINIAN AMERICAN F.C.U.']: 'SELFRELIANCE UKRAINIAN AMERICAN F.C.U.',
  ['SENB BANK']: 'SENB BANK',
  ['SENSHU IKEDA VC CO., LTD.']: 'SENSHU IKEDA VC CO., LTD.',
  ['SEQR PAYMENTS AB']: 'SEQR PAYMENTS AB',
  ['SEQUIOA F.C.U.']: 'SEQUIOA F.C.U.',
  ['SERVICE 1ST F.C.U.']: 'SERVICE 1ST F.C.U.',
  ['SERVICES C.U.']: 'SERVICES C.U.',
  ['SERVICIOS FINANCIEROS CARREFOUR, ESTABLECIMIENTO FINANCIERO DE CREDITO']:
    'SERVICIOS FINANCIEROS CARREFOUR, ESTABLECIMIENTO FINANCIERO DE CREDITO',
  ['SERVICIOS FINANCIEROS SORIANA, SAPI DE C.V. SOFOM. ENR.']:
    'SERVICIOS FINANCIEROS SORIANA, SAPI DE C.V. SOFOM. ENR.',
  ['SERVICIOS FINANCIEROS Y ADMINISTRACION DE CREDITOS COMERCIALES S.A.']:
    'SERVICIOS FINANCIEROS Y ADMINISTRACION DE CREDITOS COMERCIALES S.A.',
  ['SERVIRED, SOCIEDAD ESPANOLA DE MEDIOS DE PAGO S.A.']: 'SERVIRED, SOCIEDAD ESPANOLA DE MEDIOS DE PAGO S.A.',
  ['SERVNET ADMINISTRACAO DE CARTOES LTDA']: 'SERVNET ADMINISTRACAO DE CARTOES LTDA',
  ['SERVUS CREDIT UNION LTD.']: 'SERVUS CREDIT UNION LTD.',
  ['SETTLERS BANK']: 'SETTLERS BANK',
  ['SETTLERS F.C.U.']: 'SETTLERS F.C.U.',
  ['SEVEN SEVENTEEN CREDIT UNION INC.']: 'SEVEN SEVENTEEN CREDIT UNION INC.',
  ['SFS -FINANCIAL SERVICES, IME, S.A']: 'SFS -FINANCIAL SERVICES, IME, S.A',
  ['SGB-BANK S.A.']: 'SGB-BANK S.A.',
  ['SHAHJALAL ISLAMI BANK, LTD.']: 'SHAHJALAL ISLAMI BANK, LTD.',
  ['SHANGHAI COMMERCIAL BANK LTD.']: 'SHANGHAI COMMERCIAL BANK LTD.',
  ['SHANGHAI PUDONG DEVELOPMENT BANK']: 'SHANGHAI PUDONG DEVELOPMENT BANK',
  ['SHAREFAX CREDIT UNION, INC.']: 'SHAREFAX CREDIT UNION, INC.',
  ['SHARJAH ISLAMIC BANK PJSC']: 'SHARJAH ISLAMIC BANK PJSC',
  ['SHARON C.U.']: 'SHARON C.U.',
  ['SHARONVIEW F.C.U.']: 'SHARONVIEW F.C.U.',
  ['SHAZAM, INC.']: 'SHAZAM, INC.',
  ['SHELBY SAVINGS BANK, S.S.B.']: 'SHELBY SAVINGS BANK, S.S.B.',
  ['SHENZHEN DEVELOPMENT BANK, LTD.']: 'SHENZHEN DEVELOPMENT BANK, LTD.',
  ['SHINHAN BANK AMERICA']: 'SHINHAN BANK AMERICA',
  ['SHINHAN CARD CO., LTD.']: 'SHINHAN CARD CO., LTD.',
  ['SHINHAN VIETNAM BANK, LTD.']: 'SHINHAN VIETNAM BANK, LTD.',
  ['SHINKIN BANK CARD CO., LTD.']: 'SHINKIN BANK CARD CO., LTD.',
  ['SHORELINE C.U.']: 'SHORELINE C.U.',
  ['SHOW ME C.U.']: 'SHOW ME C.U.',
  ['SHOWA SHELL']: 'SHOWA SHELL',
  ['SHREWSBURY C.U.']: 'SHREWSBURY C.U.',
  ['SIA FSC EU']: 'SIA FSC EU',
  ['SIA TRANSACT PRO']: 'SIA TRANSACT PRO',
  ['SIA-SSB SPA']: 'SIA-SSB SPA',
  ['SIAM COMMERCIAL BANK PUBLIC COMPANY LIMITED']: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LIMITED',
  ['SIAPAY SRL']: 'SIAPAY SRL',
  ['SICHUAN TIANFU BANK CO., LTD.']: 'SICHUAN TIANFU BANK CO., LTD.',
  ['SIDNEY FEDERAL CREDIT UNION']: 'SIDNEY FEDERAL CREDIT UNION',
  ['SIERRA CENTRAL C.U.']: 'SIERRA CENTRAL C.U.',
  ['SIGNAL FINANCIAL F.C.U.']: 'SIGNAL FINANCIAL F.C.U.',
  ['SIGNATURE F.C.U.']: 'SIGNATURE F.C.U.',
  ['SIKORSKY FINANCIAL CREDIT UNION, INC.']: 'SIKORSKY FINANCIAL CREDIT UNION, INC.',
  ['SILICON VALLEY BANK']: 'SILICON VALLEY BANK',
  ['SILVER STATE SCHOOLS C.U.']: 'SILVER STATE SCHOOLS C.U.',
  ['SIMMONS BANK']: 'SIMMONS BANK',
  ['SIMMONS FIRST NATIONAL BANK']: 'SIMMONS FIRST NATIONAL BANK',
  ['SIMPLICITY C.U.']: 'SIMPLICITY C.U.',
  ['SINGAPORE BANKING CORP., LTD.']: 'SINGAPORE BANKING CORP., LTD.',
  ['SISALPAY S.P.A.']: 'SISALPAY S.P.A.',
  ['SISTEMAS INTERNACIONALES S.A. DE C.V.']: 'SISTEMAS INTERNACIONALES S.A. DE C.V.',
  ['SIU C.U.']: 'SIU C.U.',
  ['SIVALE']: 'SIVALE',
  ['SIX PAYMENT SERVICES AG']: 'SIX PAYMENT SERVICES AG',
  ['SKANDIABANKEN']: 'SKANDIABANKEN',
  ['SKANDINAVISKA ENSKILDA BANKEN AB']: 'SKANDINAVISKA ENSKILDA BANKEN AB',
  ['SKYE BANK PLC']: 'SKYE BANK PLC',
  ['SKYONE F.C.U.']: 'SKYONE F.C.U.',
  ['SKYWARD']: 'SKYWARD',
  ['SLOVENSKA SPORITELNA A.S.']: 'SLOVENSKA SPORITELNA A.S.',
  ['SMARTPURSE']: 'SMARTPURSE',
  ['SMBC FINANCE SERVICE CO., LTD.']: 'SMBC FINANCE SERVICE CO., LTD.',
  ['SNAKE RIVER F.C.U.']: 'SNAKE RIVER F.C.U.',
  ['SNAPSWAP INTERNATIONAL SA']: 'SNAPSWAP INTERNATIONAL SA',
  ['SNOHOMISH COUNTY PUD C.U.']: 'SNOHOMISH COUNTY PUD C.U.',
  ['SOCIEDADE INTERBANCARIA E SISTEMAS DE PAGAMENTOS,SA']: 'SOCIEDADE INTERBANCARIA E SISTEMAS DE PAGAMENTOS,SA',
  ['SOCIETE GENERALE']: 'SOCIETE GENERALE',
  ['SOCIETE GENERALE DE BANQUE - JORDAN']: 'SOCIETE GENERALE DE BANQUE - JORDAN',
  ['SOCIETE GENERALE DE BANQUE AU LIBAN S.A.L.']: 'SOCIETE GENERALE DE BANQUE AU LIBAN S.A.L.',
  ['SOCIETE GENERALE MAROCAINE DE BANQUES']: 'SOCIETE GENERALE MAROCAINE DE BANQUES',
  ['SOCIETE IVOIRIENNE DE BANQUE']: 'SOCIETE IVOIRIENNE DE BANQUE',
  ['SOCIETE MONETIQUE-TUNISIE']: 'SOCIETE MONETIQUE-TUNISIE',
  ['SODEXO MOTIVATION SOLUTIONS MEXICO SA DE CV']: 'SODEXO MOTIVATION SOLUTIONS MEXICO SA DE CV',
  ['SODEXO PASS ROMANIA SRL']: 'SODEXO PASS ROMANIA SRL',
  ['SOFTBANK']: 'SOFTBANK',
  ['SOGEXIA SA']: 'SOGEXIA SA',
  ['SOLARISBANK AG']: 'SOLARISBANK AG',
  ['SOLARITY C.U.']: 'SOLARITY C.U.',
  ['SOLDO FINANCIAL SERVICES IRELAND DAC']: 'SOLDO FINANCIAL SERVICES IRELAND DAC',
  ['SOLIDARITY COMMUNITY F.C.U.']: 'SOLIDARITY COMMUNITY F.C.U.',
  ['SOLVAY BANK']: 'SOLVAY BANK',
  ['SOMERSET TRUST COMPANY']: 'SOMERSET TRUST COMPANY',
  ['SOUND C.U.']: 'SOUND C.U.',
  ['SOUNDVIEW F.C.U.']: 'SOUNDVIEW F.C.U.',
  ['SOUTH CAROLINA BANK AND TRUST, N.A.']: 'SOUTH CAROLINA BANK AND TRUST, N.A.',
  ['SOUTH CAROLINA FEDERAL CREDIT UNION']: 'SOUTH CAROLINA FEDERAL CREDIT UNION',
  ['SOUTH CENTRAL BANK OF BARREN COUNTY, INC.']: 'SOUTH CENTRAL BANK OF BARREN COUNTY, INC.',
  ['SOUTH CENTRAL BANK, INC.']: 'SOUTH CENTRAL BANK, INC.',
  ['SOUTH DIVISION C.U.']: 'SOUTH DIVISION C.U.',
  ['SOUTH INDIAN BANK LTD., THE']: 'SOUTH INDIAN BANK LTD., THE',
  ['SOUTH STATE BANK']: 'SOUTH STATE BANK',
  ['SOUTH STORY BANK AND TRUST']: 'SOUTH STORY BANK AND TRUST',
  ['SOUTHEAST ASIA COMMERCIAL JOINT STOCK BANK']: 'SOUTHEAST ASIA COMMERCIAL JOINT STOCK BANK',
  ['SOUTHEAST ASIA COMMERCIAL JSB']: 'SOUTHEAST ASIA COMMERCIAL JSB',
  ['SOUTHERN BANK']: 'SOUTHERN BANK',
  ['SOUTHERN COMMERCE BANK, N.A.']: 'SOUTHERN COMMERCE BANK, N.A.',
  ['SOUTHERN CREDIT BANKING CORPORATION']: 'SOUTHERN CREDIT BANKING CORPORATION',
  ['SOUTHLAND BANK']: 'SOUTHLAND BANK',
  ['SOUTHLAND C.U.']: 'SOUTHLAND C.U.',
  ['SOUTHSIDE BANK']: 'SOUTHSIDE BANK',
  ['SOUTHTRUST BANK']: 'SOUTHTRUST BANK',
  ['SOUTHWEST CORPORATE FEDERAL CR']: 'SOUTHWEST CORPORATE FEDERAL CR',
  ['SOUTHWEST HEALTHCARE C.U.']: 'SOUTHWEST HEALTHCARE C.U.',
  ['SOUTHWEST HERITAGE C.U.']: 'SOUTHWEST HERITAGE C.U.',
  ['SOUTHWEST LOUISIANA C.U.']: 'SOUTHWEST LOUISIANA C.U.',
  ['SOUTHWEST MISSOURI BANK']: 'SOUTHWEST MISSOURI BANK',
  ['SOUTHWEST OKLAHOMA F.C.U.']: 'SOUTHWEST OKLAHOMA F.C.U.',
  ['SPACE COAST C.U.']: 'SPACE COAST C.U.',
  ['SPARBANKEN SKANE']: 'SPARBANKEN SKANE',
  ['SPARKASSE BANK DD SARAJEVO']: 'SPARKASSE BANK DD SARAJEVO',
  ['SPE F.C.U.']: 'SPE F.C.U.',
  ['SPENCER COUNTY BANK']: 'SPENCER COUNTY BANK',
  ['SPENCER SAVINGS BANK, SLA']: 'SPENCER SAVINGS BANK, SLA',
  ['SPIRA DE MEXICO S.A. DE C.V.']: 'SPIRA DE MEXICO S.A. DE C.V.',
  ['SPIRE BANK, LTD.']: 'SPIRE BANK, LTD.',
  ['SPIRIT FINANCIAL C.U.']: 'SPIRIT FINANCIAL C.U.',
  ['SPIRIT OF ALASKA F.C.U.']: 'SPIRIT OF ALASKA F.C.U.',
  ['SPOKANE TEACHERS CREDIT UNION']: 'SPOKANE TEACHERS CREDIT UNION',
  ['SPRINGFIELD STATE BANK']: 'SPRINGFIELD STATE BANK',
  ['SRP F.C.U.']: 'SRP F.C.U.',
  ['SRPSKA BANKA A.D. BEOGRAD']: 'SRPSKA BANKA A.D. BEOGRAD',
  ['ST CLOUD FINANCIAL CREDIT UNION']: 'ST CLOUD FINANCIAL CREDIT UNION',
  ['ST PIUS X CHURCH F.C.U.']: 'ST PIUS X CHURCH F.C.U.',
  ["ST. ANNE'S CREDIT UNION OF FALL RIVER"]: "ST. ANNE'S CREDIT UNION OF FALL RIVER",
  ['ST. FRANCIS X F.C.U.']: 'ST. FRANCIS X F.C.U.',
  ['ST. GEORGE BANK, LTD.']: 'ST. GEORGE BANK, LTD.',
  ['ST. KITTS-NEVIS-ANGUILLA NATIONAL BANK, LTD.']: 'ST. KITTS-NEVIS-ANGUILLA NATIONAL BANK, LTD.',
  ["ST. MARY'S CREDIT UNION"]: "ST. MARY'S CREDIT UNION",
  ['ST. MARYS BANK C.U.']: 'ST. MARYS BANK C.U.',
  ['ST1 FINANCE OY']: 'ST1 FINANCE OY',
  ['STADTSPARKASSE MUENCHEN']: 'STADTSPARKASSE MUENCHEN',
  ['STALEY C.U.']: 'STALEY C.U.',
  ['STAMFORD F.C.U.']: 'STAMFORD F.C.U.',
  ['STANBIC BANK GHANA, LTD.']: 'STANBIC BANK GHANA, LTD.',
  ['STANBIC BANK KENYA, LTD.']: 'STANBIC BANK KENYA, LTD.',
  ['STANBIC BANK, LTD.']: 'STANBIC BANK, LTD.',
  ['STANBIC IBTC BANK PLC']: 'STANBIC IBTC BANK PLC',
  ['STANDARD BANK OF SOUTH AFRICA, LTD.']: 'STANDARD BANK OF SOUTH AFRICA, LTD.',
  ['STANDARD BANK, PASB']: 'STANDARD BANK, PASB',
  ['STANDARD CHARTERED (JERSEY), LTD.']: 'STANDARD CHARTERED (JERSEY), LTD.',
  ['STANDARD CHARTERED BANK']: 'STANDARD CHARTERED BANK',
  ['STANDARD CHARTERED BANK (CI) LTD.']: 'STANDARD CHARTERED BANK (CI) LTD.',
  ['STANDARD CHARTERED BANK (HONG KONG) LIMITED']: 'STANDARD CHARTERED BANK (HONG KONG) LIMITED',
  ['STANDARD CHARTERED BANK (HONG KONG), LTD.']: 'STANDARD CHARTERED BANK (HONG KONG), LTD.',
  ['STANDARD CHARTERED BANK (PAKISTAN), LTD.']: 'STANDARD CHARTERED BANK (PAKISTAN), LTD.',
  ['STANDARD CHARTERED BANK (SINGAPORE) LIMITED']: 'STANDARD CHARTERED BANK (SINGAPORE) LIMITED',
  ['STANDARD CHARTERED BANK (TAIWAN) LIMITED']: 'STANDARD CHARTERED BANK (TAIWAN) LIMITED',
  ['STANDARD CHARTERED BANK (TAIWAN), LTD.']: 'STANDARD CHARTERED BANK (TAIWAN), LTD.',
  ['STANDARD CHARTERED BANK (THAI) PUBLIC CO., LTD.']: 'STANDARD CHARTERED BANK (THAI) PUBLIC CO., LTD.',
  ['STANDARD CHARTERED BANK (VIETNAM) LIMITED']: 'STANDARD CHARTERED BANK (VIETNAM) LIMITED',
  ['STANDARD CHARTERED BANK MALAYSIA BERHAD']: 'STANDARD CHARTERED BANK MALAYSIA BERHAD',
  ['STANTON NATIONAL BANK']: 'STANTON NATIONAL BANK',
  ['STAR BANK, N.A.']: 'STAR BANK, N.A.',
  ['STAR CHOICE C.U.']: 'STAR CHOICE C.U.',
  ['STAR FINANCIAL BANK']: 'STAR FINANCIAL BANK',
  ['STAR ONE C.U.']: 'STAR ONE C.U.',
  ['STAR PROCESSING INC.']: 'STAR PROCESSING INC.',
  ['STARION BANK']: 'STARION BANK',
  ['STARLING BANK LIMITED']: 'STARLING BANK LIMITED',
  ['STATE BANK']: 'STATE BANK',
  ['STATE BANK FINANCIAL']: 'STATE BANK FINANCIAL',
  ['STATE BANK OF BEMENT']: 'STATE BANK OF BEMENT',
  ['STATE BANK OF CROSS PLAINS']: 'STATE BANK OF CROSS PLAINS',
  ['STATE BANK OF INDIA']: 'STATE BANK OF INDIA',
  ['STATE BANK OF LINCOLN']: 'STATE BANK OF LINCOLN',
  ['STATE BANK OF LIZTON']: 'STATE BANK OF LIZTON',
  ['STATE BANK OF SOUTHERN UTAH']: 'STATE BANK OF SOUTHERN UTAH',
  ['STATE DEPARTMENT F.C.U.']: 'STATE DEPARTMENT F.C.U.',
  ['STATE EMPLOYEES C.U.']: 'STATE EMPLOYEES C.U.',
  ['STATE EMPLOYEES CREDIT UNION OF MARYLAND INC']: 'STATE EMPLOYEES CREDIT UNION OF MARYLAND INC',
  ['STATE EMPLOYEES CREDIT UNION OF MARYLAND, INC.']: 'STATE EMPLOYEES CREDIT UNION OF MARYLAND, INC.',
  ['STATE EMPLOYEES F.C.U.']: 'STATE EMPLOYEES F.C.U.',
  ['STATE FARM BANK F.S.B']: 'STATE FARM BANK F.S.B',
  ['STATE STREET BANK AND TRUST COMPANY']: 'STATE STREET BANK AND TRUST COMPANY',
  ['STATEWIDE F.C.U.']: 'STATEWIDE F.C.U.',
  ['STATUSBANK']: 'STATUSBANK',
  ['STAVROPOLPROMSTROYBANK OAO']: 'STAVROPOLPROMSTROYBANK OAO',
  ['STEARNS BANK NATIONAL ASSOCIATION']: 'STEARNS BANK NATIONAL ASSOCIATION',
  ['STERLING BANK']: 'STERLING BANK',
  ['STERLING F.C.U.']: 'STERLING F.C.U.',
  ['STERLING FEDERAL BANK F.S.B.']: 'STERLING FEDERAL BANK F.S.B.',
  ['STERLING NATIONAL BANK']: 'STERLING NATIONAL BANK',
  ['STEWARD BANK LIMITED']: 'STEWARD BANK LIMITED',
  ['STIFEL BANK']: 'STIFEL BANK',
  ['STILLMAN BANCCORP, N.A.']: 'STILLMAN BANCCORP, N.A.',
  ['STILLWATER NATIONAL BANK & TRUST COMPANY']: 'STILLWATER NATIONAL BANK & TRUST COMPANY',
  ['STOCK YARDS BANK & TRUST COMPANY']: 'STOCK YARDS BANK & TRUST COMPANY',
  ['STONEHAMBANK A CO-OPERATIVE BANK']: 'STONEHAMBANK A CO-OPERATIVE BANK',
  ['STOPANSKA BANKA A.D BITOLA']: 'STOPANSKA BANKA A.D BITOLA',
  ['STOPANSKA BANKA AD SKOPJE']: 'STOPANSKA BANKA AD SKOPJE',
  ['STOREFINANCIAL SERVICES UK LTD']: 'STOREFINANCIAL SERVICES UK LTD',
  ['STRAITS AREA F.C.U.']: 'STRAITS AREA F.C.U.',
  ['STRATA FEDERAL CREDIT UNION']: 'STRATA FEDERAL CREDIT UNION',
  ['STREATOR ONIZED C.U.']: 'STREATOR ONIZED C.U.',
  ['STRIDE BANK']: 'STRIDE BANK',
  ['STROMSBURG BANK']: 'STROMSBURG BANK',
  ['STURGIS BANK AND TRUST COMPANY']: 'STURGIS BANK AND TRUST COMPANY',
  ['SUBSIDIARY BANK SBERBANK OF RUSSIA JOINT STOCK COMPANY']: 'SUBSIDIARY BANK SBERBANK OF RUSSIA JOINT STOCK COMPANY',
  ['SUFFOLK FEDERAL CREDIT UNION']: 'SUFFOLK FEDERAL CREDIT UNION',
  ['SUMA (YONKERS) F.C.U.']: 'SUMA (YONKERS) F.C.U.',
  ['SUMITOMO MITSUI CARD CO., LTD.']: 'SUMITOMO MITSUI CARD CO., LTD.',
  ['SUMMIT BANK']: 'SUMMIT BANK',
  ['SUMMIT NATIONAL BANK']: 'SUMMIT NATIONAL BANK',
  ['SUMUP PAYMENTS LIMITED']: 'SUMUP PAYMENTS LIMITED',
  ['SUN C.U.']: 'SUN C.U.',
  ['SUN COMMUNITY FEDERAL CREDIT UNION']: 'SUN COMMUNITY FEDERAL CREDIT UNION',
  ['SUN EAST FEDERAL CREDIT UNION']: 'SUN EAST FEDERAL CREDIT UNION',
  ['SUN F.C.U.']: 'SUN F.C.U.',
  ['SUNCOAST C.U.']: 'SUNCOAST C.U.',
  ['SUNCOAST SCHOOLS F.C.U.']: 'SUNCOAST SCHOOLS F.C.U.',
  ['SUNFLOWER BANK, N.A.']: 'SUNFLOWER BANK, N.A.',
  ['SUNMARK CREDIT UNION']: 'SUNMARK CREDIT UNION',
  ['SUNMARK F.C.U.']: 'SUNMARK F.C.U.',
  ['SUNRISE BANK']: 'SUNRISE BANK',
  ['SUNSET SCIENCE PARK F.C.U.']: 'SUNSET SCIENCE PARK F.C.U.',
  ['SUNSTATE F.C.U.']: 'SUNSTATE F.C.U.',
  ['SUNTRUST BANK']: 'SUNTRUST BANK',
  ['SUPERIOR CHOICE C.U.']: 'SUPERIOR CHOICE C.U.',
  ['SUPERIOR F.C.U.']: 'SUPERIOR F.C.U.',
  ['SURGUTNEFTEGASBANK CJSC']: 'SURGUTNEFTEGASBANK CJSC',
  ['SURUGA CARD CO. LTD.']: 'SURUGA CARD CO. LTD.',
  ['SUSQUEHANNA COMMUNITY BANK']: 'SUSQUEHANNA COMMUNITY BANK',
  ['SUSQUEHANNA VALLEY F.C.U.']: 'SUSQUEHANNA VALLEY F.C.U.',
  ['SUTTON BANK']: 'SUTTON BANK',
  ['SVEA BANK AB']: 'SVEA BANK AB',
  ['SVENSKA HANDELSBANKEN AB']: 'SVENSKA HANDELSBANKEN AB',
  ['SVIAZ-BANK']: 'SVIAZ-BANK',
  ['SWAN']: 'SWAN',
  ['SWAP MEIOS DE PAGAMENTOS SA']: 'SWAP MEIOS DE PAGAMENTOS SA',
  ['SWEDBANK']: 'SWEDBANK',
  ['SWISS AMERICAN BANK']: 'SWISS AMERICAN BANK',
  ['SWISS BANKERS PREPAID SERVICES AG']: 'SWISS BANKERS PREPAID SERVICES AG',
  ['SWISSCARD AECS GMBH']: 'SWISSCARD AECS GMBH',
  ['SWISSQUOTE BANK']: 'SWISSQUOTE BANK',
  ['SYNCHRONY BANK']: 'SYNCHRONY BANK',
  ['SYNOVUS BANK']: 'SYNOVUS BANK',
  ['SYNOVUS FINANCIAL CORPORATION']: 'SYNOVUS FINANCIAL CORPORATION',
  ['T.C. ZIRAAT BANKASI A.S.']: 'T.C. ZIRAAT BANKASI A.S.',
  ['T24 BLACK ISSUED BY VOICE COMMERCE, LTD.']: 'T24 BLACK ISSUED BY VOICE COMMERCE, LTD.',
  ['TA CHONG BANK, LTD.']: 'TA CHONG BANK, LTD.',
  ['TAIPEI FUBON COMMERCIAL BANK CO., LTD.']: 'TAIPEI FUBON COMMERCIAL BANK CO., LTD.',
  ['TAISHIN INTERNATIONAL BANK']: 'TAISHIN INTERNATIONAL BANK',
  ['TAIWAN COOPERATIVE BANK']: 'TAIWAN COOPERATIVE BANK',
  ['TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD.']: 'TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD.',
  ['TAKASHIMAYA CARDS']: 'TAKASHIMAYA CARDS',
  ['TAMILNAD MERCANTILE BANK LTD.']: 'TAMILNAD MERCANTILE BANK LTD.',
  ['TAMPA BAY FEDERAL CREDIT UNION']: 'TAMPA BAY FEDERAL CREDIT UNION',
  ['TAMPA POSTAL FEDERAL CREDIT UNION']: 'TAMPA POSTAL FEDERAL CREDIT UNION',
  ['TANDEM BANK LIMITED']: 'TANDEM BANK LIMITED',
  ['TANGERINE BANK']: 'TANGERINE BANK',
  ['TAPCO C.U.']: 'TAPCO C.U.',
  ['TARGOBANK AG & CO. KGAA']: 'TARGOBANK AG & CO. KGAA',
  ['TARJETA AGORA']: 'TARJETA AGORA',
  ['TARJETAS BANAMEX, SA DE CV, SOFOM E.R.']: 'TARJETAS BANAMEX, SA DE CV, SOFOM E.R.',
  ['TARJETAS DE ORO S.A. DE C.V.']: 'TARJETAS DE ORO S.A. DE C.V.',
  ['TATRA BANKA, A.S.']: 'TATRA BANKA, A.S.',
  ['TAUNTON F.C.U.']: 'TAUNTON F.C.U.',
  ['TBA C.U.']: 'TBA C.U.',
  ['TBI BANK EAD']: 'TBI BANK EAD',
  ['TBK BANK, SSB']: 'TBK BANK, SSB',
  ['TCF FINANCIAL CORPORATION']: 'TCF FINANCIAL CORPORATION',
  ['TCM BANK, N.A.']: 'TCM BANK, N.A.',
  ['TCT F.C.U.']: 'TCT F.C.U.',
  ['TD BANK']: 'TD BANK',
  ['TD BANKNORTH, N.A.']: 'TD BANKNORTH, N.A.',
  ['TD WATERHOUSE BANK']: 'TD WATERHOUSE BANK',
  ['TEACHERS C.U.']: 'TEACHERS C.U.',
  ['TEAM ONE C.U.']: 'TEAM ONE C.U.',
  ['TECH C.U.']: 'TECH C.U.',
  ['TECHNOLOGY C.U.']: 'TECHNOLOGY C.U.',
  ['TECNICARD, INC.']: 'TECNICARD, INC.',
  ['TECU C.U.']: 'TECU C.U.',
  ['TEG FEDERAL CREDIT UNION']: 'TEG FEDERAL CREDIT UNION',
  ['TELCO F.C.U.']: 'TELCO F.C.U.',
  ['TELCOMM C.U.']: 'TELCOMM C.U.',
  ['TELLER, A.S.']: 'TELLER, A.S.',
  ['TENGRI BANK   JOINT STOCK COMPANY']: 'TENGRI BANK   JOINT STOCK COMPANY',
  ['TENMAYA CARD']: 'TENMAYA CARD',
  ['TENNESSEE C.U.']: 'TENNESSEE C.U.',
  ['TENNESSEE STATE BANK']: 'TENNESSEE STATE BANK',
  ['TENSAS STATE BANK']: 'TENSAS STATE BANK',
  ['TERRE HAUTE FIRST NATIONAL BANK']: 'TERRE HAUTE FIRST NATIONAL BANK',
  ['TESCO PERSONAL FINANCE LIMITED']: 'TESCO PERSONAL FINANCE LIMITED',
  ['TEXAS BANK AND TRUST COMPANY']: 'TEXAS BANK AND TRUST COMPANY',
  ['TEXAS CITIZENS BANK, N.A.']: 'TEXAS CITIZENS BANK, N.A.',
  ['TEXAS DOW EMPLOYEES C.U.']: 'TEXAS DOW EMPLOYEES C.U.',
  ['TEXAS FIRST BANK']: 'TEXAS FIRST BANK',
  ['TEXAS LEADERSHIP BANK']: 'TEXAS LEADERSHIP BANK',
  ['TEXAS TECH FEDERAL CREDIT UNION']: 'TEXAS TECH FEDERAL CREDIT UNION',
  ['TEXAS TRUST C.U.']: 'TEXAS TRUST C.U.',
  ['TEXELL C.U.']: 'TEXELL C.U.',
  ['TEXIM BANK A.D.']: 'TEXIM BANK A.D.',
  ['THAI FARMERS BANK PUBLIC CO., LTD.']: 'THAI FARMERS BANK PUBLIC CO., LTD.',
  ['THAI MILITARY BANK PUBLIC COMPANY LIMITED']: 'THAI MILITARY BANK PUBLIC COMPANY LIMITED',
  ['THANACHART BANK PUBLIC COMPANY LIMITED']: 'THANACHART BANK PUBLIC COMPANY LIMITED',
  ['THE AMERICAN NATIONAL BANK OF MOUNT PLEASANT']: 'THE AMERICAN NATIONAL BANK OF MOUNT PLEASANT',
  ['THE BANCORP BANK']: 'THE BANCORP BANK',
  ['THE BANK']: 'THE BANK',
  ['THE BANK OF BERMUDA LIMITED']: 'THE BANK OF BERMUDA LIMITED',
  ['THE BANK OF FUKUOKA, LTD.']: 'THE BANK OF FUKUOKA, LTD.',
  ['THE BANK OF JORDAN']: 'THE BANK OF JORDAN',
  ['THE BANK OF NOVA SCOTIA']: 'THE BANK OF NOVA SCOTIA',
  ['THE BANK OF SAGA LTD.']: 'THE BANK OF SAGA LTD.',
  ['THE BANK OF YOKOHAMA, LTD.']: 'THE BANK OF YOKOHAMA, LTD.',
  ['THE CANAAN NATIONAL BANK']: 'THE CANAAN NATIONAL BANK',
  ['THE CARTHAGE BANK']: 'THE CARTHAGE BANK',
  ['THE CHUGIN CARD COMPANY, LIMITED']: 'THE CHUGIN CARD COMPANY, LIMITED',
  ['THE CITIZENS BANK COMPANY']: 'THE CITIZENS BANK COMPANY',
  ['THE CITIZENS BANK OF EDMOND']: 'THE CITIZENS BANK OF EDMOND',
  ['THE CITIZENS BANKING COMPANY']: 'THE CITIZENS BANKING COMPANY',
  ['THE CITIZENS NATIONAL BANK OF HOPE']: 'THE CITIZENS NATIONAL BANK OF HOPE',
  ['THE CITIZENS STATE BANK']: 'THE CITIZENS STATE BANK',
  ['THE COMMERCIAL BANK OF DUBAI L']: 'THE COMMERCIAL BANK OF DUBAI L',
  ['THE COMMERCIAL BANK OF DUBAI LIMITED']: 'THE COMMERCIAL BANK OF DUBAI LIMITED',
  ['THE COUNTY F.C.U.']: 'THE COUNTY F.C.U.',
  ['THE FARMERS NATIONAL BANK OF DANVILLE']: 'THE FARMERS NATIONAL BANK OF DANVILLE',
  ['THE FFG CARD CO., LTD']: 'THE FFG CARD CO., LTD',
  ['THE FIRST']: 'THE FIRST',
  ['THE FIRST - A NATIONAL BANKING ASSOCIATION']: 'THE FIRST - A NATIONAL BANKING ASSOCIATION',
  ['THE FIRST NATIONAL BANK IN SIOUX FALLS']: 'THE FIRST NATIONAL BANK IN SIOUX FALLS',
  ['THE FIRST NATIONAL BANK OF FORT SMITH']: 'THE FIRST NATIONAL BANK OF FORT SMITH',
  ['THE FIRST NATIONAL BANK OF GRANBURY']: 'THE FIRST NATIONAL BANK OF GRANBURY',
  ['THE FIRST NATIONAL BANK OF HENNING']: 'THE FIRST NATIONAL BANK OF HENNING',
  ['THE FIRST NATIONAL BANK OF TRENTON']: 'THE FIRST NATIONAL BANK OF TRENTON',
  ['THE GOGIN CREDIT COMPANY LIMITED']: 'THE GOGIN CREDIT COMPANY LIMITED',
  ['THE GOVERNOR AND COMPANY OF THE BANK OF IRELAND']: 'THE GOVERNOR AND COMPANY OF THE BANK OF IRELAND',
  ['THE HAMILTON BANK']: 'THE HAMILTON BANK',
  ['THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED']: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED',
  ['THE HONGKONG AND SHANGHAI BANKING CORPORATION, LTD.']: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION, LTD.',
  ['THE HUNTINGTON NATIONAL BANK']: 'THE HUNTINGTON NATIONAL BANK',
  ['THE INTERNATIONAL BANK OF AZERBAIJAN']: 'THE INTERNATIONAL BANK OF AZERBAIJAN',
  ['THE KYUSHU CARD CO., LTD.']: 'THE KYUSHU CARD CO., LTD.',
  ['THE MAURITIUS COMMERCIAL BANK, LTD.']: 'THE MAURITIUS COMMERCIAL BANK, LTD.',
  ['THE NATIONAL BANK OF RAS AL-KHAIMAH']: 'THE NATIONAL BANK OF RAS AL-KHAIMAH',
  ['THE NATIONAL BANK PLC']: 'THE NATIONAL BANK PLC',
  ['THE PARK NATIONAL BANK']: 'THE PARK NATIONAL BANK',
  ['THE PEOPLES BANK']: 'THE PEOPLES BANK',
  ['THE PRIVATEBANK AND TRUST COMP']: 'THE PRIVATEBANK AND TRUST COMP',
  ['THE PROGRESSIVE BANK']: 'THE PROGRESSIVE BANK',
  ['THE PROVIDENT BANK']: 'THE PROVIDENT BANK',
  ['THE ROYAL BANK OF SCOTLAND INTERNATIONAL, LTD.']: 'THE ROYAL BANK OF SCOTLAND INTERNATIONAL, LTD.',
  ['THE STATE EXPORT-IMPORT BANK OF UKRAINE (UKREXIMBANK)']: 'THE STATE EXPORT-IMPORT BANK OF UKRAINE (UKREXIMBANK)',
  ['THE TORONTO-DOMINION BANK']: 'THE TORONTO-DOMINION BANK',
  ['THE VILLAGE BANK']: 'THE VILLAGE BANK',
  ['THE VINTON COUNTY NATIONAL BANK OF MCARTHUR']: 'THE VINTON COUNTY NATIONAL BANK OF MCARTHUR',
  ['THINK MONEY LIMITED']: 'THINK MONEY LIMITED',
  ['THINK MUTUAL BANK']: 'THINK MUTUAL BANK',
  ['THOMAS COOK (INDIA) LIMITED']: 'THOMAS COOK (INDIA) LIMITED',
  ['THREE RIVERS F.C.U.']: 'THREE RIVERS F.C.U.',
  ['THREE RIVERS FEDERAL CREDIT UNION']: 'THREE RIVERS FEDERAL CREDIT UNION',
  ['THRIVENT FEDERAL CREDIT UNION']: 'THRIVENT FEDERAL CREDIT UNION',
  ['TIAA BANK']: 'TIAA BANK',
  ['TIB THE INDEPENDENT BANKERSBANK']: 'TIB THE INDEPENDENT BANKERSBANK',
  ['TICONDEROGA F.C.U.']: 'TICONDEROGA F.C.U.',
  ['TIDEMARK F.C.U.']: 'TIDEMARK F.C.U.',
  ['TIEN PHONG COMMERCIAL JOINT STOCK BANK']: 'TIEN PHONG COMMERCIAL JOINT STOCK BANK',
  ['TINKER F.C.U.']: 'TINKER F.C.U.',
  ['TINKER FEDERAL CREDIT UNION']: 'TINKER FEDERAL CREDIT UNION',
  ['TINKOFF BANK']: 'TINKOFF BANK',
  ['TITAN TRUST BANK LIMITED']: 'TITAN TRUST BANK LIMITED',
  ['TLC COMMUNITY C.U.']: 'TLC COMMUNITY C.U.',
  ['TLC F.C.U.']: 'TLC F.C.U.',
  ['TMB BANK PUBLIC COMPANY LIMITED']: 'TMB BANK PUBLIC COMPANY LIMITED',
  ['TNB BANK']: 'TNB BANK',
  ['TNCONNECT C.U.']: 'TNCONNECT C.U.',
  ['TNG (ASIA) LIMITED']: 'TNG (ASIA) LIMITED',
  ['TOGETHER C.U.']: 'TOGETHER C.U.',
  ['TOHOKU SHINKIN BANK CARD CO., LTD.']: 'TOHOKU SHINKIN BANK CARD CO., LTD.',
  ['TOKYO CREDIT SERVICES, LTD.']: 'TOKYO CREDIT SERVICES, LTD.',
  ['TOKYO-MITSUBISHI UFJ BANK, LTD.']: 'TOKYO-MITSUBISHI UFJ BANK, LTD.',
  ['TOLEDO POLICE F.C.U.']: 'TOLEDO POLICE F.C.U.',
  ['TOMPKINS TRUST COMPANY']: 'TOMPKINS TRUST COMPANY',
  ['TONGASS F.C.U.']: 'TONGASS F.C.U.',
  ['TONIK DIGITAL BANK, INC.']: 'TONIK DIGITAL BANK, INC.',
  ['TOPCARD SERVICE AG']: 'TOPCARD SERVICE AG',
  ['TORONTO-DOMINION BANK']: 'TORONTO-DOMINION BANK',
  ['TORRANCE COMMUNITY FEDERAL CREDIT UNION']: 'TORRANCE COMMUNITY FEDERAL CREDIT UNION',
  ['TORREY PINES BANK']: 'TORREY PINES BANK',
  ['TOTAL COMMUNITY C.U.']: 'TOTAL COMMUNITY C.U.',
  ['TOTAL SYSTEM SERVICES, INC.']: 'TOTAL SYSTEM SERVICES, INC.',
  ['TOWER F.C.U.']: 'TOWER F.C.U.',
  ['TOWN AND COUNTRY BANK']: 'TOWN AND COUNTRY BANK',
  ['TOWN AND COUNTRY C.U.']: 'TOWN AND COUNTRY C.U.',
  ['TOWN NORTH BANK, N.A.']: 'TOWN NORTH BANK, N.A.',
  ['TOWN OF HEMPSTEAD EMPLOYEES F.C.U.']: 'TOWN OF HEMPSTEAD EMPLOYEES F.C.U.',
  ['TOYOTA FINANCE CORPORATION']: 'TOYOTA FINANCE CORPORATION',
  ['TRADE & COMMERCE BANK']: 'TRADE & COMMERCE BANK',
  ['TRADE AND DEVELOPMENT BANK OF MONGOLIA']: 'TRADE AND DEVELOPMENT BANK OF MONGOLIA',
  ['TRADITION CAPITAL BANK']: 'TRADITION CAPITAL BANK',
  ['TRAILHEAD C.U.']: 'TRAILHEAD C.U.',
  ['TRANSACT NETWORK, LTD.']: 'TRANSACT NETWORK, LTD.',
  ['TRANSCAPITALBANK']: 'TRANSCAPITALBANK',
  ['TRANSFERWISE AUSTRALIA PTY LTD']: 'TRANSFERWISE AUSTRALIA PTY LTD',
  ['TRANSFERWISE LTD']: 'TRANSFERWISE LTD',
  ['TRANSFERWISE SINGAPORE PTE LTD']: 'TRANSFERWISE SINGAPORE PTE LTD',
  ['TRANSFOREX (HONG KONG) INVESTMENT CONSULTING CO., LTD.']: 'TRANSFOREX (HONG KONG) INVESTMENT CONSULTING CO., LTD.',
  ['TRANSPORTATION ALLIANCE BANK INC.']: 'TRANSPORTATION ALLIANCE BANK INC.',
  ['TRANSWEST C.U.']: 'TRANSWEST C.U.',
  ['TRAVELEX CARD SERVICES LIMITED']: 'TRAVELEX CARD SERVICES LIMITED',
  ['TRAVELEX JAPAN KK']: 'TRAVELEX JAPAN KK',
  ['TREASURY DEPARTMENT FEDERAL CREDIT UNION']: 'TREASURY DEPARTMENT FEDERAL CREDIT UNION',
  ['TREEZOR SAS']: 'TREEZOR SAS',
  ['TRELLANCE, INC.']: 'TRELLANCE, INC.',
  ['TRIANGLE C.U.']: 'TRIANGLE C.U.',
  ['TRINITY BANK, N.A.']: 'TRINITY BANK, N.A.',
  ['TRIUM BANK & TRUST, LTD.']: 'TRIUM BANK & TRUST, LTD.',
  ['TRUE NORTH F.C.U.']: 'TRUE NORTH F.C.U.',
  ['TRUE SKY C.U.']: 'TRUE SKY C.U.',
  ['TRUECORE F.C.U.']: 'TRUECORE F.C.U.',
  ['TRUEVO PAYMENTS LTD']: 'TRUEVO PAYMENTS LTD',
  ['TRUIST BANK']: 'TRUIST BANK',
  ['TRULIANT F.C.U.']: 'TRULIANT F.C.U.',
  ['TRUPARTNER C.U.']: 'TRUPARTNER C.U.',
  ['TRUPOINT BANK']: 'TRUPOINT BANK',
  ['TRUSERVICE COMMUNITY F.C.U.']: 'TRUSERVICE COMMUNITY F.C.U.',
  ['TRUST MERCHANT BANK']: 'TRUST MERCHANT BANK',
  ['TRUSTBANK']: 'TRUSTBANK',
  ['TRUSTMARK NATIONAL BANK']: 'TRUSTMARK NATIONAL BANK',
  ['TRUSTONE FINANCIAL F.C.U.']: 'TRUSTONE FINANCIAL F.C.U.',
  ['TRUU INNOVATION SAPI DE CV']: 'TRUU INNOVATION SAPI DE CV',
  ['TRUWEST C.U.']: 'TRUWEST C.U.',
  ['TSB BANK PLC']: 'TSB BANK PLC',
  ['TUCOEMAS F.C.U.']: 'TUCOEMAS F.C.U.',
  ['TUCSON F.C.U.']: 'TUCSON F.C.U.',
  ['TUCSON OLD PUEBLO C.U.']: 'TUCSON OLD PUEBLO C.U.',
  ['TULAN BEST MARKETING COMPANY']: 'TULAN BEST MARKETING COMPANY',
  ['TULSA C.U.']: 'TULSA C.U.',
  ['TURK EKONOMI BANKASI A.S.']: 'TURK EKONOMI BANKASI A.S.',
  ['TURKIYE GARANTI BANKASI A.S.']: 'TURKIYE GARANTI BANKASI A.S.',
  ['TURKIYE IS BANKASI A.S.']: 'TURKIYE IS BANKASI A.S.',
  ['TUSKEGEE F.C.U.']: 'TUSKEGEE F.C.U.',
  ['TVA C.U.']: 'TVA C.U.',
  ['TWIN COUNTY CREDIT UNION']: 'TWIN COUNTY CREDIT UNION',
  ['TWINSTAR C.U.']: 'TWINSTAR C.U.',
  ['TWISTO PAYMENTS AS']: 'TWISTO PAYMENTS AS',
  ['TYNDALL F.C.U.']: 'TYNDALL F.C.U.',
  ['U MOBILE SDN BHD']: 'U MOBILE SDN BHD',
  ['U OF I COMMUNITY C.U.']: 'U OF I COMMUNITY C.U.',
  ['U OF P F.C.U.']: 'U OF P F.C.U.',
  ['U S #1364 F.C.U.']: 'U S #1364 F.C.U.',
  ['U S POSTAL SERVICE F.C.U.']: 'U S POSTAL SERVICE F.C.U.',
  ['U-MASS/FIVE COLLEGE F.C.U.']: 'U-MASS/FIVE COLLEGE F.C.U.',
  ['U.P. STATE C.U.']: 'U.P. STATE C.U.',
  ['U.S. BANK NATIONAL ASSOCIATION']: 'U.S. BANK NATIONAL ASSOCIATION',
  ['U.S. BANKCARD']: 'U.S. BANKCARD',
  ['U.S. EAGLE F.C.U.']: 'U.S. EAGLE F.C.U.',
  ['U.S. EMPLOYEES C.U.']: 'U.S. EMPLOYEES C.U.',
  ['U.S., N.A.']: 'U.S., N.A.',
  ['UAB SAFU.COM']: 'UAB SAFU.COM',
  ['UAB ZEN.COM']: 'UAB ZEN.COM',
  ['UAE EXCHANGE CENTRE LLC']: 'UAE EXCHANGE CENTRE LLC',
  ['UBA KENYA BANK, LTD.']: 'UBA KENYA BANK, LTD.',
  ['UBS AG']: 'UBS AG',
  ['UBS AG (UNION BANK OF SWITZERLAND)']: 'UBS AG (UNION BANK OF SWITZERLAND)',
  ['UBS BANK USA']: 'UBS BANK USA',
  ['UBS SWITZERLAND AG']: 'UBS SWITZERLAND AG',
  ['UC CARD CO., LTD.']: 'UC CARD CO., LTD.',
  ['UCS CO., LTD.']: 'UCS CO., LTD.',
  ['UFCW F.C.U.']: 'UFCW F.C.U.',
  ['UFIRST F.C.U.']: 'UFIRST F.C.U.',
  ['UKRAINIAN NATIONAL F.C.U.']: 'UKRAINIAN NATIONAL F.C.U.',
  ['UKRAINIAN SELFRELIANCE (MICHIGAN) F.C.U.']: 'UKRAINIAN SELFRELIANCE (MICHIGAN) F.C.U.',
  ['UKRAINIAN SELFRELIANCE F.C.U.']: 'UKRAINIAN SELFRELIANCE F.C.U.',
  ['UKRGAZBANK']: 'UKRGAZBANK',
  ['ULSTER BANK']: 'ULSTER BANK',
  ['UMB BANK, NATIONAL ASSOCIATION']: 'UMB BANK, NATIONAL ASSOCIATION',
  ['UME F.C.U.']: 'UME F.C.U.',
  ['UMPQUA BANK']: 'UMPQUA BANK',
  ['UNCLE C.U.']: 'UNCLE C.U.',
  ['UNIBANCA, S.A']: 'UNIBANCA, S.A',
  ['UNIBANCO - UNIAO DE BANCOS BRASILEIROS S.A.']: 'UNIBANCO - UNIAO DE BANCOS BRASILEIROS S.A.',
  ['UNIBANK CJCS']: 'UNIBANK CJCS',
  ['UNIBANK COMMERCIAL BANK']: 'UNIBANK COMMERCIAL BANK',
  ['UNIBANK FOR SAVINGS']: 'UNIBANK FOR SAVINGS',
  ['UNICARD SOLUTION LIMITED']: 'UNICARD SOLUTION LIMITED',
  ['UNICRE - INSTITUICAO FINANCEIRA DE CREDITO, S.A.']: 'UNICRE - INSTITUICAO FINANCEIRA DE CREDITO, S.A.',
  ['UNICRE-INSTITUICAO FINANCEIRA DE CREDITO, S.A.']: 'UNICRE-INSTITUICAO FINANCEIRA DE CREDITO, S.A.',
  ['UNICREDIT BANK']: 'UNICREDIT BANK',
  ['UNICREDIT BANK CZECH REPUBLIC AND SLOVAKIA, A.S.']: 'UNICREDIT BANK CZECH REPUBLIC AND SLOVAKIA, A.S.',
  ['UNICREDIT BANK D.D.']: 'UNICREDIT BANK D.D.',
  ['UNICREDIT BANK HUNGARY ZRT.']: 'UNICREDIT BANK HUNGARY ZRT.',
  ['UNICREDIT BANK SERBIA JSC BELGRAD']: 'UNICREDIT BANK SERBIA JSC BELGRAD',
  ['UNICREDIT BANK SLOVAKIA, A.S.']: 'UNICREDIT BANK SLOVAKIA, A.S.',
  ['UNICREDIT BANKA SLOVENIJA D.D.']: 'UNICREDIT BANKA SLOVENIJA D.D.',
  ['UNICREDIT BULBANK AD']: 'UNICREDIT BULBANK AD',
  ['UNICREDIT SPA']: 'UNICREDIT SPA',
  ['UNIFY F.C.U.']: 'UNIFY F.C.U.',
  ['UNIK']: 'UNIK',
  ['UNION BANK']: 'UNION BANK',
  ['UNION BANK & TRUST']: 'UNION BANK & TRUST',
  ['UNION BANK AND TRUST COMPANY']: 'UNION BANK AND TRUST COMPANY',
  ['UNION BANK COMPANY, THE']: 'UNION BANK COMPANY, THE',
  ['UNION BANK OF CALIFORNIA, N.A.']: 'UNION BANK OF CALIFORNIA, N.A.',
  ['UNION BANK OF MENA']: 'UNION BANK OF MENA',
  ['UNION BANK OF TAIWAN']: 'UNION BANK OF TAIWAN',
  ['UNION BANK OF THE PHILIPPINES']: 'UNION BANK OF THE PHILIPPINES',
  ['UNION BANK SH.A.']: 'UNION BANK SH.A.',
  ['UNION BANK UK PLC']: 'UNION BANK UK PLC',
  ['UNION COMMERCIAL BANK PLC.']: 'UNION COMMERCIAL BANK PLC.',
  ['UNION FIDELITY F.C.U.']: 'UNION FIDELITY F.C.U.',
  ['UNION NATIONAL BANK - EGYPT']: 'UNION NATIONAL BANK - EGYPT',
  ['UNION PLANTERS BANK']: 'UNION PLANTERS BANK',
  ['UNION SAVINGS BANK']: 'UNION SAVINGS BANK',
  ['UNION SQUARE CREDIT UNION']: 'UNION SQUARE CREDIT UNION',
  ['UNION STATE BANK']: 'UNION STATE BANK',
  ['UNION TOGOLAISE DE BANQUE']: 'UNION TOGOLAISE DE BANQUE',
  ['UNIONBANK']: 'UNIONBANK',
  ['UNIONBANK OF THE PHILIPPINES']: 'UNIONBANK OF THE PHILIPPINES',
  ['UNIPRIME NORTE DO PARANA']: 'UNIPRIME NORTE DO PARANA',
  ['UNISON C.U.']: 'UNISON C.U.',
  ['UNITED ARAB BANK']: 'UNITED ARAB BANK',
  ['UNITED BANK']: 'UNITED BANK',
  ['UNITED BANK FOR AFRICA (LIBERIA), LTD.']: 'UNITED BANK FOR AFRICA (LIBERIA), LTD.',
  ['UNITED BANK FOR AFRICA (SL), LTD.']: 'UNITED BANK FOR AFRICA (SL), LTD.',
  ['UNITED BANK FOR AFRICA (UBA) PLC']: 'UNITED BANK FOR AFRICA (UBA) PLC',
  ['UNITED BANK FOR AFRICA (UGANDA), LTD.']: 'UNITED BANK FOR AFRICA (UGANDA), LTD.',
  ['UNITED BANK FOR AFRICA PLC']: 'UNITED BANK FOR AFRICA PLC',
  ['UNITED BANK FOR AFRICA SENEGAL']: 'UNITED BANK FOR AFRICA SENEGAL',
  ['UNITED BANK FOR AFRICA TCHAD']: 'UNITED BANK FOR AFRICA TCHAD',
  ['UNITED BANK FOR AFRICA ZAMBIA, LTD.']: 'UNITED BANK FOR AFRICA ZAMBIA, LTD.',
  ['UNITED BANK LIMITED (UBL)']: 'UNITED BANK LIMITED (UBL)',
  ['UNITED BANK OF INDIA']: 'UNITED BANK OF INDIA',
  ['UNITED BANK S.E.A.']: 'UNITED BANK S.E.A.',
  ['UNITED BANK, LTD.']: 'UNITED BANK, LTD.',
  ["UNITED BANKERS' BANK"]: "UNITED BANKERS' BANK",
  ['UNITED BULGARIAN BANK PLC.']: 'UNITED BULGARIAN BANK PLC.',
  ['UNITED BUSINESS BANK']: 'UNITED BUSINESS BANK',
  ['UNITED C.U.']: 'UNITED C.U.',
  ['UNITED CATHOLICS F.C.U.']: 'UNITED CATHOLICS F.C.U.',
  ['UNITED CHINESE BANK LIMITED']: 'UNITED CHINESE BANK LIMITED',
  ['UNITED COMMUNITY BANK']: 'UNITED COMMUNITY BANK',
  ['UNITED COMMUNITY BANK OF WEST KENTUCKY, INC.']: 'UNITED COMMUNITY BANK OF WEST KENTUCKY, INC.',
  ['UNITED COMPANY FOR FINANCIAL SERVICES']: 'UNITED COMPANY FOR FINANCIAL SERVICES',
  ['UNITED FINANCIAL C.U.']: 'UNITED FINANCIAL C.U.',
  ['UNITED FLORISTS F.C.U.']: 'UNITED FLORISTS F.C.U.',
  ['UNITED LOCAL C.U.']: 'UNITED LOCAL C.U.',
  ['UNITED METHODIST FINANCIAL C.U.']: 'UNITED METHODIST FINANCIAL C.U.',
  ['UNITED OVERSEAS BANK (MALAYSIA) BERHAD']: 'UNITED OVERSEAS BANK (MALAYSIA) BERHAD',
  ['UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED']: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
  ['UNITED OVERSEAS BANK LIMITED']: 'UNITED OVERSEAS BANK LIMITED',
  ['UNITED OVERSEAS BANK(THAI)PUBLIC CO., LTD.']: 'UNITED OVERSEAS BANK(THAI)PUBLIC CO., LTD.',
  ['UNITED SOUTHERN BANK']: 'UNITED SOUTHERN BANK',
  ['UNITED STATES TRUST COMPANY, N.A.']: 'UNITED STATES TRUST COMPANY, N.A.',
  ['UNITED TEXAS CREDIT UNION']: 'UNITED TEXAS CREDIT UNION',
  ['UNITEDONE C.U.']: 'UNITEDONE C.U.',
  ['UNITEDTRUST BANK']: 'UNITEDTRUST BANK',
  ['UNITUS COMMUNITY C.U.']: 'UNITUS COMMUNITY C.U.',
  ['UNITY BANK PLC']: 'UNITY BANK PLC',
  ['UNITY CATHOLIC F.C.U.']: 'UNITY CATHOLIC F.C.U.',
  ['UNITY ONE C.U.']: 'UNITY ONE C.U.',
  ['UNIVERSAL BANK, N.A.']: 'UNIVERSAL BANK, N.A.',
  ['UNIVERSAL CITY STUDIOS C.U.']: 'UNIVERSAL CITY STUDIOS C.U.',
  ['UNIVERSAL INVESTMENT BANK AD SKOPJE']: 'UNIVERSAL INVESTMENT BANK AD SKOPJE',
  ['UNIVERSITY & STATE EMPLOYEES CREDIT UNION']: 'UNIVERSITY & STATE EMPLOYEES CREDIT UNION',
  ['UNIVERSITY AND STATE EMPLOYEES C.U. OF SAN DIEGO']: 'UNIVERSITY AND STATE EMPLOYEES C.U. OF SAN DIEGO',
  ['UNIVERSITY BANK']: 'UNIVERSITY BANK',
  ['UNIVERSITY C.U.']: 'UNIVERSITY C.U.',
  ['UNIVERSITY CREDIT UNION']: 'UNIVERSITY CREDIT UNION',
  ['UNIVERSITY F.C.U.']: 'UNIVERSITY F.C.U.',
  ['UNIVERSITY NATIONAL BANK']: 'UNIVERSITY NATIONAL BANK',
  ['UNIVERSITY OF KENTUCKY F.C.U.']: 'UNIVERSITY OF KENTUCKY F.C.U.',
  ['UNIVERSITY OF MICHIGAN C.U.']: 'UNIVERSITY OF MICHIGAN C.U.',
  ['UNIVERSITY OF TOLEDO F.C.U.']: 'UNIVERSITY OF TOLEDO F.C.U.',
  ['UNIVERSITY OF WISCONSIN C.U.']: 'UNIVERSITY OF WISCONSIN C.U.',
  ['UNIVEST BANK AND TRUST CO.']: 'UNIVEST BANK AND TRUST CO.',
  ['UNIWYO F.C.U.']: 'UNIWYO F.C.U.',
  ['UNLIMINT EU LTD']: 'UNLIMINT EU LTD',
  ['UP']: 'UP',
  ['UP AGANEA EDE SAU']: 'UP AGANEA EDE SAU',
  ['URAL BANK FOR RECONSTRUCTION AND DEVELOPMENT']: 'URAL BANK FOR RECONSTRUCTION AND DEVELOPMENT',
  ['URAL BANK FOR RECONSTRUCTION AND DEVELOPMENT JSC']: 'URAL BANK FOR RECONSTRUCTION AND DEVELOPMENT JSC',
  ['URALFINANS CB LLC']: 'URALFINANS CB LLC',
  ['URALS INDUSTRIAL BANK OJSC']: 'URALS INDUSTRIAL BANK OJSC',
  ['URWEGO OPPORTUNITY BANK LTD']: 'URWEGO OPPORTUNITY BANK LTD',
  ['US BANK, N.A.']: 'US BANK, N.A.',
  ['US COMMUNITY C.U.']: 'US COMMUNITY C.U.',
  ['USAA SAVINGS BANK']: 'USAA SAVINGS BANK',
  ['USALLIANCE F.C.U.']: 'USALLIANCE F.C.U.',
  ['USC CREDIT UNION']: 'USC CREDIT UNION',
  ['USNY BANK']: 'USNY BANK',
  ['USSCO JOHNSTOWN F.C.U.']: 'USSCO JOHNSTOWN F.C.U.',
  ['USX F.C.U.']: 'USX F.C.U.',
  ['UTAH F.C.U.']: 'UTAH F.C.U.',
  ['UTELCO CREDIT UNION INC']: 'UTELCO CREDIT UNION INC',
  ['UTICA GAS AND ELECTRIC C.U.']: 'UTICA GAS AND ELECTRIC C.U.',
  ['UTILITIES EMPLOYEES C.U.']: 'UTILITIES EMPLOYEES C.U.',
  ['UWHARRIE BANK']: 'UWHARRIE BANK',
  ['UZBEK INDUSTRIAL AND CONSTRUCTION BANK JSCB']: 'UZBEK INDUSTRIAL AND CONSTRUCTION BANK JSCB',
  ['UZPROMSTROYBANK UZBEK JSC INDUSTRIAL AND CONSTRUCTION BANK']:
    'UZPROMSTROYBANK UZBEK JSC INDUSTRIAL AND CONSTRUCTION BANK',
  ['VACA VALLEY F.C.U.']: 'VACA VALLEY F.C.U.',
  ['VALES INTERCONTINENTALES, S.A.']: 'VALES INTERCONTINENTALES, S.A.',
  ['VALITOR']: 'VALITOR',
  ['VALITOR PAYMENT SERVICES LTD']: 'VALITOR PAYMENT SERVICES LTD',
  ['VALLEY BANK OF NEVADA']: 'VALLEY BANK OF NEVADA',
  ['VALLEY C.U.']: 'VALLEY C.U.',
  ['VALLEY COMMERCE BANK']: 'VALLEY COMMERCE BANK',
  ['VALLEY FIRST C.U.']: 'VALLEY FIRST C.U.',
  ['VALLEY INDEPENDENT BANK']: 'VALLEY INDEPENDENT BANK',
  ['VALLEY NATIONAL BANK']: 'VALLEY NATIONAL BANK',
  ['VALLEY STRONG C.U.']: 'VALLEY STRONG C.U.',
  ['VALORES INTERNACIONALES, S.A.']: 'VALORES INTERNACIONALES, S.A.',
  ['VANCOUVER CITY SAVINGS C.U.']: 'VANCOUVER CITY SAVINGS C.U.',
  ['VANTAGE C.U.']: 'VANTAGE C.U.',
  ['VANTAGE CREDIT UNION']: 'VANTAGE CREDIT UNION',
  ['VARO/BANCORP BANK']: 'VARO/BANCORP BANK',
  ['VATTANAC BANK']: 'VATTANAC BANK',
  ['VCB']: 'VCB',
  ['VECTRA BANK COLORADO']: 'VECTRA BANK COLORADO',
  ['VELOCITY CREDIT UNION']: 'VELOCITY CREDIT UNION',
  ['VENTAS INTERNACIONALES S.A. DE C.V.']: 'VENTAS INTERNACIONALES S.A. DE C.V.',
  ['VENTURA COUNTY C.U.']: 'VENTURA COUNTY C.U.',
  ['VERABANK, N.A.']: 'VERABANK, N.A.',
  ['VERBAND DER SPARDA BANKEN E.V.']: 'VERBAND DER SPARDA BANKEN E.V.',
  ['VERIDIAN C.U.']: 'VERIDIAN C.U.',
  ['VERITY C.U.']: 'VERITY C.U.',
  ['VERMONT F.C.U.']: 'VERMONT F.C.U.',
  ['VERMONT STATE EMPLOYEES C.U.']: 'VERMONT STATE EMPLOYEES C.U.',
  ['VERSE PAYMENTS LITHUANIA UAB']: 'VERSE PAYMENTS LITHUANIA UAB',
  ['VERSOBANK']: 'VERSOBANK',
  ['VIBE C.U.']: 'VIBE C.U.',
  ['VIBRANT CREDIT UNION']: 'VIBRANT CREDIT UNION',
  ['VICTORY BANK']: 'VICTORY BANK',
  ['VIETNAM BANK FOR AGRICULTURE AND RURAL DEVELOPMENT']: 'VIETNAM BANK FOR AGRICULTURE AND RURAL DEVELOPMENT',
  ['VIETNAM BANK FOR INDUSTRY AND TRADE']: 'VIETNAM BANK FOR INDUSTRY AND TRADE',
  ['VIETNAM EXPORT-IMPORT COMMERCIAL JOINT STOCK BANK']: 'VIETNAM EXPORT-IMPORT COMMERCIAL JOINT STOCK BANK',
  ['VIETNAM INTERNATIONAL COMMERCIAL JOINT STOCK BANK']: 'VIETNAM INTERNATIONAL COMMERCIAL JOINT STOCK BANK',
  ['VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE']:
    'VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE',
  ['VIETNAM MARITIME COMMERCIAL JOINT STOCK BANK']: 'VIETNAM MARITIME COMMERCIAL JOINT STOCK BANK',
  ['VIETNAM PROSPERITY JOINT STOCK COMMERCIAL  BANK']: 'VIETNAM PROSPERITY JOINT STOCK COMMERCIAL  BANK',
  ['VIETNAM PUBLIC JOINT STOCK COMMERCIAL BANK']: 'VIETNAM PUBLIC JOINT STOCK COMMERCIAL BANK',
  ['VIETNAM TECHNOLOGICAL AND COMMERCIAL JOINT STOCK BANK']: 'VIETNAM TECHNOLOGICAL AND COMMERCIAL JOINT STOCK BANK',
  ['VILLAGE BANK']: 'VILLAGE BANK',
  ['VINTON COUNTY NATIONAL BANK OF MCARTHUR']: 'VINTON COUNTY NATIONAL BANK OF MCARTHUR',
  ['VIRGIN MONEY']: 'VIRGIN MONEY',
  ['VIRGINIA BEACH SCHOOLS F.C.U.']: 'VIRGINIA BEACH SCHOOLS F.C.U.',
  ['VIRGINIA CREDIT UNION, INC.']: 'VIRGINIA CREDIT UNION, INC.',
  ['VISA ARGENTINA, S.A.']: 'VISA ARGENTINA, S.A.',
  ['VISA DEBIT PROCESSING SERVICE']: 'VISA DEBIT PROCESSING SERVICE',
  ['VISA ICELAND']: 'VISA ICELAND',
  ['VISECA CARD SERVICES S.A.']: 'VISECA CARD SERVICES S.A.',
  ['VISECA PAYMENT SERVICES SA']: 'VISECA PAYMENT SERVICES SA',
  ['VISION BANCO SOCIEDAD ANONIMA EMISORA DECAPITAL ABIERTO']:
    'VISION BANCO SOCIEDAD ANONIMA EMISORA DECAPITAL ABIERTO',
  ['VISION BANK, N.A.']: 'VISION BANK, N.A.',
  ['VISIONS F.C.U.']: 'VISIONS F.C.U.',
  ['VIST BANK']: 'VIST BANK',
  ['VISTA BANK']: 'VISTA BANK',
  ['VIVA PAYMENT SERVICES S.A.']: 'VIVA PAYMENT SERVICES S.A.',
  ['VJA']: 'VJA',
  ['VJA CO.,LTD.']: 'VJA CO.,LTD.',
  ['VOCALITY COMMUNITY C.U.']: 'VOCALITY COMMUNITY C.U.',
  ['VOICE COMMERCE, LTD.']: 'VOICE COMMERCE, LTD.',
  ['VOJVODJANSKA BANKA AD NOVI SAD, OTP GROUP']: 'VOJVODJANSKA BANKA AD NOVI SAD, OTP GROUP',
  ['VOLT BANK LIMITED']: 'VOLT BANK LIMITED',
  ['VOLVOFINANS BANK AB (PUBL)']: 'VOLVOFINANS BANK AB (PUBL)',
  ['VOYAGE F.C.U.']: 'VOYAGE F.C.U.',
  ['VSB INTERNATIONAL B.V.']: 'VSB INTERNATIONAL B.V.',
  ['VSEOBECNA UVEROVA BANKA A.S.']: 'VSEOBECNA UVEROVA BANKA A.S.',
  ['VTB BANK (ARMENIA)']: 'VTB BANK (ARMENIA)',
  ['VTB BANK (KAZAKHSTAN) SUBSIDIARY JOINT STOCK COMPANY']: 'VTB BANK (KAZAKHSTAN) SUBSIDIARY JOINT STOCK COMPANY',
  ['VTB BANK BELARUS CLOSED JOINT-STOCK COMPANY']: 'VTB BANK BELARUS CLOSED JOINT-STOCK COMPANY',
  ['VTB BANK OJSC']: 'VTB BANK OJSC',
  ['VYSTAR C.U.']: 'VYSTAR C.U.',
  ['WALKER COUNTRY F.C.U.']: 'WALKER COUNTRY F.C.U.',
  ['WALLETTO UAB']: 'WALLETTO UAB',
  ['WARBA BANK K.S.C']: 'WARBA BANK K.S.C',
  ['WARREN FINANCIAL - WEALTH MANAGEMENT FIRM']: 'WARREN FINANCIAL - WEALTH MANAGEMENT FIRM',
  ['WASATCH PEAKS C.U.']: 'WASATCH PEAKS C.U.',
  ['WASHINGTON AREA F.C.U.']: 'WASHINGTON AREA F.C.U.',
  ['WASHINGTON FEDERAL']: 'WASHINGTON FEDERAL',
  ['WASHINGTON FEDERAL BANK']: 'WASHINGTON FEDERAL BANK',
  ['WASHINGTON SAVINGS BANK']: 'WASHINGTON SAVINGS BANK',
  ['WASHINGTON STATE EMPLOYEES C.U.']: 'WASHINGTON STATE EMPLOYEES C.U.',
  ['WASHINGTON TRUST BANK']: 'WASHINGTON TRUST BANK',
  ['WATER AND POWER COMMUNITY CREDIT UNION']: 'WATER AND POWER COMMUNITY CREDIT UNION',
  ['WATERFRONT F.C.U.']: 'WATERFRONT F.C.U.',
  ['WATERTOWN SAVINGS BANK']: 'WATERTOWN SAVINGS BANK',
  ['WAUCHULA STATE BANK']: 'WAUCHULA STATE BANK',
  ['WAUKESHA STATE BANK']: 'WAUKESHA STATE BANK',
  ['WAUNA F.C.U.']: 'WAUNA F.C.U.',
  ['WAVE CREST HOLDINGS, LTD.']: 'WAVE CREST HOLDINGS, LTD.',
  ['WAYNE BANK']: 'WAYNE BANK',
  ['WAYNE COUNTY BANK']: 'WAYNE COUNTY BANK',
  ['WAYNE SAVINGS COMMUNITY BANK']: 'WAYNE SAVINGS COMMUNITY BANK',
  ['WEBBANK']: 'WEBBANK',
  ['WEBSTER BANK']: 'WEBSTER BANK',
  ['WEBSTER FIRST FEDERAL CREDIT UNION']: 'WEBSTER FIRST FEDERAL CREDIT UNION',
  ['WELAB BANK LIMITED']: 'WELAB BANK LIMITED',
  ['WELLS FARGO']: 'WELLS FARGO',
  ['WELLS FARGO BANK ARIZONA, N.A.']: 'WELLS FARGO BANK ARIZONA, N.A.',
  ['WELLS FARGO BANK IOWA, N.A.']: 'WELLS FARGO BANK IOWA, N.A.',
  ['WELLS FARGO BANK NATIONAL ASSOCIATION']: 'WELLS FARGO BANK NATIONAL ASSOCIATION',
  ['WELLS FARGO BANK NEVADA, N.A.']: 'WELLS FARGO BANK NEVADA, N.A.',
  ['WELLS FEDERAL BANK, F.S.B.']: 'WELLS FEDERAL BANK, F.S.B.',
  ['WEMA BANK PLC']: 'WEMA BANK PLC',
  ['WEOKIE C.U.']: 'WEOKIE C.U.',
  ['WEPCO FEDERAL CREDIT UNION']: 'WEPCO FEDERAL CREDIT UNION',
  ['WESBANCO BANK INC.']: 'WESBANCO BANK INC.',
  ['WEST CENTRAL BANK']: 'WEST CENTRAL BANK',
  ['WEST MICHIGAN C.U.']: 'WEST MICHIGAN C.U.',
  ['WEST ORANGE MUN FED C.U.']: 'WEST ORANGE MUN FED C.U.',
  ['WEST PLAINS BANK AND TRUST COMPANY']: 'WEST PLAINS BANK AND TRUST COMPANY',
  ['WEST SIBERIAN COMMERCIAL BANK']: 'WEST SIBERIAN COMMERCIAL BANK',
  ['WEST SUBURBAN BANK']: 'WEST SUBURBAN BANK',
  ['WEST-AIRCOMM F.C.U.']: 'WEST-AIRCOMM F.C.U.',
  ['WESTAMERICA BANK']: 'WESTAMERICA BANK',
  ['WESTBY COOP CREDIT UNION']: 'WESTBY COOP CREDIT UNION',
  ['WESTERN ALLIANCE BANK']: 'WESTERN ALLIANCE BANK',
  ['WESTERN BANK']: 'WESTERN BANK',
  ['WESTERN BRIDGE CORPORATE F.C.U.']: 'WESTERN BRIDGE CORPORATE F.C.U.',
  ['WESTERN COOPERATIVE C.U.']: 'WESTERN COOPERATIVE C.U.',
  ['WESTERN DISTRICTS MEMBERS C.U.']: 'WESTERN DISTRICTS MEMBERS C.U.',
  ['WESTERN NATIONAL BANK']: 'WESTERN NATIONAL BANK',
  ['WESTERN NEBRASKA BANK']: 'WESTERN NEBRASKA BANK',
  ['WESTERN ROCKIES F.C.U.']: 'WESTERN ROCKIES F.C.U.',
  ['WESTERN UNION INTERNATIONAL BANK GMBH']: 'WESTERN UNION INTERNATIONAL BANK GMBH',
  ['WESTERRA C.U.']: 'WESTERRA C.U.',
  ['WESTFIELD BANK, F.S.B.']: 'WESTFIELD BANK, F.S.B.',
  ['WESTMARK C.U.']: 'WESTMARK C.U.',
  ['WESTPAC BANKING CORPORATION']: 'WESTPAC BANKING CORPORATION',
  ['WESTPAC NEW ZEALAND LIMITED']: 'WESTPAC NEW ZEALAND LIMITED',
  ['WESTPAC NEW ZEALAND, LTD.']: 'WESTPAC NEW ZEALAND, LTD.',
  ['WEX BANK']: 'WEX BANK',
  ['WEX CANADA LTD.']: 'WEX CANADA LTD.',
  ['WEX EUROPE NETHERLANDS BV']: 'WEX EUROPE NETHERLANDS BV',
  ['WEX EUROPE UK LTD']: 'WEX EUROPE UK LTD',
  ['WFCU C.U.']: 'WFCU C.U.',
  ['WHEATLAND BANK']: 'WHEATLAND BANK',
  ['WHEELHOUSE C.U.']: 'WHEELHOUSE C.U.',
  ['WHITAKER BANK']: 'WHITAKER BANK',
  ['WHITE ROSE C.U.']: 'WHITE ROSE C.U.',
  ['WICHITA F.C.U.']: 'WICHITA F.C.U.',
  ['WIDGET FINANCIAL']: 'WIDGET FINANCIAL',
  ['WILDFIRE C.U.']: 'WILDFIRE C.U.',
  ['WILMINGTON SAVINGS FUND SOCIETY']: 'WILMINGTON SAVINGS FUND SOCIETY',
  ['WILMINGTON TRUST, N.A.']: 'WILMINGTON TRUST, N.A.',
  ['WILOBANK S.A.']: 'WILOBANK S.A.',
  ['WILSON BANK AND TRUST']: 'WILSON BANK AND TRUST',
  ['WINCHESTER SAVINGS BANK']: 'WINCHESTER SAVINGS BANK',
  ['WINDSOR FEDERAL SAVINGS AND LOAN ASSOCIATION']: 'WINDSOR FEDERAL SAVINGS AND LOAN ASSOCIATION',
  ['WING (CAMBODIA) LIMITED SPECIALISED BANK']: 'WING (CAMBODIA) LIMITED SPECIALISED BANK',
  ['WINGS F.C.U.']: 'WINGS F.C.U.',
  ['WINGS FINANCIAL F.C.U.']: 'WINGS FINANCIAL F.C.U.',
  ['WINNSBORO STATE BANK AND TRUST COMPANY']: 'WINNSBORO STATE BANK AND TRUST COMPANY',
  ['WINSOUTH C.U.']: 'WINSOUTH C.U.',
  ['WINTHROP-UNIVERSITY HOSPITAL EMPLOYEES F.C.U.']: 'WINTHROP-UNIVERSITY HOSPITAL EMPLOYEES F.C.U.',
  ['WIRECARD']: 'WIRECARD',
  ['WIRECARD BRASIL SA']: 'WIRECARD BRASIL SA',
  ['WIRECARD CARD SOLUTIONS']: 'WIRECARD CARD SOLUTIONS',
  ['WIRED PLASTIC CARD ISSUED BY BANCORP BANK']: 'WIRED PLASTIC CARD ISSUED BY BANCORP BANK',
  ['WIREX LIMITED']: 'WIREX LIMITED',
  ['WIZINK BANK SA']: 'WIZINK BANK SA',
  ['WNB FINANCIAL']: 'WNB FINANCIAL',
  ['WOLVERINE STATE C.U.']: 'WOLVERINE STATE C.U.',
  ['WOOD AND HUSTON BANK']: 'WOOD AND HUSTON BANK',
  ['WOODFOREST NATIONAL BANK']: 'WOODFOREST NATIONAL BANK',
  ['WOODLAND BANK']: 'WOODLAND BANK',
  ['WOODSVILLE GUARANTY SAVINGS BANK']: 'WOODSVILLE GUARANTY SAVINGS BANK',
  ['WOORICARD CO., LTD']: 'WOORICARD CO., LTD',
  ["WORKERS' CREDIT UNION"]: "WORKERS' CREDIT UNION",
  ['WRIGHT PATT C.U.']: 'WRIGHT PATT C.U.',
  ['WSFS BANK']: 'WSFS BANK',
  ['WUESTENROT BANK AG PFANDBRIEBANK']: 'WUESTENROT BANK AG PFANDBRIEBANK',
  ['WWW.SIMPLE.COM BY THE BANCORP']: 'WWW.SIMPLE.COM BY THE BANCORP',
  ['WYHY F.C.U.']: 'WYHY F.C.U.',
  ['XACBANK LLC']: 'XACBANK LLC',
  ['XAPO BANK (GIBRALTAR) LIMITED']: 'XAPO BANK (GIBRALTAR) LIMITED',
  ['XAPO CARD ISSUED BY WAVE CREST HOLDINGS, LTD.']: 'XAPO CARD ISSUED BY WAVE CREST HOLDINGS, LTD.',
  ['XCEED FINANCIAL F.C.U.']: 'XCEED FINANCIAL F.C.U.',
  ['XCEL F.C.U.']: 'XCEL F.C.U.',
  ['XINJA BANK LTD']: 'XINJA BANK LTD',
  ['XPLORE F.C.U.']: 'XPLORE F.C.U.',
  ['Y-12 F.C.U.']: 'Y-12 F.C.U.',
  ['YAHOO JAPAN CORPORATION']: 'YAHOO JAPAN CORPORATION',
  ['YAMAGIN CARD CO., LTD.']: 'YAMAGIN CARD CO., LTD.',
  ['YAMPA VALLEY BANK']: 'YAMPA VALLEY BANK',
  ['YAPI VE KREDI BANKASI A.S.']: 'YAPI VE KREDI BANKASI A.S.',
  ['YELLOWSTONE BANK, THE']: 'YELLOWSTONE BANK, THE',
  ['YEMEN BANK FOR RECONSTRUCTION AND DEVELOPMENT']: 'YEMEN BANK FOR RECONSTRUCTION AND DEVELOPMENT',
  ['YES BANK LIMITED']: 'YES BANK LIMITED',
  ['YOLO F.C.U.']: 'YOLO F.C.U.',
  ['YOOMONEY, NBCO LLC']: 'YOOMONEY, NBCO LLC',
  ['YORKSHIRE BANK']: 'YORKSHIRE BANK',
  ['YOU TECHNOLOGIES GROUP (SINGAPORE) PTE. LTD.']: 'YOU TECHNOLOGIES GROUP (SINGAPORE) PTE. LTD.',
  ['YUANTA COMMERCIAL BANK CO., LTD.']: 'YUANTA COMMERCIAL BANK CO., LTD.',
  ['ZAGREBACKA BANKA D.D.']: 'ZAGREBACKA BANKA D.D.',
  ['ZAMBIA INDUSTRIAL COMMERCIAL BANK LIMITED']: 'ZAMBIA INDUSTRIAL COMMERCIAL BANK LIMITED',
  ['ZAO RAIFFEISENBANK']: 'ZAO RAIFFEISENBANK',
  ['ZAPSIBKOMBANK']: 'ZAPSIBKOMBANK',
  ['ZENITH BANK']: 'ZENITH BANK',
  ['ZENITH BANK (GHANA) LIMITED']: 'ZENITH BANK (GHANA) LIMITED',
  ['ZHONGYUAN BANK CO., LTD.']: 'ZHONGYUAN BANK CO., LTD.',
  ['ZIA C.U.']: 'ZIA C.U.',
  ['ZIONS FIRST NATIONAL BANK']: 'ZIONS FIRST NATIONAL BANK',
  ['ZOOMPASS']: 'ZOOMPASS',
  ['ZUERCHER KANTONALBANK']: 'ZUERCHER KANTONALBANK',
};

module.exports = Issuers;
